/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as R403RouteImport } from './routes/403'
import { Route as VendorRouteRouteImport } from './routes/vendor/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorIndexRouteImport } from './routes/vendor/index'
import { Route as VendorLoginRouteImport } from './routes/vendor/login'
import { Route as VendorDashboardRouteImport } from './routes/vendor/dashboard'
import { Route as AdminSalesDashboardRouteImport } from './routes/admin/sales-dashboard'
import { Route as AdminProfileRouteImport } from './routes/admin/profile'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as VendorTransferIndexRouteImport } from './routes/vendor/transfer/index'
import { Route as VendorStockIndexRouteImport } from './routes/vendor/stock/index'
import { Route as VendorSalesIndexRouteImport } from './routes/vendor/sales/index'
import { Route as VendorRentalIndexRouteImport } from './routes/vendor/rental/index'
import { Route as AdminWarehouseIndexRouteImport } from './routes/admin/warehouse/index'
import { Route as AdminWarehouseLocationGroupIndexRouteImport } from './routes/admin/warehouse-location-group/index'
import { Route as AdminVoucherIndexRouteImport } from './routes/admin/voucher/index'
import { Route as AdminVoucherCategoryIndexRouteImport } from './routes/admin/voucher-category/index'
import { Route as AdminVendorIndexRouteImport } from './routes/admin/vendor/index'
import { Route as AdminVendorRentalApprovalIndexRouteImport } from './routes/admin/vendor-rental-approval/index'
import { Route as AdminVendorConsignmentRentalPeriodIndexRouteImport } from './routes/admin/vendor-consignment-rental-period/index'
import { Route as AdminVendorCategoryIndexRouteImport } from './routes/admin/vendor-category/index'
import { Route as AdminUserShiftIndexRouteImport } from './routes/admin/user-shift/index'
import { Route as AdminUomCategoryIndexRouteImport } from './routes/admin/uom-category/index'
import { Route as AdminTransferRequestIndexRouteImport } from './routes/admin/transfer-request/index'
import { Route as AdminTransferOrderIndexRouteImport } from './routes/admin/transfer-order/index'
import { Route as AdminTaxIndexRouteImport } from './routes/admin/tax/index'
import { Route as AdminSupplierIndexRouteImport } from './routes/admin/supplier/index'
import { Route as AdminSimpleTransferOrderIndexRouteImport } from './routes/admin/simple-transfer-order/index'
import { Route as AdminSalesInvoiceIndexRouteImport } from './routes/admin/sales-invoice/index'
import { Route as AdminSalesInvoiceReviewIndexRouteImport } from './routes/admin/sales-invoice-review/index'
import { Route as AdminSalesChannelIndexRouteImport } from './routes/admin/sales-channel/index'
import { Route as AdminSalesChannelStockThresholdIndexRouteImport } from './routes/admin/sales-channel-stock-threshold/index'
import { Route as AdminSalesChannelCategoryMappingIndexRouteImport } from './routes/admin/sales-channel-category-mapping/index'
import { Route as AdminSalesChannelCategoryGroupIndexRouteImport } from './routes/admin/sales-channel-category-group/index'
import { Route as AdminSalesChannelCampaignIndexRouteImport } from './routes/admin/sales-channel-campaign/index'
import { Route as AdminRevenueSharingIndexRouteImport } from './routes/admin/revenue-sharing/index'
import { Route as AdminRevenueReportIndexRouteImport } from './routes/admin/revenue-report/index'
import { Route as AdminRevenueReportTemplateIndexRouteImport } from './routes/admin/revenue-report-template/index'
import { Route as AdminRevenueReportPartnerIndexRouteImport } from './routes/admin/revenue-report-partner/index'
import { Route as AdminRevenueReportPartnerBranchIndexRouteImport } from './routes/admin/revenue-report-partner-branch/index'
import { Route as AdminRevenueReportAccessLogIndexRouteImport } from './routes/admin/revenue-report-access-log/index'
import { Route as AdminReplenishmentIndexRouteImport } from './routes/admin/replenishment/index'
import { Route as AdminReplenishmentTemplateIndexRouteImport } from './routes/admin/replenishment-template/index'
import { Route as AdminReplenishmentTemplateCategoryIndexRouteImport } from './routes/admin/replenishment-template-category/index'
import { Route as AdminReconOutstandingIndexRouteImport } from './routes/admin/recon-outstanding/index'
import { Route as AdminReconBankIndexRouteImport } from './routes/admin/recon-bank/index'
import { Route as AdminReconBankUploadIndexRouteImport } from './routes/admin/recon-bank-upload/index'
import { Route as AdminReceivingIndexRouteImport } from './routes/admin/receiving/index'
import { Route as AdminPutawayTaskIndexRouteImport } from './routes/admin/putaway-task/index'
import { Route as AdminPurchaseOrderIndexRouteImport } from './routes/admin/purchase-order/index'
import { Route as AdminPurchaseAreaIndexRouteImport } from './routes/admin/purchase-area/index'
import { Route as AdminPromoIndexRouteImport } from './routes/admin/promo/index'
import { Route as AdminProductionIndexRouteImport } from './routes/admin/production/index'
import { Route as AdminProductIndexRouteImport } from './routes/admin/product/index'
import { Route as AdminProductTagIndexRouteImport } from './routes/admin/product-tag/index'
import { Route as AdminProductSubDepartmentIndexRouteImport } from './routes/admin/product-sub-department/index'
import { Route as AdminProductSubCategoryIndexRouteImport } from './routes/admin/product-sub-category/index'
import { Route as AdminProductDivisionIndexRouteImport } from './routes/admin/product-division/index'
import { Route as AdminProductDepartmentIndexRouteImport } from './routes/admin/product-department/index'
import { Route as AdminProductCategoryIndexRouteImport } from './routes/admin/product-category/index'
import { Route as AdminProductBrandIndexRouteImport } from './routes/admin/product-brand/index'
import { Route as AdminProductAvailabilityTemplateIndexRouteImport } from './routes/admin/product-availability-template/index'
import { Route as AdminProductAddonIndexRouteImport } from './routes/admin/product-addon/index'
import { Route as AdminProductAddonGroupIndexRouteImport } from './routes/admin/product-addon-group/index'
import { Route as AdminProductAccountingCategoryIndexRouteImport } from './routes/admin/product-accounting-category/index'
import { Route as AdminPrintNonConsignmentIndexRouteImport } from './routes/admin/print-non-consignment/index'
import { Route as AdminPrintConsignmentIndexRouteImport } from './routes/admin/print-consignment/index'
import { Route as AdminPricelistIndexRouteImport } from './routes/admin/pricelist/index'
import { Route as AdminPosterIndexRouteImport } from './routes/admin/poster/index'
import { Route as AdminPosBookmarkIndexRouteImport } from './routes/admin/pos-bookmark/index'
import { Route as AdminPickingTaskIndexRouteImport } from './routes/admin/picking-task/index'
import { Route as AdminPettyCashIndexRouteImport } from './routes/admin/petty-cash/index'
import { Route as AdminPendingSyncSalesOrderIndexRouteImport } from './routes/admin/pending-sync-sales-order/index'
import { Route as AdminPendingSyncMarketplaceOrderIndexRouteImport } from './routes/admin/pending-sync-marketplace-order/index'
import { Route as AdminPaymentWebhookEventIndexRouteImport } from './routes/admin/payment-webhook-event/index'
import { Route as AdminPaymentTransactionIndexRouteImport } from './routes/admin/payment-transaction/index'
import { Route as AdminPaymentProviderConfigIndexRouteImport } from './routes/admin/payment-provider-config/index'
import { Route as AdminPaymentMethodIndexRouteImport } from './routes/admin/payment-method/index'
import { Route as AdminPaymentInboundRequestIndexRouteImport } from './routes/admin/payment-inbound-request/index'
import { Route as AdminPackingTaskIndexRouteImport } from './routes/admin/packing-task/index'
import { Route as AdminOutboundContainerIndexRouteImport } from './routes/admin/outbound-container/index'
import { Route as AdminMemberTypeIndexRouteImport } from './routes/admin/member-type/index'
import { Route as AdminMarketplaceOrderIndexRouteImport } from './routes/admin/marketplace-order/index'
import { Route as AdminMarketplaceChannelLogIndexRouteImport } from './routes/admin/marketplace-channel-log/index'
import { Route as AdminMarketplaceAutomationIndexRouteImport } from './routes/admin/marketplace-automation/index'
import { Route as AdminInventoryTransactionIndexRouteImport } from './routes/admin/inventory-transaction/index'
import { Route as AdminInventoryTransactionLineUnitIndexRouteImport } from './routes/admin/inventory-transaction-line-unit/index'
import { Route as AdminInventorySummaryIndexRouteImport } from './routes/admin/inventory-summary/index'
import { Route as AdminInventoryMovementSummaryIndexRouteImport } from './routes/admin/inventory-movement-summary/index'
import { Route as AdminInventoryLocationIndexRouteImport } from './routes/admin/inventory-location/index'
import { Route as AdminInventoryCountIndexRouteImport } from './routes/admin/inventory-count/index'
import { Route as AdminInventoryCountTemplateItemIndexRouteImport } from './routes/admin/inventory-count-template-item/index'
import { Route as AdminInventoryCountMonitoringIndexRouteImport } from './routes/admin/inventory-count-monitoring/index'
import { Route as AdminInventoryAdjustmentIndexRouteImport } from './routes/admin/inventory-adjustment/index'
import { Route as AdminInventoryAdjustmentReasonIndexRouteImport } from './routes/admin/inventory-adjustment-reason/index'
import { Route as AdminInternalTransferIndexRouteImport } from './routes/admin/internal-transfer/index'
import { Route as AdminIncomingTransferRequestIndexRouteImport } from './routes/admin/incoming-transfer-request/index'
import { Route as AdminExpenseItemIndexRouteImport } from './routes/admin/expense-item/index'
import { Route as AdminExampleIndexRouteImport } from './routes/admin/example/index'
import { Route as AdminEdcTerminalIndexRouteImport } from './routes/admin/edc-terminal/index'
import { Route as AdminDeliveryOrderIndexRouteImport } from './routes/admin/delivery-order/index'
import { Route as AdminDeliveryOrderBatchIndexRouteImport } from './routes/admin/delivery-order-batch/index'
import { Route as AdminCustomerIndexRouteImport } from './routes/admin/customer/index'
import { Route as AdminConsignmentVendorRegistrationIndexRouteImport } from './routes/admin/consignment-vendor-registration/index'
import { Route as AdminConsignmentVendorApplicationInviteIndexRouteImport } from './routes/admin/consignment-vendor-application-invite/index'
import { Route as AdminConsignmentStockoutIndexRouteImport } from './routes/admin/consignment-stockout/index'
import { Route as AdminConsignmentStockinIndexRouteImport } from './routes/admin/consignment-stockin/index'
import { Route as AdminConsignmentStockinRequestIndexRouteImport } from './routes/admin/consignment-stockin-request/index'
import { Route as AdminConsignmentSettlementIndexRouteImport } from './routes/admin/consignment-settlement/index'
import { Route as AdminConsignmentSettingIndexRouteImport } from './routes/admin/consignment-setting/index'
import { Route as AdminConsignmentRequestIndexRouteImport } from './routes/admin/consignment-request/index'
import { Route as AdminConsignmentRegionIndexRouteImport } from './routes/admin/consignment-region/index'
import { Route as AdminConsignmentProductRequestIndexRouteImport } from './routes/admin/consignment-product-request/index'
import { Route as AdminConsignmentCurationIndexRouteImport } from './routes/admin/consignment-curation/index'
import { Route as AdminConsignmentConfigIndexRouteImport } from './routes/admin/consignment-config/index'
import { Route as AdminConsignmentBranchSettingIndexRouteImport } from './routes/admin/consignment-branch-setting/index'
import { Route as AdminConsignmentAdminTeamIndexRouteImport } from './routes/admin/consignment-admin-team/index'
import { Route as AdminBranchIndexRouteImport } from './routes/admin/branch/index'
import { Route as AdminBranchSalesChannelIndexRouteImport } from './routes/admin/branch-sales-channel/index'
import { Route as AdminBranchQrisMerchantIndexRouteImport } from './routes/admin/branch-qris-merchant/index'
import { Route as AdminBranchCategoryIndexRouteImport } from './routes/admin/branch-category/index'
import { Route as AdminBranchBankAccountIndexRouteImport } from './routes/admin/branch-bank-account/index'
import { Route as AdminBillOfMaterialIndexRouteImport } from './routes/admin/bill-of-material/index'
import { Route as AdminBankIndexRouteImport } from './routes/admin/bank/index'
import { Route as AdminBankAccountIndexRouteImport } from './routes/admin/bank-account/index'
import { Route as VendorSalesSalesConsignmentInvoiceIDRouteImport } from './routes/vendor/sales/$salesConsignmentInvoiceID'
import { Route as VendorRentalNewRouteImport } from './routes/vendor/rental/new'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/auth/reset-password/$token'
import { Route as AdminWarehouseLocationGroupCreateRouteImport } from './routes/admin/warehouse-location-group/create'
import { Route as AdminVoucherCreateRouteImport } from './routes/admin/voucher/create'
import { Route as AdminVoucherCategoryCreateRouteImport } from './routes/admin/voucher-category/create'
import { Route as AdminVendorCreateRouteImport } from './routes/admin/vendor/create'
import { Route as AdminVendorCategoryCreateRouteImport } from './routes/admin/vendor-category/create'
import { Route as AdminUomCategoryCreateRouteImport } from './routes/admin/uom-category/create'
import { Route as AdminTransferRequestImportRouteImport } from './routes/admin/transfer-request/import'
import { Route as AdminTransferRequestCreateRouteImport } from './routes/admin/transfer-request/create'
import { Route as AdminTransferOrderImportRouteImport } from './routes/admin/transfer-order/import'
import { Route as AdminTransferOrderCreateRouteImport } from './routes/admin/transfer-order/create'
import { Route as AdminTaxCreateRouteImport } from './routes/admin/tax/create'
import { Route as AdminSupplierCreateRouteImport } from './routes/admin/supplier/create'
import { Route as AdminSimpleTransferOrderCreateRouteImport } from './routes/admin/simple-transfer-order/create'
import { Route as AdminSalesChannelCreateRouteImport } from './routes/admin/sales-channel/create'
import { Route as AdminSalesChannelCategoryMappingImportRouteImport } from './routes/admin/sales-channel-category-mapping/import'
import { Route as AdminSalesChannelCategoryMappingCreateRouteImport } from './routes/admin/sales-channel-category-mapping/create'
import { Route as AdminSalesChannelCategoryGroupCreateRouteImport } from './routes/admin/sales-channel-category-group/create'
import { Route as AdminSalesChannelCampaignRulesRouteImport } from './routes/admin/sales-channel-campaign/rules'
import { Route as AdminSalesChannelCampaignCreateRouteImport } from './routes/admin/sales-channel-campaign/create'
import { Route as AdminReplenishmentTemplateCreateRouteImport } from './routes/admin/replenishment-template/create'
import { Route as AdminReplenishmentTemplateCategoryCreateRouteImport } from './routes/admin/replenishment-template-category/create'
import { Route as AdminReconBankUploadRouteImport } from './routes/admin/recon-bank/upload'
import { Route as AdminReconBankUploadAddRouteImport } from './routes/admin/recon-bank-upload/add'
import { Route as AdminReceivingCreateRouteImport } from './routes/admin/receiving/create'
import { Route as AdminPurchaseOrderImportRouteImport } from './routes/admin/purchase-order/import'
import { Route as AdminPurchaseOrderCreateRouteImport } from './routes/admin/purchase-order/create'
import { Route as AdminPurchaseAreaCreateRouteImport } from './routes/admin/purchase-area/create'
import { Route as AdminPromoImportRouteImport } from './routes/admin/promo/import'
import { Route as AdminPromoCreateRouteImport } from './routes/admin/promo/create'
import { Route as AdminProductionCreateRouteImport } from './routes/admin/production/create'
import { Route as AdminProductImportRouteImport } from './routes/admin/product/import'
import { Route as AdminProductCreateRouteImport } from './routes/admin/product/create'
import { Route as AdminProductTagCreateRouteImport } from './routes/admin/product-tag/create'
import { Route as AdminProductSubDepartmentCreateRouteImport } from './routes/admin/product-sub-department/create'
import { Route as AdminProductSubCategoryCreateRouteImport } from './routes/admin/product-sub-category/create'
import { Route as AdminProductDivisionCreateRouteImport } from './routes/admin/product-division/create'
import { Route as AdminProductDepartmentCreateRouteImport } from './routes/admin/product-department/create'
import { Route as AdminProductCategoryCreateRouteImport } from './routes/admin/product-category/create'
import { Route as AdminProductBrandCreateRouteImport } from './routes/admin/product-brand/create'
import { Route as AdminProductAvailabilityTemplateCreateRouteImport } from './routes/admin/product-availability-template/create'
import { Route as AdminProductAddonCreateRouteImport } from './routes/admin/product-addon/create'
import { Route as AdminProductAddonGroupCreateRouteImport } from './routes/admin/product-addon-group/create'
import { Route as AdminProductAccountingCategoryCreateRouteImport } from './routes/admin/product-accounting-category/create'
import { Route as AdminPrintLabelSmallRouteImport } from './routes/admin/print-label/small'
import { Route as AdminPrintLabelLargeRouteImport } from './routes/admin/print-label/large'
import { Route as AdminPricelistCreateRouteImport } from './routes/admin/pricelist/create'
import { Route as AdminPosterCreateRouteImport } from './routes/admin/poster/create'
import { Route as AdminPosBookmarkCreateRouteImport } from './routes/admin/pos-bookmark/create'
import { Route as AdminPaymentMethodCreateRouteImport } from './routes/admin/payment-method/create'
import { Route as AdminOutboundContainerScanRouteImport } from './routes/admin/outbound-container/scan'
import { Route as AdminMemberTypeCreateRouteImport } from './routes/admin/member-type/create'
import { Route as AdminMarketplaceAutomationJobKeyRouteImport } from './routes/admin/marketplace-automation/$jobKey'
import { Route as AdminInventoryCountCreateRouteImport } from './routes/admin/inventory-count/create'
import { Route as AdminInventoryCountTemplateItemCreateRouteImport } from './routes/admin/inventory-count-template-item/create'
import { Route as AdminInventoryAdjustmentCreateRouteImport } from './routes/admin/inventory-adjustment/create'
import { Route as AdminInventoryAdjustmentReasonCreateRouteImport } from './routes/admin/inventory-adjustment-reason/create'
import { Route as AdminInternalTransferCreateRouteImport } from './routes/admin/internal-transfer/create'
import { Route as AdminImportTemplateTypeRouteImport } from './routes/admin/import/$templateType'
import { Route as AdminExpenseItemCreateRouteImport } from './routes/admin/expense-item/create'
import { Route as AdminExampleSeePermissionsRouteImport } from './routes/admin/example/see-permissions'
import { Route as AdminEdcTerminalCreateRouteImport } from './routes/admin/edc-terminal/create'
import { Route as AdminDeliveryOrderCreateRouteImport } from './routes/admin/delivery-order/create'
import { Route as AdminDeliveryOrderBatchCreateRouteImport } from './routes/admin/delivery-order-batch/create'
import { Route as AdminCustomerCreateRouteImport } from './routes/admin/customer/create'
import { Route as AdminConsignmentVendorRegistrationIdRouteImport } from './routes/admin/consignment-vendor-registration/$id'
import { Route as AdminConsignmentStockoutCreateRouteImport } from './routes/admin/consignment-stockout/create'
import { Route as AdminConsignmentStockinCreateRouteImport } from './routes/admin/consignment-stockin/create'
import { Route as AdminConsignmentSettlementCreateRouteImport } from './routes/admin/consignment-settlement/create'
import { Route as AdminConsignmentConfigCreateRouteImport } from './routes/admin/consignment-config/create'
import { Route as AdminBranchCreateRouteImport } from './routes/admin/branch/create'
import { Route as AdminBranchQrisMerchantCreateRouteImport } from './routes/admin/branch-qris-merchant/create'
import { Route as AdminBranchCategoryCreateRouteImport } from './routes/admin/branch-category/create'
import { Route as AdminBillOfMaterialCreateRouteImport } from './routes/admin/bill-of-material/create'
import { Route as AdminBankAccountCreateRouteImport } from './routes/admin/bank-account/create'
import { Route as VendorStockProductIDIndexRouteImport } from './routes/vendor/stock/$productID/index'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/index'
import { Route as AdminPricelistPeriodIndexRouteImport } from './routes/admin/pricelist/period/index'
import { Route as AdminGeolocationVillageIndexRouteImport } from './routes/admin/geolocation/village/index'
import { Route as AdminGeolocationSubdistrictIndexRouteImport } from './routes/admin/geolocation/subdistrict/index'
import { Route as AdminGeolocationProvinceIndexRouteImport } from './routes/admin/geolocation/province/index'
import { Route as AdminGeolocationCountryIndexRouteImport } from './routes/admin/geolocation/country/index'
import { Route as AdminGeolocationCityIndexRouteImport } from './routes/admin/geolocation/city/index'
import { Route as AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRouteImport } from './routes/admin/delivery-order-batch/$deliveryOrderBatchID/index'
import { Route as AdminConsignmentStoresTeamsIndexRouteImport } from './routes/admin/consignment/stores-teams/index'
import { Route as AdminConsignmentRequestsIndexRouteImport } from './routes/admin/consignment/requests/index'
import { Route as AdminConsignmentOnboardingIndexRouteImport } from './routes/admin/consignment/onboarding/index'
import { Route as AdminBackgroundJobTransactionIndexRouteImport } from './routes/admin/background-job/transaction/index'
import { Route as AdminAccessUserIndexRouteImport } from './routes/admin/access/user/index'
import { Route as AdminAccessRoleIndexRouteImport } from './routes/admin/access/role/index'
import { Route as AdminAccessResourceIndexRouteImport } from './routes/admin/access/resource/index'
import { Route as AdminAccessPermissionIndexRouteImport } from './routes/admin/access/permission/index'
import { Route as AdminAccessAppIndexRouteImport } from './routes/admin/access/app/index'
import { Route as VendorTransferTypeIdRouteImport } from './routes/vendor/transfer/$type/$id'
import { Route as VendorStockProductIDInventoryRouteImport } from './routes/vendor/stock/$productID/inventory'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/print'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
import { Route as VendorAuthResetPasswordTokenRouteImport } from './routes/vendor/auth/reset-password/$token'
import { Route as AdminWarehouseIdDetailRouteImport } from './routes/admin/warehouse/$id/detail'
import { Route as AdminWarehouseLocationGroupIdUpdateRouteImport } from './routes/admin/warehouse-location-group/$id.update'
import { Route as AdminWarehouseLocationGroupIdDetailRouteImport } from './routes/admin/warehouse-location-group/$id.detail'
import { Route as AdminVoucherIdUpdateRouteImport } from './routes/admin/voucher/$id/update'
import { Route as AdminVoucherIdDetailRouteImport } from './routes/admin/voucher/$id/detail'
import { Route as AdminVoucherCategoryIdUpdateRouteImport } from './routes/admin/voucher-category/$id/update'
import { Route as AdminVoucherCategoryIdDetailRouteImport } from './routes/admin/voucher-category/$id/detail'
import { Route as AdminVendorIdUpdateRouteImport } from './routes/admin/vendor/$id/update'
import { Route as AdminVendorIdDetailRouteImport } from './routes/admin/vendor/$id/detail'
import { Route as AdminVendorRentalApprovalIdPrintRouteImport } from './routes/admin/vendor-rental-approval/$id/print'
import { Route as AdminVendorRentalApprovalIdDetailRouteImport } from './routes/admin/vendor-rental-approval/$id/detail'
import { Route as AdminVendorCategoryIdUpdateRouteImport } from './routes/admin/vendor-category/$id/update'
import { Route as AdminVendorCategoryIdDetailRouteImport } from './routes/admin/vendor-category/$id/detail'
import { Route as AdminUserShiftIdDetailRouteImport } from './routes/admin/user-shift/$id/detail'
import { Route as AdminUomCategoryIdUpdateRouteImport } from './routes/admin/uom-category/$id/update'
import { Route as AdminUomCategoryIdDetailRouteImport } from './routes/admin/uom-category/$id/detail'
import { Route as AdminTransferRequestIdUpdateRouteImport } from './routes/admin/transfer-request/$id/update'
import { Route as AdminTransferRequestIdDetailRouteImport } from './routes/admin/transfer-request/$id/detail'
import { Route as AdminTransferOrderIdUpdateRouteImport } from './routes/admin/transfer-order/$id/update'
import { Route as AdminTransferOrderIdPrintRouteImport } from './routes/admin/transfer-order/$id/print'
import { Route as AdminTransferOrderIdDetailRouteImport } from './routes/admin/transfer-order/$id/detail'
import { Route as AdminTransferOrderIdCreateRouteImport } from './routes/admin/transfer-order/$id/create'
import { Route as AdminTaxIdUpdateRouteImport } from './routes/admin/tax/$id/update'
import { Route as AdminTaxIdDetailRouteImport } from './routes/admin/tax/$id/detail'
import { Route as AdminSupplierIdUpdateRouteImport } from './routes/admin/supplier/$id/update'
import { Route as AdminSupplierIdDetailRouteImport } from './routes/admin/supplier/$id/detail'
import { Route as AdminSimpleTransferOrderIdUpdateRouteImport } from './routes/admin/simple-transfer-order/$id/update'
import { Route as AdminSimpleTransferOrderIdPrintRouteImport } from './routes/admin/simple-transfer-order/$id/print'
import { Route as AdminSimpleTransferOrderIdDetailRouteImport } from './routes/admin/simple-transfer-order/$id/detail'
import { Route as AdminSalesInvoiceIdDetailRouteImport } from './routes/admin/sales-invoice/$id.detail'
import { Route as AdminSalesInvoiceReviewIdDetailRouteImport } from './routes/admin/sales-invoice-review/$id.detail'
import { Route as AdminSalesChannelIdUpdateRouteImport } from './routes/admin/sales-channel/$id/update'
import { Route as AdminSalesChannelIdDetailRouteImport } from './routes/admin/sales-channel/$id/detail'
import { Route as AdminSalesChannelCategoryMappingIdUpdateRouteImport } from './routes/admin/sales-channel-category-mapping/$id.update'
import { Route as AdminSalesChannelCategoryMappingIdDetailRouteImport } from './routes/admin/sales-channel-category-mapping/$id.detail'
import { Route as AdminSalesChannelCategoryGroupIdUpdateRouteImport } from './routes/admin/sales-channel-category-group/$id/update'
import { Route as AdminSalesChannelCategoryGroupIdDetailRouteImport } from './routes/admin/sales-channel-category-group/$id/detail'
import { Route as AdminSalesChannelCampaignIdUpdateRouteImport } from './routes/admin/sales-channel-campaign/$id/update'
import { Route as AdminSalesChannelCampaignIdDetailRouteImport } from './routes/admin/sales-channel-campaign/$id/detail'
import { Route as AdminRevenueReportIdDetailRouteImport } from './routes/admin/revenue-report/$id/detail'
import { Route as AdminRevenueReportTemplateIdDetailRouteImport } from './routes/admin/revenue-report-template/$id/detail'
import { Route as AdminRevenueReportPartnerIdDetailRouteImport } from './routes/admin/revenue-report-partner/$id/detail'
import { Route as AdminRevenueReportPartnerBranchIdDetailRouteImport } from './routes/admin/revenue-report-partner-branch/$id/detail'
import { Route as AdminReplenishmentIdDetailRouteImport } from './routes/admin/replenishment/$id/detail'
import { Route as AdminReplenishmentTemplateIdUpdateRouteImport } from './routes/admin/replenishment-template/$id/update'
import { Route as AdminReplenishmentTemplateIdImportRouteImport } from './routes/admin/replenishment-template/$id/import'
import { Route as AdminReplenishmentTemplateIdDetailRouteImport } from './routes/admin/replenishment-template/$id/detail'
import { Route as AdminReplenishmentTemplateCategoryIdUpdateRouteImport } from './routes/admin/replenishment-template-category/$id/update'
import { Route as AdminReplenishmentTemplateCategoryIdDetailRouteImport } from './routes/admin/replenishment-template-category/$id/detail'
import { Route as AdminReconBankIdUploadRouteImport } from './routes/admin/recon-bank/$id/upload'
import { Route as AdminReconBankIdProcessRouteImport } from './routes/admin/recon-bank/$id/process'
import { Route as AdminReconBankIdDetailRouteImport } from './routes/admin/recon-bank/$id/detail'
import { Route as AdminReconBankUploadIdDetailRouteImport } from './routes/admin/recon-bank-upload/$id/detail'
import { Route as AdminReceivingTransferOrderCreateRouteImport } from './routes/admin/receiving/transfer-order/create'
import { Route as AdminReceivingSimpleTransferOrderCreateRouteImport } from './routes/admin/receiving/simple-transfer-order/create'
import { Route as AdminReceivingIdUpdateRouteImport } from './routes/admin/receiving/$id/update'
import { Route as AdminReceivingIdPrintRouteImport } from './routes/admin/receiving/$id/print'
import { Route as AdminReceivingIdDetailRouteImport } from './routes/admin/receiving/$id/detail'
import { Route as AdminReceivingIdCreateRouteImport } from './routes/admin/receiving/$id/create'
import { Route as AdminPutawayTaskIdDetailRouteImport } from './routes/admin/putaway-task/$id/detail'
import { Route as AdminPurchaseOrderIdUpdateRouteImport } from './routes/admin/purchase-order/$id.update'
import { Route as AdminPurchaseOrderIdReviseRouteImport } from './routes/admin/purchase-order/$id.revise'
import { Route as AdminPurchaseOrderIdPrintRouteImport } from './routes/admin/purchase-order/$id.print'
import { Route as AdminPurchaseOrderIdDetailRouteImport } from './routes/admin/purchase-order/$id.detail'
import { Route as AdminPurchaseAreaIdUpdateRouteImport } from './routes/admin/purchase-area/$id.update'
import { Route as AdminPurchaseAreaIdDetailRouteImport } from './routes/admin/purchase-area/$id.detail'
import { Route as AdminPromoIdUpdateRouteImport } from './routes/admin/promo/$id/update'
import { Route as AdminPromoIdImportRouteImport } from './routes/admin/promo/$id/import'
import { Route as AdminPromoIdDetailRouteImport } from './routes/admin/promo/$id/detail'
import { Route as AdminProductionIdUpdateRouteImport } from './routes/admin/production/$id/update'
import { Route as AdminProductionIdDetailRouteImport } from './routes/admin/production/$id/detail'
import { Route as AdminProductIdUpdateRouteImport } from './routes/admin/product/$id/update'
import { Route as AdminProductIdDetailRouteImport } from './routes/admin/product/$id/detail'
import { Route as AdminProductTagIdUpdateRouteImport } from './routes/admin/product-tag/$id/update'
import { Route as AdminProductTagIdDetailRouteImport } from './routes/admin/product-tag/$id/detail'
import { Route as AdminProductSubDepartmentIdUpdateRouteImport } from './routes/admin/product-sub-department/$id.update'
import { Route as AdminProductSubDepartmentIdDetailRouteImport } from './routes/admin/product-sub-department/$id.detail'
import { Route as AdminProductSubCategoryIdUpdateRouteImport } from './routes/admin/product-sub-category/$id.update'
import { Route as AdminProductSubCategoryIdDetailRouteImport } from './routes/admin/product-sub-category/$id.detail'
import { Route as AdminProductDivisionIdUpdateRouteImport } from './routes/admin/product-division/$id.update'
import { Route as AdminProductDivisionIdDetailRouteImport } from './routes/admin/product-division/$id.detail'
import { Route as AdminProductDepartmentIdUpdateRouteImport } from './routes/admin/product-department/$id.update'
import { Route as AdminProductDepartmentIdDetailRouteImport } from './routes/admin/product-department/$id.detail'
import { Route as AdminProductCategoryIdUpdateRouteImport } from './routes/admin/product-category/$id.update'
import { Route as AdminProductCategoryIdDetailRouteImport } from './routes/admin/product-category/$id.detail'
import { Route as AdminProductBrandIdUpdateRouteImport } from './routes/admin/product-brand/$id.update'
import { Route as AdminProductBrandIdDetailRouteImport } from './routes/admin/product-brand/$id.detail'
import { Route as AdminProductAvailabilityTemplateIdUpdateRouteImport } from './routes/admin/product-availability-template/$id/update'
import { Route as AdminProductAvailabilityTemplateIdImportRouteImport } from './routes/admin/product-availability-template/$id/import'
import { Route as AdminProductAvailabilityTemplateIdDetailRouteImport } from './routes/admin/product-availability-template/$id/detail'
import { Route as AdminProductAddonIdUpdateRouteImport } from './routes/admin/product-addon/$id/update'
import { Route as AdminProductAddonIdDetailRouteImport } from './routes/admin/product-addon/$id/detail'
import { Route as AdminProductAddonGroupIdUpdateRouteImport } from './routes/admin/product-addon-group/$id/update'
import { Route as AdminProductAddonGroupIdDetailRouteImport } from './routes/admin/product-addon-group/$id/detail'
import { Route as AdminProductAccountingCategoryIdUpdateRouteImport } from './routes/admin/product-accounting-category/$id/update'
import { Route as AdminProductAccountingCategoryIdDetailRouteImport } from './routes/admin/product-accounting-category/$id/detail'
import { Route as AdminPricelistPeriodCreateRouteImport } from './routes/admin/pricelist/period/create'
import { Route as AdminPricelistIdUpdateRouteImport } from './routes/admin/pricelist/$id/update'
import { Route as AdminPricelistIdImportRouteImport } from './routes/admin/pricelist/$id/import'
import { Route as AdminPricelistIdDetailRouteImport } from './routes/admin/pricelist/$id/detail'
import { Route as AdminPosterIdUpdateRouteImport } from './routes/admin/poster/$id/update'
import { Route as AdminPosterIdDetailRouteImport } from './routes/admin/poster/$id/detail'
import { Route as AdminPosBookmarkIdUpdateRouteImport } from './routes/admin/pos-bookmark/$id/update'
import { Route as AdminPosBookmarkIdDetailRouteImport } from './routes/admin/pos-bookmark/$id/detail'
import { Route as AdminPickingTaskIdDetailRouteImport } from './routes/admin/picking-task/$id/detail'
import { Route as AdminPickingTaskIdCreateLocationGroupRouteImport } from './routes/admin/picking-task/$id/create-location-group'
import { Route as AdminPettyCashRefundCreateRouteImport } from './routes/admin/petty-cash/refund/create'
import { Route as AdminPettyCashExpenseCreateRouteImport } from './routes/admin/petty-cash/expense/create'
import { Route as AdminPettyCashAddFundCreateRouteImport } from './routes/admin/petty-cash/add-fund/create'
import { Route as AdminPettyCashIdPrintRouteImport } from './routes/admin/petty-cash/$id/print'
import { Route as AdminPettyCashIdDetailRouteImport } from './routes/admin/petty-cash/$id/detail'
import { Route as AdminPaymentTransactionIdDetailRouteImport } from './routes/admin/payment-transaction/$id/detail'
import { Route as AdminPaymentProviderConfigIdUpdateRouteImport } from './routes/admin/payment-provider-config/$id.update'
import { Route as AdminPaymentMethodIdUpdateRouteImport } from './routes/admin/payment-method/$id/update'
import { Route as AdminPaymentMethodIdDetailRouteImport } from './routes/admin/payment-method/$id/detail'
import { Route as AdminPackingTaskIdVerifyRouteImport } from './routes/admin/packing-task/$id/verify'
import { Route as AdminPackingTaskIdProcessRouteImport } from './routes/admin/packing-task/$id/process'
import { Route as AdminPackingTaskIdDetailRouteImport } from './routes/admin/packing-task/$id/detail'
import { Route as AdminOutboundContainerIdDetailRouteImport } from './routes/admin/outbound-container/$id/detail'
import { Route as AdminMemberTypeIdUpdateRouteImport } from './routes/admin/member-type/$id/update'
import { Route as AdminMemberTypeIdDetailRouteImport } from './routes/admin/member-type/$id/detail'
import { Route as AdminMarketplaceOrderIdDetailRouteImport } from './routes/admin/marketplace-order/$id/detail'
import { Route as AdminMarketplaceChannelLogIdDetailRouteImport } from './routes/admin/marketplace-channel-log/$id/detail'
import { Route as AdminInventoryTransactionIdDetailRouteImport } from './routes/admin/inventory-transaction/$id/detail'
import { Route as AdminInventoryCountIdUpdateRouteImport } from './routes/admin/inventory-count/$id/update'
import { Route as AdminInventoryCountIdRecountRouteImport } from './routes/admin/inventory-count/$id/recount'
import { Route as AdminInventoryCountIdPrintRouteImport } from './routes/admin/inventory-count/$id/print'
import { Route as AdminInventoryCountIdDetailRouteImport } from './routes/admin/inventory-count/$id/detail'
import { Route as AdminInventoryCountTemplateItemIdUpdateRouteImport } from './routes/admin/inventory-count-template-item/$id/update'
import { Route as AdminInventoryCountTemplateItemIdImportRouteImport } from './routes/admin/inventory-count-template-item/$id/import'
import { Route as AdminInventoryCountTemplateItemIdDetailRouteImport } from './routes/admin/inventory-count-template-item/$id/detail'
import { Route as AdminInventoryAdjustmentOpeningBalanceImportRouteImport } from './routes/admin/inventory-adjustment/opening-balance/import'
import { Route as AdminInventoryAdjustmentCostAdjustmentImportRouteImport } from './routes/admin/inventory-adjustment/cost-adjustment/import'
import { Route as AdminInventoryAdjustmentIdUpdateRouteImport } from './routes/admin/inventory-adjustment/$id/update'
import { Route as AdminInventoryAdjustmentIdPrintRouteImport } from './routes/admin/inventory-adjustment/$id/print'
import { Route as AdminInventoryAdjustmentIdDetailRouteImport } from './routes/admin/inventory-adjustment/$id/detail'
import { Route as AdminInventoryAdjustmentReasonIdUpdateRouteImport } from './routes/admin/inventory-adjustment-reason/$id/update'
import { Route as AdminInventoryAdjustmentReasonIdDetailRouteImport } from './routes/admin/inventory-adjustment-reason/$id/detail'
import { Route as AdminInternalTransferIdUpdateRouteImport } from './routes/admin/internal-transfer/$id/update'
import { Route as AdminInternalTransferIdPrintRouteImport } from './routes/admin/internal-transfer/$id/print'
import { Route as AdminInternalTransferIdDetailRouteImport } from './routes/admin/internal-transfer/$id/detail'
import { Route as AdminIncomingTransferRequestIdUpdateRouteImport } from './routes/admin/incoming-transfer-request/$id/update'
import { Route as AdminIncomingTransferRequestIdDetailRouteImport } from './routes/admin/incoming-transfer-request/$id/detail'
import { Route as AdminGeolocationVillageCreateRouteImport } from './routes/admin/geolocation/village/create'
import { Route as AdminGeolocationSubdistrictCreateRouteImport } from './routes/admin/geolocation/subdistrict/create'
import { Route as AdminGeolocationProvinceCreateRouteImport } from './routes/admin/geolocation/province/create'
import { Route as AdminGeolocationCountryCreateRouteImport } from './routes/admin/geolocation/country/create'
import { Route as AdminGeolocationCityCreateRouteImport } from './routes/admin/geolocation/city/create'
import { Route as AdminExpenseItemIdUpdateRouteImport } from './routes/admin/expense-item/$id/update'
import { Route as AdminExpenseItemIdDetailRouteImport } from './routes/admin/expense-item/$id/detail'
import { Route as AdminEdcTerminalIdUpdateRouteImport } from './routes/admin/edc-terminal/$id.update'
import { Route as AdminEdcTerminalIdDetailRouteImport } from './routes/admin/edc-terminal/$id.detail'
import { Route as AdminDeliveryOrderIdUpdateRouteImport } from './routes/admin/delivery-order/$id/update'
import { Route as AdminDeliveryOrderIdPrintRouteImport } from './routes/admin/delivery-order/$id/print'
import { Route as AdminDeliveryOrderIdDetailRouteImport } from './routes/admin/delivery-order/$id/detail'
import { Route as AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRouteImport } from './routes/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
import { Route as AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRouteImport } from './routes/admin/delivery-order-batch/$deliveryOrderBatchID/result'
import { Route as AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRouteImport } from './routes/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
import { Route as AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRouteImport } from './routes/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
import { Route as AdminCustomerIdUpdateRouteImport } from './routes/admin/customer/$id.update'
import { Route as AdminCustomerIdDetailRouteImport } from './routes/admin/customer/$id.detail'
import { Route as AdminConsignmentStockoutIdUpdateRouteImport } from './routes/admin/consignment-stockout/$id/update'
import { Route as AdminConsignmentStockoutIdPrintRouteImport } from './routes/admin/consignment-stockout/$id/print'
import { Route as AdminConsignmentStockoutIdDetailRouteImport } from './routes/admin/consignment-stockout/$id/detail'
import { Route as AdminConsignmentStockinIdUpdateRouteImport } from './routes/admin/consignment-stockin/$id/update'
import { Route as AdminConsignmentStockinIdPrintRouteImport } from './routes/admin/consignment-stockin/$id/print'
import { Route as AdminConsignmentStockinIdDetailRouteImport } from './routes/admin/consignment-stockin/$id/detail'
import { Route as AdminConsignmentStockinRequestIdPrintRouteImport } from './routes/admin/consignment-stockin-request/$id/print'
import { Route as AdminConsignmentStockinRequestIdDetailRouteImport } from './routes/admin/consignment-stockin-request/$id/detail'
import { Route as AdminConsignmentSettlementIdEmailPreviewRouteImport } from './routes/admin/consignment-settlement/$id/email-preview'
import { Route as AdminConsignmentSettlementIdEditItemsRouteImport } from './routes/admin/consignment-settlement/$id/edit-items'
import { Route as AdminConsignmentSettlementIdEditRouteImport } from './routes/admin/consignment-settlement/$id/edit'
import { Route as AdminConsignmentSettlementIdDetailRouteImport } from './routes/admin/consignment-settlement/$id/detail'
import { Route as AdminConsignmentRequestIdDetailRouteImport } from './routes/admin/consignment-request/$id.detail'
import { Route as AdminConsignmentProductRequestIdDetailRouteImport } from './routes/admin/consignment-product-request/$id/detail'
import { Route as AdminBranchIdUpdateRouteImport } from './routes/admin/branch/$id.update'
import { Route as AdminBranchIdDetailRouteImport } from './routes/admin/branch/$id.detail'
import { Route as AdminBranchSalesChannelIdOperatingHoursRouteImport } from './routes/admin/branch-sales-channel/$id/operating-hours'
import { Route as AdminBranchSalesChannelIdDetailRouteImport } from './routes/admin/branch-sales-channel/$id/detail'
import { Route as AdminBranchQrisMerchantIdUpdateRouteImport } from './routes/admin/branch-qris-merchant/$id.update'
import { Route as AdminBranchQrisMerchantIdDetailRouteImport } from './routes/admin/branch-qris-merchant/$id.detail'
import { Route as AdminBranchCategoryIdUpdateRouteImport } from './routes/admin/branch-category/$id.update'
import { Route as AdminBranchCategoryIdDetailRouteImport } from './routes/admin/branch-category/$id.detail'
import { Route as AdminBillOfMaterialIdUpdateRouteImport } from './routes/admin/bill-of-material/$id/update'
import { Route as AdminBillOfMaterialIdDetailRouteImport } from './routes/admin/bill-of-material/$id/detail'
import { Route as AdminBankAccountIdUpdateRouteImport } from './routes/admin/bank-account/$id/update'
import { Route as AdminBankAccountIdDetailRouteImport } from './routes/admin/bank-account/$id/detail'
import { Route as AdminAccessUserCreateRouteImport } from './routes/admin/access/user/create'
import { Route as AdminAccessRoleCreateRouteImport } from './routes/admin/access/role/create'
import { Route as AdminAccessResourceCreateRouteImport } from './routes/admin/access/resource/create'
import { Route as AdminAccessPermissionCreateRouteImport } from './routes/admin/access/permission/create'
import { Route as AdminAccessAppCreateRouteImport } from './routes/admin/access/app/create'
import { Route as AdminRevenueSharingIdDetailIndexRouteImport } from './routes/admin/revenue-sharing/$id/detail/index'
import { Route as AdminRevenueSharingIdDetailDetailIdRouteImport } from './routes/admin/revenue-sharing/$id/detail/$detailId'
import { Route as AdminReceivingTransferOrderIdUpdateRouteImport } from './routes/admin/receiving/transfer-order/$id/update'
import { Route as AdminReceivingTransferOrderIdDetailRouteImport } from './routes/admin/receiving/transfer-order/$id/detail'
import { Route as AdminReceivingSimpleTransferOrderIdUpdateRouteImport } from './routes/admin/receiving/simple-transfer-order/$id/update'
import { Route as AdminReceivingSimpleTransferOrderIdPrintRouteImport } from './routes/admin/receiving/simple-transfer-order/$id/print'
import { Route as AdminReceivingSimpleTransferOrderIdDetailRouteImport } from './routes/admin/receiving/simple-transfer-order/$id/detail'
import { Route as AdminPricelistPeriodIdUpdateRouteImport } from './routes/admin/pricelist/period/$id/update'
import { Route as AdminPricelistPeriodIdDetailRouteImport } from './routes/admin/pricelist/period/$id/detail'
import { Route as AdminPettyCashRefundIdUpdateRouteImport } from './routes/admin/petty-cash/refund/$id/update'
import { Route as AdminPettyCashRefundIdDetailRouteImport } from './routes/admin/petty-cash/refund/$id/detail'
import { Route as AdminPettyCashExpenseIdUpdateRouteImport } from './routes/admin/petty-cash/expense/$id/update'
import { Route as AdminPettyCashExpenseIdDetailRouteImport } from './routes/admin/petty-cash/expense/$id/detail'
import { Route as AdminPettyCashAddFundIdUpdateRouteImport } from './routes/admin/petty-cash/add-fund/$id/update'
import { Route as AdminPettyCashAddFundIdDetailRouteImport } from './routes/admin/petty-cash/add-fund/$id/detail'
import { Route as AdminGeolocationVillageIdUpdateRouteImport } from './routes/admin/geolocation/village/$id.update'
import { Route as AdminGeolocationVillageIdDetailRouteImport } from './routes/admin/geolocation/village/$id.detail'
import { Route as AdminGeolocationSubdistrictIdUpdateRouteImport } from './routes/admin/geolocation/subdistrict/$id.update'
import { Route as AdminGeolocationSubdistrictIdDetailRouteImport } from './routes/admin/geolocation/subdistrict/$id.detail'
import { Route as AdminGeolocationProvinceIdUpdateRouteImport } from './routes/admin/geolocation/province/$id.update'
import { Route as AdminGeolocationProvinceIdDetailRouteImport } from './routes/admin/geolocation/province/$id.detail'
import { Route as AdminGeolocationCountryIdUpdateRouteImport } from './routes/admin/geolocation/country/$id.update'
import { Route as AdminGeolocationCountryIdDetailRouteImport } from './routes/admin/geolocation/country/$id.detail'
import { Route as AdminGeolocationCityIdUpdateRouteImport } from './routes/admin/geolocation/city/$id.update'
import { Route as AdminGeolocationCityIdDetailRouteImport } from './routes/admin/geolocation/city/$id.detail'
import { Route as AdminConsignmentRegistrationsIdDetailRouteImport } from './routes/admin/consignment/registrations/$id/detail'
import { Route as AdminBackgroundJobTransactionIdDetailRouteImport } from './routes/admin/background-job/transaction/$id.detail'
import { Route as AdminAccessUserIdUpdateRouteImport } from './routes/admin/access/user/$id.update'
import { Route as AdminAccessRoleIdUpdateRouteImport } from './routes/admin/access/role/$id.update'
import { Route as AdminAccessResourceIdUpdateRouteImport } from './routes/admin/access/resource/$id.update'
import { Route as AdminAccessPermissionIdUpdateRouteImport } from './routes/admin/access/permission/$id.update'
import { Route as AdminAccessAppIdUpdateRouteImport } from './routes/admin/access/app/$id.update'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRouteRoute = VendorRouteRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorIndexRoute = VendorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorLoginRoute = VendorLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorDashboardRoute = VendorDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => VendorRouteRoute,
} as any)
const AdminSalesDashboardRoute = AdminSalesDashboardRouteImport.update({
  id: '/sales-dashboard',
  path: '/sales-dashboard',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRouteRoute,
} as any)
const VendorTransferIndexRoute = VendorTransferIndexRouteImport.update({
  id: '/transfer/',
  path: '/transfer/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockIndexRoute = VendorStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSalesIndexRoute = VendorSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorRentalIndexRoute = VendorRentalIndexRouteImport.update({
  id: '/rental/',
  path: '/rental/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const AdminWarehouseIndexRoute = AdminWarehouseIndexRouteImport.update({
  id: '/warehouse/',
  path: '/warehouse/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWarehouseLocationGroupIndexRoute =
  AdminWarehouseLocationGroupIndexRouteImport.update({
    id: '/warehouse-location-group/',
    path: '/warehouse-location-group/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVoucherIndexRoute = AdminVoucherIndexRouteImport.update({
  id: '/voucher/',
  path: '/voucher/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVoucherCategoryIndexRoute =
  AdminVoucherCategoryIndexRouteImport.update({
    id: '/voucher-category/',
    path: '/voucher-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorIndexRoute = AdminVendorIndexRouteImport.update({
  id: '/vendor/',
  path: '/vendor/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVendorRentalApprovalIndexRoute =
  AdminVendorRentalApprovalIndexRouteImport.update({
    id: '/vendor-rental-approval/',
    path: '/vendor-rental-approval/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorConsignmentRentalPeriodIndexRoute =
  AdminVendorConsignmentRentalPeriodIndexRouteImport.update({
    id: '/vendor-consignment-rental-period/',
    path: '/vendor-consignment-rental-period/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorCategoryIndexRoute =
  AdminVendorCategoryIndexRouteImport.update({
    id: '/vendor-category/',
    path: '/vendor-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminUserShiftIndexRoute = AdminUserShiftIndexRouteImport.update({
  id: '/user-shift/',
  path: '/user-shift/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUomCategoryIndexRoute = AdminUomCategoryIndexRouteImport.update({
  id: '/uom-category/',
  path: '/uom-category/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTransferRequestIndexRoute =
  AdminTransferRequestIndexRouteImport.update({
    id: '/transfer-request/',
    path: '/transfer-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderIndexRoute = AdminTransferOrderIndexRouteImport.update({
  id: '/transfer-order/',
  path: '/transfer-order/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTaxIndexRoute = AdminTaxIndexRouteImport.update({
  id: '/tax/',
  path: '/tax/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSupplierIndexRoute = AdminSupplierIndexRouteImport.update({
  id: '/supplier/',
  path: '/supplier/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSimpleTransferOrderIndexRoute =
  AdminSimpleTransferOrderIndexRouteImport.update({
    id: '/simple-transfer-order/',
    path: '/simple-transfer-order/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesInvoiceIndexRoute = AdminSalesInvoiceIndexRouteImport.update({
  id: '/sales-invoice/',
  path: '/sales-invoice/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSalesInvoiceReviewIndexRoute =
  AdminSalesInvoiceReviewIndexRouteImport.update({
    id: '/sales-invoice-review/',
    path: '/sales-invoice-review/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelIndexRoute = AdminSalesChannelIndexRouteImport.update({
  id: '/sales-channel/',
  path: '/sales-channel/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSalesChannelStockThresholdIndexRoute =
  AdminSalesChannelStockThresholdIndexRouteImport.update({
    id: '/sales-channel-stock-threshold/',
    path: '/sales-channel-stock-threshold/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryMappingIndexRoute =
  AdminSalesChannelCategoryMappingIndexRouteImport.update({
    id: '/sales-channel-category-mapping/',
    path: '/sales-channel-category-mapping/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryGroupIndexRoute =
  AdminSalesChannelCategoryGroupIndexRouteImport.update({
    id: '/sales-channel-category-group/',
    path: '/sales-channel-category-group/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCampaignIndexRoute =
  AdminSalesChannelCampaignIndexRouteImport.update({
    id: '/sales-channel-campaign/',
    path: '/sales-channel-campaign/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueSharingIndexRoute =
  AdminRevenueSharingIndexRouteImport.update({
    id: '/revenue-sharing/',
    path: '/revenue-sharing/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportIndexRoute = AdminRevenueReportIndexRouteImport.update({
  id: '/revenue-report/',
  path: '/revenue-report/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRevenueReportTemplateIndexRoute =
  AdminRevenueReportTemplateIndexRouteImport.update({
    id: '/revenue-report-template/',
    path: '/revenue-report-template/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportPartnerIndexRoute =
  AdminRevenueReportPartnerIndexRouteImport.update({
    id: '/revenue-report-partner/',
    path: '/revenue-report-partner/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportPartnerBranchIndexRoute =
  AdminRevenueReportPartnerBranchIndexRouteImport.update({
    id: '/revenue-report-partner-branch/',
    path: '/revenue-report-partner-branch/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportAccessLogIndexRoute =
  AdminRevenueReportAccessLogIndexRouteImport.update({
    id: '/revenue-report-access-log/',
    path: '/revenue-report-access-log/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentIndexRoute = AdminReplenishmentIndexRouteImport.update({
  id: '/replenishment/',
  path: '/replenishment/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReplenishmentTemplateIndexRoute =
  AdminReplenishmentTemplateIndexRouteImport.update({
    id: '/replenishment-template/',
    path: '/replenishment-template/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateCategoryIndexRoute =
  AdminReplenishmentTemplateCategoryIndexRouteImport.update({
    id: '/replenishment-template-category/',
    path: '/replenishment-template-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReconOutstandingIndexRoute =
  AdminReconOutstandingIndexRouteImport.update({
    id: '/recon-outstanding/',
    path: '/recon-outstanding/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReconBankIndexRoute = AdminReconBankIndexRouteImport.update({
  id: '/recon-bank/',
  path: '/recon-bank/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReconBankUploadIndexRoute =
  AdminReconBankUploadIndexRouteImport.update({
    id: '/recon-bank-upload/',
    path: '/recon-bank-upload/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingIndexRoute = AdminReceivingIndexRouteImport.update({
  id: '/receiving/',
  path: '/receiving/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPutawayTaskIndexRoute = AdminPutawayTaskIndexRouteImport.update({
  id: '/putaway-task/',
  path: '/putaway-task/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPurchaseOrderIndexRoute = AdminPurchaseOrderIndexRouteImport.update({
  id: '/purchase-order/',
  path: '/purchase-order/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPurchaseAreaIndexRoute = AdminPurchaseAreaIndexRouteImport.update({
  id: '/purchase-area/',
  path: '/purchase-area/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPromoIndexRoute = AdminPromoIndexRouteImport.update({
  id: '/promo/',
  path: '/promo/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductionIndexRoute = AdminProductionIndexRouteImport.update({
  id: '/production/',
  path: '/production/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductIndexRoute = AdminProductIndexRouteImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductTagIndexRoute = AdminProductTagIndexRouteImport.update({
  id: '/product-tag/',
  path: '/product-tag/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductSubDepartmentIndexRoute =
  AdminProductSubDepartmentIndexRouteImport.update({
    id: '/product-sub-department/',
    path: '/product-sub-department/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductSubCategoryIndexRoute =
  AdminProductSubCategoryIndexRouteImport.update({
    id: '/product-sub-category/',
    path: '/product-sub-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDivisionIndexRoute =
  AdminProductDivisionIndexRouteImport.update({
    id: '/product-division/',
    path: '/product-division/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDepartmentIndexRoute =
  AdminProductDepartmentIndexRouteImport.update({
    id: '/product-department/',
    path: '/product-department/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductCategoryIndexRoute =
  AdminProductCategoryIndexRouteImport.update({
    id: '/product-category/',
    path: '/product-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductBrandIndexRoute = AdminProductBrandIndexRouteImport.update({
  id: '/product-brand/',
  path: '/product-brand/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductAvailabilityTemplateIndexRoute =
  AdminProductAvailabilityTemplateIndexRouteImport.update({
    id: '/product-availability-template/',
    path: '/product-availability-template/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonIndexRoute = AdminProductAddonIndexRouteImport.update({
  id: '/product-addon/',
  path: '/product-addon/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductAddonGroupIndexRoute =
  AdminProductAddonGroupIndexRouteImport.update({
    id: '/product-addon-group/',
    path: '/product-addon-group/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAccountingCategoryIndexRoute =
  AdminProductAccountingCategoryIndexRouteImport.update({
    id: '/product-accounting-category/',
    path: '/product-accounting-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPrintNonConsignmentIndexRoute =
  AdminPrintNonConsignmentIndexRouteImport.update({
    id: '/print-non-consignment/',
    path: '/print-non-consignment/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPrintConsignmentIndexRoute =
  AdminPrintConsignmentIndexRouteImport.update({
    id: '/print-consignment/',
    path: '/print-consignment/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPricelistIndexRoute = AdminPricelistIndexRouteImport.update({
  id: '/pricelist/',
  path: '/pricelist/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosterIndexRoute = AdminPosterIndexRouteImport.update({
  id: '/poster/',
  path: '/poster/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosBookmarkIndexRoute = AdminPosBookmarkIndexRouteImport.update({
  id: '/pos-bookmark/',
  path: '/pos-bookmark/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPickingTaskIndexRoute = AdminPickingTaskIndexRouteImport.update({
  id: '/picking-task/',
  path: '/picking-task/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPettyCashIndexRoute = AdminPettyCashIndexRouteImport.update({
  id: '/petty-cash/',
  path: '/petty-cash/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPendingSyncSalesOrderIndexRoute =
  AdminPendingSyncSalesOrderIndexRouteImport.update({
    id: '/pending-sync-sales-order/',
    path: '/pending-sync-sales-order/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPendingSyncMarketplaceOrderIndexRoute =
  AdminPendingSyncMarketplaceOrderIndexRouteImport.update({
    id: '/pending-sync-marketplace-order/',
    path: '/pending-sync-marketplace-order/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentWebhookEventIndexRoute =
  AdminPaymentWebhookEventIndexRouteImport.update({
    id: '/payment-webhook-event/',
    path: '/payment-webhook-event/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentTransactionIndexRoute =
  AdminPaymentTransactionIndexRouteImport.update({
    id: '/payment-transaction/',
    path: '/payment-transaction/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentProviderConfigIndexRoute =
  AdminPaymentProviderConfigIndexRouteImport.update({
    id: '/payment-provider-config/',
    path: '/payment-provider-config/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentMethodIndexRoute = AdminPaymentMethodIndexRouteImport.update({
  id: '/payment-method/',
  path: '/payment-method/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPaymentInboundRequestIndexRoute =
  AdminPaymentInboundRequestIndexRouteImport.update({
    id: '/payment-inbound-request/',
    path: '/payment-inbound-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPackingTaskIndexRoute = AdminPackingTaskIndexRouteImport.update({
  id: '/packing-task/',
  path: '/packing-task/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOutboundContainerIndexRoute =
  AdminOutboundContainerIndexRouteImport.update({
    id: '/outbound-container/',
    path: '/outbound-container/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMemberTypeIndexRoute = AdminMemberTypeIndexRouteImport.update({
  id: '/member-type/',
  path: '/member-type/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMarketplaceOrderIndexRoute =
  AdminMarketplaceOrderIndexRouteImport.update({
    id: '/marketplace-order/',
    path: '/marketplace-order/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMarketplaceChannelLogIndexRoute =
  AdminMarketplaceChannelLogIndexRouteImport.update({
    id: '/marketplace-channel-log/',
    path: '/marketplace-channel-log/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMarketplaceAutomationIndexRoute =
  AdminMarketplaceAutomationIndexRouteImport.update({
    id: '/marketplace-automation/',
    path: '/marketplace-automation/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryTransactionIndexRoute =
  AdminInventoryTransactionIndexRouteImport.update({
    id: '/inventory-transaction/',
    path: '/inventory-transaction/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryTransactionLineUnitIndexRoute =
  AdminInventoryTransactionLineUnitIndexRouteImport.update({
    id: '/inventory-transaction-line-unit/',
    path: '/inventory-transaction-line-unit/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventorySummaryIndexRoute =
  AdminInventorySummaryIndexRouteImport.update({
    id: '/inventory-summary/',
    path: '/inventory-summary/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryMovementSummaryIndexRoute =
  AdminInventoryMovementSummaryIndexRouteImport.update({
    id: '/inventory-movement-summary/',
    path: '/inventory-movement-summary/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryLocationIndexRoute =
  AdminInventoryLocationIndexRouteImport.update({
    id: '/inventory-location/',
    path: '/inventory-location/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountIndexRoute =
  AdminInventoryCountIndexRouteImport.update({
    id: '/inventory-count/',
    path: '/inventory-count/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountTemplateItemIndexRoute =
  AdminInventoryCountTemplateItemIndexRouteImport.update({
    id: '/inventory-count-template-item/',
    path: '/inventory-count-template-item/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountMonitoringIndexRoute =
  AdminInventoryCountMonitoringIndexRouteImport.update({
    id: '/inventory-count-monitoring/',
    path: '/inventory-count-monitoring/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentIndexRoute =
  AdminInventoryAdjustmentIndexRouteImport.update({
    id: '/inventory-adjustment/',
    path: '/inventory-adjustment/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentReasonIndexRoute =
  AdminInventoryAdjustmentReasonIndexRouteImport.update({
    id: '/inventory-adjustment-reason/',
    path: '/inventory-adjustment-reason/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInternalTransferIndexRoute =
  AdminInternalTransferIndexRouteImport.update({
    id: '/internal-transfer/',
    path: '/internal-transfer/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminIncomingTransferRequestIndexRoute =
  AdminIncomingTransferRequestIndexRouteImport.update({
    id: '/incoming-transfer-request/',
    path: '/incoming-transfer-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminExpenseItemIndexRoute = AdminExpenseItemIndexRouteImport.update({
  id: '/expense-item/',
  path: '/expense-item/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminExampleIndexRoute = AdminExampleIndexRouteImport.update({
  id: '/example/',
  path: '/example/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEdcTerminalIndexRoute = AdminEdcTerminalIndexRouteImport.update({
  id: '/edc-terminal/',
  path: '/edc-terminal/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDeliveryOrderIndexRoute = AdminDeliveryOrderIndexRouteImport.update({
  id: '/delivery-order/',
  path: '/delivery-order/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDeliveryOrderBatchIndexRoute =
  AdminDeliveryOrderBatchIndexRouteImport.update({
    id: '/delivery-order-batch/',
    path: '/delivery-order-batch/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomerIndexRoute = AdminCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConsignmentVendorRegistrationIndexRoute =
  AdminConsignmentVendorRegistrationIndexRouteImport.update({
    id: '/consignment-vendor-registration/',
    path: '/consignment-vendor-registration/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentVendorApplicationInviteIndexRoute =
  AdminConsignmentVendorApplicationInviteIndexRouteImport.update({
    id: '/consignment-vendor-application-invite/',
    path: '/consignment-vendor-application-invite/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockoutIndexRoute =
  AdminConsignmentStockoutIndexRouteImport.update({
    id: '/consignment-stockout/',
    path: '/consignment-stockout/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinIndexRoute =
  AdminConsignmentStockinIndexRouteImport.update({
    id: '/consignment-stockin/',
    path: '/consignment-stockin/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinRequestIndexRoute =
  AdminConsignmentStockinRequestIndexRouteImport.update({
    id: '/consignment-stockin-request/',
    path: '/consignment-stockin-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementIndexRoute =
  AdminConsignmentSettlementIndexRouteImport.update({
    id: '/consignment-settlement/',
    path: '/consignment-settlement/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettingIndexRoute =
  AdminConsignmentSettingIndexRouteImport.update({
    id: '/consignment-setting/',
    path: '/consignment-setting/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentRequestIndexRoute =
  AdminConsignmentRequestIndexRouteImport.update({
    id: '/consignment-request/',
    path: '/consignment-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentRegionIndexRoute =
  AdminConsignmentRegionIndexRouteImport.update({
    id: '/consignment-region/',
    path: '/consignment-region/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentProductRequestIndexRoute =
  AdminConsignmentProductRequestIndexRouteImport.update({
    id: '/consignment-product-request/',
    path: '/consignment-product-request/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentCurationIndexRoute =
  AdminConsignmentCurationIndexRouteImport.update({
    id: '/consignment-curation/',
    path: '/consignment-curation/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentConfigIndexRoute =
  AdminConsignmentConfigIndexRouteImport.update({
    id: '/consignment-config/',
    path: '/consignment-config/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentBranchSettingIndexRoute =
  AdminConsignmentBranchSettingIndexRouteImport.update({
    id: '/consignment-branch-setting/',
    path: '/consignment-branch-setting/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentAdminTeamIndexRoute =
  AdminConsignmentAdminTeamIndexRouteImport.update({
    id: '/consignment-admin-team/',
    path: '/consignment-admin-team/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchIndexRoute = AdminBranchIndexRouteImport.update({
  id: '/branch/',
  path: '/branch/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchSalesChannelIndexRoute =
  AdminBranchSalesChannelIndexRouteImport.update({
    id: '/branch-sales-channel/',
    path: '/branch-sales-channel/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchQrisMerchantIndexRoute =
  AdminBranchQrisMerchantIndexRouteImport.update({
    id: '/branch-qris-merchant/',
    path: '/branch-qris-merchant/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchCategoryIndexRoute =
  AdminBranchCategoryIndexRouteImport.update({
    id: '/branch-category/',
    path: '/branch-category/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchBankAccountIndexRoute =
  AdminBranchBankAccountIndexRouteImport.update({
    id: '/branch-bank-account/',
    path: '/branch-bank-account/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBillOfMaterialIndexRoute =
  AdminBillOfMaterialIndexRouteImport.update({
    id: '/bill-of-material/',
    path: '/bill-of-material/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBankIndexRoute = AdminBankIndexRouteImport.update({
  id: '/bank/',
  path: '/bank/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBankAccountIndexRoute = AdminBankAccountIndexRouteImport.update({
  id: '/bank-account/',
  path: '/bank-account/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const VendorSalesSalesConsignmentInvoiceIDRoute =
  VendorSalesSalesConsignmentInvoiceIDRouteImport.update({
    id: '/sales/$salesConsignmentInvoiceID',
    path: '/sales/$salesConsignmentInvoiceID',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalNewRoute = VendorRentalNewRouteImport.update({
  id: '/rental/new',
  path: '/rental/new',
  getParentRoute: () => VendorRouteRoute,
} as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/auth/reset-password/$token',
  path: '/auth/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWarehouseLocationGroupCreateRoute =
  AdminWarehouseLocationGroupCreateRouteImport.update({
    id: '/warehouse-location-group/create',
    path: '/warehouse-location-group/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVoucherCreateRoute = AdminVoucherCreateRouteImport.update({
  id: '/voucher/create',
  path: '/voucher/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVoucherCategoryCreateRoute =
  AdminVoucherCategoryCreateRouteImport.update({
    id: '/voucher-category/create',
    path: '/voucher-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorCreateRoute = AdminVendorCreateRouteImport.update({
  id: '/vendor/create',
  path: '/vendor/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVendorCategoryCreateRoute =
  AdminVendorCategoryCreateRouteImport.update({
    id: '/vendor-category/create',
    path: '/vendor-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminUomCategoryCreateRoute = AdminUomCategoryCreateRouteImport.update({
  id: '/uom-category/create',
  path: '/uom-category/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTransferRequestImportRoute =
  AdminTransferRequestImportRouteImport.update({
    id: '/transfer-request/import',
    path: '/transfer-request/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferRequestCreateRoute =
  AdminTransferRequestCreateRouteImport.update({
    id: '/transfer-request/create',
    path: '/transfer-request/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderImportRoute =
  AdminTransferOrderImportRouteImport.update({
    id: '/transfer-order/import',
    path: '/transfer-order/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderCreateRoute =
  AdminTransferOrderCreateRouteImport.update({
    id: '/transfer-order/create',
    path: '/transfer-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTaxCreateRoute = AdminTaxCreateRouteImport.update({
  id: '/tax/create',
  path: '/tax/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSupplierCreateRoute = AdminSupplierCreateRouteImport.update({
  id: '/supplier/create',
  path: '/supplier/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSimpleTransferOrderCreateRoute =
  AdminSimpleTransferOrderCreateRouteImport.update({
    id: '/simple-transfer-order/create',
    path: '/simple-transfer-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCreateRoute = AdminSalesChannelCreateRouteImport.update({
  id: '/sales-channel/create',
  path: '/sales-channel/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSalesChannelCategoryMappingImportRoute =
  AdminSalesChannelCategoryMappingImportRouteImport.update({
    id: '/sales-channel-category-mapping/import',
    path: '/sales-channel-category-mapping/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryMappingCreateRoute =
  AdminSalesChannelCategoryMappingCreateRouteImport.update({
    id: '/sales-channel-category-mapping/create',
    path: '/sales-channel-category-mapping/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryGroupCreateRoute =
  AdminSalesChannelCategoryGroupCreateRouteImport.update({
    id: '/sales-channel-category-group/create',
    path: '/sales-channel-category-group/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCampaignRulesRoute =
  AdminSalesChannelCampaignRulesRouteImport.update({
    id: '/sales-channel-campaign/rules',
    path: '/sales-channel-campaign/rules',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCampaignCreateRoute =
  AdminSalesChannelCampaignCreateRouteImport.update({
    id: '/sales-channel-campaign/create',
    path: '/sales-channel-campaign/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateCreateRoute =
  AdminReplenishmentTemplateCreateRouteImport.update({
    id: '/replenishment-template/create',
    path: '/replenishment-template/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateCategoryCreateRoute =
  AdminReplenishmentTemplateCategoryCreateRouteImport.update({
    id: '/replenishment-template-category/create',
    path: '/replenishment-template-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReconBankUploadRoute = AdminReconBankUploadRouteImport.update({
  id: '/recon-bank/upload',
  path: '/recon-bank/upload',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReconBankUploadAddRoute = AdminReconBankUploadAddRouteImport.update({
  id: '/recon-bank-upload/add',
  path: '/recon-bank-upload/add',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReceivingCreateRoute = AdminReceivingCreateRouteImport.update({
  id: '/receiving/create',
  path: '/receiving/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPurchaseOrderImportRoute =
  AdminPurchaseOrderImportRouteImport.update({
    id: '/purchase-order/import',
    path: '/purchase-order/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseOrderCreateRoute =
  AdminPurchaseOrderCreateRouteImport.update({
    id: '/purchase-order/create',
    path: '/purchase-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseAreaCreateRoute = AdminPurchaseAreaCreateRouteImport.update({
  id: '/purchase-area/create',
  path: '/purchase-area/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPromoImportRoute = AdminPromoImportRouteImport.update({
  id: '/promo/import',
  path: '/promo/import',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPromoCreateRoute = AdminPromoCreateRouteImport.update({
  id: '/promo/create',
  path: '/promo/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductionCreateRoute = AdminProductionCreateRouteImport.update({
  id: '/production/create',
  path: '/production/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductImportRoute = AdminProductImportRouteImport.update({
  id: '/product/import',
  path: '/product/import',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductCreateRoute = AdminProductCreateRouteImport.update({
  id: '/product/create',
  path: '/product/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductTagCreateRoute = AdminProductTagCreateRouteImport.update({
  id: '/product-tag/create',
  path: '/product-tag/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductSubDepartmentCreateRoute =
  AdminProductSubDepartmentCreateRouteImport.update({
    id: '/product-sub-department/create',
    path: '/product-sub-department/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductSubCategoryCreateRoute =
  AdminProductSubCategoryCreateRouteImport.update({
    id: '/product-sub-category/create',
    path: '/product-sub-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDivisionCreateRoute =
  AdminProductDivisionCreateRouteImport.update({
    id: '/product-division/create',
    path: '/product-division/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDepartmentCreateRoute =
  AdminProductDepartmentCreateRouteImport.update({
    id: '/product-department/create',
    path: '/product-department/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductCategoryCreateRoute =
  AdminProductCategoryCreateRouteImport.update({
    id: '/product-category/create',
    path: '/product-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductBrandCreateRoute = AdminProductBrandCreateRouteImport.update({
  id: '/product-brand/create',
  path: '/product-brand/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductAvailabilityTemplateCreateRoute =
  AdminProductAvailabilityTemplateCreateRouteImport.update({
    id: '/product-availability-template/create',
    path: '/product-availability-template/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonCreateRoute = AdminProductAddonCreateRouteImport.update({
  id: '/product-addon/create',
  path: '/product-addon/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductAddonGroupCreateRoute =
  AdminProductAddonGroupCreateRouteImport.update({
    id: '/product-addon-group/create',
    path: '/product-addon-group/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAccountingCategoryCreateRoute =
  AdminProductAccountingCategoryCreateRouteImport.update({
    id: '/product-accounting-category/create',
    path: '/product-accounting-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPrintLabelSmallRoute = AdminPrintLabelSmallRouteImport.update({
  id: '/print-label/small',
  path: '/print-label/small',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPrintLabelLargeRoute = AdminPrintLabelLargeRouteImport.update({
  id: '/print-label/large',
  path: '/print-label/large',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPricelistCreateRoute = AdminPricelistCreateRouteImport.update({
  id: '/pricelist/create',
  path: '/pricelist/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosterCreateRoute = AdminPosterCreateRouteImport.update({
  id: '/poster/create',
  path: '/poster/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosBookmarkCreateRoute = AdminPosBookmarkCreateRouteImport.update({
  id: '/pos-bookmark/create',
  path: '/pos-bookmark/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPaymentMethodCreateRoute =
  AdminPaymentMethodCreateRouteImport.update({
    id: '/payment-method/create',
    path: '/payment-method/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminOutboundContainerScanRoute =
  AdminOutboundContainerScanRouteImport.update({
    id: '/outbound-container/scan',
    path: '/outbound-container/scan',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMemberTypeCreateRoute = AdminMemberTypeCreateRouteImport.update({
  id: '/member-type/create',
  path: '/member-type/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMarketplaceAutomationJobKeyRoute =
  AdminMarketplaceAutomationJobKeyRouteImport.update({
    id: '/marketplace-automation/$jobKey',
    path: '/marketplace-automation/$jobKey',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountCreateRoute =
  AdminInventoryCountCreateRouteImport.update({
    id: '/inventory-count/create',
    path: '/inventory-count/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountTemplateItemCreateRoute =
  AdminInventoryCountTemplateItemCreateRouteImport.update({
    id: '/inventory-count-template-item/create',
    path: '/inventory-count-template-item/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentCreateRoute =
  AdminInventoryAdjustmentCreateRouteImport.update({
    id: '/inventory-adjustment/create',
    path: '/inventory-adjustment/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentReasonCreateRoute =
  AdminInventoryAdjustmentReasonCreateRouteImport.update({
    id: '/inventory-adjustment-reason/create',
    path: '/inventory-adjustment-reason/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInternalTransferCreateRoute =
  AdminInternalTransferCreateRouteImport.update({
    id: '/internal-transfer/create',
    path: '/internal-transfer/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminImportTemplateTypeRoute = AdminImportTemplateTypeRouteImport.update({
  id: '/import/$templateType',
  path: '/import/$templateType',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminExpenseItemCreateRoute = AdminExpenseItemCreateRouteImport.update({
  id: '/expense-item/create',
  path: '/expense-item/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminExampleSeePermissionsRoute =
  AdminExampleSeePermissionsRouteImport.update({
    id: '/example/see-permissions',
    path: '/example/see-permissions',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminEdcTerminalCreateRoute = AdminEdcTerminalCreateRouteImport.update({
  id: '/edc-terminal/create',
  path: '/edc-terminal/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDeliveryOrderCreateRoute =
  AdminDeliveryOrderCreateRouteImport.update({
    id: '/delivery-order/create',
    path: '/delivery-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderBatchCreateRoute =
  AdminDeliveryOrderBatchCreateRouteImport.update({
    id: '/delivery-order-batch/create',
    path: '/delivery-order-batch/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomerCreateRoute = AdminCustomerCreateRouteImport.update({
  id: '/customer/create',
  path: '/customer/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConsignmentVendorRegistrationIdRoute =
  AdminConsignmentVendorRegistrationIdRouteImport.update({
    id: '/consignment-vendor-registration/$id',
    path: '/consignment-vendor-registration/$id',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockoutCreateRoute =
  AdminConsignmentStockoutCreateRouteImport.update({
    id: '/consignment-stockout/create',
    path: '/consignment-stockout/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinCreateRoute =
  AdminConsignmentStockinCreateRouteImport.update({
    id: '/consignment-stockin/create',
    path: '/consignment-stockin/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementCreateRoute =
  AdminConsignmentSettlementCreateRouteImport.update({
    id: '/consignment-settlement/create',
    path: '/consignment-settlement/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentConfigCreateRoute =
  AdminConsignmentConfigCreateRouteImport.update({
    id: '/consignment-config/create',
    path: '/consignment-config/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchCreateRoute = AdminBranchCreateRouteImport.update({
  id: '/branch/create',
  path: '/branch/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchQrisMerchantCreateRoute =
  AdminBranchQrisMerchantCreateRouteImport.update({
    id: '/branch-qris-merchant/create',
    path: '/branch-qris-merchant/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchCategoryCreateRoute =
  AdminBranchCategoryCreateRouteImport.update({
    id: '/branch-category/create',
    path: '/branch-category/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBillOfMaterialCreateRoute =
  AdminBillOfMaterialCreateRouteImport.update({
    id: '/bill-of-material/create',
    path: '/bill-of-material/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBankAccountCreateRoute = AdminBankAccountCreateRouteImport.update({
  id: '/bank-account/create',
  path: '/bank-account/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const VendorStockProductIDIndexRoute =
  VendorStockProductIDIndexRouteImport.update({
    id: '/stock/$productID/',
    path: '/stock/$productID/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDIndexRoute =
  VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/',
    path: '/rental/$vendorConsignmentRentalPaymentID/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const AdminPricelistPeriodIndexRoute =
  AdminPricelistPeriodIndexRouteImport.update({
    id: '/pricelist/period/',
    path: '/pricelist/period/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationVillageIndexRoute =
  AdminGeolocationVillageIndexRouteImport.update({
    id: '/geolocation/village/',
    path: '/geolocation/village/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationSubdistrictIndexRoute =
  AdminGeolocationSubdistrictIndexRouteImport.update({
    id: '/geolocation/subdistrict/',
    path: '/geolocation/subdistrict/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationProvinceIndexRoute =
  AdminGeolocationProvinceIndexRouteImport.update({
    id: '/geolocation/province/',
    path: '/geolocation/province/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCountryIndexRoute =
  AdminGeolocationCountryIndexRouteImport.update({
    id: '/geolocation/country/',
    path: '/geolocation/country/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCityIndexRoute =
  AdminGeolocationCityIndexRouteImport.update({
    id: '/geolocation/city/',
    path: '/geolocation/city/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute =
  AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRouteImport.update({
    id: '/delivery-order-batch/$deliveryOrderBatchID/',
    path: '/delivery-order-batch/$deliveryOrderBatchID/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStoresTeamsIndexRoute =
  AdminConsignmentStoresTeamsIndexRouteImport.update({
    id: '/consignment/stores-teams/',
    path: '/consignment/stores-teams/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentRequestsIndexRoute =
  AdminConsignmentRequestsIndexRouteImport.update({
    id: '/consignment/requests/',
    path: '/consignment/requests/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentOnboardingIndexRoute =
  AdminConsignmentOnboardingIndexRouteImport.update({
    id: '/consignment/onboarding/',
    path: '/consignment/onboarding/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBackgroundJobTransactionIndexRoute =
  AdminBackgroundJobTransactionIndexRouteImport.update({
    id: '/background-job/transaction/',
    path: '/background-job/transaction/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessUserIndexRoute = AdminAccessUserIndexRouteImport.update({
  id: '/access/user/',
  path: '/access/user/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessRoleIndexRoute = AdminAccessRoleIndexRouteImport.update({
  id: '/access/role/',
  path: '/access/role/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessResourceIndexRoute =
  AdminAccessResourceIndexRouteImport.update({
    id: '/access/resource/',
    path: '/access/resource/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessPermissionIndexRoute =
  AdminAccessPermissionIndexRouteImport.update({
    id: '/access/permission/',
    path: '/access/permission/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessAppIndexRoute = AdminAccessAppIndexRouteImport.update({
  id: '/access/app/',
  path: '/access/app/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const VendorTransferTypeIdRoute = VendorTransferTypeIdRouteImport.update({
  id: '/transfer/$type/$id',
  path: '/transfer/$type/$id',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockProductIDInventoryRoute =
  VendorStockProductIDInventoryRouteImport.update({
    id: '/stock/$productID/inventory',
    path: '/stock/$productID/inventory',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDPrintRoute =
  VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/print',
    path: '/rental/$vendorConsignmentRentalPaymentID/print',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDEditRoute =
  VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/edit',
    path: '/rental/$vendorConsignmentRentalPaymentID/edit',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorAuthResetPasswordTokenRoute =
  VendorAuthResetPasswordTokenRouteImport.update({
    id: '/auth/reset-password/$token',
    path: '/auth/reset-password/$token',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const AdminWarehouseIdDetailRoute = AdminWarehouseIdDetailRouteImport.update({
  id: '/warehouse/$id/detail',
  path: '/warehouse/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWarehouseLocationGroupIdUpdateRoute =
  AdminWarehouseLocationGroupIdUpdateRouteImport.update({
    id: '/warehouse-location-group/$id/update',
    path: '/warehouse-location-group/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminWarehouseLocationGroupIdDetailRoute =
  AdminWarehouseLocationGroupIdDetailRouteImport.update({
    id: '/warehouse-location-group/$id/detail',
    path: '/warehouse-location-group/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVoucherIdUpdateRoute = AdminVoucherIdUpdateRouteImport.update({
  id: '/voucher/$id/update',
  path: '/voucher/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVoucherIdDetailRoute = AdminVoucherIdDetailRouteImport.update({
  id: '/voucher/$id/detail',
  path: '/voucher/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVoucherCategoryIdUpdateRoute =
  AdminVoucherCategoryIdUpdateRouteImport.update({
    id: '/voucher-category/$id/update',
    path: '/voucher-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVoucherCategoryIdDetailRoute =
  AdminVoucherCategoryIdDetailRouteImport.update({
    id: '/voucher-category/$id/detail',
    path: '/voucher-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorIdUpdateRoute = AdminVendorIdUpdateRouteImport.update({
  id: '/vendor/$id/update',
  path: '/vendor/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVendorIdDetailRoute = AdminVendorIdDetailRouteImport.update({
  id: '/vendor/$id/detail',
  path: '/vendor/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVendorRentalApprovalIdPrintRoute =
  AdminVendorRentalApprovalIdPrintRouteImport.update({
    id: '/vendor-rental-approval/$id/print',
    path: '/vendor-rental-approval/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorRentalApprovalIdDetailRoute =
  AdminVendorRentalApprovalIdDetailRouteImport.update({
    id: '/vendor-rental-approval/$id/detail',
    path: '/vendor-rental-approval/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorCategoryIdUpdateRoute =
  AdminVendorCategoryIdUpdateRouteImport.update({
    id: '/vendor-category/$id/update',
    path: '/vendor-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminVendorCategoryIdDetailRoute =
  AdminVendorCategoryIdDetailRouteImport.update({
    id: '/vendor-category/$id/detail',
    path: '/vendor-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminUserShiftIdDetailRoute = AdminUserShiftIdDetailRouteImport.update({
  id: '/user-shift/$id/detail',
  path: '/user-shift/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUomCategoryIdUpdateRoute =
  AdminUomCategoryIdUpdateRouteImport.update({
    id: '/uom-category/$id/update',
    path: '/uom-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminUomCategoryIdDetailRoute =
  AdminUomCategoryIdDetailRouteImport.update({
    id: '/uom-category/$id/detail',
    path: '/uom-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferRequestIdUpdateRoute =
  AdminTransferRequestIdUpdateRouteImport.update({
    id: '/transfer-request/$id/update',
    path: '/transfer-request/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferRequestIdDetailRoute =
  AdminTransferRequestIdDetailRouteImport.update({
    id: '/transfer-request/$id/detail',
    path: '/transfer-request/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderIdUpdateRoute =
  AdminTransferOrderIdUpdateRouteImport.update({
    id: '/transfer-order/$id/update',
    path: '/transfer-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderIdPrintRoute =
  AdminTransferOrderIdPrintRouteImport.update({
    id: '/transfer-order/$id/print',
    path: '/transfer-order/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderIdDetailRoute =
  AdminTransferOrderIdDetailRouteImport.update({
    id: '/transfer-order/$id/detail',
    path: '/transfer-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTransferOrderIdCreateRoute =
  AdminTransferOrderIdCreateRouteImport.update({
    id: '/transfer-order/$id/create',
    path: '/transfer-order/$id/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTaxIdUpdateRoute = AdminTaxIdUpdateRouteImport.update({
  id: '/tax/$id/update',
  path: '/tax/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTaxIdDetailRoute = AdminTaxIdDetailRouteImport.update({
  id: '/tax/$id/detail',
  path: '/tax/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSupplierIdUpdateRoute = AdminSupplierIdUpdateRouteImport.update({
  id: '/supplier/$id/update',
  path: '/supplier/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSupplierIdDetailRoute = AdminSupplierIdDetailRouteImport.update({
  id: '/supplier/$id/detail',
  path: '/supplier/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSimpleTransferOrderIdUpdateRoute =
  AdminSimpleTransferOrderIdUpdateRouteImport.update({
    id: '/simple-transfer-order/$id/update',
    path: '/simple-transfer-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSimpleTransferOrderIdPrintRoute =
  AdminSimpleTransferOrderIdPrintRouteImport.update({
    id: '/simple-transfer-order/$id/print',
    path: '/simple-transfer-order/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSimpleTransferOrderIdDetailRoute =
  AdminSimpleTransferOrderIdDetailRouteImport.update({
    id: '/simple-transfer-order/$id/detail',
    path: '/simple-transfer-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesInvoiceIdDetailRoute =
  AdminSalesInvoiceIdDetailRouteImport.update({
    id: '/sales-invoice/$id/detail',
    path: '/sales-invoice/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesInvoiceReviewIdDetailRoute =
  AdminSalesInvoiceReviewIdDetailRouteImport.update({
    id: '/sales-invoice-review/$id/detail',
    path: '/sales-invoice-review/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelIdUpdateRoute =
  AdminSalesChannelIdUpdateRouteImport.update({
    id: '/sales-channel/$id/update',
    path: '/sales-channel/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelIdDetailRoute =
  AdminSalesChannelIdDetailRouteImport.update({
    id: '/sales-channel/$id/detail',
    path: '/sales-channel/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryMappingIdUpdateRoute =
  AdminSalesChannelCategoryMappingIdUpdateRouteImport.update({
    id: '/sales-channel-category-mapping/$id/update',
    path: '/sales-channel-category-mapping/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryMappingIdDetailRoute =
  AdminSalesChannelCategoryMappingIdDetailRouteImport.update({
    id: '/sales-channel-category-mapping/$id/detail',
    path: '/sales-channel-category-mapping/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryGroupIdUpdateRoute =
  AdminSalesChannelCategoryGroupIdUpdateRouteImport.update({
    id: '/sales-channel-category-group/$id/update',
    path: '/sales-channel-category-group/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCategoryGroupIdDetailRoute =
  AdminSalesChannelCategoryGroupIdDetailRouteImport.update({
    id: '/sales-channel-category-group/$id/detail',
    path: '/sales-channel-category-group/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCampaignIdUpdateRoute =
  AdminSalesChannelCampaignIdUpdateRouteImport.update({
    id: '/sales-channel-campaign/$id/update',
    path: '/sales-channel-campaign/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSalesChannelCampaignIdDetailRoute =
  AdminSalesChannelCampaignIdDetailRouteImport.update({
    id: '/sales-channel-campaign/$id/detail',
    path: '/sales-channel-campaign/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportIdDetailRoute =
  AdminRevenueReportIdDetailRouteImport.update({
    id: '/revenue-report/$id/detail',
    path: '/revenue-report/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportTemplateIdDetailRoute =
  AdminRevenueReportTemplateIdDetailRouteImport.update({
    id: '/revenue-report-template/$id/detail',
    path: '/revenue-report-template/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportPartnerIdDetailRoute =
  AdminRevenueReportPartnerIdDetailRouteImport.update({
    id: '/revenue-report-partner/$id/detail',
    path: '/revenue-report-partner/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueReportPartnerBranchIdDetailRoute =
  AdminRevenueReportPartnerBranchIdDetailRouteImport.update({
    id: '/revenue-report-partner-branch/$id/detail',
    path: '/revenue-report-partner-branch/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentIdDetailRoute =
  AdminReplenishmentIdDetailRouteImport.update({
    id: '/replenishment/$id/detail',
    path: '/replenishment/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateIdUpdateRoute =
  AdminReplenishmentTemplateIdUpdateRouteImport.update({
    id: '/replenishment-template/$id/update',
    path: '/replenishment-template/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateIdImportRoute =
  AdminReplenishmentTemplateIdImportRouteImport.update({
    id: '/replenishment-template/$id/import',
    path: '/replenishment-template/$id/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateIdDetailRoute =
  AdminReplenishmentTemplateIdDetailRouteImport.update({
    id: '/replenishment-template/$id/detail',
    path: '/replenishment-template/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateCategoryIdUpdateRoute =
  AdminReplenishmentTemplateCategoryIdUpdateRouteImport.update({
    id: '/replenishment-template-category/$id/update',
    path: '/replenishment-template-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReplenishmentTemplateCategoryIdDetailRoute =
  AdminReplenishmentTemplateCategoryIdDetailRouteImport.update({
    id: '/replenishment-template-category/$id/detail',
    path: '/replenishment-template-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReconBankIdUploadRoute = AdminReconBankIdUploadRouteImport.update({
  id: '/recon-bank/$id/upload',
  path: '/recon-bank/$id/upload',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReconBankIdProcessRoute = AdminReconBankIdProcessRouteImport.update({
  id: '/recon-bank/$id/process',
  path: '/recon-bank/$id/process',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReconBankIdDetailRoute = AdminReconBankIdDetailRouteImport.update({
  id: '/recon-bank/$id/detail',
  path: '/recon-bank/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReconBankUploadIdDetailRoute =
  AdminReconBankUploadIdDetailRouteImport.update({
    id: '/recon-bank-upload/$id/detail',
    path: '/recon-bank-upload/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingTransferOrderCreateRoute =
  AdminReceivingTransferOrderCreateRouteImport.update({
    id: '/receiving/transfer-order/create',
    path: '/receiving/transfer-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingSimpleTransferOrderCreateRoute =
  AdminReceivingSimpleTransferOrderCreateRouteImport.update({
    id: '/receiving/simple-transfer-order/create',
    path: '/receiving/simple-transfer-order/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingIdUpdateRoute = AdminReceivingIdUpdateRouteImport.update({
  id: '/receiving/$id/update',
  path: '/receiving/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReceivingIdPrintRoute = AdminReceivingIdPrintRouteImport.update({
  id: '/receiving/$id/print',
  path: '/receiving/$id/print',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReceivingIdDetailRoute = AdminReceivingIdDetailRouteImport.update({
  id: '/receiving/$id/detail',
  path: '/receiving/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReceivingIdCreateRoute = AdminReceivingIdCreateRouteImport.update({
  id: '/receiving/$id/create',
  path: '/receiving/$id/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPutawayTaskIdDetailRoute =
  AdminPutawayTaskIdDetailRouteImport.update({
    id: '/putaway-task/$id/detail',
    path: '/putaway-task/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseOrderIdUpdateRoute =
  AdminPurchaseOrderIdUpdateRouteImport.update({
    id: '/purchase-order/$id/update',
    path: '/purchase-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseOrderIdReviseRoute =
  AdminPurchaseOrderIdReviseRouteImport.update({
    id: '/purchase-order/$id/revise',
    path: '/purchase-order/$id/revise',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseOrderIdPrintRoute =
  AdminPurchaseOrderIdPrintRouteImport.update({
    id: '/purchase-order/$id/print',
    path: '/purchase-order/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseOrderIdDetailRoute =
  AdminPurchaseOrderIdDetailRouteImport.update({
    id: '/purchase-order/$id/detail',
    path: '/purchase-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseAreaIdUpdateRoute =
  AdminPurchaseAreaIdUpdateRouteImport.update({
    id: '/purchase-area/$id/update',
    path: '/purchase-area/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPurchaseAreaIdDetailRoute =
  AdminPurchaseAreaIdDetailRouteImport.update({
    id: '/purchase-area/$id/detail',
    path: '/purchase-area/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPromoIdUpdateRoute = AdminPromoIdUpdateRouteImport.update({
  id: '/promo/$id/update',
  path: '/promo/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPromoIdImportRoute = AdminPromoIdImportRouteImport.update({
  id: '/promo/$id/import',
  path: '/promo/$id/import',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPromoIdDetailRoute = AdminPromoIdDetailRouteImport.update({
  id: '/promo/$id/detail',
  path: '/promo/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductionIdUpdateRoute = AdminProductionIdUpdateRouteImport.update({
  id: '/production/$id/update',
  path: '/production/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductionIdDetailRoute = AdminProductionIdDetailRouteImport.update({
  id: '/production/$id/detail',
  path: '/production/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductIdUpdateRoute = AdminProductIdUpdateRouteImport.update({
  id: '/product/$id/update',
  path: '/product/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductIdDetailRoute = AdminProductIdDetailRouteImport.update({
  id: '/product/$id/detail',
  path: '/product/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductTagIdUpdateRoute = AdminProductTagIdUpdateRouteImport.update({
  id: '/product-tag/$id/update',
  path: '/product-tag/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductTagIdDetailRoute = AdminProductTagIdDetailRouteImport.update({
  id: '/product-tag/$id/detail',
  path: '/product-tag/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductSubDepartmentIdUpdateRoute =
  AdminProductSubDepartmentIdUpdateRouteImport.update({
    id: '/product-sub-department/$id/update',
    path: '/product-sub-department/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductSubDepartmentIdDetailRoute =
  AdminProductSubDepartmentIdDetailRouteImport.update({
    id: '/product-sub-department/$id/detail',
    path: '/product-sub-department/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductSubCategoryIdUpdateRoute =
  AdminProductSubCategoryIdUpdateRouteImport.update({
    id: '/product-sub-category/$id/update',
    path: '/product-sub-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductSubCategoryIdDetailRoute =
  AdminProductSubCategoryIdDetailRouteImport.update({
    id: '/product-sub-category/$id/detail',
    path: '/product-sub-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDivisionIdUpdateRoute =
  AdminProductDivisionIdUpdateRouteImport.update({
    id: '/product-division/$id/update',
    path: '/product-division/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDivisionIdDetailRoute =
  AdminProductDivisionIdDetailRouteImport.update({
    id: '/product-division/$id/detail',
    path: '/product-division/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDepartmentIdUpdateRoute =
  AdminProductDepartmentIdUpdateRouteImport.update({
    id: '/product-department/$id/update',
    path: '/product-department/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductDepartmentIdDetailRoute =
  AdminProductDepartmentIdDetailRouteImport.update({
    id: '/product-department/$id/detail',
    path: '/product-department/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductCategoryIdUpdateRoute =
  AdminProductCategoryIdUpdateRouteImport.update({
    id: '/product-category/$id/update',
    path: '/product-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductCategoryIdDetailRoute =
  AdminProductCategoryIdDetailRouteImport.update({
    id: '/product-category/$id/detail',
    path: '/product-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductBrandIdUpdateRoute =
  AdminProductBrandIdUpdateRouteImport.update({
    id: '/product-brand/$id/update',
    path: '/product-brand/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductBrandIdDetailRoute =
  AdminProductBrandIdDetailRouteImport.update({
    id: '/product-brand/$id/detail',
    path: '/product-brand/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAvailabilityTemplateIdUpdateRoute =
  AdminProductAvailabilityTemplateIdUpdateRouteImport.update({
    id: '/product-availability-template/$id/update',
    path: '/product-availability-template/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAvailabilityTemplateIdImportRoute =
  AdminProductAvailabilityTemplateIdImportRouteImport.update({
    id: '/product-availability-template/$id/import',
    path: '/product-availability-template/$id/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAvailabilityTemplateIdDetailRoute =
  AdminProductAvailabilityTemplateIdDetailRouteImport.update({
    id: '/product-availability-template/$id/detail',
    path: '/product-availability-template/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonIdUpdateRoute =
  AdminProductAddonIdUpdateRouteImport.update({
    id: '/product-addon/$id/update',
    path: '/product-addon/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonIdDetailRoute =
  AdminProductAddonIdDetailRouteImport.update({
    id: '/product-addon/$id/detail',
    path: '/product-addon/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonGroupIdUpdateRoute =
  AdminProductAddonGroupIdUpdateRouteImport.update({
    id: '/product-addon-group/$id/update',
    path: '/product-addon-group/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAddonGroupIdDetailRoute =
  AdminProductAddonGroupIdDetailRouteImport.update({
    id: '/product-addon-group/$id/detail',
    path: '/product-addon-group/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAccountingCategoryIdUpdateRoute =
  AdminProductAccountingCategoryIdUpdateRouteImport.update({
    id: '/product-accounting-category/$id/update',
    path: '/product-accounting-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminProductAccountingCategoryIdDetailRoute =
  AdminProductAccountingCategoryIdDetailRouteImport.update({
    id: '/product-accounting-category/$id/detail',
    path: '/product-accounting-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPricelistPeriodCreateRoute =
  AdminPricelistPeriodCreateRouteImport.update({
    id: '/pricelist/period/create',
    path: '/pricelist/period/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPricelistIdUpdateRoute = AdminPricelistIdUpdateRouteImport.update({
  id: '/pricelist/$id/update',
  path: '/pricelist/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPricelistIdImportRoute = AdminPricelistIdImportRouteImport.update({
  id: '/pricelist/$id/import',
  path: '/pricelist/$id/import',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPricelistIdDetailRoute = AdminPricelistIdDetailRouteImport.update({
  id: '/pricelist/$id/detail',
  path: '/pricelist/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosterIdUpdateRoute = AdminPosterIdUpdateRouteImport.update({
  id: '/poster/$id/update',
  path: '/poster/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosterIdDetailRoute = AdminPosterIdDetailRouteImport.update({
  id: '/poster/$id/detail',
  path: '/poster/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPosBookmarkIdUpdateRoute =
  AdminPosBookmarkIdUpdateRouteImport.update({
    id: '/pos-bookmark/$id/update',
    path: '/pos-bookmark/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPosBookmarkIdDetailRoute =
  AdminPosBookmarkIdDetailRouteImport.update({
    id: '/pos-bookmark/$id/detail',
    path: '/pos-bookmark/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPickingTaskIdDetailRoute =
  AdminPickingTaskIdDetailRouteImport.update({
    id: '/picking-task/$id/detail',
    path: '/picking-task/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPickingTaskIdCreateLocationGroupRoute =
  AdminPickingTaskIdCreateLocationGroupRouteImport.update({
    id: '/picking-task/$id/create-location-group',
    path: '/picking-task/$id/create-location-group',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashRefundCreateRoute =
  AdminPettyCashRefundCreateRouteImport.update({
    id: '/petty-cash/refund/create',
    path: '/petty-cash/refund/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashExpenseCreateRoute =
  AdminPettyCashExpenseCreateRouteImport.update({
    id: '/petty-cash/expense/create',
    path: '/petty-cash/expense/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashAddFundCreateRoute =
  AdminPettyCashAddFundCreateRouteImport.update({
    id: '/petty-cash/add-fund/create',
    path: '/petty-cash/add-fund/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashIdPrintRoute = AdminPettyCashIdPrintRouteImport.update({
  id: '/petty-cash/$id/print',
  path: '/petty-cash/$id/print',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPettyCashIdDetailRoute = AdminPettyCashIdDetailRouteImport.update({
  id: '/petty-cash/$id/detail',
  path: '/petty-cash/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPaymentTransactionIdDetailRoute =
  AdminPaymentTransactionIdDetailRouteImport.update({
    id: '/payment-transaction/$id/detail',
    path: '/payment-transaction/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentProviderConfigIdUpdateRoute =
  AdminPaymentProviderConfigIdUpdateRouteImport.update({
    id: '/payment-provider-config/$id/update',
    path: '/payment-provider-config/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentMethodIdUpdateRoute =
  AdminPaymentMethodIdUpdateRouteImport.update({
    id: '/payment-method/$id/update',
    path: '/payment-method/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPaymentMethodIdDetailRoute =
  AdminPaymentMethodIdDetailRouteImport.update({
    id: '/payment-method/$id/detail',
    path: '/payment-method/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPackingTaskIdVerifyRoute =
  AdminPackingTaskIdVerifyRouteImport.update({
    id: '/packing-task/$id/verify',
    path: '/packing-task/$id/verify',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPackingTaskIdProcessRoute =
  AdminPackingTaskIdProcessRouteImport.update({
    id: '/packing-task/$id/process',
    path: '/packing-task/$id/process',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPackingTaskIdDetailRoute =
  AdminPackingTaskIdDetailRouteImport.update({
    id: '/packing-task/$id/detail',
    path: '/packing-task/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminOutboundContainerIdDetailRoute =
  AdminOutboundContainerIdDetailRouteImport.update({
    id: '/outbound-container/$id/detail',
    path: '/outbound-container/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMemberTypeIdUpdateRoute = AdminMemberTypeIdUpdateRouteImport.update({
  id: '/member-type/$id/update',
  path: '/member-type/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMemberTypeIdDetailRoute = AdminMemberTypeIdDetailRouteImport.update({
  id: '/member-type/$id/detail',
  path: '/member-type/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMarketplaceOrderIdDetailRoute =
  AdminMarketplaceOrderIdDetailRouteImport.update({
    id: '/marketplace-order/$id/detail',
    path: '/marketplace-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMarketplaceChannelLogIdDetailRoute =
  AdminMarketplaceChannelLogIdDetailRouteImport.update({
    id: '/marketplace-channel-log/$id/detail',
    path: '/marketplace-channel-log/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryTransactionIdDetailRoute =
  AdminInventoryTransactionIdDetailRouteImport.update({
    id: '/inventory-transaction/$id/detail',
    path: '/inventory-transaction/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountIdUpdateRoute =
  AdminInventoryCountIdUpdateRouteImport.update({
    id: '/inventory-count/$id/update',
    path: '/inventory-count/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountIdRecountRoute =
  AdminInventoryCountIdRecountRouteImport.update({
    id: '/inventory-count/$id/recount',
    path: '/inventory-count/$id/recount',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountIdPrintRoute =
  AdminInventoryCountIdPrintRouteImport.update({
    id: '/inventory-count/$id/print',
    path: '/inventory-count/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountIdDetailRoute =
  AdminInventoryCountIdDetailRouteImport.update({
    id: '/inventory-count/$id/detail',
    path: '/inventory-count/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountTemplateItemIdUpdateRoute =
  AdminInventoryCountTemplateItemIdUpdateRouteImport.update({
    id: '/inventory-count-template-item/$id/update',
    path: '/inventory-count-template-item/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountTemplateItemIdImportRoute =
  AdminInventoryCountTemplateItemIdImportRouteImport.update({
    id: '/inventory-count-template-item/$id/import',
    path: '/inventory-count-template-item/$id/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryCountTemplateItemIdDetailRoute =
  AdminInventoryCountTemplateItemIdDetailRouteImport.update({
    id: '/inventory-count-template-item/$id/detail',
    path: '/inventory-count-template-item/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentOpeningBalanceImportRoute =
  AdminInventoryAdjustmentOpeningBalanceImportRouteImport.update({
    id: '/inventory-adjustment/opening-balance/import',
    path: '/inventory-adjustment/opening-balance/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentCostAdjustmentImportRoute =
  AdminInventoryAdjustmentCostAdjustmentImportRouteImport.update({
    id: '/inventory-adjustment/cost-adjustment/import',
    path: '/inventory-adjustment/cost-adjustment/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentIdUpdateRoute =
  AdminInventoryAdjustmentIdUpdateRouteImport.update({
    id: '/inventory-adjustment/$id/update',
    path: '/inventory-adjustment/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentIdPrintRoute =
  AdminInventoryAdjustmentIdPrintRouteImport.update({
    id: '/inventory-adjustment/$id/print',
    path: '/inventory-adjustment/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentIdDetailRoute =
  AdminInventoryAdjustmentIdDetailRouteImport.update({
    id: '/inventory-adjustment/$id/detail',
    path: '/inventory-adjustment/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentReasonIdUpdateRoute =
  AdminInventoryAdjustmentReasonIdUpdateRouteImport.update({
    id: '/inventory-adjustment-reason/$id/update',
    path: '/inventory-adjustment-reason/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInventoryAdjustmentReasonIdDetailRoute =
  AdminInventoryAdjustmentReasonIdDetailRouteImport.update({
    id: '/inventory-adjustment-reason/$id/detail',
    path: '/inventory-adjustment-reason/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInternalTransferIdUpdateRoute =
  AdminInternalTransferIdUpdateRouteImport.update({
    id: '/internal-transfer/$id/update',
    path: '/internal-transfer/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInternalTransferIdPrintRoute =
  AdminInternalTransferIdPrintRouteImport.update({
    id: '/internal-transfer/$id/print',
    path: '/internal-transfer/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminInternalTransferIdDetailRoute =
  AdminInternalTransferIdDetailRouteImport.update({
    id: '/internal-transfer/$id/detail',
    path: '/internal-transfer/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminIncomingTransferRequestIdUpdateRoute =
  AdminIncomingTransferRequestIdUpdateRouteImport.update({
    id: '/incoming-transfer-request/$id/update',
    path: '/incoming-transfer-request/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminIncomingTransferRequestIdDetailRoute =
  AdminIncomingTransferRequestIdDetailRouteImport.update({
    id: '/incoming-transfer-request/$id/detail',
    path: '/incoming-transfer-request/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationVillageCreateRoute =
  AdminGeolocationVillageCreateRouteImport.update({
    id: '/geolocation/village/create',
    path: '/geolocation/village/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationSubdistrictCreateRoute =
  AdminGeolocationSubdistrictCreateRouteImport.update({
    id: '/geolocation/subdistrict/create',
    path: '/geolocation/subdistrict/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationProvinceCreateRoute =
  AdminGeolocationProvinceCreateRouteImport.update({
    id: '/geolocation/province/create',
    path: '/geolocation/province/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCountryCreateRoute =
  AdminGeolocationCountryCreateRouteImport.update({
    id: '/geolocation/country/create',
    path: '/geolocation/country/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCityCreateRoute =
  AdminGeolocationCityCreateRouteImport.update({
    id: '/geolocation/city/create',
    path: '/geolocation/city/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminExpenseItemIdUpdateRoute =
  AdminExpenseItemIdUpdateRouteImport.update({
    id: '/expense-item/$id/update',
    path: '/expense-item/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminExpenseItemIdDetailRoute =
  AdminExpenseItemIdDetailRouteImport.update({
    id: '/expense-item/$id/detail',
    path: '/expense-item/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminEdcTerminalIdUpdateRoute =
  AdminEdcTerminalIdUpdateRouteImport.update({
    id: '/edc-terminal/$id/update',
    path: '/edc-terminal/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminEdcTerminalIdDetailRoute =
  AdminEdcTerminalIdDetailRouteImport.update({
    id: '/edc-terminal/$id/detail',
    path: '/edc-terminal/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderIdUpdateRoute =
  AdminDeliveryOrderIdUpdateRouteImport.update({
    id: '/delivery-order/$id/update',
    path: '/delivery-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderIdPrintRoute =
  AdminDeliveryOrderIdPrintRouteImport.update({
    id: '/delivery-order/$id/print',
    path: '/delivery-order/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderIdDetailRoute =
  AdminDeliveryOrderIdDetailRouteImport.update({
    id: '/delivery-order/$id/detail',
    path: '/delivery-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute =
  AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRouteImport.update({
    id: '/delivery-order-batch/$deliveryOrderBatchID/stpb',
    path: '/delivery-order-batch/$deliveryOrderBatchID/stpb',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute =
  AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRouteImport.update({
    id: '/delivery-order-batch/$deliveryOrderBatchID/result',
    path: '/delivery-order-batch/$deliveryOrderBatchID/result',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute =
  AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRouteImport.update(
    {
      id: '/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders',
      path: '/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders',
      getParentRoute: () => AdminRouteRoute,
    } as any,
  )
const AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute =
  AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRouteImport.update({
    id: '/delivery-order-batch/$deliveryOrderBatchID/left-containers',
    path: '/delivery-order-batch/$deliveryOrderBatchID/left-containers',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomerIdUpdateRoute = AdminCustomerIdUpdateRouteImport.update({
  id: '/customer/$id/update',
  path: '/customer/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCustomerIdDetailRoute = AdminCustomerIdDetailRouteImport.update({
  id: '/customer/$id/detail',
  path: '/customer/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConsignmentStockoutIdUpdateRoute =
  AdminConsignmentStockoutIdUpdateRouteImport.update({
    id: '/consignment-stockout/$id/update',
    path: '/consignment-stockout/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockoutIdPrintRoute =
  AdminConsignmentStockoutIdPrintRouteImport.update({
    id: '/consignment-stockout/$id/print',
    path: '/consignment-stockout/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockoutIdDetailRoute =
  AdminConsignmentStockoutIdDetailRouteImport.update({
    id: '/consignment-stockout/$id/detail',
    path: '/consignment-stockout/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinIdUpdateRoute =
  AdminConsignmentStockinIdUpdateRouteImport.update({
    id: '/consignment-stockin/$id/update',
    path: '/consignment-stockin/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinIdPrintRoute =
  AdminConsignmentStockinIdPrintRouteImport.update({
    id: '/consignment-stockin/$id/print',
    path: '/consignment-stockin/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinIdDetailRoute =
  AdminConsignmentStockinIdDetailRouteImport.update({
    id: '/consignment-stockin/$id/detail',
    path: '/consignment-stockin/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinRequestIdPrintRoute =
  AdminConsignmentStockinRequestIdPrintRouteImport.update({
    id: '/consignment-stockin-request/$id/print',
    path: '/consignment-stockin-request/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentStockinRequestIdDetailRoute =
  AdminConsignmentStockinRequestIdDetailRouteImport.update({
    id: '/consignment-stockin-request/$id/detail',
    path: '/consignment-stockin-request/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementIdEmailPreviewRoute =
  AdminConsignmentSettlementIdEmailPreviewRouteImport.update({
    id: '/consignment-settlement/$id/email-preview',
    path: '/consignment-settlement/$id/email-preview',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementIdEditItemsRoute =
  AdminConsignmentSettlementIdEditItemsRouteImport.update({
    id: '/consignment-settlement/$id/edit-items',
    path: '/consignment-settlement/$id/edit-items',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementIdEditRoute =
  AdminConsignmentSettlementIdEditRouteImport.update({
    id: '/consignment-settlement/$id/edit',
    path: '/consignment-settlement/$id/edit',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentSettlementIdDetailRoute =
  AdminConsignmentSettlementIdDetailRouteImport.update({
    id: '/consignment-settlement/$id/detail',
    path: '/consignment-settlement/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentRequestIdDetailRoute =
  AdminConsignmentRequestIdDetailRouteImport.update({
    id: '/consignment-request/$id/detail',
    path: '/consignment-request/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentProductRequestIdDetailRoute =
  AdminConsignmentProductRequestIdDetailRouteImport.update({
    id: '/consignment-product-request/$id/detail',
    path: '/consignment-product-request/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchIdUpdateRoute = AdminBranchIdUpdateRouteImport.update({
  id: '/branch/$id/update',
  path: '/branch/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchIdDetailRoute = AdminBranchIdDetailRouteImport.update({
  id: '/branch/$id/detail',
  path: '/branch/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchSalesChannelIdOperatingHoursRoute =
  AdminBranchSalesChannelIdOperatingHoursRouteImport.update({
    id: '/branch-sales-channel/$id/operating-hours',
    path: '/branch-sales-channel/$id/operating-hours',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchSalesChannelIdDetailRoute =
  AdminBranchSalesChannelIdDetailRouteImport.update({
    id: '/branch-sales-channel/$id/detail',
    path: '/branch-sales-channel/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchQrisMerchantIdUpdateRoute =
  AdminBranchQrisMerchantIdUpdateRouteImport.update({
    id: '/branch-qris-merchant/$id/update',
    path: '/branch-qris-merchant/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchQrisMerchantIdDetailRoute =
  AdminBranchQrisMerchantIdDetailRouteImport.update({
    id: '/branch-qris-merchant/$id/detail',
    path: '/branch-qris-merchant/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchCategoryIdUpdateRoute =
  AdminBranchCategoryIdUpdateRouteImport.update({
    id: '/branch-category/$id/update',
    path: '/branch-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBranchCategoryIdDetailRoute =
  AdminBranchCategoryIdDetailRouteImport.update({
    id: '/branch-category/$id/detail',
    path: '/branch-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBillOfMaterialIdUpdateRoute =
  AdminBillOfMaterialIdUpdateRouteImport.update({
    id: '/bill-of-material/$id/update',
    path: '/bill-of-material/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBillOfMaterialIdDetailRoute =
  AdminBillOfMaterialIdDetailRouteImport.update({
    id: '/bill-of-material/$id/detail',
    path: '/bill-of-material/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBankAccountIdUpdateRoute =
  AdminBankAccountIdUpdateRouteImport.update({
    id: '/bank-account/$id/update',
    path: '/bank-account/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBankAccountIdDetailRoute =
  AdminBankAccountIdDetailRouteImport.update({
    id: '/bank-account/$id/detail',
    path: '/bank-account/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessUserCreateRoute = AdminAccessUserCreateRouteImport.update({
  id: '/access/user/create',
  path: '/access/user/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessRoleCreateRoute = AdminAccessRoleCreateRouteImport.update({
  id: '/access/role/create',
  path: '/access/role/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessResourceCreateRoute =
  AdminAccessResourceCreateRouteImport.update({
    id: '/access/resource/create',
    path: '/access/resource/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessPermissionCreateRoute =
  AdminAccessPermissionCreateRouteImport.update({
    id: '/access/permission/create',
    path: '/access/permission/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessAppCreateRoute = AdminAccessAppCreateRouteImport.update({
  id: '/access/app/create',
  path: '/access/app/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRevenueSharingIdDetailIndexRoute =
  AdminRevenueSharingIdDetailIndexRouteImport.update({
    id: '/revenue-sharing/$id/detail/',
    path: '/revenue-sharing/$id/detail/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRevenueSharingIdDetailDetailIdRoute =
  AdminRevenueSharingIdDetailDetailIdRouteImport.update({
    id: '/revenue-sharing/$id/detail/$detailId',
    path: '/revenue-sharing/$id/detail/$detailId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingTransferOrderIdUpdateRoute =
  AdminReceivingTransferOrderIdUpdateRouteImport.update({
    id: '/receiving/transfer-order/$id/update',
    path: '/receiving/transfer-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingTransferOrderIdDetailRoute =
  AdminReceivingTransferOrderIdDetailRouteImport.update({
    id: '/receiving/transfer-order/$id/detail',
    path: '/receiving/transfer-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingSimpleTransferOrderIdUpdateRoute =
  AdminReceivingSimpleTransferOrderIdUpdateRouteImport.update({
    id: '/receiving/simple-transfer-order/$id/update',
    path: '/receiving/simple-transfer-order/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingSimpleTransferOrderIdPrintRoute =
  AdminReceivingSimpleTransferOrderIdPrintRouteImport.update({
    id: '/receiving/simple-transfer-order/$id/print',
    path: '/receiving/simple-transfer-order/$id/print',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminReceivingSimpleTransferOrderIdDetailRoute =
  AdminReceivingSimpleTransferOrderIdDetailRouteImport.update({
    id: '/receiving/simple-transfer-order/$id/detail',
    path: '/receiving/simple-transfer-order/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPricelistPeriodIdUpdateRoute =
  AdminPricelistPeriodIdUpdateRouteImport.update({
    id: '/pricelist/period/$id/update',
    path: '/pricelist/period/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPricelistPeriodIdDetailRoute =
  AdminPricelistPeriodIdDetailRouteImport.update({
    id: '/pricelist/period/$id/detail',
    path: '/pricelist/period/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashRefundIdUpdateRoute =
  AdminPettyCashRefundIdUpdateRouteImport.update({
    id: '/petty-cash/refund/$id/update',
    path: '/petty-cash/refund/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashRefundIdDetailRoute =
  AdminPettyCashRefundIdDetailRouteImport.update({
    id: '/petty-cash/refund/$id/detail',
    path: '/petty-cash/refund/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashExpenseIdUpdateRoute =
  AdminPettyCashExpenseIdUpdateRouteImport.update({
    id: '/petty-cash/expense/$id/update',
    path: '/petty-cash/expense/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashExpenseIdDetailRoute =
  AdminPettyCashExpenseIdDetailRouteImport.update({
    id: '/petty-cash/expense/$id/detail',
    path: '/petty-cash/expense/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashAddFundIdUpdateRoute =
  AdminPettyCashAddFundIdUpdateRouteImport.update({
    id: '/petty-cash/add-fund/$id/update',
    path: '/petty-cash/add-fund/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPettyCashAddFundIdDetailRoute =
  AdminPettyCashAddFundIdDetailRouteImport.update({
    id: '/petty-cash/add-fund/$id/detail',
    path: '/petty-cash/add-fund/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationVillageIdUpdateRoute =
  AdminGeolocationVillageIdUpdateRouteImport.update({
    id: '/geolocation/village/$id/update',
    path: '/geolocation/village/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationVillageIdDetailRoute =
  AdminGeolocationVillageIdDetailRouteImport.update({
    id: '/geolocation/village/$id/detail',
    path: '/geolocation/village/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationSubdistrictIdUpdateRoute =
  AdminGeolocationSubdistrictIdUpdateRouteImport.update({
    id: '/geolocation/subdistrict/$id/update',
    path: '/geolocation/subdistrict/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationSubdistrictIdDetailRoute =
  AdminGeolocationSubdistrictIdDetailRouteImport.update({
    id: '/geolocation/subdistrict/$id/detail',
    path: '/geolocation/subdistrict/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationProvinceIdUpdateRoute =
  AdminGeolocationProvinceIdUpdateRouteImport.update({
    id: '/geolocation/province/$id/update',
    path: '/geolocation/province/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationProvinceIdDetailRoute =
  AdminGeolocationProvinceIdDetailRouteImport.update({
    id: '/geolocation/province/$id/detail',
    path: '/geolocation/province/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCountryIdUpdateRoute =
  AdminGeolocationCountryIdUpdateRouteImport.update({
    id: '/geolocation/country/$id/update',
    path: '/geolocation/country/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCountryIdDetailRoute =
  AdminGeolocationCountryIdDetailRouteImport.update({
    id: '/geolocation/country/$id/detail',
    path: '/geolocation/country/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCityIdUpdateRoute =
  AdminGeolocationCityIdUpdateRouteImport.update({
    id: '/geolocation/city/$id/update',
    path: '/geolocation/city/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminGeolocationCityIdDetailRoute =
  AdminGeolocationCityIdDetailRouteImport.update({
    id: '/geolocation/city/$id/detail',
    path: '/geolocation/city/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConsignmentRegistrationsIdDetailRoute =
  AdminConsignmentRegistrationsIdDetailRouteImport.update({
    id: '/consignment/registrations/$id/detail',
    path: '/consignment/registrations/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminBackgroundJobTransactionIdDetailRoute =
  AdminBackgroundJobTransactionIdDetailRouteImport.update({
    id: '/background-job/transaction/$id/detail',
    path: '/background-job/transaction/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessUserIdUpdateRoute = AdminAccessUserIdUpdateRouteImport.update({
  id: '/access/user/$id/update',
  path: '/access/user/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessRoleIdUpdateRoute = AdminAccessRoleIdUpdateRouteImport.update({
  id: '/access/role/$id/update',
  path: '/access/role/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessResourceIdUpdateRoute =
  AdminAccessResourceIdUpdateRouteImport.update({
    id: '/access/resource/$id/update',
    path: '/access/resource/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessPermissionIdUpdateRoute =
  AdminAccessPermissionIdUpdateRouteImport.update({
    id: '/access/permission/$id/update',
    path: '/access/permission/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAccessAppIdUpdateRoute = AdminAccessAppIdUpdateRouteImport.update({
  id: '/access/app/$id/update',
  path: '/access/app/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/sales-dashboard': typeof AdminSalesDashboardRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/': typeof VendorIndexRoute
  '/admin/bank-account/create': typeof AdminBankAccountCreateRoute
  '/admin/bill-of-material/create': typeof AdminBillOfMaterialCreateRoute
  '/admin/branch-category/create': typeof AdminBranchCategoryCreateRoute
  '/admin/branch-qris-merchant/create': typeof AdminBranchQrisMerchantCreateRoute
  '/admin/branch/create': typeof AdminBranchCreateRoute
  '/admin/consignment-config/create': typeof AdminConsignmentConfigCreateRoute
  '/admin/consignment-settlement/create': typeof AdminConsignmentSettlementCreateRoute
  '/admin/consignment-stockin/create': typeof AdminConsignmentStockinCreateRoute
  '/admin/consignment-stockout/create': typeof AdminConsignmentStockoutCreateRoute
  '/admin/consignment-vendor-registration/$id': typeof AdminConsignmentVendorRegistrationIdRoute
  '/admin/customer/create': typeof AdminCustomerCreateRoute
  '/admin/delivery-order-batch/create': typeof AdminDeliveryOrderBatchCreateRoute
  '/admin/delivery-order/create': typeof AdminDeliveryOrderCreateRoute
  '/admin/edc-terminal/create': typeof AdminEdcTerminalCreateRoute
  '/admin/example/see-permissions': typeof AdminExampleSeePermissionsRoute
  '/admin/expense-item/create': typeof AdminExpenseItemCreateRoute
  '/admin/import/$templateType': typeof AdminImportTemplateTypeRoute
  '/admin/internal-transfer/create': typeof AdminInternalTransferCreateRoute
  '/admin/inventory-adjustment-reason/create': typeof AdminInventoryAdjustmentReasonCreateRoute
  '/admin/inventory-adjustment/create': typeof AdminInventoryAdjustmentCreateRoute
  '/admin/inventory-count-template-item/create': typeof AdminInventoryCountTemplateItemCreateRoute
  '/admin/inventory-count/create': typeof AdminInventoryCountCreateRoute
  '/admin/marketplace-automation/$jobKey': typeof AdminMarketplaceAutomationJobKeyRoute
  '/admin/member-type/create': typeof AdminMemberTypeCreateRoute
  '/admin/outbound-container/scan': typeof AdminOutboundContainerScanRoute
  '/admin/payment-method/create': typeof AdminPaymentMethodCreateRoute
  '/admin/pos-bookmark/create': typeof AdminPosBookmarkCreateRoute
  '/admin/poster/create': typeof AdminPosterCreateRoute
  '/admin/pricelist/create': typeof AdminPricelistCreateRoute
  '/admin/print-label/large': typeof AdminPrintLabelLargeRoute
  '/admin/print-label/small': typeof AdminPrintLabelSmallRoute
  '/admin/product-accounting-category/create': typeof AdminProductAccountingCategoryCreateRoute
  '/admin/product-addon-group/create': typeof AdminProductAddonGroupCreateRoute
  '/admin/product-addon/create': typeof AdminProductAddonCreateRoute
  '/admin/product-availability-template/create': typeof AdminProductAvailabilityTemplateCreateRoute
  '/admin/product-brand/create': typeof AdminProductBrandCreateRoute
  '/admin/product-category/create': typeof AdminProductCategoryCreateRoute
  '/admin/product-department/create': typeof AdminProductDepartmentCreateRoute
  '/admin/product-division/create': typeof AdminProductDivisionCreateRoute
  '/admin/product-sub-category/create': typeof AdminProductSubCategoryCreateRoute
  '/admin/product-sub-department/create': typeof AdminProductSubDepartmentCreateRoute
  '/admin/product-tag/create': typeof AdminProductTagCreateRoute
  '/admin/product/create': typeof AdminProductCreateRoute
  '/admin/product/import': typeof AdminProductImportRoute
  '/admin/production/create': typeof AdminProductionCreateRoute
  '/admin/promo/create': typeof AdminPromoCreateRoute
  '/admin/promo/import': typeof AdminPromoImportRoute
  '/admin/purchase-area/create': typeof AdminPurchaseAreaCreateRoute
  '/admin/purchase-order/create': typeof AdminPurchaseOrderCreateRoute
  '/admin/purchase-order/import': typeof AdminPurchaseOrderImportRoute
  '/admin/receiving/create': typeof AdminReceivingCreateRoute
  '/admin/recon-bank-upload/add': typeof AdminReconBankUploadAddRoute
  '/admin/recon-bank/upload': typeof AdminReconBankUploadRoute
  '/admin/replenishment-template-category/create': typeof AdminReplenishmentTemplateCategoryCreateRoute
  '/admin/replenishment-template/create': typeof AdminReplenishmentTemplateCreateRoute
  '/admin/sales-channel-campaign/create': typeof AdminSalesChannelCampaignCreateRoute
  '/admin/sales-channel-campaign/rules': typeof AdminSalesChannelCampaignRulesRoute
  '/admin/sales-channel-category-group/create': typeof AdminSalesChannelCategoryGroupCreateRoute
  '/admin/sales-channel-category-mapping/create': typeof AdminSalesChannelCategoryMappingCreateRoute
  '/admin/sales-channel-category-mapping/import': typeof AdminSalesChannelCategoryMappingImportRoute
  '/admin/sales-channel/create': typeof AdminSalesChannelCreateRoute
  '/admin/simple-transfer-order/create': typeof AdminSimpleTransferOrderCreateRoute
  '/admin/supplier/create': typeof AdminSupplierCreateRoute
  '/admin/tax/create': typeof AdminTaxCreateRoute
  '/admin/transfer-order/create': typeof AdminTransferOrderCreateRoute
  '/admin/transfer-order/import': typeof AdminTransferOrderImportRoute
  '/admin/transfer-request/create': typeof AdminTransferRequestCreateRoute
  '/admin/transfer-request/import': typeof AdminTransferRequestImportRoute
  '/admin/uom-category/create': typeof AdminUomCategoryCreateRoute
  '/admin/vendor-category/create': typeof AdminVendorCategoryCreateRoute
  '/admin/vendor/create': typeof AdminVendorCreateRoute
  '/admin/voucher-category/create': typeof AdminVoucherCategoryCreateRoute
  '/admin/voucher/create': typeof AdminVoucherCreateRoute
  '/admin/warehouse-location-group/create': typeof AdminWarehouseLocationGroupCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/admin/bank-account': typeof AdminBankAccountIndexRoute
  '/admin/bank': typeof AdminBankIndexRoute
  '/admin/bill-of-material': typeof AdminBillOfMaterialIndexRoute
  '/admin/branch-bank-account': typeof AdminBranchBankAccountIndexRoute
  '/admin/branch-category': typeof AdminBranchCategoryIndexRoute
  '/admin/branch-qris-merchant': typeof AdminBranchQrisMerchantIndexRoute
  '/admin/branch-sales-channel': typeof AdminBranchSalesChannelIndexRoute
  '/admin/branch': typeof AdminBranchIndexRoute
  '/admin/consignment-admin-team': typeof AdminConsignmentAdminTeamIndexRoute
  '/admin/consignment-branch-setting': typeof AdminConsignmentBranchSettingIndexRoute
  '/admin/consignment-config': typeof AdminConsignmentConfigIndexRoute
  '/admin/consignment-curation': typeof AdminConsignmentCurationIndexRoute
  '/admin/consignment-product-request': typeof AdminConsignmentProductRequestIndexRoute
  '/admin/consignment-region': typeof AdminConsignmentRegionIndexRoute
  '/admin/consignment-request': typeof AdminConsignmentRequestIndexRoute
  '/admin/consignment-setting': typeof AdminConsignmentSettingIndexRoute
  '/admin/consignment-settlement': typeof AdminConsignmentSettlementIndexRoute
  '/admin/consignment-stockin-request': typeof AdminConsignmentStockinRequestIndexRoute
  '/admin/consignment-stockin': typeof AdminConsignmentStockinIndexRoute
  '/admin/consignment-stockout': typeof AdminConsignmentStockoutIndexRoute
  '/admin/consignment-vendor-application-invite': typeof AdminConsignmentVendorApplicationInviteIndexRoute
  '/admin/consignment-vendor-registration': typeof AdminConsignmentVendorRegistrationIndexRoute
  '/admin/customer': typeof AdminCustomerIndexRoute
  '/admin/delivery-order-batch': typeof AdminDeliveryOrderBatchIndexRoute
  '/admin/delivery-order': typeof AdminDeliveryOrderIndexRoute
  '/admin/edc-terminal': typeof AdminEdcTerminalIndexRoute
  '/admin/example': typeof AdminExampleIndexRoute
  '/admin/expense-item': typeof AdminExpenseItemIndexRoute
  '/admin/incoming-transfer-request': typeof AdminIncomingTransferRequestIndexRoute
  '/admin/internal-transfer': typeof AdminInternalTransferIndexRoute
  '/admin/inventory-adjustment-reason': typeof AdminInventoryAdjustmentReasonIndexRoute
  '/admin/inventory-adjustment': typeof AdminInventoryAdjustmentIndexRoute
  '/admin/inventory-count-monitoring': typeof AdminInventoryCountMonitoringIndexRoute
  '/admin/inventory-count-template-item': typeof AdminInventoryCountTemplateItemIndexRoute
  '/admin/inventory-count': typeof AdminInventoryCountIndexRoute
  '/admin/inventory-location': typeof AdminInventoryLocationIndexRoute
  '/admin/inventory-movement-summary': typeof AdminInventoryMovementSummaryIndexRoute
  '/admin/inventory-summary': typeof AdminInventorySummaryIndexRoute
  '/admin/inventory-transaction-line-unit': typeof AdminInventoryTransactionLineUnitIndexRoute
  '/admin/inventory-transaction': typeof AdminInventoryTransactionIndexRoute
  '/admin/marketplace-automation': typeof AdminMarketplaceAutomationIndexRoute
  '/admin/marketplace-channel-log': typeof AdminMarketplaceChannelLogIndexRoute
  '/admin/marketplace-order': typeof AdminMarketplaceOrderIndexRoute
  '/admin/member-type': typeof AdminMemberTypeIndexRoute
  '/admin/outbound-container': typeof AdminOutboundContainerIndexRoute
  '/admin/packing-task': typeof AdminPackingTaskIndexRoute
  '/admin/payment-inbound-request': typeof AdminPaymentInboundRequestIndexRoute
  '/admin/payment-method': typeof AdminPaymentMethodIndexRoute
  '/admin/payment-provider-config': typeof AdminPaymentProviderConfigIndexRoute
  '/admin/payment-transaction': typeof AdminPaymentTransactionIndexRoute
  '/admin/payment-webhook-event': typeof AdminPaymentWebhookEventIndexRoute
  '/admin/pending-sync-marketplace-order': typeof AdminPendingSyncMarketplaceOrderIndexRoute
  '/admin/pending-sync-sales-order': typeof AdminPendingSyncSalesOrderIndexRoute
  '/admin/petty-cash': typeof AdminPettyCashIndexRoute
  '/admin/picking-task': typeof AdminPickingTaskIndexRoute
  '/admin/pos-bookmark': typeof AdminPosBookmarkIndexRoute
  '/admin/poster': typeof AdminPosterIndexRoute
  '/admin/pricelist': typeof AdminPricelistIndexRoute
  '/admin/print-consignment': typeof AdminPrintConsignmentIndexRoute
  '/admin/print-non-consignment': typeof AdminPrintNonConsignmentIndexRoute
  '/admin/product-accounting-category': typeof AdminProductAccountingCategoryIndexRoute
  '/admin/product-addon-group': typeof AdminProductAddonGroupIndexRoute
  '/admin/product-addon': typeof AdminProductAddonIndexRoute
  '/admin/product-availability-template': typeof AdminProductAvailabilityTemplateIndexRoute
  '/admin/product-brand': typeof AdminProductBrandIndexRoute
  '/admin/product-category': typeof AdminProductCategoryIndexRoute
  '/admin/product-department': typeof AdminProductDepartmentIndexRoute
  '/admin/product-division': typeof AdminProductDivisionIndexRoute
  '/admin/product-sub-category': typeof AdminProductSubCategoryIndexRoute
  '/admin/product-sub-department': typeof AdminProductSubDepartmentIndexRoute
  '/admin/product-tag': typeof AdminProductTagIndexRoute
  '/admin/product': typeof AdminProductIndexRoute
  '/admin/production': typeof AdminProductionIndexRoute
  '/admin/promo': typeof AdminPromoIndexRoute
  '/admin/purchase-area': typeof AdminPurchaseAreaIndexRoute
  '/admin/purchase-order': typeof AdminPurchaseOrderIndexRoute
  '/admin/putaway-task': typeof AdminPutawayTaskIndexRoute
  '/admin/receiving': typeof AdminReceivingIndexRoute
  '/admin/recon-bank-upload': typeof AdminReconBankUploadIndexRoute
  '/admin/recon-bank': typeof AdminReconBankIndexRoute
  '/admin/recon-outstanding': typeof AdminReconOutstandingIndexRoute
  '/admin/replenishment-template-category': typeof AdminReplenishmentTemplateCategoryIndexRoute
  '/admin/replenishment-template': typeof AdminReplenishmentTemplateIndexRoute
  '/admin/replenishment': typeof AdminReplenishmentIndexRoute
  '/admin/revenue-report-access-log': typeof AdminRevenueReportAccessLogIndexRoute
  '/admin/revenue-report-partner-branch': typeof AdminRevenueReportPartnerBranchIndexRoute
  '/admin/revenue-report-partner': typeof AdminRevenueReportPartnerIndexRoute
  '/admin/revenue-report-template': typeof AdminRevenueReportTemplateIndexRoute
  '/admin/revenue-report': typeof AdminRevenueReportIndexRoute
  '/admin/revenue-sharing': typeof AdminRevenueSharingIndexRoute
  '/admin/sales-channel-campaign': typeof AdminSalesChannelCampaignIndexRoute
  '/admin/sales-channel-category-group': typeof AdminSalesChannelCategoryGroupIndexRoute
  '/admin/sales-channel-category-mapping': typeof AdminSalesChannelCategoryMappingIndexRoute
  '/admin/sales-channel-stock-threshold': typeof AdminSalesChannelStockThresholdIndexRoute
  '/admin/sales-channel': typeof AdminSalesChannelIndexRoute
  '/admin/sales-invoice-review': typeof AdminSalesInvoiceReviewIndexRoute
  '/admin/sales-invoice': typeof AdminSalesInvoiceIndexRoute
  '/admin/simple-transfer-order': typeof AdminSimpleTransferOrderIndexRoute
  '/admin/supplier': typeof AdminSupplierIndexRoute
  '/admin/tax': typeof AdminTaxIndexRoute
  '/admin/transfer-order': typeof AdminTransferOrderIndexRoute
  '/admin/transfer-request': typeof AdminTransferRequestIndexRoute
  '/admin/uom-category': typeof AdminUomCategoryIndexRoute
  '/admin/user-shift': typeof AdminUserShiftIndexRoute
  '/admin/vendor-category': typeof AdminVendorCategoryIndexRoute
  '/admin/vendor-consignment-rental-period': typeof AdminVendorConsignmentRentalPeriodIndexRoute
  '/admin/vendor-rental-approval': typeof AdminVendorRentalApprovalIndexRoute
  '/admin/vendor': typeof AdminVendorIndexRoute
  '/admin/voucher-category': typeof AdminVoucherCategoryIndexRoute
  '/admin/voucher': typeof AdminVoucherIndexRoute
  '/admin/warehouse-location-group': typeof AdminWarehouseLocationGroupIndexRoute
  '/admin/warehouse': typeof AdminWarehouseIndexRoute
  '/vendor/rental': typeof VendorRentalIndexRoute
  '/vendor/sales': typeof VendorSalesIndexRoute
  '/vendor/stock': typeof VendorStockIndexRoute
  '/vendor/transfer': typeof VendorTransferIndexRoute
  '/admin/access/app/create': typeof AdminAccessAppCreateRoute
  '/admin/access/permission/create': typeof AdminAccessPermissionCreateRoute
  '/admin/access/resource/create': typeof AdminAccessResourceCreateRoute
  '/admin/access/role/create': typeof AdminAccessRoleCreateRoute
  '/admin/access/user/create': typeof AdminAccessUserCreateRoute
  '/admin/bank-account/$id/detail': typeof AdminBankAccountIdDetailRoute
  '/admin/bank-account/$id/update': typeof AdminBankAccountIdUpdateRoute
  '/admin/bill-of-material/$id/detail': typeof AdminBillOfMaterialIdDetailRoute
  '/admin/bill-of-material/$id/update': typeof AdminBillOfMaterialIdUpdateRoute
  '/admin/branch-category/$id/detail': typeof AdminBranchCategoryIdDetailRoute
  '/admin/branch-category/$id/update': typeof AdminBranchCategoryIdUpdateRoute
  '/admin/branch-qris-merchant/$id/detail': typeof AdminBranchQrisMerchantIdDetailRoute
  '/admin/branch-qris-merchant/$id/update': typeof AdminBranchQrisMerchantIdUpdateRoute
  '/admin/branch-sales-channel/$id/detail': typeof AdminBranchSalesChannelIdDetailRoute
  '/admin/branch-sales-channel/$id/operating-hours': typeof AdminBranchSalesChannelIdOperatingHoursRoute
  '/admin/branch/$id/detail': typeof AdminBranchIdDetailRoute
  '/admin/branch/$id/update': typeof AdminBranchIdUpdateRoute
  '/admin/consignment-product-request/$id/detail': typeof AdminConsignmentProductRequestIdDetailRoute
  '/admin/consignment-request/$id/detail': typeof AdminConsignmentRequestIdDetailRoute
  '/admin/consignment-settlement/$id/detail': typeof AdminConsignmentSettlementIdDetailRoute
  '/admin/consignment-settlement/$id/edit': typeof AdminConsignmentSettlementIdEditRoute
  '/admin/consignment-settlement/$id/edit-items': typeof AdminConsignmentSettlementIdEditItemsRoute
  '/admin/consignment-settlement/$id/email-preview': typeof AdminConsignmentSettlementIdEmailPreviewRoute
  '/admin/consignment-stockin-request/$id/detail': typeof AdminConsignmentStockinRequestIdDetailRoute
  '/admin/consignment-stockin-request/$id/print': typeof AdminConsignmentStockinRequestIdPrintRoute
  '/admin/consignment-stockin/$id/detail': typeof AdminConsignmentStockinIdDetailRoute
  '/admin/consignment-stockin/$id/print': typeof AdminConsignmentStockinIdPrintRoute
  '/admin/consignment-stockin/$id/update': typeof AdminConsignmentStockinIdUpdateRoute
  '/admin/consignment-stockout/$id/detail': typeof AdminConsignmentStockoutIdDetailRoute
  '/admin/consignment-stockout/$id/print': typeof AdminConsignmentStockoutIdPrintRoute
  '/admin/consignment-stockout/$id/update': typeof AdminConsignmentStockoutIdUpdateRoute
  '/admin/customer/$id/detail': typeof AdminCustomerIdDetailRoute
  '/admin/customer/$id/update': typeof AdminCustomerIdUpdateRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/result': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute
  '/admin/delivery-order/$id/detail': typeof AdminDeliveryOrderIdDetailRoute
  '/admin/delivery-order/$id/print': typeof AdminDeliveryOrderIdPrintRoute
  '/admin/delivery-order/$id/update': typeof AdminDeliveryOrderIdUpdateRoute
  '/admin/edc-terminal/$id/detail': typeof AdminEdcTerminalIdDetailRoute
  '/admin/edc-terminal/$id/update': typeof AdminEdcTerminalIdUpdateRoute
  '/admin/expense-item/$id/detail': typeof AdminExpenseItemIdDetailRoute
  '/admin/expense-item/$id/update': typeof AdminExpenseItemIdUpdateRoute
  '/admin/geolocation/city/create': typeof AdminGeolocationCityCreateRoute
  '/admin/geolocation/country/create': typeof AdminGeolocationCountryCreateRoute
  '/admin/geolocation/province/create': typeof AdminGeolocationProvinceCreateRoute
  '/admin/geolocation/subdistrict/create': typeof AdminGeolocationSubdistrictCreateRoute
  '/admin/geolocation/village/create': typeof AdminGeolocationVillageCreateRoute
  '/admin/incoming-transfer-request/$id/detail': typeof AdminIncomingTransferRequestIdDetailRoute
  '/admin/incoming-transfer-request/$id/update': typeof AdminIncomingTransferRequestIdUpdateRoute
  '/admin/internal-transfer/$id/detail': typeof AdminInternalTransferIdDetailRoute
  '/admin/internal-transfer/$id/print': typeof AdminInternalTransferIdPrintRoute
  '/admin/internal-transfer/$id/update': typeof AdminInternalTransferIdUpdateRoute
  '/admin/inventory-adjustment-reason/$id/detail': typeof AdminInventoryAdjustmentReasonIdDetailRoute
  '/admin/inventory-adjustment-reason/$id/update': typeof AdminInventoryAdjustmentReasonIdUpdateRoute
  '/admin/inventory-adjustment/$id/detail': typeof AdminInventoryAdjustmentIdDetailRoute
  '/admin/inventory-adjustment/$id/print': typeof AdminInventoryAdjustmentIdPrintRoute
  '/admin/inventory-adjustment/$id/update': typeof AdminInventoryAdjustmentIdUpdateRoute
  '/admin/inventory-adjustment/cost-adjustment/import': typeof AdminInventoryAdjustmentCostAdjustmentImportRoute
  '/admin/inventory-adjustment/opening-balance/import': typeof AdminInventoryAdjustmentOpeningBalanceImportRoute
  '/admin/inventory-count-template-item/$id/detail': typeof AdminInventoryCountTemplateItemIdDetailRoute
  '/admin/inventory-count-template-item/$id/import': typeof AdminInventoryCountTemplateItemIdImportRoute
  '/admin/inventory-count-template-item/$id/update': typeof AdminInventoryCountTemplateItemIdUpdateRoute
  '/admin/inventory-count/$id/detail': typeof AdminInventoryCountIdDetailRoute
  '/admin/inventory-count/$id/print': typeof AdminInventoryCountIdPrintRoute
  '/admin/inventory-count/$id/recount': typeof AdminInventoryCountIdRecountRoute
  '/admin/inventory-count/$id/update': typeof AdminInventoryCountIdUpdateRoute
  '/admin/inventory-transaction/$id/detail': typeof AdminInventoryTransactionIdDetailRoute
  '/admin/marketplace-channel-log/$id/detail': typeof AdminMarketplaceChannelLogIdDetailRoute
  '/admin/marketplace-order/$id/detail': typeof AdminMarketplaceOrderIdDetailRoute
  '/admin/member-type/$id/detail': typeof AdminMemberTypeIdDetailRoute
  '/admin/member-type/$id/update': typeof AdminMemberTypeIdUpdateRoute
  '/admin/outbound-container/$id/detail': typeof AdminOutboundContainerIdDetailRoute
  '/admin/packing-task/$id/detail': typeof AdminPackingTaskIdDetailRoute
  '/admin/packing-task/$id/process': typeof AdminPackingTaskIdProcessRoute
  '/admin/packing-task/$id/verify': typeof AdminPackingTaskIdVerifyRoute
  '/admin/payment-method/$id/detail': typeof AdminPaymentMethodIdDetailRoute
  '/admin/payment-method/$id/update': typeof AdminPaymentMethodIdUpdateRoute
  '/admin/payment-provider-config/$id/update': typeof AdminPaymentProviderConfigIdUpdateRoute
  '/admin/payment-transaction/$id/detail': typeof AdminPaymentTransactionIdDetailRoute
  '/admin/petty-cash/$id/detail': typeof AdminPettyCashIdDetailRoute
  '/admin/petty-cash/$id/print': typeof AdminPettyCashIdPrintRoute
  '/admin/petty-cash/add-fund/create': typeof AdminPettyCashAddFundCreateRoute
  '/admin/petty-cash/expense/create': typeof AdminPettyCashExpenseCreateRoute
  '/admin/petty-cash/refund/create': typeof AdminPettyCashRefundCreateRoute
  '/admin/picking-task/$id/create-location-group': typeof AdminPickingTaskIdCreateLocationGroupRoute
  '/admin/picking-task/$id/detail': typeof AdminPickingTaskIdDetailRoute
  '/admin/pos-bookmark/$id/detail': typeof AdminPosBookmarkIdDetailRoute
  '/admin/pos-bookmark/$id/update': typeof AdminPosBookmarkIdUpdateRoute
  '/admin/poster/$id/detail': typeof AdminPosterIdDetailRoute
  '/admin/poster/$id/update': typeof AdminPosterIdUpdateRoute
  '/admin/pricelist/$id/detail': typeof AdminPricelistIdDetailRoute
  '/admin/pricelist/$id/import': typeof AdminPricelistIdImportRoute
  '/admin/pricelist/$id/update': typeof AdminPricelistIdUpdateRoute
  '/admin/pricelist/period/create': typeof AdminPricelistPeriodCreateRoute
  '/admin/product-accounting-category/$id/detail': typeof AdminProductAccountingCategoryIdDetailRoute
  '/admin/product-accounting-category/$id/update': typeof AdminProductAccountingCategoryIdUpdateRoute
  '/admin/product-addon-group/$id/detail': typeof AdminProductAddonGroupIdDetailRoute
  '/admin/product-addon-group/$id/update': typeof AdminProductAddonGroupIdUpdateRoute
  '/admin/product-addon/$id/detail': typeof AdminProductAddonIdDetailRoute
  '/admin/product-addon/$id/update': typeof AdminProductAddonIdUpdateRoute
  '/admin/product-availability-template/$id/detail': typeof AdminProductAvailabilityTemplateIdDetailRoute
  '/admin/product-availability-template/$id/import': typeof AdminProductAvailabilityTemplateIdImportRoute
  '/admin/product-availability-template/$id/update': typeof AdminProductAvailabilityTemplateIdUpdateRoute
  '/admin/product-brand/$id/detail': typeof AdminProductBrandIdDetailRoute
  '/admin/product-brand/$id/update': typeof AdminProductBrandIdUpdateRoute
  '/admin/product-category/$id/detail': typeof AdminProductCategoryIdDetailRoute
  '/admin/product-category/$id/update': typeof AdminProductCategoryIdUpdateRoute
  '/admin/product-department/$id/detail': typeof AdminProductDepartmentIdDetailRoute
  '/admin/product-department/$id/update': typeof AdminProductDepartmentIdUpdateRoute
  '/admin/product-division/$id/detail': typeof AdminProductDivisionIdDetailRoute
  '/admin/product-division/$id/update': typeof AdminProductDivisionIdUpdateRoute
  '/admin/product-sub-category/$id/detail': typeof AdminProductSubCategoryIdDetailRoute
  '/admin/product-sub-category/$id/update': typeof AdminProductSubCategoryIdUpdateRoute
  '/admin/product-sub-department/$id/detail': typeof AdminProductSubDepartmentIdDetailRoute
  '/admin/product-sub-department/$id/update': typeof AdminProductSubDepartmentIdUpdateRoute
  '/admin/product-tag/$id/detail': typeof AdminProductTagIdDetailRoute
  '/admin/product-tag/$id/update': typeof AdminProductTagIdUpdateRoute
  '/admin/product/$id/detail': typeof AdminProductIdDetailRoute
  '/admin/product/$id/update': typeof AdminProductIdUpdateRoute
  '/admin/production/$id/detail': typeof AdminProductionIdDetailRoute
  '/admin/production/$id/update': typeof AdminProductionIdUpdateRoute
  '/admin/promo/$id/detail': typeof AdminPromoIdDetailRoute
  '/admin/promo/$id/import': typeof AdminPromoIdImportRoute
  '/admin/promo/$id/update': typeof AdminPromoIdUpdateRoute
  '/admin/purchase-area/$id/detail': typeof AdminPurchaseAreaIdDetailRoute
  '/admin/purchase-area/$id/update': typeof AdminPurchaseAreaIdUpdateRoute
  '/admin/purchase-order/$id/detail': typeof AdminPurchaseOrderIdDetailRoute
  '/admin/purchase-order/$id/print': typeof AdminPurchaseOrderIdPrintRoute
  '/admin/purchase-order/$id/revise': typeof AdminPurchaseOrderIdReviseRoute
  '/admin/purchase-order/$id/update': typeof AdminPurchaseOrderIdUpdateRoute
  '/admin/putaway-task/$id/detail': typeof AdminPutawayTaskIdDetailRoute
  '/admin/receiving/$id/create': typeof AdminReceivingIdCreateRoute
  '/admin/receiving/$id/detail': typeof AdminReceivingIdDetailRoute
  '/admin/receiving/$id/print': typeof AdminReceivingIdPrintRoute
  '/admin/receiving/$id/update': typeof AdminReceivingIdUpdateRoute
  '/admin/receiving/simple-transfer-order/create': typeof AdminReceivingSimpleTransferOrderCreateRoute
  '/admin/receiving/transfer-order/create': typeof AdminReceivingTransferOrderCreateRoute
  '/admin/recon-bank-upload/$id/detail': typeof AdminReconBankUploadIdDetailRoute
  '/admin/recon-bank/$id/detail': typeof AdminReconBankIdDetailRoute
  '/admin/recon-bank/$id/process': typeof AdminReconBankIdProcessRoute
  '/admin/recon-bank/$id/upload': typeof AdminReconBankIdUploadRoute
  '/admin/replenishment-template-category/$id/detail': typeof AdminReplenishmentTemplateCategoryIdDetailRoute
  '/admin/replenishment-template-category/$id/update': typeof AdminReplenishmentTemplateCategoryIdUpdateRoute
  '/admin/replenishment-template/$id/detail': typeof AdminReplenishmentTemplateIdDetailRoute
  '/admin/replenishment-template/$id/import': typeof AdminReplenishmentTemplateIdImportRoute
  '/admin/replenishment-template/$id/update': typeof AdminReplenishmentTemplateIdUpdateRoute
  '/admin/replenishment/$id/detail': typeof AdminReplenishmentIdDetailRoute
  '/admin/revenue-report-partner-branch/$id/detail': typeof AdminRevenueReportPartnerBranchIdDetailRoute
  '/admin/revenue-report-partner/$id/detail': typeof AdminRevenueReportPartnerIdDetailRoute
  '/admin/revenue-report-template/$id/detail': typeof AdminRevenueReportTemplateIdDetailRoute
  '/admin/revenue-report/$id/detail': typeof AdminRevenueReportIdDetailRoute
  '/admin/sales-channel-campaign/$id/detail': typeof AdminSalesChannelCampaignIdDetailRoute
  '/admin/sales-channel-campaign/$id/update': typeof AdminSalesChannelCampaignIdUpdateRoute
  '/admin/sales-channel-category-group/$id/detail': typeof AdminSalesChannelCategoryGroupIdDetailRoute
  '/admin/sales-channel-category-group/$id/update': typeof AdminSalesChannelCategoryGroupIdUpdateRoute
  '/admin/sales-channel-category-mapping/$id/detail': typeof AdminSalesChannelCategoryMappingIdDetailRoute
  '/admin/sales-channel-category-mapping/$id/update': typeof AdminSalesChannelCategoryMappingIdUpdateRoute
  '/admin/sales-channel/$id/detail': typeof AdminSalesChannelIdDetailRoute
  '/admin/sales-channel/$id/update': typeof AdminSalesChannelIdUpdateRoute
  '/admin/sales-invoice-review/$id/detail': typeof AdminSalesInvoiceReviewIdDetailRoute
  '/admin/sales-invoice/$id/detail': typeof AdminSalesInvoiceIdDetailRoute
  '/admin/simple-transfer-order/$id/detail': typeof AdminSimpleTransferOrderIdDetailRoute
  '/admin/simple-transfer-order/$id/print': typeof AdminSimpleTransferOrderIdPrintRoute
  '/admin/simple-transfer-order/$id/update': typeof AdminSimpleTransferOrderIdUpdateRoute
  '/admin/supplier/$id/detail': typeof AdminSupplierIdDetailRoute
  '/admin/supplier/$id/update': typeof AdminSupplierIdUpdateRoute
  '/admin/tax/$id/detail': typeof AdminTaxIdDetailRoute
  '/admin/tax/$id/update': typeof AdminTaxIdUpdateRoute
  '/admin/transfer-order/$id/create': typeof AdminTransferOrderIdCreateRoute
  '/admin/transfer-order/$id/detail': typeof AdminTransferOrderIdDetailRoute
  '/admin/transfer-order/$id/print': typeof AdminTransferOrderIdPrintRoute
  '/admin/transfer-order/$id/update': typeof AdminTransferOrderIdUpdateRoute
  '/admin/transfer-request/$id/detail': typeof AdminTransferRequestIdDetailRoute
  '/admin/transfer-request/$id/update': typeof AdminTransferRequestIdUpdateRoute
  '/admin/uom-category/$id/detail': typeof AdminUomCategoryIdDetailRoute
  '/admin/uom-category/$id/update': typeof AdminUomCategoryIdUpdateRoute
  '/admin/user-shift/$id/detail': typeof AdminUserShiftIdDetailRoute
  '/admin/vendor-category/$id/detail': typeof AdminVendorCategoryIdDetailRoute
  '/admin/vendor-category/$id/update': typeof AdminVendorCategoryIdUpdateRoute
  '/admin/vendor-rental-approval/$id/detail': typeof AdminVendorRentalApprovalIdDetailRoute
  '/admin/vendor-rental-approval/$id/print': typeof AdminVendorRentalApprovalIdPrintRoute
  '/admin/vendor/$id/detail': typeof AdminVendorIdDetailRoute
  '/admin/vendor/$id/update': typeof AdminVendorIdUpdateRoute
  '/admin/voucher-category/$id/detail': typeof AdminVoucherCategoryIdDetailRoute
  '/admin/voucher-category/$id/update': typeof AdminVoucherCategoryIdUpdateRoute
  '/admin/voucher/$id/detail': typeof AdminVoucherIdDetailRoute
  '/admin/voucher/$id/update': typeof AdminVoucherIdUpdateRoute
  '/admin/warehouse-location-group/$id/detail': typeof AdminWarehouseLocationGroupIdDetailRoute
  '/admin/warehouse-location-group/$id/update': typeof AdminWarehouseLocationGroupIdUpdateRoute
  '/admin/warehouse/$id/detail': typeof AdminWarehouseIdDetailRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/admin/access/app': typeof AdminAccessAppIndexRoute
  '/admin/access/permission': typeof AdminAccessPermissionIndexRoute
  '/admin/access/resource': typeof AdminAccessResourceIndexRoute
  '/admin/access/role': typeof AdminAccessRoleIndexRoute
  '/admin/access/user': typeof AdminAccessUserIndexRoute
  '/admin/background-job/transaction': typeof AdminBackgroundJobTransactionIndexRoute
  '/admin/consignment/onboarding': typeof AdminConsignmentOnboardingIndexRoute
  '/admin/consignment/requests': typeof AdminConsignmentRequestsIndexRoute
  '/admin/consignment/stores-teams': typeof AdminConsignmentStoresTeamsIndexRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute
  '/admin/geolocation/city': typeof AdminGeolocationCityIndexRoute
  '/admin/geolocation/country': typeof AdminGeolocationCountryIndexRoute
  '/admin/geolocation/province': typeof AdminGeolocationProvinceIndexRoute
  '/admin/geolocation/subdistrict': typeof AdminGeolocationSubdistrictIndexRoute
  '/admin/geolocation/village': typeof AdminGeolocationVillageIndexRoute
  '/admin/pricelist/period': typeof AdminPricelistPeriodIndexRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID': typeof VendorStockProductIDIndexRoute
  '/admin/access/app/$id/update': typeof AdminAccessAppIdUpdateRoute
  '/admin/access/permission/$id/update': typeof AdminAccessPermissionIdUpdateRoute
  '/admin/access/resource/$id/update': typeof AdminAccessResourceIdUpdateRoute
  '/admin/access/role/$id/update': typeof AdminAccessRoleIdUpdateRoute
  '/admin/access/user/$id/update': typeof AdminAccessUserIdUpdateRoute
  '/admin/background-job/transaction/$id/detail': typeof AdminBackgroundJobTransactionIdDetailRoute
  '/admin/consignment/registrations/$id/detail': typeof AdminConsignmentRegistrationsIdDetailRoute
  '/admin/geolocation/city/$id/detail': typeof AdminGeolocationCityIdDetailRoute
  '/admin/geolocation/city/$id/update': typeof AdminGeolocationCityIdUpdateRoute
  '/admin/geolocation/country/$id/detail': typeof AdminGeolocationCountryIdDetailRoute
  '/admin/geolocation/country/$id/update': typeof AdminGeolocationCountryIdUpdateRoute
  '/admin/geolocation/province/$id/detail': typeof AdminGeolocationProvinceIdDetailRoute
  '/admin/geolocation/province/$id/update': typeof AdminGeolocationProvinceIdUpdateRoute
  '/admin/geolocation/subdistrict/$id/detail': typeof AdminGeolocationSubdistrictIdDetailRoute
  '/admin/geolocation/subdistrict/$id/update': typeof AdminGeolocationSubdistrictIdUpdateRoute
  '/admin/geolocation/village/$id/detail': typeof AdminGeolocationVillageIdDetailRoute
  '/admin/geolocation/village/$id/update': typeof AdminGeolocationVillageIdUpdateRoute
  '/admin/petty-cash/add-fund/$id/detail': typeof AdminPettyCashAddFundIdDetailRoute
  '/admin/petty-cash/add-fund/$id/update': typeof AdminPettyCashAddFundIdUpdateRoute
  '/admin/petty-cash/expense/$id/detail': typeof AdminPettyCashExpenseIdDetailRoute
  '/admin/petty-cash/expense/$id/update': typeof AdminPettyCashExpenseIdUpdateRoute
  '/admin/petty-cash/refund/$id/detail': typeof AdminPettyCashRefundIdDetailRoute
  '/admin/petty-cash/refund/$id/update': typeof AdminPettyCashRefundIdUpdateRoute
  '/admin/pricelist/period/$id/detail': typeof AdminPricelistPeriodIdDetailRoute
  '/admin/pricelist/period/$id/update': typeof AdminPricelistPeriodIdUpdateRoute
  '/admin/receiving/simple-transfer-order/$id/detail': typeof AdminReceivingSimpleTransferOrderIdDetailRoute
  '/admin/receiving/simple-transfer-order/$id/print': typeof AdminReceivingSimpleTransferOrderIdPrintRoute
  '/admin/receiving/simple-transfer-order/$id/update': typeof AdminReceivingSimpleTransferOrderIdUpdateRoute
  '/admin/receiving/transfer-order/$id/detail': typeof AdminReceivingTransferOrderIdDetailRoute
  '/admin/receiving/transfer-order/$id/update': typeof AdminReceivingTransferOrderIdUpdateRoute
  '/admin/revenue-sharing/$id/detail/$detailId': typeof AdminRevenueSharingIdDetailDetailIdRoute
  '/admin/revenue-sharing/$id/detail': typeof AdminRevenueSharingIdDetailIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/sales-dashboard': typeof AdminSalesDashboardRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor': typeof VendorIndexRoute
  '/admin/bank-account/create': typeof AdminBankAccountCreateRoute
  '/admin/bill-of-material/create': typeof AdminBillOfMaterialCreateRoute
  '/admin/branch-category/create': typeof AdminBranchCategoryCreateRoute
  '/admin/branch-qris-merchant/create': typeof AdminBranchQrisMerchantCreateRoute
  '/admin/branch/create': typeof AdminBranchCreateRoute
  '/admin/consignment-config/create': typeof AdminConsignmentConfigCreateRoute
  '/admin/consignment-settlement/create': typeof AdminConsignmentSettlementCreateRoute
  '/admin/consignment-stockin/create': typeof AdminConsignmentStockinCreateRoute
  '/admin/consignment-stockout/create': typeof AdminConsignmentStockoutCreateRoute
  '/admin/consignment-vendor-registration/$id': typeof AdminConsignmentVendorRegistrationIdRoute
  '/admin/customer/create': typeof AdminCustomerCreateRoute
  '/admin/delivery-order-batch/create': typeof AdminDeliveryOrderBatchCreateRoute
  '/admin/delivery-order/create': typeof AdminDeliveryOrderCreateRoute
  '/admin/edc-terminal/create': typeof AdminEdcTerminalCreateRoute
  '/admin/example/see-permissions': typeof AdminExampleSeePermissionsRoute
  '/admin/expense-item/create': typeof AdminExpenseItemCreateRoute
  '/admin/import/$templateType': typeof AdminImportTemplateTypeRoute
  '/admin/internal-transfer/create': typeof AdminInternalTransferCreateRoute
  '/admin/inventory-adjustment-reason/create': typeof AdminInventoryAdjustmentReasonCreateRoute
  '/admin/inventory-adjustment/create': typeof AdminInventoryAdjustmentCreateRoute
  '/admin/inventory-count-template-item/create': typeof AdminInventoryCountTemplateItemCreateRoute
  '/admin/inventory-count/create': typeof AdminInventoryCountCreateRoute
  '/admin/marketplace-automation/$jobKey': typeof AdminMarketplaceAutomationJobKeyRoute
  '/admin/member-type/create': typeof AdminMemberTypeCreateRoute
  '/admin/outbound-container/scan': typeof AdminOutboundContainerScanRoute
  '/admin/payment-method/create': typeof AdminPaymentMethodCreateRoute
  '/admin/pos-bookmark/create': typeof AdminPosBookmarkCreateRoute
  '/admin/poster/create': typeof AdminPosterCreateRoute
  '/admin/pricelist/create': typeof AdminPricelistCreateRoute
  '/admin/print-label/large': typeof AdminPrintLabelLargeRoute
  '/admin/print-label/small': typeof AdminPrintLabelSmallRoute
  '/admin/product-accounting-category/create': typeof AdminProductAccountingCategoryCreateRoute
  '/admin/product-addon-group/create': typeof AdminProductAddonGroupCreateRoute
  '/admin/product-addon/create': typeof AdminProductAddonCreateRoute
  '/admin/product-availability-template/create': typeof AdminProductAvailabilityTemplateCreateRoute
  '/admin/product-brand/create': typeof AdminProductBrandCreateRoute
  '/admin/product-category/create': typeof AdminProductCategoryCreateRoute
  '/admin/product-department/create': typeof AdminProductDepartmentCreateRoute
  '/admin/product-division/create': typeof AdminProductDivisionCreateRoute
  '/admin/product-sub-category/create': typeof AdminProductSubCategoryCreateRoute
  '/admin/product-sub-department/create': typeof AdminProductSubDepartmentCreateRoute
  '/admin/product-tag/create': typeof AdminProductTagCreateRoute
  '/admin/product/create': typeof AdminProductCreateRoute
  '/admin/product/import': typeof AdminProductImportRoute
  '/admin/production/create': typeof AdminProductionCreateRoute
  '/admin/promo/create': typeof AdminPromoCreateRoute
  '/admin/promo/import': typeof AdminPromoImportRoute
  '/admin/purchase-area/create': typeof AdminPurchaseAreaCreateRoute
  '/admin/purchase-order/create': typeof AdminPurchaseOrderCreateRoute
  '/admin/purchase-order/import': typeof AdminPurchaseOrderImportRoute
  '/admin/receiving/create': typeof AdminReceivingCreateRoute
  '/admin/recon-bank-upload/add': typeof AdminReconBankUploadAddRoute
  '/admin/recon-bank/upload': typeof AdminReconBankUploadRoute
  '/admin/replenishment-template-category/create': typeof AdminReplenishmentTemplateCategoryCreateRoute
  '/admin/replenishment-template/create': typeof AdminReplenishmentTemplateCreateRoute
  '/admin/sales-channel-campaign/create': typeof AdminSalesChannelCampaignCreateRoute
  '/admin/sales-channel-campaign/rules': typeof AdminSalesChannelCampaignRulesRoute
  '/admin/sales-channel-category-group/create': typeof AdminSalesChannelCategoryGroupCreateRoute
  '/admin/sales-channel-category-mapping/create': typeof AdminSalesChannelCategoryMappingCreateRoute
  '/admin/sales-channel-category-mapping/import': typeof AdminSalesChannelCategoryMappingImportRoute
  '/admin/sales-channel/create': typeof AdminSalesChannelCreateRoute
  '/admin/simple-transfer-order/create': typeof AdminSimpleTransferOrderCreateRoute
  '/admin/supplier/create': typeof AdminSupplierCreateRoute
  '/admin/tax/create': typeof AdminTaxCreateRoute
  '/admin/transfer-order/create': typeof AdminTransferOrderCreateRoute
  '/admin/transfer-order/import': typeof AdminTransferOrderImportRoute
  '/admin/transfer-request/create': typeof AdminTransferRequestCreateRoute
  '/admin/transfer-request/import': typeof AdminTransferRequestImportRoute
  '/admin/uom-category/create': typeof AdminUomCategoryCreateRoute
  '/admin/vendor-category/create': typeof AdminVendorCategoryCreateRoute
  '/admin/vendor/create': typeof AdminVendorCreateRoute
  '/admin/voucher-category/create': typeof AdminVoucherCategoryCreateRoute
  '/admin/voucher/create': typeof AdminVoucherCreateRoute
  '/admin/warehouse-location-group/create': typeof AdminWarehouseLocationGroupCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/admin/bank-account': typeof AdminBankAccountIndexRoute
  '/admin/bank': typeof AdminBankIndexRoute
  '/admin/bill-of-material': typeof AdminBillOfMaterialIndexRoute
  '/admin/branch-bank-account': typeof AdminBranchBankAccountIndexRoute
  '/admin/branch-category': typeof AdminBranchCategoryIndexRoute
  '/admin/branch-qris-merchant': typeof AdminBranchQrisMerchantIndexRoute
  '/admin/branch-sales-channel': typeof AdminBranchSalesChannelIndexRoute
  '/admin/branch': typeof AdminBranchIndexRoute
  '/admin/consignment-admin-team': typeof AdminConsignmentAdminTeamIndexRoute
  '/admin/consignment-branch-setting': typeof AdminConsignmentBranchSettingIndexRoute
  '/admin/consignment-config': typeof AdminConsignmentConfigIndexRoute
  '/admin/consignment-curation': typeof AdminConsignmentCurationIndexRoute
  '/admin/consignment-product-request': typeof AdminConsignmentProductRequestIndexRoute
  '/admin/consignment-region': typeof AdminConsignmentRegionIndexRoute
  '/admin/consignment-request': typeof AdminConsignmentRequestIndexRoute
  '/admin/consignment-setting': typeof AdminConsignmentSettingIndexRoute
  '/admin/consignment-settlement': typeof AdminConsignmentSettlementIndexRoute
  '/admin/consignment-stockin-request': typeof AdminConsignmentStockinRequestIndexRoute
  '/admin/consignment-stockin': typeof AdminConsignmentStockinIndexRoute
  '/admin/consignment-stockout': typeof AdminConsignmentStockoutIndexRoute
  '/admin/consignment-vendor-application-invite': typeof AdminConsignmentVendorApplicationInviteIndexRoute
  '/admin/consignment-vendor-registration': typeof AdminConsignmentVendorRegistrationIndexRoute
  '/admin/customer': typeof AdminCustomerIndexRoute
  '/admin/delivery-order-batch': typeof AdminDeliveryOrderBatchIndexRoute
  '/admin/delivery-order': typeof AdminDeliveryOrderIndexRoute
  '/admin/edc-terminal': typeof AdminEdcTerminalIndexRoute
  '/admin/example': typeof AdminExampleIndexRoute
  '/admin/expense-item': typeof AdminExpenseItemIndexRoute
  '/admin/incoming-transfer-request': typeof AdminIncomingTransferRequestIndexRoute
  '/admin/internal-transfer': typeof AdminInternalTransferIndexRoute
  '/admin/inventory-adjustment-reason': typeof AdminInventoryAdjustmentReasonIndexRoute
  '/admin/inventory-adjustment': typeof AdminInventoryAdjustmentIndexRoute
  '/admin/inventory-count-monitoring': typeof AdminInventoryCountMonitoringIndexRoute
  '/admin/inventory-count-template-item': typeof AdminInventoryCountTemplateItemIndexRoute
  '/admin/inventory-count': typeof AdminInventoryCountIndexRoute
  '/admin/inventory-location': typeof AdminInventoryLocationIndexRoute
  '/admin/inventory-movement-summary': typeof AdminInventoryMovementSummaryIndexRoute
  '/admin/inventory-summary': typeof AdminInventorySummaryIndexRoute
  '/admin/inventory-transaction-line-unit': typeof AdminInventoryTransactionLineUnitIndexRoute
  '/admin/inventory-transaction': typeof AdminInventoryTransactionIndexRoute
  '/admin/marketplace-automation': typeof AdminMarketplaceAutomationIndexRoute
  '/admin/marketplace-channel-log': typeof AdminMarketplaceChannelLogIndexRoute
  '/admin/marketplace-order': typeof AdminMarketplaceOrderIndexRoute
  '/admin/member-type': typeof AdminMemberTypeIndexRoute
  '/admin/outbound-container': typeof AdminOutboundContainerIndexRoute
  '/admin/packing-task': typeof AdminPackingTaskIndexRoute
  '/admin/payment-inbound-request': typeof AdminPaymentInboundRequestIndexRoute
  '/admin/payment-method': typeof AdminPaymentMethodIndexRoute
  '/admin/payment-provider-config': typeof AdminPaymentProviderConfigIndexRoute
  '/admin/payment-transaction': typeof AdminPaymentTransactionIndexRoute
  '/admin/payment-webhook-event': typeof AdminPaymentWebhookEventIndexRoute
  '/admin/pending-sync-marketplace-order': typeof AdminPendingSyncMarketplaceOrderIndexRoute
  '/admin/pending-sync-sales-order': typeof AdminPendingSyncSalesOrderIndexRoute
  '/admin/petty-cash': typeof AdminPettyCashIndexRoute
  '/admin/picking-task': typeof AdminPickingTaskIndexRoute
  '/admin/pos-bookmark': typeof AdminPosBookmarkIndexRoute
  '/admin/poster': typeof AdminPosterIndexRoute
  '/admin/pricelist': typeof AdminPricelistIndexRoute
  '/admin/print-consignment': typeof AdminPrintConsignmentIndexRoute
  '/admin/print-non-consignment': typeof AdminPrintNonConsignmentIndexRoute
  '/admin/product-accounting-category': typeof AdminProductAccountingCategoryIndexRoute
  '/admin/product-addon-group': typeof AdminProductAddonGroupIndexRoute
  '/admin/product-addon': typeof AdminProductAddonIndexRoute
  '/admin/product-availability-template': typeof AdminProductAvailabilityTemplateIndexRoute
  '/admin/product-brand': typeof AdminProductBrandIndexRoute
  '/admin/product-category': typeof AdminProductCategoryIndexRoute
  '/admin/product-department': typeof AdminProductDepartmentIndexRoute
  '/admin/product-division': typeof AdminProductDivisionIndexRoute
  '/admin/product-sub-category': typeof AdminProductSubCategoryIndexRoute
  '/admin/product-sub-department': typeof AdminProductSubDepartmentIndexRoute
  '/admin/product-tag': typeof AdminProductTagIndexRoute
  '/admin/product': typeof AdminProductIndexRoute
  '/admin/production': typeof AdminProductionIndexRoute
  '/admin/promo': typeof AdminPromoIndexRoute
  '/admin/purchase-area': typeof AdminPurchaseAreaIndexRoute
  '/admin/purchase-order': typeof AdminPurchaseOrderIndexRoute
  '/admin/putaway-task': typeof AdminPutawayTaskIndexRoute
  '/admin/receiving': typeof AdminReceivingIndexRoute
  '/admin/recon-bank-upload': typeof AdminReconBankUploadIndexRoute
  '/admin/recon-bank': typeof AdminReconBankIndexRoute
  '/admin/recon-outstanding': typeof AdminReconOutstandingIndexRoute
  '/admin/replenishment-template-category': typeof AdminReplenishmentTemplateCategoryIndexRoute
  '/admin/replenishment-template': typeof AdminReplenishmentTemplateIndexRoute
  '/admin/replenishment': typeof AdminReplenishmentIndexRoute
  '/admin/revenue-report-access-log': typeof AdminRevenueReportAccessLogIndexRoute
  '/admin/revenue-report-partner-branch': typeof AdminRevenueReportPartnerBranchIndexRoute
  '/admin/revenue-report-partner': typeof AdminRevenueReportPartnerIndexRoute
  '/admin/revenue-report-template': typeof AdminRevenueReportTemplateIndexRoute
  '/admin/revenue-report': typeof AdminRevenueReportIndexRoute
  '/admin/revenue-sharing': typeof AdminRevenueSharingIndexRoute
  '/admin/sales-channel-campaign': typeof AdminSalesChannelCampaignIndexRoute
  '/admin/sales-channel-category-group': typeof AdminSalesChannelCategoryGroupIndexRoute
  '/admin/sales-channel-category-mapping': typeof AdminSalesChannelCategoryMappingIndexRoute
  '/admin/sales-channel-stock-threshold': typeof AdminSalesChannelStockThresholdIndexRoute
  '/admin/sales-channel': typeof AdminSalesChannelIndexRoute
  '/admin/sales-invoice-review': typeof AdminSalesInvoiceReviewIndexRoute
  '/admin/sales-invoice': typeof AdminSalesInvoiceIndexRoute
  '/admin/simple-transfer-order': typeof AdminSimpleTransferOrderIndexRoute
  '/admin/supplier': typeof AdminSupplierIndexRoute
  '/admin/tax': typeof AdminTaxIndexRoute
  '/admin/transfer-order': typeof AdminTransferOrderIndexRoute
  '/admin/transfer-request': typeof AdminTransferRequestIndexRoute
  '/admin/uom-category': typeof AdminUomCategoryIndexRoute
  '/admin/user-shift': typeof AdminUserShiftIndexRoute
  '/admin/vendor-category': typeof AdminVendorCategoryIndexRoute
  '/admin/vendor-consignment-rental-period': typeof AdminVendorConsignmentRentalPeriodIndexRoute
  '/admin/vendor-rental-approval': typeof AdminVendorRentalApprovalIndexRoute
  '/admin/vendor': typeof AdminVendorIndexRoute
  '/admin/voucher-category': typeof AdminVoucherCategoryIndexRoute
  '/admin/voucher': typeof AdminVoucherIndexRoute
  '/admin/warehouse-location-group': typeof AdminWarehouseLocationGroupIndexRoute
  '/admin/warehouse': typeof AdminWarehouseIndexRoute
  '/vendor/rental': typeof VendorRentalIndexRoute
  '/vendor/sales': typeof VendorSalesIndexRoute
  '/vendor/stock': typeof VendorStockIndexRoute
  '/vendor/transfer': typeof VendorTransferIndexRoute
  '/admin/access/app/create': typeof AdminAccessAppCreateRoute
  '/admin/access/permission/create': typeof AdminAccessPermissionCreateRoute
  '/admin/access/resource/create': typeof AdminAccessResourceCreateRoute
  '/admin/access/role/create': typeof AdminAccessRoleCreateRoute
  '/admin/access/user/create': typeof AdminAccessUserCreateRoute
  '/admin/bank-account/$id/detail': typeof AdminBankAccountIdDetailRoute
  '/admin/bank-account/$id/update': typeof AdminBankAccountIdUpdateRoute
  '/admin/bill-of-material/$id/detail': typeof AdminBillOfMaterialIdDetailRoute
  '/admin/bill-of-material/$id/update': typeof AdminBillOfMaterialIdUpdateRoute
  '/admin/branch-category/$id/detail': typeof AdminBranchCategoryIdDetailRoute
  '/admin/branch-category/$id/update': typeof AdminBranchCategoryIdUpdateRoute
  '/admin/branch-qris-merchant/$id/detail': typeof AdminBranchQrisMerchantIdDetailRoute
  '/admin/branch-qris-merchant/$id/update': typeof AdminBranchQrisMerchantIdUpdateRoute
  '/admin/branch-sales-channel/$id/detail': typeof AdminBranchSalesChannelIdDetailRoute
  '/admin/branch-sales-channel/$id/operating-hours': typeof AdminBranchSalesChannelIdOperatingHoursRoute
  '/admin/branch/$id/detail': typeof AdminBranchIdDetailRoute
  '/admin/branch/$id/update': typeof AdminBranchIdUpdateRoute
  '/admin/consignment-product-request/$id/detail': typeof AdminConsignmentProductRequestIdDetailRoute
  '/admin/consignment-request/$id/detail': typeof AdminConsignmentRequestIdDetailRoute
  '/admin/consignment-settlement/$id/detail': typeof AdminConsignmentSettlementIdDetailRoute
  '/admin/consignment-settlement/$id/edit': typeof AdminConsignmentSettlementIdEditRoute
  '/admin/consignment-settlement/$id/edit-items': typeof AdminConsignmentSettlementIdEditItemsRoute
  '/admin/consignment-settlement/$id/email-preview': typeof AdminConsignmentSettlementIdEmailPreviewRoute
  '/admin/consignment-stockin-request/$id/detail': typeof AdminConsignmentStockinRequestIdDetailRoute
  '/admin/consignment-stockin-request/$id/print': typeof AdminConsignmentStockinRequestIdPrintRoute
  '/admin/consignment-stockin/$id/detail': typeof AdminConsignmentStockinIdDetailRoute
  '/admin/consignment-stockin/$id/print': typeof AdminConsignmentStockinIdPrintRoute
  '/admin/consignment-stockin/$id/update': typeof AdminConsignmentStockinIdUpdateRoute
  '/admin/consignment-stockout/$id/detail': typeof AdminConsignmentStockoutIdDetailRoute
  '/admin/consignment-stockout/$id/print': typeof AdminConsignmentStockoutIdPrintRoute
  '/admin/consignment-stockout/$id/update': typeof AdminConsignmentStockoutIdUpdateRoute
  '/admin/customer/$id/detail': typeof AdminCustomerIdDetailRoute
  '/admin/customer/$id/update': typeof AdminCustomerIdUpdateRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/result': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute
  '/admin/delivery-order/$id/detail': typeof AdminDeliveryOrderIdDetailRoute
  '/admin/delivery-order/$id/print': typeof AdminDeliveryOrderIdPrintRoute
  '/admin/delivery-order/$id/update': typeof AdminDeliveryOrderIdUpdateRoute
  '/admin/edc-terminal/$id/detail': typeof AdminEdcTerminalIdDetailRoute
  '/admin/edc-terminal/$id/update': typeof AdminEdcTerminalIdUpdateRoute
  '/admin/expense-item/$id/detail': typeof AdminExpenseItemIdDetailRoute
  '/admin/expense-item/$id/update': typeof AdminExpenseItemIdUpdateRoute
  '/admin/geolocation/city/create': typeof AdminGeolocationCityCreateRoute
  '/admin/geolocation/country/create': typeof AdminGeolocationCountryCreateRoute
  '/admin/geolocation/province/create': typeof AdminGeolocationProvinceCreateRoute
  '/admin/geolocation/subdistrict/create': typeof AdminGeolocationSubdistrictCreateRoute
  '/admin/geolocation/village/create': typeof AdminGeolocationVillageCreateRoute
  '/admin/incoming-transfer-request/$id/detail': typeof AdminIncomingTransferRequestIdDetailRoute
  '/admin/incoming-transfer-request/$id/update': typeof AdminIncomingTransferRequestIdUpdateRoute
  '/admin/internal-transfer/$id/detail': typeof AdminInternalTransferIdDetailRoute
  '/admin/internal-transfer/$id/print': typeof AdminInternalTransferIdPrintRoute
  '/admin/internal-transfer/$id/update': typeof AdminInternalTransferIdUpdateRoute
  '/admin/inventory-adjustment-reason/$id/detail': typeof AdminInventoryAdjustmentReasonIdDetailRoute
  '/admin/inventory-adjustment-reason/$id/update': typeof AdminInventoryAdjustmentReasonIdUpdateRoute
  '/admin/inventory-adjustment/$id/detail': typeof AdminInventoryAdjustmentIdDetailRoute
  '/admin/inventory-adjustment/$id/print': typeof AdminInventoryAdjustmentIdPrintRoute
  '/admin/inventory-adjustment/$id/update': typeof AdminInventoryAdjustmentIdUpdateRoute
  '/admin/inventory-adjustment/cost-adjustment/import': typeof AdminInventoryAdjustmentCostAdjustmentImportRoute
  '/admin/inventory-adjustment/opening-balance/import': typeof AdminInventoryAdjustmentOpeningBalanceImportRoute
  '/admin/inventory-count-template-item/$id/detail': typeof AdminInventoryCountTemplateItemIdDetailRoute
  '/admin/inventory-count-template-item/$id/import': typeof AdminInventoryCountTemplateItemIdImportRoute
  '/admin/inventory-count-template-item/$id/update': typeof AdminInventoryCountTemplateItemIdUpdateRoute
  '/admin/inventory-count/$id/detail': typeof AdminInventoryCountIdDetailRoute
  '/admin/inventory-count/$id/print': typeof AdminInventoryCountIdPrintRoute
  '/admin/inventory-count/$id/recount': typeof AdminInventoryCountIdRecountRoute
  '/admin/inventory-count/$id/update': typeof AdminInventoryCountIdUpdateRoute
  '/admin/inventory-transaction/$id/detail': typeof AdminInventoryTransactionIdDetailRoute
  '/admin/marketplace-channel-log/$id/detail': typeof AdminMarketplaceChannelLogIdDetailRoute
  '/admin/marketplace-order/$id/detail': typeof AdminMarketplaceOrderIdDetailRoute
  '/admin/member-type/$id/detail': typeof AdminMemberTypeIdDetailRoute
  '/admin/member-type/$id/update': typeof AdminMemberTypeIdUpdateRoute
  '/admin/outbound-container/$id/detail': typeof AdminOutboundContainerIdDetailRoute
  '/admin/packing-task/$id/detail': typeof AdminPackingTaskIdDetailRoute
  '/admin/packing-task/$id/process': typeof AdminPackingTaskIdProcessRoute
  '/admin/packing-task/$id/verify': typeof AdminPackingTaskIdVerifyRoute
  '/admin/payment-method/$id/detail': typeof AdminPaymentMethodIdDetailRoute
  '/admin/payment-method/$id/update': typeof AdminPaymentMethodIdUpdateRoute
  '/admin/payment-provider-config/$id/update': typeof AdminPaymentProviderConfigIdUpdateRoute
  '/admin/payment-transaction/$id/detail': typeof AdminPaymentTransactionIdDetailRoute
  '/admin/petty-cash/$id/detail': typeof AdminPettyCashIdDetailRoute
  '/admin/petty-cash/$id/print': typeof AdminPettyCashIdPrintRoute
  '/admin/petty-cash/add-fund/create': typeof AdminPettyCashAddFundCreateRoute
  '/admin/petty-cash/expense/create': typeof AdminPettyCashExpenseCreateRoute
  '/admin/petty-cash/refund/create': typeof AdminPettyCashRefundCreateRoute
  '/admin/picking-task/$id/create-location-group': typeof AdminPickingTaskIdCreateLocationGroupRoute
  '/admin/picking-task/$id/detail': typeof AdminPickingTaskIdDetailRoute
  '/admin/pos-bookmark/$id/detail': typeof AdminPosBookmarkIdDetailRoute
  '/admin/pos-bookmark/$id/update': typeof AdminPosBookmarkIdUpdateRoute
  '/admin/poster/$id/detail': typeof AdminPosterIdDetailRoute
  '/admin/poster/$id/update': typeof AdminPosterIdUpdateRoute
  '/admin/pricelist/$id/detail': typeof AdminPricelistIdDetailRoute
  '/admin/pricelist/$id/import': typeof AdminPricelistIdImportRoute
  '/admin/pricelist/$id/update': typeof AdminPricelistIdUpdateRoute
  '/admin/pricelist/period/create': typeof AdminPricelistPeriodCreateRoute
  '/admin/product-accounting-category/$id/detail': typeof AdminProductAccountingCategoryIdDetailRoute
  '/admin/product-accounting-category/$id/update': typeof AdminProductAccountingCategoryIdUpdateRoute
  '/admin/product-addon-group/$id/detail': typeof AdminProductAddonGroupIdDetailRoute
  '/admin/product-addon-group/$id/update': typeof AdminProductAddonGroupIdUpdateRoute
  '/admin/product-addon/$id/detail': typeof AdminProductAddonIdDetailRoute
  '/admin/product-addon/$id/update': typeof AdminProductAddonIdUpdateRoute
  '/admin/product-availability-template/$id/detail': typeof AdminProductAvailabilityTemplateIdDetailRoute
  '/admin/product-availability-template/$id/import': typeof AdminProductAvailabilityTemplateIdImportRoute
  '/admin/product-availability-template/$id/update': typeof AdminProductAvailabilityTemplateIdUpdateRoute
  '/admin/product-brand/$id/detail': typeof AdminProductBrandIdDetailRoute
  '/admin/product-brand/$id/update': typeof AdminProductBrandIdUpdateRoute
  '/admin/product-category/$id/detail': typeof AdminProductCategoryIdDetailRoute
  '/admin/product-category/$id/update': typeof AdminProductCategoryIdUpdateRoute
  '/admin/product-department/$id/detail': typeof AdminProductDepartmentIdDetailRoute
  '/admin/product-department/$id/update': typeof AdminProductDepartmentIdUpdateRoute
  '/admin/product-division/$id/detail': typeof AdminProductDivisionIdDetailRoute
  '/admin/product-division/$id/update': typeof AdminProductDivisionIdUpdateRoute
  '/admin/product-sub-category/$id/detail': typeof AdminProductSubCategoryIdDetailRoute
  '/admin/product-sub-category/$id/update': typeof AdminProductSubCategoryIdUpdateRoute
  '/admin/product-sub-department/$id/detail': typeof AdminProductSubDepartmentIdDetailRoute
  '/admin/product-sub-department/$id/update': typeof AdminProductSubDepartmentIdUpdateRoute
  '/admin/product-tag/$id/detail': typeof AdminProductTagIdDetailRoute
  '/admin/product-tag/$id/update': typeof AdminProductTagIdUpdateRoute
  '/admin/product/$id/detail': typeof AdminProductIdDetailRoute
  '/admin/product/$id/update': typeof AdminProductIdUpdateRoute
  '/admin/production/$id/detail': typeof AdminProductionIdDetailRoute
  '/admin/production/$id/update': typeof AdminProductionIdUpdateRoute
  '/admin/promo/$id/detail': typeof AdminPromoIdDetailRoute
  '/admin/promo/$id/import': typeof AdminPromoIdImportRoute
  '/admin/promo/$id/update': typeof AdminPromoIdUpdateRoute
  '/admin/purchase-area/$id/detail': typeof AdminPurchaseAreaIdDetailRoute
  '/admin/purchase-area/$id/update': typeof AdminPurchaseAreaIdUpdateRoute
  '/admin/purchase-order/$id/detail': typeof AdminPurchaseOrderIdDetailRoute
  '/admin/purchase-order/$id/print': typeof AdminPurchaseOrderIdPrintRoute
  '/admin/purchase-order/$id/revise': typeof AdminPurchaseOrderIdReviseRoute
  '/admin/purchase-order/$id/update': typeof AdminPurchaseOrderIdUpdateRoute
  '/admin/putaway-task/$id/detail': typeof AdminPutawayTaskIdDetailRoute
  '/admin/receiving/$id/create': typeof AdminReceivingIdCreateRoute
  '/admin/receiving/$id/detail': typeof AdminReceivingIdDetailRoute
  '/admin/receiving/$id/print': typeof AdminReceivingIdPrintRoute
  '/admin/receiving/$id/update': typeof AdminReceivingIdUpdateRoute
  '/admin/receiving/simple-transfer-order/create': typeof AdminReceivingSimpleTransferOrderCreateRoute
  '/admin/receiving/transfer-order/create': typeof AdminReceivingTransferOrderCreateRoute
  '/admin/recon-bank-upload/$id/detail': typeof AdminReconBankUploadIdDetailRoute
  '/admin/recon-bank/$id/detail': typeof AdminReconBankIdDetailRoute
  '/admin/recon-bank/$id/process': typeof AdminReconBankIdProcessRoute
  '/admin/recon-bank/$id/upload': typeof AdminReconBankIdUploadRoute
  '/admin/replenishment-template-category/$id/detail': typeof AdminReplenishmentTemplateCategoryIdDetailRoute
  '/admin/replenishment-template-category/$id/update': typeof AdminReplenishmentTemplateCategoryIdUpdateRoute
  '/admin/replenishment-template/$id/detail': typeof AdminReplenishmentTemplateIdDetailRoute
  '/admin/replenishment-template/$id/import': typeof AdminReplenishmentTemplateIdImportRoute
  '/admin/replenishment-template/$id/update': typeof AdminReplenishmentTemplateIdUpdateRoute
  '/admin/replenishment/$id/detail': typeof AdminReplenishmentIdDetailRoute
  '/admin/revenue-report-partner-branch/$id/detail': typeof AdminRevenueReportPartnerBranchIdDetailRoute
  '/admin/revenue-report-partner/$id/detail': typeof AdminRevenueReportPartnerIdDetailRoute
  '/admin/revenue-report-template/$id/detail': typeof AdminRevenueReportTemplateIdDetailRoute
  '/admin/revenue-report/$id/detail': typeof AdminRevenueReportIdDetailRoute
  '/admin/sales-channel-campaign/$id/detail': typeof AdminSalesChannelCampaignIdDetailRoute
  '/admin/sales-channel-campaign/$id/update': typeof AdminSalesChannelCampaignIdUpdateRoute
  '/admin/sales-channel-category-group/$id/detail': typeof AdminSalesChannelCategoryGroupIdDetailRoute
  '/admin/sales-channel-category-group/$id/update': typeof AdminSalesChannelCategoryGroupIdUpdateRoute
  '/admin/sales-channel-category-mapping/$id/detail': typeof AdminSalesChannelCategoryMappingIdDetailRoute
  '/admin/sales-channel-category-mapping/$id/update': typeof AdminSalesChannelCategoryMappingIdUpdateRoute
  '/admin/sales-channel/$id/detail': typeof AdminSalesChannelIdDetailRoute
  '/admin/sales-channel/$id/update': typeof AdminSalesChannelIdUpdateRoute
  '/admin/sales-invoice-review/$id/detail': typeof AdminSalesInvoiceReviewIdDetailRoute
  '/admin/sales-invoice/$id/detail': typeof AdminSalesInvoiceIdDetailRoute
  '/admin/simple-transfer-order/$id/detail': typeof AdminSimpleTransferOrderIdDetailRoute
  '/admin/simple-transfer-order/$id/print': typeof AdminSimpleTransferOrderIdPrintRoute
  '/admin/simple-transfer-order/$id/update': typeof AdminSimpleTransferOrderIdUpdateRoute
  '/admin/supplier/$id/detail': typeof AdminSupplierIdDetailRoute
  '/admin/supplier/$id/update': typeof AdminSupplierIdUpdateRoute
  '/admin/tax/$id/detail': typeof AdminTaxIdDetailRoute
  '/admin/tax/$id/update': typeof AdminTaxIdUpdateRoute
  '/admin/transfer-order/$id/create': typeof AdminTransferOrderIdCreateRoute
  '/admin/transfer-order/$id/detail': typeof AdminTransferOrderIdDetailRoute
  '/admin/transfer-order/$id/print': typeof AdminTransferOrderIdPrintRoute
  '/admin/transfer-order/$id/update': typeof AdminTransferOrderIdUpdateRoute
  '/admin/transfer-request/$id/detail': typeof AdminTransferRequestIdDetailRoute
  '/admin/transfer-request/$id/update': typeof AdminTransferRequestIdUpdateRoute
  '/admin/uom-category/$id/detail': typeof AdminUomCategoryIdDetailRoute
  '/admin/uom-category/$id/update': typeof AdminUomCategoryIdUpdateRoute
  '/admin/user-shift/$id/detail': typeof AdminUserShiftIdDetailRoute
  '/admin/vendor-category/$id/detail': typeof AdminVendorCategoryIdDetailRoute
  '/admin/vendor-category/$id/update': typeof AdminVendorCategoryIdUpdateRoute
  '/admin/vendor-rental-approval/$id/detail': typeof AdminVendorRentalApprovalIdDetailRoute
  '/admin/vendor-rental-approval/$id/print': typeof AdminVendorRentalApprovalIdPrintRoute
  '/admin/vendor/$id/detail': typeof AdminVendorIdDetailRoute
  '/admin/vendor/$id/update': typeof AdminVendorIdUpdateRoute
  '/admin/voucher-category/$id/detail': typeof AdminVoucherCategoryIdDetailRoute
  '/admin/voucher-category/$id/update': typeof AdminVoucherCategoryIdUpdateRoute
  '/admin/voucher/$id/detail': typeof AdminVoucherIdDetailRoute
  '/admin/voucher/$id/update': typeof AdminVoucherIdUpdateRoute
  '/admin/warehouse-location-group/$id/detail': typeof AdminWarehouseLocationGroupIdDetailRoute
  '/admin/warehouse-location-group/$id/update': typeof AdminWarehouseLocationGroupIdUpdateRoute
  '/admin/warehouse/$id/detail': typeof AdminWarehouseIdDetailRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/admin/access/app': typeof AdminAccessAppIndexRoute
  '/admin/access/permission': typeof AdminAccessPermissionIndexRoute
  '/admin/access/resource': typeof AdminAccessResourceIndexRoute
  '/admin/access/role': typeof AdminAccessRoleIndexRoute
  '/admin/access/user': typeof AdminAccessUserIndexRoute
  '/admin/background-job/transaction': typeof AdminBackgroundJobTransactionIndexRoute
  '/admin/consignment/onboarding': typeof AdminConsignmentOnboardingIndexRoute
  '/admin/consignment/requests': typeof AdminConsignmentRequestsIndexRoute
  '/admin/consignment/stores-teams': typeof AdminConsignmentStoresTeamsIndexRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute
  '/admin/geolocation/city': typeof AdminGeolocationCityIndexRoute
  '/admin/geolocation/country': typeof AdminGeolocationCountryIndexRoute
  '/admin/geolocation/province': typeof AdminGeolocationProvinceIndexRoute
  '/admin/geolocation/subdistrict': typeof AdminGeolocationSubdistrictIndexRoute
  '/admin/geolocation/village': typeof AdminGeolocationVillageIndexRoute
  '/admin/pricelist/period': typeof AdminPricelistPeriodIndexRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID': typeof VendorStockProductIDIndexRoute
  '/admin/access/app/$id/update': typeof AdminAccessAppIdUpdateRoute
  '/admin/access/permission/$id/update': typeof AdminAccessPermissionIdUpdateRoute
  '/admin/access/resource/$id/update': typeof AdminAccessResourceIdUpdateRoute
  '/admin/access/role/$id/update': typeof AdminAccessRoleIdUpdateRoute
  '/admin/access/user/$id/update': typeof AdminAccessUserIdUpdateRoute
  '/admin/background-job/transaction/$id/detail': typeof AdminBackgroundJobTransactionIdDetailRoute
  '/admin/consignment/registrations/$id/detail': typeof AdminConsignmentRegistrationsIdDetailRoute
  '/admin/geolocation/city/$id/detail': typeof AdminGeolocationCityIdDetailRoute
  '/admin/geolocation/city/$id/update': typeof AdminGeolocationCityIdUpdateRoute
  '/admin/geolocation/country/$id/detail': typeof AdminGeolocationCountryIdDetailRoute
  '/admin/geolocation/country/$id/update': typeof AdminGeolocationCountryIdUpdateRoute
  '/admin/geolocation/province/$id/detail': typeof AdminGeolocationProvinceIdDetailRoute
  '/admin/geolocation/province/$id/update': typeof AdminGeolocationProvinceIdUpdateRoute
  '/admin/geolocation/subdistrict/$id/detail': typeof AdminGeolocationSubdistrictIdDetailRoute
  '/admin/geolocation/subdistrict/$id/update': typeof AdminGeolocationSubdistrictIdUpdateRoute
  '/admin/geolocation/village/$id/detail': typeof AdminGeolocationVillageIdDetailRoute
  '/admin/geolocation/village/$id/update': typeof AdminGeolocationVillageIdUpdateRoute
  '/admin/petty-cash/add-fund/$id/detail': typeof AdminPettyCashAddFundIdDetailRoute
  '/admin/petty-cash/add-fund/$id/update': typeof AdminPettyCashAddFundIdUpdateRoute
  '/admin/petty-cash/expense/$id/detail': typeof AdminPettyCashExpenseIdDetailRoute
  '/admin/petty-cash/expense/$id/update': typeof AdminPettyCashExpenseIdUpdateRoute
  '/admin/petty-cash/refund/$id/detail': typeof AdminPettyCashRefundIdDetailRoute
  '/admin/petty-cash/refund/$id/update': typeof AdminPettyCashRefundIdUpdateRoute
  '/admin/pricelist/period/$id/detail': typeof AdminPricelistPeriodIdDetailRoute
  '/admin/pricelist/period/$id/update': typeof AdminPricelistPeriodIdUpdateRoute
  '/admin/receiving/simple-transfer-order/$id/detail': typeof AdminReceivingSimpleTransferOrderIdDetailRoute
  '/admin/receiving/simple-transfer-order/$id/print': typeof AdminReceivingSimpleTransferOrderIdPrintRoute
  '/admin/receiving/simple-transfer-order/$id/update': typeof AdminReceivingSimpleTransferOrderIdUpdateRoute
  '/admin/receiving/transfer-order/$id/detail': typeof AdminReceivingTransferOrderIdDetailRoute
  '/admin/receiving/transfer-order/$id/update': typeof AdminReceivingTransferOrderIdUpdateRoute
  '/admin/revenue-sharing/$id/detail/$detailId': typeof AdminRevenueSharingIdDetailDetailIdRoute
  '/admin/revenue-sharing/$id/detail': typeof AdminRevenueSharingIdDetailIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/sales-dashboard': typeof AdminSalesDashboardRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/': typeof VendorIndexRoute
  '/admin/bank-account/create': typeof AdminBankAccountCreateRoute
  '/admin/bill-of-material/create': typeof AdminBillOfMaterialCreateRoute
  '/admin/branch-category/create': typeof AdminBranchCategoryCreateRoute
  '/admin/branch-qris-merchant/create': typeof AdminBranchQrisMerchantCreateRoute
  '/admin/branch/create': typeof AdminBranchCreateRoute
  '/admin/consignment-config/create': typeof AdminConsignmentConfigCreateRoute
  '/admin/consignment-settlement/create': typeof AdminConsignmentSettlementCreateRoute
  '/admin/consignment-stockin/create': typeof AdminConsignmentStockinCreateRoute
  '/admin/consignment-stockout/create': typeof AdminConsignmentStockoutCreateRoute
  '/admin/consignment-vendor-registration/$id': typeof AdminConsignmentVendorRegistrationIdRoute
  '/admin/customer/create': typeof AdminCustomerCreateRoute
  '/admin/delivery-order-batch/create': typeof AdminDeliveryOrderBatchCreateRoute
  '/admin/delivery-order/create': typeof AdminDeliveryOrderCreateRoute
  '/admin/edc-terminal/create': typeof AdminEdcTerminalCreateRoute
  '/admin/example/see-permissions': typeof AdminExampleSeePermissionsRoute
  '/admin/expense-item/create': typeof AdminExpenseItemCreateRoute
  '/admin/import/$templateType': typeof AdminImportTemplateTypeRoute
  '/admin/internal-transfer/create': typeof AdminInternalTransferCreateRoute
  '/admin/inventory-adjustment-reason/create': typeof AdminInventoryAdjustmentReasonCreateRoute
  '/admin/inventory-adjustment/create': typeof AdminInventoryAdjustmentCreateRoute
  '/admin/inventory-count-template-item/create': typeof AdminInventoryCountTemplateItemCreateRoute
  '/admin/inventory-count/create': typeof AdminInventoryCountCreateRoute
  '/admin/marketplace-automation/$jobKey': typeof AdminMarketplaceAutomationJobKeyRoute
  '/admin/member-type/create': typeof AdminMemberTypeCreateRoute
  '/admin/outbound-container/scan': typeof AdminOutboundContainerScanRoute
  '/admin/payment-method/create': typeof AdminPaymentMethodCreateRoute
  '/admin/pos-bookmark/create': typeof AdminPosBookmarkCreateRoute
  '/admin/poster/create': typeof AdminPosterCreateRoute
  '/admin/pricelist/create': typeof AdminPricelistCreateRoute
  '/admin/print-label/large': typeof AdminPrintLabelLargeRoute
  '/admin/print-label/small': typeof AdminPrintLabelSmallRoute
  '/admin/product-accounting-category/create': typeof AdminProductAccountingCategoryCreateRoute
  '/admin/product-addon-group/create': typeof AdminProductAddonGroupCreateRoute
  '/admin/product-addon/create': typeof AdminProductAddonCreateRoute
  '/admin/product-availability-template/create': typeof AdminProductAvailabilityTemplateCreateRoute
  '/admin/product-brand/create': typeof AdminProductBrandCreateRoute
  '/admin/product-category/create': typeof AdminProductCategoryCreateRoute
  '/admin/product-department/create': typeof AdminProductDepartmentCreateRoute
  '/admin/product-division/create': typeof AdminProductDivisionCreateRoute
  '/admin/product-sub-category/create': typeof AdminProductSubCategoryCreateRoute
  '/admin/product-sub-department/create': typeof AdminProductSubDepartmentCreateRoute
  '/admin/product-tag/create': typeof AdminProductTagCreateRoute
  '/admin/product/create': typeof AdminProductCreateRoute
  '/admin/product/import': typeof AdminProductImportRoute
  '/admin/production/create': typeof AdminProductionCreateRoute
  '/admin/promo/create': typeof AdminPromoCreateRoute
  '/admin/promo/import': typeof AdminPromoImportRoute
  '/admin/purchase-area/create': typeof AdminPurchaseAreaCreateRoute
  '/admin/purchase-order/create': typeof AdminPurchaseOrderCreateRoute
  '/admin/purchase-order/import': typeof AdminPurchaseOrderImportRoute
  '/admin/receiving/create': typeof AdminReceivingCreateRoute
  '/admin/recon-bank-upload/add': typeof AdminReconBankUploadAddRoute
  '/admin/recon-bank/upload': typeof AdminReconBankUploadRoute
  '/admin/replenishment-template-category/create': typeof AdminReplenishmentTemplateCategoryCreateRoute
  '/admin/replenishment-template/create': typeof AdminReplenishmentTemplateCreateRoute
  '/admin/sales-channel-campaign/create': typeof AdminSalesChannelCampaignCreateRoute
  '/admin/sales-channel-campaign/rules': typeof AdminSalesChannelCampaignRulesRoute
  '/admin/sales-channel-category-group/create': typeof AdminSalesChannelCategoryGroupCreateRoute
  '/admin/sales-channel-category-mapping/create': typeof AdminSalesChannelCategoryMappingCreateRoute
  '/admin/sales-channel-category-mapping/import': typeof AdminSalesChannelCategoryMappingImportRoute
  '/admin/sales-channel/create': typeof AdminSalesChannelCreateRoute
  '/admin/simple-transfer-order/create': typeof AdminSimpleTransferOrderCreateRoute
  '/admin/supplier/create': typeof AdminSupplierCreateRoute
  '/admin/tax/create': typeof AdminTaxCreateRoute
  '/admin/transfer-order/create': typeof AdminTransferOrderCreateRoute
  '/admin/transfer-order/import': typeof AdminTransferOrderImportRoute
  '/admin/transfer-request/create': typeof AdminTransferRequestCreateRoute
  '/admin/transfer-request/import': typeof AdminTransferRequestImportRoute
  '/admin/uom-category/create': typeof AdminUomCategoryCreateRoute
  '/admin/vendor-category/create': typeof AdminVendorCategoryCreateRoute
  '/admin/vendor/create': typeof AdminVendorCreateRoute
  '/admin/voucher-category/create': typeof AdminVoucherCategoryCreateRoute
  '/admin/voucher/create': typeof AdminVoucherCreateRoute
  '/admin/warehouse-location-group/create': typeof AdminWarehouseLocationGroupCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/admin/bank-account/': typeof AdminBankAccountIndexRoute
  '/admin/bank/': typeof AdminBankIndexRoute
  '/admin/bill-of-material/': typeof AdminBillOfMaterialIndexRoute
  '/admin/branch-bank-account/': typeof AdminBranchBankAccountIndexRoute
  '/admin/branch-category/': typeof AdminBranchCategoryIndexRoute
  '/admin/branch-qris-merchant/': typeof AdminBranchQrisMerchantIndexRoute
  '/admin/branch-sales-channel/': typeof AdminBranchSalesChannelIndexRoute
  '/admin/branch/': typeof AdminBranchIndexRoute
  '/admin/consignment-admin-team/': typeof AdminConsignmentAdminTeamIndexRoute
  '/admin/consignment-branch-setting/': typeof AdminConsignmentBranchSettingIndexRoute
  '/admin/consignment-config/': typeof AdminConsignmentConfigIndexRoute
  '/admin/consignment-curation/': typeof AdminConsignmentCurationIndexRoute
  '/admin/consignment-product-request/': typeof AdminConsignmentProductRequestIndexRoute
  '/admin/consignment-region/': typeof AdminConsignmentRegionIndexRoute
  '/admin/consignment-request/': typeof AdminConsignmentRequestIndexRoute
  '/admin/consignment-setting/': typeof AdminConsignmentSettingIndexRoute
  '/admin/consignment-settlement/': typeof AdminConsignmentSettlementIndexRoute
  '/admin/consignment-stockin-request/': typeof AdminConsignmentStockinRequestIndexRoute
  '/admin/consignment-stockin/': typeof AdminConsignmentStockinIndexRoute
  '/admin/consignment-stockout/': typeof AdminConsignmentStockoutIndexRoute
  '/admin/consignment-vendor-application-invite/': typeof AdminConsignmentVendorApplicationInviteIndexRoute
  '/admin/consignment-vendor-registration/': typeof AdminConsignmentVendorRegistrationIndexRoute
  '/admin/customer/': typeof AdminCustomerIndexRoute
  '/admin/delivery-order-batch/': typeof AdminDeliveryOrderBatchIndexRoute
  '/admin/delivery-order/': typeof AdminDeliveryOrderIndexRoute
  '/admin/edc-terminal/': typeof AdminEdcTerminalIndexRoute
  '/admin/example/': typeof AdminExampleIndexRoute
  '/admin/expense-item/': typeof AdminExpenseItemIndexRoute
  '/admin/incoming-transfer-request/': typeof AdminIncomingTransferRequestIndexRoute
  '/admin/internal-transfer/': typeof AdminInternalTransferIndexRoute
  '/admin/inventory-adjustment-reason/': typeof AdminInventoryAdjustmentReasonIndexRoute
  '/admin/inventory-adjustment/': typeof AdminInventoryAdjustmentIndexRoute
  '/admin/inventory-count-monitoring/': typeof AdminInventoryCountMonitoringIndexRoute
  '/admin/inventory-count-template-item/': typeof AdminInventoryCountTemplateItemIndexRoute
  '/admin/inventory-count/': typeof AdminInventoryCountIndexRoute
  '/admin/inventory-location/': typeof AdminInventoryLocationIndexRoute
  '/admin/inventory-movement-summary/': typeof AdminInventoryMovementSummaryIndexRoute
  '/admin/inventory-summary/': typeof AdminInventorySummaryIndexRoute
  '/admin/inventory-transaction-line-unit/': typeof AdminInventoryTransactionLineUnitIndexRoute
  '/admin/inventory-transaction/': typeof AdminInventoryTransactionIndexRoute
  '/admin/marketplace-automation/': typeof AdminMarketplaceAutomationIndexRoute
  '/admin/marketplace-channel-log/': typeof AdminMarketplaceChannelLogIndexRoute
  '/admin/marketplace-order/': typeof AdminMarketplaceOrderIndexRoute
  '/admin/member-type/': typeof AdminMemberTypeIndexRoute
  '/admin/outbound-container/': typeof AdminOutboundContainerIndexRoute
  '/admin/packing-task/': typeof AdminPackingTaskIndexRoute
  '/admin/payment-inbound-request/': typeof AdminPaymentInboundRequestIndexRoute
  '/admin/payment-method/': typeof AdminPaymentMethodIndexRoute
  '/admin/payment-provider-config/': typeof AdminPaymentProviderConfigIndexRoute
  '/admin/payment-transaction/': typeof AdminPaymentTransactionIndexRoute
  '/admin/payment-webhook-event/': typeof AdminPaymentWebhookEventIndexRoute
  '/admin/pending-sync-marketplace-order/': typeof AdminPendingSyncMarketplaceOrderIndexRoute
  '/admin/pending-sync-sales-order/': typeof AdminPendingSyncSalesOrderIndexRoute
  '/admin/petty-cash/': typeof AdminPettyCashIndexRoute
  '/admin/picking-task/': typeof AdminPickingTaskIndexRoute
  '/admin/pos-bookmark/': typeof AdminPosBookmarkIndexRoute
  '/admin/poster/': typeof AdminPosterIndexRoute
  '/admin/pricelist/': typeof AdminPricelistIndexRoute
  '/admin/print-consignment/': typeof AdminPrintConsignmentIndexRoute
  '/admin/print-non-consignment/': typeof AdminPrintNonConsignmentIndexRoute
  '/admin/product-accounting-category/': typeof AdminProductAccountingCategoryIndexRoute
  '/admin/product-addon-group/': typeof AdminProductAddonGroupIndexRoute
  '/admin/product-addon/': typeof AdminProductAddonIndexRoute
  '/admin/product-availability-template/': typeof AdminProductAvailabilityTemplateIndexRoute
  '/admin/product-brand/': typeof AdminProductBrandIndexRoute
  '/admin/product-category/': typeof AdminProductCategoryIndexRoute
  '/admin/product-department/': typeof AdminProductDepartmentIndexRoute
  '/admin/product-division/': typeof AdminProductDivisionIndexRoute
  '/admin/product-sub-category/': typeof AdminProductSubCategoryIndexRoute
  '/admin/product-sub-department/': typeof AdminProductSubDepartmentIndexRoute
  '/admin/product-tag/': typeof AdminProductTagIndexRoute
  '/admin/product/': typeof AdminProductIndexRoute
  '/admin/production/': typeof AdminProductionIndexRoute
  '/admin/promo/': typeof AdminPromoIndexRoute
  '/admin/purchase-area/': typeof AdminPurchaseAreaIndexRoute
  '/admin/purchase-order/': typeof AdminPurchaseOrderIndexRoute
  '/admin/putaway-task/': typeof AdminPutawayTaskIndexRoute
  '/admin/receiving/': typeof AdminReceivingIndexRoute
  '/admin/recon-bank-upload/': typeof AdminReconBankUploadIndexRoute
  '/admin/recon-bank/': typeof AdminReconBankIndexRoute
  '/admin/recon-outstanding/': typeof AdminReconOutstandingIndexRoute
  '/admin/replenishment-template-category/': typeof AdminReplenishmentTemplateCategoryIndexRoute
  '/admin/replenishment-template/': typeof AdminReplenishmentTemplateIndexRoute
  '/admin/replenishment/': typeof AdminReplenishmentIndexRoute
  '/admin/revenue-report-access-log/': typeof AdminRevenueReportAccessLogIndexRoute
  '/admin/revenue-report-partner-branch/': typeof AdminRevenueReportPartnerBranchIndexRoute
  '/admin/revenue-report-partner/': typeof AdminRevenueReportPartnerIndexRoute
  '/admin/revenue-report-template/': typeof AdminRevenueReportTemplateIndexRoute
  '/admin/revenue-report/': typeof AdminRevenueReportIndexRoute
  '/admin/revenue-sharing/': typeof AdminRevenueSharingIndexRoute
  '/admin/sales-channel-campaign/': typeof AdminSalesChannelCampaignIndexRoute
  '/admin/sales-channel-category-group/': typeof AdminSalesChannelCategoryGroupIndexRoute
  '/admin/sales-channel-category-mapping/': typeof AdminSalesChannelCategoryMappingIndexRoute
  '/admin/sales-channel-stock-threshold/': typeof AdminSalesChannelStockThresholdIndexRoute
  '/admin/sales-channel/': typeof AdminSalesChannelIndexRoute
  '/admin/sales-invoice-review/': typeof AdminSalesInvoiceReviewIndexRoute
  '/admin/sales-invoice/': typeof AdminSalesInvoiceIndexRoute
  '/admin/simple-transfer-order/': typeof AdminSimpleTransferOrderIndexRoute
  '/admin/supplier/': typeof AdminSupplierIndexRoute
  '/admin/tax/': typeof AdminTaxIndexRoute
  '/admin/transfer-order/': typeof AdminTransferOrderIndexRoute
  '/admin/transfer-request/': typeof AdminTransferRequestIndexRoute
  '/admin/uom-category/': typeof AdminUomCategoryIndexRoute
  '/admin/user-shift/': typeof AdminUserShiftIndexRoute
  '/admin/vendor-category/': typeof AdminVendorCategoryIndexRoute
  '/admin/vendor-consignment-rental-period/': typeof AdminVendorConsignmentRentalPeriodIndexRoute
  '/admin/vendor-rental-approval/': typeof AdminVendorRentalApprovalIndexRoute
  '/admin/vendor/': typeof AdminVendorIndexRoute
  '/admin/voucher-category/': typeof AdminVoucherCategoryIndexRoute
  '/admin/voucher/': typeof AdminVoucherIndexRoute
  '/admin/warehouse-location-group/': typeof AdminWarehouseLocationGroupIndexRoute
  '/admin/warehouse/': typeof AdminWarehouseIndexRoute
  '/vendor/rental/': typeof VendorRentalIndexRoute
  '/vendor/sales/': typeof VendorSalesIndexRoute
  '/vendor/stock/': typeof VendorStockIndexRoute
  '/vendor/transfer/': typeof VendorTransferIndexRoute
  '/admin/access/app/create': typeof AdminAccessAppCreateRoute
  '/admin/access/permission/create': typeof AdminAccessPermissionCreateRoute
  '/admin/access/resource/create': typeof AdminAccessResourceCreateRoute
  '/admin/access/role/create': typeof AdminAccessRoleCreateRoute
  '/admin/access/user/create': typeof AdminAccessUserCreateRoute
  '/admin/bank-account/$id/detail': typeof AdminBankAccountIdDetailRoute
  '/admin/bank-account/$id/update': typeof AdminBankAccountIdUpdateRoute
  '/admin/bill-of-material/$id/detail': typeof AdminBillOfMaterialIdDetailRoute
  '/admin/bill-of-material/$id/update': typeof AdminBillOfMaterialIdUpdateRoute
  '/admin/branch-category/$id/detail': typeof AdminBranchCategoryIdDetailRoute
  '/admin/branch-category/$id/update': typeof AdminBranchCategoryIdUpdateRoute
  '/admin/branch-qris-merchant/$id/detail': typeof AdminBranchQrisMerchantIdDetailRoute
  '/admin/branch-qris-merchant/$id/update': typeof AdminBranchQrisMerchantIdUpdateRoute
  '/admin/branch-sales-channel/$id/detail': typeof AdminBranchSalesChannelIdDetailRoute
  '/admin/branch-sales-channel/$id/operating-hours': typeof AdminBranchSalesChannelIdOperatingHoursRoute
  '/admin/branch/$id/detail': typeof AdminBranchIdDetailRoute
  '/admin/branch/$id/update': typeof AdminBranchIdUpdateRoute
  '/admin/consignment-product-request/$id/detail': typeof AdminConsignmentProductRequestIdDetailRoute
  '/admin/consignment-request/$id/detail': typeof AdminConsignmentRequestIdDetailRoute
  '/admin/consignment-settlement/$id/detail': typeof AdminConsignmentSettlementIdDetailRoute
  '/admin/consignment-settlement/$id/edit': typeof AdminConsignmentSettlementIdEditRoute
  '/admin/consignment-settlement/$id/edit-items': typeof AdminConsignmentSettlementIdEditItemsRoute
  '/admin/consignment-settlement/$id/email-preview': typeof AdminConsignmentSettlementIdEmailPreviewRoute
  '/admin/consignment-stockin-request/$id/detail': typeof AdminConsignmentStockinRequestIdDetailRoute
  '/admin/consignment-stockin-request/$id/print': typeof AdminConsignmentStockinRequestIdPrintRoute
  '/admin/consignment-stockin/$id/detail': typeof AdminConsignmentStockinIdDetailRoute
  '/admin/consignment-stockin/$id/print': typeof AdminConsignmentStockinIdPrintRoute
  '/admin/consignment-stockin/$id/update': typeof AdminConsignmentStockinIdUpdateRoute
  '/admin/consignment-stockout/$id/detail': typeof AdminConsignmentStockoutIdDetailRoute
  '/admin/consignment-stockout/$id/print': typeof AdminConsignmentStockoutIdPrintRoute
  '/admin/consignment-stockout/$id/update': typeof AdminConsignmentStockoutIdUpdateRoute
  '/admin/customer/$id/detail': typeof AdminCustomerIdDetailRoute
  '/admin/customer/$id/update': typeof AdminCustomerIdUpdateRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/result': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute
  '/admin/delivery-order/$id/detail': typeof AdminDeliveryOrderIdDetailRoute
  '/admin/delivery-order/$id/print': typeof AdminDeliveryOrderIdPrintRoute
  '/admin/delivery-order/$id/update': typeof AdminDeliveryOrderIdUpdateRoute
  '/admin/edc-terminal/$id/detail': typeof AdminEdcTerminalIdDetailRoute
  '/admin/edc-terminal/$id/update': typeof AdminEdcTerminalIdUpdateRoute
  '/admin/expense-item/$id/detail': typeof AdminExpenseItemIdDetailRoute
  '/admin/expense-item/$id/update': typeof AdminExpenseItemIdUpdateRoute
  '/admin/geolocation/city/create': typeof AdminGeolocationCityCreateRoute
  '/admin/geolocation/country/create': typeof AdminGeolocationCountryCreateRoute
  '/admin/geolocation/province/create': typeof AdminGeolocationProvinceCreateRoute
  '/admin/geolocation/subdistrict/create': typeof AdminGeolocationSubdistrictCreateRoute
  '/admin/geolocation/village/create': typeof AdminGeolocationVillageCreateRoute
  '/admin/incoming-transfer-request/$id/detail': typeof AdminIncomingTransferRequestIdDetailRoute
  '/admin/incoming-transfer-request/$id/update': typeof AdminIncomingTransferRequestIdUpdateRoute
  '/admin/internal-transfer/$id/detail': typeof AdminInternalTransferIdDetailRoute
  '/admin/internal-transfer/$id/print': typeof AdminInternalTransferIdPrintRoute
  '/admin/internal-transfer/$id/update': typeof AdminInternalTransferIdUpdateRoute
  '/admin/inventory-adjustment-reason/$id/detail': typeof AdminInventoryAdjustmentReasonIdDetailRoute
  '/admin/inventory-adjustment-reason/$id/update': typeof AdminInventoryAdjustmentReasonIdUpdateRoute
  '/admin/inventory-adjustment/$id/detail': typeof AdminInventoryAdjustmentIdDetailRoute
  '/admin/inventory-adjustment/$id/print': typeof AdminInventoryAdjustmentIdPrintRoute
  '/admin/inventory-adjustment/$id/update': typeof AdminInventoryAdjustmentIdUpdateRoute
  '/admin/inventory-adjustment/cost-adjustment/import': typeof AdminInventoryAdjustmentCostAdjustmentImportRoute
  '/admin/inventory-adjustment/opening-balance/import': typeof AdminInventoryAdjustmentOpeningBalanceImportRoute
  '/admin/inventory-count-template-item/$id/detail': typeof AdminInventoryCountTemplateItemIdDetailRoute
  '/admin/inventory-count-template-item/$id/import': typeof AdminInventoryCountTemplateItemIdImportRoute
  '/admin/inventory-count-template-item/$id/update': typeof AdminInventoryCountTemplateItemIdUpdateRoute
  '/admin/inventory-count/$id/detail': typeof AdminInventoryCountIdDetailRoute
  '/admin/inventory-count/$id/print': typeof AdminInventoryCountIdPrintRoute
  '/admin/inventory-count/$id/recount': typeof AdminInventoryCountIdRecountRoute
  '/admin/inventory-count/$id/update': typeof AdminInventoryCountIdUpdateRoute
  '/admin/inventory-transaction/$id/detail': typeof AdminInventoryTransactionIdDetailRoute
  '/admin/marketplace-channel-log/$id/detail': typeof AdminMarketplaceChannelLogIdDetailRoute
  '/admin/marketplace-order/$id/detail': typeof AdminMarketplaceOrderIdDetailRoute
  '/admin/member-type/$id/detail': typeof AdminMemberTypeIdDetailRoute
  '/admin/member-type/$id/update': typeof AdminMemberTypeIdUpdateRoute
  '/admin/outbound-container/$id/detail': typeof AdminOutboundContainerIdDetailRoute
  '/admin/packing-task/$id/detail': typeof AdminPackingTaskIdDetailRoute
  '/admin/packing-task/$id/process': typeof AdminPackingTaskIdProcessRoute
  '/admin/packing-task/$id/verify': typeof AdminPackingTaskIdVerifyRoute
  '/admin/payment-method/$id/detail': typeof AdminPaymentMethodIdDetailRoute
  '/admin/payment-method/$id/update': typeof AdminPaymentMethodIdUpdateRoute
  '/admin/payment-provider-config/$id/update': typeof AdminPaymentProviderConfigIdUpdateRoute
  '/admin/payment-transaction/$id/detail': typeof AdminPaymentTransactionIdDetailRoute
  '/admin/petty-cash/$id/detail': typeof AdminPettyCashIdDetailRoute
  '/admin/petty-cash/$id/print': typeof AdminPettyCashIdPrintRoute
  '/admin/petty-cash/add-fund/create': typeof AdminPettyCashAddFundCreateRoute
  '/admin/petty-cash/expense/create': typeof AdminPettyCashExpenseCreateRoute
  '/admin/petty-cash/refund/create': typeof AdminPettyCashRefundCreateRoute
  '/admin/picking-task/$id/create-location-group': typeof AdminPickingTaskIdCreateLocationGroupRoute
  '/admin/picking-task/$id/detail': typeof AdminPickingTaskIdDetailRoute
  '/admin/pos-bookmark/$id/detail': typeof AdminPosBookmarkIdDetailRoute
  '/admin/pos-bookmark/$id/update': typeof AdminPosBookmarkIdUpdateRoute
  '/admin/poster/$id/detail': typeof AdminPosterIdDetailRoute
  '/admin/poster/$id/update': typeof AdminPosterIdUpdateRoute
  '/admin/pricelist/$id/detail': typeof AdminPricelistIdDetailRoute
  '/admin/pricelist/$id/import': typeof AdminPricelistIdImportRoute
  '/admin/pricelist/$id/update': typeof AdminPricelistIdUpdateRoute
  '/admin/pricelist/period/create': typeof AdminPricelistPeriodCreateRoute
  '/admin/product-accounting-category/$id/detail': typeof AdminProductAccountingCategoryIdDetailRoute
  '/admin/product-accounting-category/$id/update': typeof AdminProductAccountingCategoryIdUpdateRoute
  '/admin/product-addon-group/$id/detail': typeof AdminProductAddonGroupIdDetailRoute
  '/admin/product-addon-group/$id/update': typeof AdminProductAddonGroupIdUpdateRoute
  '/admin/product-addon/$id/detail': typeof AdminProductAddonIdDetailRoute
  '/admin/product-addon/$id/update': typeof AdminProductAddonIdUpdateRoute
  '/admin/product-availability-template/$id/detail': typeof AdminProductAvailabilityTemplateIdDetailRoute
  '/admin/product-availability-template/$id/import': typeof AdminProductAvailabilityTemplateIdImportRoute
  '/admin/product-availability-template/$id/update': typeof AdminProductAvailabilityTemplateIdUpdateRoute
  '/admin/product-brand/$id/detail': typeof AdminProductBrandIdDetailRoute
  '/admin/product-brand/$id/update': typeof AdminProductBrandIdUpdateRoute
  '/admin/product-category/$id/detail': typeof AdminProductCategoryIdDetailRoute
  '/admin/product-category/$id/update': typeof AdminProductCategoryIdUpdateRoute
  '/admin/product-department/$id/detail': typeof AdminProductDepartmentIdDetailRoute
  '/admin/product-department/$id/update': typeof AdminProductDepartmentIdUpdateRoute
  '/admin/product-division/$id/detail': typeof AdminProductDivisionIdDetailRoute
  '/admin/product-division/$id/update': typeof AdminProductDivisionIdUpdateRoute
  '/admin/product-sub-category/$id/detail': typeof AdminProductSubCategoryIdDetailRoute
  '/admin/product-sub-category/$id/update': typeof AdminProductSubCategoryIdUpdateRoute
  '/admin/product-sub-department/$id/detail': typeof AdminProductSubDepartmentIdDetailRoute
  '/admin/product-sub-department/$id/update': typeof AdminProductSubDepartmentIdUpdateRoute
  '/admin/product-tag/$id/detail': typeof AdminProductTagIdDetailRoute
  '/admin/product-tag/$id/update': typeof AdminProductTagIdUpdateRoute
  '/admin/product/$id/detail': typeof AdminProductIdDetailRoute
  '/admin/product/$id/update': typeof AdminProductIdUpdateRoute
  '/admin/production/$id/detail': typeof AdminProductionIdDetailRoute
  '/admin/production/$id/update': typeof AdminProductionIdUpdateRoute
  '/admin/promo/$id/detail': typeof AdminPromoIdDetailRoute
  '/admin/promo/$id/import': typeof AdminPromoIdImportRoute
  '/admin/promo/$id/update': typeof AdminPromoIdUpdateRoute
  '/admin/purchase-area/$id/detail': typeof AdminPurchaseAreaIdDetailRoute
  '/admin/purchase-area/$id/update': typeof AdminPurchaseAreaIdUpdateRoute
  '/admin/purchase-order/$id/detail': typeof AdminPurchaseOrderIdDetailRoute
  '/admin/purchase-order/$id/print': typeof AdminPurchaseOrderIdPrintRoute
  '/admin/purchase-order/$id/revise': typeof AdminPurchaseOrderIdReviseRoute
  '/admin/purchase-order/$id/update': typeof AdminPurchaseOrderIdUpdateRoute
  '/admin/putaway-task/$id/detail': typeof AdminPutawayTaskIdDetailRoute
  '/admin/receiving/$id/create': typeof AdminReceivingIdCreateRoute
  '/admin/receiving/$id/detail': typeof AdminReceivingIdDetailRoute
  '/admin/receiving/$id/print': typeof AdminReceivingIdPrintRoute
  '/admin/receiving/$id/update': typeof AdminReceivingIdUpdateRoute
  '/admin/receiving/simple-transfer-order/create': typeof AdminReceivingSimpleTransferOrderCreateRoute
  '/admin/receiving/transfer-order/create': typeof AdminReceivingTransferOrderCreateRoute
  '/admin/recon-bank-upload/$id/detail': typeof AdminReconBankUploadIdDetailRoute
  '/admin/recon-bank/$id/detail': typeof AdminReconBankIdDetailRoute
  '/admin/recon-bank/$id/process': typeof AdminReconBankIdProcessRoute
  '/admin/recon-bank/$id/upload': typeof AdminReconBankIdUploadRoute
  '/admin/replenishment-template-category/$id/detail': typeof AdminReplenishmentTemplateCategoryIdDetailRoute
  '/admin/replenishment-template-category/$id/update': typeof AdminReplenishmentTemplateCategoryIdUpdateRoute
  '/admin/replenishment-template/$id/detail': typeof AdminReplenishmentTemplateIdDetailRoute
  '/admin/replenishment-template/$id/import': typeof AdminReplenishmentTemplateIdImportRoute
  '/admin/replenishment-template/$id/update': typeof AdminReplenishmentTemplateIdUpdateRoute
  '/admin/replenishment/$id/detail': typeof AdminReplenishmentIdDetailRoute
  '/admin/revenue-report-partner-branch/$id/detail': typeof AdminRevenueReportPartnerBranchIdDetailRoute
  '/admin/revenue-report-partner/$id/detail': typeof AdminRevenueReportPartnerIdDetailRoute
  '/admin/revenue-report-template/$id/detail': typeof AdminRevenueReportTemplateIdDetailRoute
  '/admin/revenue-report/$id/detail': typeof AdminRevenueReportIdDetailRoute
  '/admin/sales-channel-campaign/$id/detail': typeof AdminSalesChannelCampaignIdDetailRoute
  '/admin/sales-channel-campaign/$id/update': typeof AdminSalesChannelCampaignIdUpdateRoute
  '/admin/sales-channel-category-group/$id/detail': typeof AdminSalesChannelCategoryGroupIdDetailRoute
  '/admin/sales-channel-category-group/$id/update': typeof AdminSalesChannelCategoryGroupIdUpdateRoute
  '/admin/sales-channel-category-mapping/$id/detail': typeof AdminSalesChannelCategoryMappingIdDetailRoute
  '/admin/sales-channel-category-mapping/$id/update': typeof AdminSalesChannelCategoryMappingIdUpdateRoute
  '/admin/sales-channel/$id/detail': typeof AdminSalesChannelIdDetailRoute
  '/admin/sales-channel/$id/update': typeof AdminSalesChannelIdUpdateRoute
  '/admin/sales-invoice-review/$id/detail': typeof AdminSalesInvoiceReviewIdDetailRoute
  '/admin/sales-invoice/$id/detail': typeof AdminSalesInvoiceIdDetailRoute
  '/admin/simple-transfer-order/$id/detail': typeof AdminSimpleTransferOrderIdDetailRoute
  '/admin/simple-transfer-order/$id/print': typeof AdminSimpleTransferOrderIdPrintRoute
  '/admin/simple-transfer-order/$id/update': typeof AdminSimpleTransferOrderIdUpdateRoute
  '/admin/supplier/$id/detail': typeof AdminSupplierIdDetailRoute
  '/admin/supplier/$id/update': typeof AdminSupplierIdUpdateRoute
  '/admin/tax/$id/detail': typeof AdminTaxIdDetailRoute
  '/admin/tax/$id/update': typeof AdminTaxIdUpdateRoute
  '/admin/transfer-order/$id/create': typeof AdminTransferOrderIdCreateRoute
  '/admin/transfer-order/$id/detail': typeof AdminTransferOrderIdDetailRoute
  '/admin/transfer-order/$id/print': typeof AdminTransferOrderIdPrintRoute
  '/admin/transfer-order/$id/update': typeof AdminTransferOrderIdUpdateRoute
  '/admin/transfer-request/$id/detail': typeof AdminTransferRequestIdDetailRoute
  '/admin/transfer-request/$id/update': typeof AdminTransferRequestIdUpdateRoute
  '/admin/uom-category/$id/detail': typeof AdminUomCategoryIdDetailRoute
  '/admin/uom-category/$id/update': typeof AdminUomCategoryIdUpdateRoute
  '/admin/user-shift/$id/detail': typeof AdminUserShiftIdDetailRoute
  '/admin/vendor-category/$id/detail': typeof AdminVendorCategoryIdDetailRoute
  '/admin/vendor-category/$id/update': typeof AdminVendorCategoryIdUpdateRoute
  '/admin/vendor-rental-approval/$id/detail': typeof AdminVendorRentalApprovalIdDetailRoute
  '/admin/vendor-rental-approval/$id/print': typeof AdminVendorRentalApprovalIdPrintRoute
  '/admin/vendor/$id/detail': typeof AdminVendorIdDetailRoute
  '/admin/vendor/$id/update': typeof AdminVendorIdUpdateRoute
  '/admin/voucher-category/$id/detail': typeof AdminVoucherCategoryIdDetailRoute
  '/admin/voucher-category/$id/update': typeof AdminVoucherCategoryIdUpdateRoute
  '/admin/voucher/$id/detail': typeof AdminVoucherIdDetailRoute
  '/admin/voucher/$id/update': typeof AdminVoucherIdUpdateRoute
  '/admin/warehouse-location-group/$id/detail': typeof AdminWarehouseLocationGroupIdDetailRoute
  '/admin/warehouse-location-group/$id/update': typeof AdminWarehouseLocationGroupIdUpdateRoute
  '/admin/warehouse/$id/detail': typeof AdminWarehouseIdDetailRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/admin/access/app/': typeof AdminAccessAppIndexRoute
  '/admin/access/permission/': typeof AdminAccessPermissionIndexRoute
  '/admin/access/resource/': typeof AdminAccessResourceIndexRoute
  '/admin/access/role/': typeof AdminAccessRoleIndexRoute
  '/admin/access/user/': typeof AdminAccessUserIndexRoute
  '/admin/background-job/transaction/': typeof AdminBackgroundJobTransactionIndexRoute
  '/admin/consignment/onboarding/': typeof AdminConsignmentOnboardingIndexRoute
  '/admin/consignment/requests/': typeof AdminConsignmentRequestsIndexRoute
  '/admin/consignment/stores-teams/': typeof AdminConsignmentStoresTeamsIndexRoute
  '/admin/delivery-order-batch/$deliveryOrderBatchID/': typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute
  '/admin/geolocation/city/': typeof AdminGeolocationCityIndexRoute
  '/admin/geolocation/country/': typeof AdminGeolocationCountryIndexRoute
  '/admin/geolocation/province/': typeof AdminGeolocationProvinceIndexRoute
  '/admin/geolocation/subdistrict/': typeof AdminGeolocationSubdistrictIndexRoute
  '/admin/geolocation/village/': typeof AdminGeolocationVillageIndexRoute
  '/admin/pricelist/period/': typeof AdminPricelistPeriodIndexRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID/': typeof VendorStockProductIDIndexRoute
  '/admin/access/app/$id/update': typeof AdminAccessAppIdUpdateRoute
  '/admin/access/permission/$id/update': typeof AdminAccessPermissionIdUpdateRoute
  '/admin/access/resource/$id/update': typeof AdminAccessResourceIdUpdateRoute
  '/admin/access/role/$id/update': typeof AdminAccessRoleIdUpdateRoute
  '/admin/access/user/$id/update': typeof AdminAccessUserIdUpdateRoute
  '/admin/background-job/transaction/$id/detail': typeof AdminBackgroundJobTransactionIdDetailRoute
  '/admin/consignment/registrations/$id/detail': typeof AdminConsignmentRegistrationsIdDetailRoute
  '/admin/geolocation/city/$id/detail': typeof AdminGeolocationCityIdDetailRoute
  '/admin/geolocation/city/$id/update': typeof AdminGeolocationCityIdUpdateRoute
  '/admin/geolocation/country/$id/detail': typeof AdminGeolocationCountryIdDetailRoute
  '/admin/geolocation/country/$id/update': typeof AdminGeolocationCountryIdUpdateRoute
  '/admin/geolocation/province/$id/detail': typeof AdminGeolocationProvinceIdDetailRoute
  '/admin/geolocation/province/$id/update': typeof AdminGeolocationProvinceIdUpdateRoute
  '/admin/geolocation/subdistrict/$id/detail': typeof AdminGeolocationSubdistrictIdDetailRoute
  '/admin/geolocation/subdistrict/$id/update': typeof AdminGeolocationSubdistrictIdUpdateRoute
  '/admin/geolocation/village/$id/detail': typeof AdminGeolocationVillageIdDetailRoute
  '/admin/geolocation/village/$id/update': typeof AdminGeolocationVillageIdUpdateRoute
  '/admin/petty-cash/add-fund/$id/detail': typeof AdminPettyCashAddFundIdDetailRoute
  '/admin/petty-cash/add-fund/$id/update': typeof AdminPettyCashAddFundIdUpdateRoute
  '/admin/petty-cash/expense/$id/detail': typeof AdminPettyCashExpenseIdDetailRoute
  '/admin/petty-cash/expense/$id/update': typeof AdminPettyCashExpenseIdUpdateRoute
  '/admin/petty-cash/refund/$id/detail': typeof AdminPettyCashRefundIdDetailRoute
  '/admin/petty-cash/refund/$id/update': typeof AdminPettyCashRefundIdUpdateRoute
  '/admin/pricelist/period/$id/detail': typeof AdminPricelistPeriodIdDetailRoute
  '/admin/pricelist/period/$id/update': typeof AdminPricelistPeriodIdUpdateRoute
  '/admin/receiving/simple-transfer-order/$id/detail': typeof AdminReceivingSimpleTransferOrderIdDetailRoute
  '/admin/receiving/simple-transfer-order/$id/print': typeof AdminReceivingSimpleTransferOrderIdPrintRoute
  '/admin/receiving/simple-transfer-order/$id/update': typeof AdminReceivingSimpleTransferOrderIdUpdateRoute
  '/admin/receiving/transfer-order/$id/detail': typeof AdminReceivingTransferOrderIdDetailRoute
  '/admin/receiving/transfer-order/$id/update': typeof AdminReceivingTransferOrderIdUpdateRoute
  '/admin/revenue-sharing/$id/detail/$detailId': typeof AdminRevenueSharingIdDetailDetailIdRoute
  '/admin/revenue-sharing/$id/detail/': typeof AdminRevenueSharingIdDetailIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/vendor'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/dashboard'
    | '/admin/profile'
    | '/admin/sales-dashboard'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor/'
    | '/admin/bank-account/create'
    | '/admin/bill-of-material/create'
    | '/admin/branch-category/create'
    | '/admin/branch-qris-merchant/create'
    | '/admin/branch/create'
    | '/admin/consignment-config/create'
    | '/admin/consignment-settlement/create'
    | '/admin/consignment-stockin/create'
    | '/admin/consignment-stockout/create'
    | '/admin/consignment-vendor-registration/$id'
    | '/admin/customer/create'
    | '/admin/delivery-order-batch/create'
    | '/admin/delivery-order/create'
    | '/admin/edc-terminal/create'
    | '/admin/example/see-permissions'
    | '/admin/expense-item/create'
    | '/admin/import/$templateType'
    | '/admin/internal-transfer/create'
    | '/admin/inventory-adjustment-reason/create'
    | '/admin/inventory-adjustment/create'
    | '/admin/inventory-count-template-item/create'
    | '/admin/inventory-count/create'
    | '/admin/marketplace-automation/$jobKey'
    | '/admin/member-type/create'
    | '/admin/outbound-container/scan'
    | '/admin/payment-method/create'
    | '/admin/pos-bookmark/create'
    | '/admin/poster/create'
    | '/admin/pricelist/create'
    | '/admin/print-label/large'
    | '/admin/print-label/small'
    | '/admin/product-accounting-category/create'
    | '/admin/product-addon-group/create'
    | '/admin/product-addon/create'
    | '/admin/product-availability-template/create'
    | '/admin/product-brand/create'
    | '/admin/product-category/create'
    | '/admin/product-department/create'
    | '/admin/product-division/create'
    | '/admin/product-sub-category/create'
    | '/admin/product-sub-department/create'
    | '/admin/product-tag/create'
    | '/admin/product/create'
    | '/admin/product/import'
    | '/admin/production/create'
    | '/admin/promo/create'
    | '/admin/promo/import'
    | '/admin/purchase-area/create'
    | '/admin/purchase-order/create'
    | '/admin/purchase-order/import'
    | '/admin/receiving/create'
    | '/admin/recon-bank-upload/add'
    | '/admin/recon-bank/upload'
    | '/admin/replenishment-template-category/create'
    | '/admin/replenishment-template/create'
    | '/admin/sales-channel-campaign/create'
    | '/admin/sales-channel-campaign/rules'
    | '/admin/sales-channel-category-group/create'
    | '/admin/sales-channel-category-mapping/create'
    | '/admin/sales-channel-category-mapping/import'
    | '/admin/sales-channel/create'
    | '/admin/simple-transfer-order/create'
    | '/admin/supplier/create'
    | '/admin/tax/create'
    | '/admin/transfer-order/create'
    | '/admin/transfer-order/import'
    | '/admin/transfer-request/create'
    | '/admin/transfer-request/import'
    | '/admin/uom-category/create'
    | '/admin/vendor-category/create'
    | '/admin/vendor/create'
    | '/admin/voucher-category/create'
    | '/admin/voucher/create'
    | '/admin/warehouse-location-group/create'
    | '/auth/reset-password/$token'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/admin/bank-account'
    | '/admin/bank'
    | '/admin/bill-of-material'
    | '/admin/branch-bank-account'
    | '/admin/branch-category'
    | '/admin/branch-qris-merchant'
    | '/admin/branch-sales-channel'
    | '/admin/branch'
    | '/admin/consignment-admin-team'
    | '/admin/consignment-branch-setting'
    | '/admin/consignment-config'
    | '/admin/consignment-curation'
    | '/admin/consignment-product-request'
    | '/admin/consignment-region'
    | '/admin/consignment-request'
    | '/admin/consignment-setting'
    | '/admin/consignment-settlement'
    | '/admin/consignment-stockin-request'
    | '/admin/consignment-stockin'
    | '/admin/consignment-stockout'
    | '/admin/consignment-vendor-application-invite'
    | '/admin/consignment-vendor-registration'
    | '/admin/customer'
    | '/admin/delivery-order-batch'
    | '/admin/delivery-order'
    | '/admin/edc-terminal'
    | '/admin/example'
    | '/admin/expense-item'
    | '/admin/incoming-transfer-request'
    | '/admin/internal-transfer'
    | '/admin/inventory-adjustment-reason'
    | '/admin/inventory-adjustment'
    | '/admin/inventory-count-monitoring'
    | '/admin/inventory-count-template-item'
    | '/admin/inventory-count'
    | '/admin/inventory-location'
    | '/admin/inventory-movement-summary'
    | '/admin/inventory-summary'
    | '/admin/inventory-transaction-line-unit'
    | '/admin/inventory-transaction'
    | '/admin/marketplace-automation'
    | '/admin/marketplace-channel-log'
    | '/admin/marketplace-order'
    | '/admin/member-type'
    | '/admin/outbound-container'
    | '/admin/packing-task'
    | '/admin/payment-inbound-request'
    | '/admin/payment-method'
    | '/admin/payment-provider-config'
    | '/admin/payment-transaction'
    | '/admin/payment-webhook-event'
    | '/admin/pending-sync-marketplace-order'
    | '/admin/pending-sync-sales-order'
    | '/admin/petty-cash'
    | '/admin/picking-task'
    | '/admin/pos-bookmark'
    | '/admin/poster'
    | '/admin/pricelist'
    | '/admin/print-consignment'
    | '/admin/print-non-consignment'
    | '/admin/product-accounting-category'
    | '/admin/product-addon-group'
    | '/admin/product-addon'
    | '/admin/product-availability-template'
    | '/admin/product-brand'
    | '/admin/product-category'
    | '/admin/product-department'
    | '/admin/product-division'
    | '/admin/product-sub-category'
    | '/admin/product-sub-department'
    | '/admin/product-tag'
    | '/admin/product'
    | '/admin/production'
    | '/admin/promo'
    | '/admin/purchase-area'
    | '/admin/purchase-order'
    | '/admin/putaway-task'
    | '/admin/receiving'
    | '/admin/recon-bank-upload'
    | '/admin/recon-bank'
    | '/admin/recon-outstanding'
    | '/admin/replenishment-template-category'
    | '/admin/replenishment-template'
    | '/admin/replenishment'
    | '/admin/revenue-report-access-log'
    | '/admin/revenue-report-partner-branch'
    | '/admin/revenue-report-partner'
    | '/admin/revenue-report-template'
    | '/admin/revenue-report'
    | '/admin/revenue-sharing'
    | '/admin/sales-channel-campaign'
    | '/admin/sales-channel-category-group'
    | '/admin/sales-channel-category-mapping'
    | '/admin/sales-channel-stock-threshold'
    | '/admin/sales-channel'
    | '/admin/sales-invoice-review'
    | '/admin/sales-invoice'
    | '/admin/simple-transfer-order'
    | '/admin/supplier'
    | '/admin/tax'
    | '/admin/transfer-order'
    | '/admin/transfer-request'
    | '/admin/uom-category'
    | '/admin/user-shift'
    | '/admin/vendor-category'
    | '/admin/vendor-consignment-rental-period'
    | '/admin/vendor-rental-approval'
    | '/admin/vendor'
    | '/admin/voucher-category'
    | '/admin/voucher'
    | '/admin/warehouse-location-group'
    | '/admin/warehouse'
    | '/vendor/rental'
    | '/vendor/sales'
    | '/vendor/stock'
    | '/vendor/transfer'
    | '/admin/access/app/create'
    | '/admin/access/permission/create'
    | '/admin/access/resource/create'
    | '/admin/access/role/create'
    | '/admin/access/user/create'
    | '/admin/bank-account/$id/detail'
    | '/admin/bank-account/$id/update'
    | '/admin/bill-of-material/$id/detail'
    | '/admin/bill-of-material/$id/update'
    | '/admin/branch-category/$id/detail'
    | '/admin/branch-category/$id/update'
    | '/admin/branch-qris-merchant/$id/detail'
    | '/admin/branch-qris-merchant/$id/update'
    | '/admin/branch-sales-channel/$id/detail'
    | '/admin/branch-sales-channel/$id/operating-hours'
    | '/admin/branch/$id/detail'
    | '/admin/branch/$id/update'
    | '/admin/consignment-product-request/$id/detail'
    | '/admin/consignment-request/$id/detail'
    | '/admin/consignment-settlement/$id/detail'
    | '/admin/consignment-settlement/$id/edit'
    | '/admin/consignment-settlement/$id/edit-items'
    | '/admin/consignment-settlement/$id/email-preview'
    | '/admin/consignment-stockin-request/$id/detail'
    | '/admin/consignment-stockin-request/$id/print'
    | '/admin/consignment-stockin/$id/detail'
    | '/admin/consignment-stockin/$id/print'
    | '/admin/consignment-stockin/$id/update'
    | '/admin/consignment-stockout/$id/detail'
    | '/admin/consignment-stockout/$id/print'
    | '/admin/consignment-stockout/$id/update'
    | '/admin/customer/$id/detail'
    | '/admin/customer/$id/update'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/result'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
    | '/admin/delivery-order/$id/detail'
    | '/admin/delivery-order/$id/print'
    | '/admin/delivery-order/$id/update'
    | '/admin/edc-terminal/$id/detail'
    | '/admin/edc-terminal/$id/update'
    | '/admin/expense-item/$id/detail'
    | '/admin/expense-item/$id/update'
    | '/admin/geolocation/city/create'
    | '/admin/geolocation/country/create'
    | '/admin/geolocation/province/create'
    | '/admin/geolocation/subdistrict/create'
    | '/admin/geolocation/village/create'
    | '/admin/incoming-transfer-request/$id/detail'
    | '/admin/incoming-transfer-request/$id/update'
    | '/admin/internal-transfer/$id/detail'
    | '/admin/internal-transfer/$id/print'
    | '/admin/internal-transfer/$id/update'
    | '/admin/inventory-adjustment-reason/$id/detail'
    | '/admin/inventory-adjustment-reason/$id/update'
    | '/admin/inventory-adjustment/$id/detail'
    | '/admin/inventory-adjustment/$id/print'
    | '/admin/inventory-adjustment/$id/update'
    | '/admin/inventory-adjustment/cost-adjustment/import'
    | '/admin/inventory-adjustment/opening-balance/import'
    | '/admin/inventory-count-template-item/$id/detail'
    | '/admin/inventory-count-template-item/$id/import'
    | '/admin/inventory-count-template-item/$id/update'
    | '/admin/inventory-count/$id/detail'
    | '/admin/inventory-count/$id/print'
    | '/admin/inventory-count/$id/recount'
    | '/admin/inventory-count/$id/update'
    | '/admin/inventory-transaction/$id/detail'
    | '/admin/marketplace-channel-log/$id/detail'
    | '/admin/marketplace-order/$id/detail'
    | '/admin/member-type/$id/detail'
    | '/admin/member-type/$id/update'
    | '/admin/outbound-container/$id/detail'
    | '/admin/packing-task/$id/detail'
    | '/admin/packing-task/$id/process'
    | '/admin/packing-task/$id/verify'
    | '/admin/payment-method/$id/detail'
    | '/admin/payment-method/$id/update'
    | '/admin/payment-provider-config/$id/update'
    | '/admin/payment-transaction/$id/detail'
    | '/admin/petty-cash/$id/detail'
    | '/admin/petty-cash/$id/print'
    | '/admin/petty-cash/add-fund/create'
    | '/admin/petty-cash/expense/create'
    | '/admin/petty-cash/refund/create'
    | '/admin/picking-task/$id/create-location-group'
    | '/admin/picking-task/$id/detail'
    | '/admin/pos-bookmark/$id/detail'
    | '/admin/pos-bookmark/$id/update'
    | '/admin/poster/$id/detail'
    | '/admin/poster/$id/update'
    | '/admin/pricelist/$id/detail'
    | '/admin/pricelist/$id/import'
    | '/admin/pricelist/$id/update'
    | '/admin/pricelist/period/create'
    | '/admin/product-accounting-category/$id/detail'
    | '/admin/product-accounting-category/$id/update'
    | '/admin/product-addon-group/$id/detail'
    | '/admin/product-addon-group/$id/update'
    | '/admin/product-addon/$id/detail'
    | '/admin/product-addon/$id/update'
    | '/admin/product-availability-template/$id/detail'
    | '/admin/product-availability-template/$id/import'
    | '/admin/product-availability-template/$id/update'
    | '/admin/product-brand/$id/detail'
    | '/admin/product-brand/$id/update'
    | '/admin/product-category/$id/detail'
    | '/admin/product-category/$id/update'
    | '/admin/product-department/$id/detail'
    | '/admin/product-department/$id/update'
    | '/admin/product-division/$id/detail'
    | '/admin/product-division/$id/update'
    | '/admin/product-sub-category/$id/detail'
    | '/admin/product-sub-category/$id/update'
    | '/admin/product-sub-department/$id/detail'
    | '/admin/product-sub-department/$id/update'
    | '/admin/product-tag/$id/detail'
    | '/admin/product-tag/$id/update'
    | '/admin/product/$id/detail'
    | '/admin/product/$id/update'
    | '/admin/production/$id/detail'
    | '/admin/production/$id/update'
    | '/admin/promo/$id/detail'
    | '/admin/promo/$id/import'
    | '/admin/promo/$id/update'
    | '/admin/purchase-area/$id/detail'
    | '/admin/purchase-area/$id/update'
    | '/admin/purchase-order/$id/detail'
    | '/admin/purchase-order/$id/print'
    | '/admin/purchase-order/$id/revise'
    | '/admin/purchase-order/$id/update'
    | '/admin/putaway-task/$id/detail'
    | '/admin/receiving/$id/create'
    | '/admin/receiving/$id/detail'
    | '/admin/receiving/$id/print'
    | '/admin/receiving/$id/update'
    | '/admin/receiving/simple-transfer-order/create'
    | '/admin/receiving/transfer-order/create'
    | '/admin/recon-bank-upload/$id/detail'
    | '/admin/recon-bank/$id/detail'
    | '/admin/recon-bank/$id/process'
    | '/admin/recon-bank/$id/upload'
    | '/admin/replenishment-template-category/$id/detail'
    | '/admin/replenishment-template-category/$id/update'
    | '/admin/replenishment-template/$id/detail'
    | '/admin/replenishment-template/$id/import'
    | '/admin/replenishment-template/$id/update'
    | '/admin/replenishment/$id/detail'
    | '/admin/revenue-report-partner-branch/$id/detail'
    | '/admin/revenue-report-partner/$id/detail'
    | '/admin/revenue-report-template/$id/detail'
    | '/admin/revenue-report/$id/detail'
    | '/admin/sales-channel-campaign/$id/detail'
    | '/admin/sales-channel-campaign/$id/update'
    | '/admin/sales-channel-category-group/$id/detail'
    | '/admin/sales-channel-category-group/$id/update'
    | '/admin/sales-channel-category-mapping/$id/detail'
    | '/admin/sales-channel-category-mapping/$id/update'
    | '/admin/sales-channel/$id/detail'
    | '/admin/sales-channel/$id/update'
    | '/admin/sales-invoice-review/$id/detail'
    | '/admin/sales-invoice/$id/detail'
    | '/admin/simple-transfer-order/$id/detail'
    | '/admin/simple-transfer-order/$id/print'
    | '/admin/simple-transfer-order/$id/update'
    | '/admin/supplier/$id/detail'
    | '/admin/supplier/$id/update'
    | '/admin/tax/$id/detail'
    | '/admin/tax/$id/update'
    | '/admin/transfer-order/$id/create'
    | '/admin/transfer-order/$id/detail'
    | '/admin/transfer-order/$id/print'
    | '/admin/transfer-order/$id/update'
    | '/admin/transfer-request/$id/detail'
    | '/admin/transfer-request/$id/update'
    | '/admin/uom-category/$id/detail'
    | '/admin/uom-category/$id/update'
    | '/admin/user-shift/$id/detail'
    | '/admin/vendor-category/$id/detail'
    | '/admin/vendor-category/$id/update'
    | '/admin/vendor-rental-approval/$id/detail'
    | '/admin/vendor-rental-approval/$id/print'
    | '/admin/vendor/$id/detail'
    | '/admin/vendor/$id/update'
    | '/admin/voucher-category/$id/detail'
    | '/admin/voucher-category/$id/update'
    | '/admin/voucher/$id/detail'
    | '/admin/voucher/$id/update'
    | '/admin/warehouse-location-group/$id/detail'
    | '/admin/warehouse-location-group/$id/update'
    | '/admin/warehouse/$id/detail'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/admin/access/app'
    | '/admin/access/permission'
    | '/admin/access/resource'
    | '/admin/access/role'
    | '/admin/access/user'
    | '/admin/background-job/transaction'
    | '/admin/consignment/onboarding'
    | '/admin/consignment/requests'
    | '/admin/consignment/stores-teams'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID'
    | '/admin/geolocation/city'
    | '/admin/geolocation/country'
    | '/admin/geolocation/province'
    | '/admin/geolocation/subdistrict'
    | '/admin/geolocation/village'
    | '/admin/pricelist/period'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID'
    | '/vendor/stock/$productID'
    | '/admin/access/app/$id/update'
    | '/admin/access/permission/$id/update'
    | '/admin/access/resource/$id/update'
    | '/admin/access/role/$id/update'
    | '/admin/access/user/$id/update'
    | '/admin/background-job/transaction/$id/detail'
    | '/admin/consignment/registrations/$id/detail'
    | '/admin/geolocation/city/$id/detail'
    | '/admin/geolocation/city/$id/update'
    | '/admin/geolocation/country/$id/detail'
    | '/admin/geolocation/country/$id/update'
    | '/admin/geolocation/province/$id/detail'
    | '/admin/geolocation/province/$id/update'
    | '/admin/geolocation/subdistrict/$id/detail'
    | '/admin/geolocation/subdistrict/$id/update'
    | '/admin/geolocation/village/$id/detail'
    | '/admin/geolocation/village/$id/update'
    | '/admin/petty-cash/add-fund/$id/detail'
    | '/admin/petty-cash/add-fund/$id/update'
    | '/admin/petty-cash/expense/$id/detail'
    | '/admin/petty-cash/expense/$id/update'
    | '/admin/petty-cash/refund/$id/detail'
    | '/admin/petty-cash/refund/$id/update'
    | '/admin/pricelist/period/$id/detail'
    | '/admin/pricelist/period/$id/update'
    | '/admin/receiving/simple-transfer-order/$id/detail'
    | '/admin/receiving/simple-transfer-order/$id/print'
    | '/admin/receiving/simple-transfer-order/$id/update'
    | '/admin/receiving/transfer-order/$id/detail'
    | '/admin/receiving/transfer-order/$id/update'
    | '/admin/revenue-sharing/$id/detail/$detailId'
    | '/admin/revenue-sharing/$id/detail'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/dashboard'
    | '/admin/profile'
    | '/admin/sales-dashboard'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor'
    | '/admin/bank-account/create'
    | '/admin/bill-of-material/create'
    | '/admin/branch-category/create'
    | '/admin/branch-qris-merchant/create'
    | '/admin/branch/create'
    | '/admin/consignment-config/create'
    | '/admin/consignment-settlement/create'
    | '/admin/consignment-stockin/create'
    | '/admin/consignment-stockout/create'
    | '/admin/consignment-vendor-registration/$id'
    | '/admin/customer/create'
    | '/admin/delivery-order-batch/create'
    | '/admin/delivery-order/create'
    | '/admin/edc-terminal/create'
    | '/admin/example/see-permissions'
    | '/admin/expense-item/create'
    | '/admin/import/$templateType'
    | '/admin/internal-transfer/create'
    | '/admin/inventory-adjustment-reason/create'
    | '/admin/inventory-adjustment/create'
    | '/admin/inventory-count-template-item/create'
    | '/admin/inventory-count/create'
    | '/admin/marketplace-automation/$jobKey'
    | '/admin/member-type/create'
    | '/admin/outbound-container/scan'
    | '/admin/payment-method/create'
    | '/admin/pos-bookmark/create'
    | '/admin/poster/create'
    | '/admin/pricelist/create'
    | '/admin/print-label/large'
    | '/admin/print-label/small'
    | '/admin/product-accounting-category/create'
    | '/admin/product-addon-group/create'
    | '/admin/product-addon/create'
    | '/admin/product-availability-template/create'
    | '/admin/product-brand/create'
    | '/admin/product-category/create'
    | '/admin/product-department/create'
    | '/admin/product-division/create'
    | '/admin/product-sub-category/create'
    | '/admin/product-sub-department/create'
    | '/admin/product-tag/create'
    | '/admin/product/create'
    | '/admin/product/import'
    | '/admin/production/create'
    | '/admin/promo/create'
    | '/admin/promo/import'
    | '/admin/purchase-area/create'
    | '/admin/purchase-order/create'
    | '/admin/purchase-order/import'
    | '/admin/receiving/create'
    | '/admin/recon-bank-upload/add'
    | '/admin/recon-bank/upload'
    | '/admin/replenishment-template-category/create'
    | '/admin/replenishment-template/create'
    | '/admin/sales-channel-campaign/create'
    | '/admin/sales-channel-campaign/rules'
    | '/admin/sales-channel-category-group/create'
    | '/admin/sales-channel-category-mapping/create'
    | '/admin/sales-channel-category-mapping/import'
    | '/admin/sales-channel/create'
    | '/admin/simple-transfer-order/create'
    | '/admin/supplier/create'
    | '/admin/tax/create'
    | '/admin/transfer-order/create'
    | '/admin/transfer-order/import'
    | '/admin/transfer-request/create'
    | '/admin/transfer-request/import'
    | '/admin/uom-category/create'
    | '/admin/vendor-category/create'
    | '/admin/vendor/create'
    | '/admin/voucher-category/create'
    | '/admin/voucher/create'
    | '/admin/warehouse-location-group/create'
    | '/auth/reset-password/$token'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/admin/bank-account'
    | '/admin/bank'
    | '/admin/bill-of-material'
    | '/admin/branch-bank-account'
    | '/admin/branch-category'
    | '/admin/branch-qris-merchant'
    | '/admin/branch-sales-channel'
    | '/admin/branch'
    | '/admin/consignment-admin-team'
    | '/admin/consignment-branch-setting'
    | '/admin/consignment-config'
    | '/admin/consignment-curation'
    | '/admin/consignment-product-request'
    | '/admin/consignment-region'
    | '/admin/consignment-request'
    | '/admin/consignment-setting'
    | '/admin/consignment-settlement'
    | '/admin/consignment-stockin-request'
    | '/admin/consignment-stockin'
    | '/admin/consignment-stockout'
    | '/admin/consignment-vendor-application-invite'
    | '/admin/consignment-vendor-registration'
    | '/admin/customer'
    | '/admin/delivery-order-batch'
    | '/admin/delivery-order'
    | '/admin/edc-terminal'
    | '/admin/example'
    | '/admin/expense-item'
    | '/admin/incoming-transfer-request'
    | '/admin/internal-transfer'
    | '/admin/inventory-adjustment-reason'
    | '/admin/inventory-adjustment'
    | '/admin/inventory-count-monitoring'
    | '/admin/inventory-count-template-item'
    | '/admin/inventory-count'
    | '/admin/inventory-location'
    | '/admin/inventory-movement-summary'
    | '/admin/inventory-summary'
    | '/admin/inventory-transaction-line-unit'
    | '/admin/inventory-transaction'
    | '/admin/marketplace-automation'
    | '/admin/marketplace-channel-log'
    | '/admin/marketplace-order'
    | '/admin/member-type'
    | '/admin/outbound-container'
    | '/admin/packing-task'
    | '/admin/payment-inbound-request'
    | '/admin/payment-method'
    | '/admin/payment-provider-config'
    | '/admin/payment-transaction'
    | '/admin/payment-webhook-event'
    | '/admin/pending-sync-marketplace-order'
    | '/admin/pending-sync-sales-order'
    | '/admin/petty-cash'
    | '/admin/picking-task'
    | '/admin/pos-bookmark'
    | '/admin/poster'
    | '/admin/pricelist'
    | '/admin/print-consignment'
    | '/admin/print-non-consignment'
    | '/admin/product-accounting-category'
    | '/admin/product-addon-group'
    | '/admin/product-addon'
    | '/admin/product-availability-template'
    | '/admin/product-brand'
    | '/admin/product-category'
    | '/admin/product-department'
    | '/admin/product-division'
    | '/admin/product-sub-category'
    | '/admin/product-sub-department'
    | '/admin/product-tag'
    | '/admin/product'
    | '/admin/production'
    | '/admin/promo'
    | '/admin/purchase-area'
    | '/admin/purchase-order'
    | '/admin/putaway-task'
    | '/admin/receiving'
    | '/admin/recon-bank-upload'
    | '/admin/recon-bank'
    | '/admin/recon-outstanding'
    | '/admin/replenishment-template-category'
    | '/admin/replenishment-template'
    | '/admin/replenishment'
    | '/admin/revenue-report-access-log'
    | '/admin/revenue-report-partner-branch'
    | '/admin/revenue-report-partner'
    | '/admin/revenue-report-template'
    | '/admin/revenue-report'
    | '/admin/revenue-sharing'
    | '/admin/sales-channel-campaign'
    | '/admin/sales-channel-category-group'
    | '/admin/sales-channel-category-mapping'
    | '/admin/sales-channel-stock-threshold'
    | '/admin/sales-channel'
    | '/admin/sales-invoice-review'
    | '/admin/sales-invoice'
    | '/admin/simple-transfer-order'
    | '/admin/supplier'
    | '/admin/tax'
    | '/admin/transfer-order'
    | '/admin/transfer-request'
    | '/admin/uom-category'
    | '/admin/user-shift'
    | '/admin/vendor-category'
    | '/admin/vendor-consignment-rental-period'
    | '/admin/vendor-rental-approval'
    | '/admin/vendor'
    | '/admin/voucher-category'
    | '/admin/voucher'
    | '/admin/warehouse-location-group'
    | '/admin/warehouse'
    | '/vendor/rental'
    | '/vendor/sales'
    | '/vendor/stock'
    | '/vendor/transfer'
    | '/admin/access/app/create'
    | '/admin/access/permission/create'
    | '/admin/access/resource/create'
    | '/admin/access/role/create'
    | '/admin/access/user/create'
    | '/admin/bank-account/$id/detail'
    | '/admin/bank-account/$id/update'
    | '/admin/bill-of-material/$id/detail'
    | '/admin/bill-of-material/$id/update'
    | '/admin/branch-category/$id/detail'
    | '/admin/branch-category/$id/update'
    | '/admin/branch-qris-merchant/$id/detail'
    | '/admin/branch-qris-merchant/$id/update'
    | '/admin/branch-sales-channel/$id/detail'
    | '/admin/branch-sales-channel/$id/operating-hours'
    | '/admin/branch/$id/detail'
    | '/admin/branch/$id/update'
    | '/admin/consignment-product-request/$id/detail'
    | '/admin/consignment-request/$id/detail'
    | '/admin/consignment-settlement/$id/detail'
    | '/admin/consignment-settlement/$id/edit'
    | '/admin/consignment-settlement/$id/edit-items'
    | '/admin/consignment-settlement/$id/email-preview'
    | '/admin/consignment-stockin-request/$id/detail'
    | '/admin/consignment-stockin-request/$id/print'
    | '/admin/consignment-stockin/$id/detail'
    | '/admin/consignment-stockin/$id/print'
    | '/admin/consignment-stockin/$id/update'
    | '/admin/consignment-stockout/$id/detail'
    | '/admin/consignment-stockout/$id/print'
    | '/admin/consignment-stockout/$id/update'
    | '/admin/customer/$id/detail'
    | '/admin/customer/$id/update'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/result'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
    | '/admin/delivery-order/$id/detail'
    | '/admin/delivery-order/$id/print'
    | '/admin/delivery-order/$id/update'
    | '/admin/edc-terminal/$id/detail'
    | '/admin/edc-terminal/$id/update'
    | '/admin/expense-item/$id/detail'
    | '/admin/expense-item/$id/update'
    | '/admin/geolocation/city/create'
    | '/admin/geolocation/country/create'
    | '/admin/geolocation/province/create'
    | '/admin/geolocation/subdistrict/create'
    | '/admin/geolocation/village/create'
    | '/admin/incoming-transfer-request/$id/detail'
    | '/admin/incoming-transfer-request/$id/update'
    | '/admin/internal-transfer/$id/detail'
    | '/admin/internal-transfer/$id/print'
    | '/admin/internal-transfer/$id/update'
    | '/admin/inventory-adjustment-reason/$id/detail'
    | '/admin/inventory-adjustment-reason/$id/update'
    | '/admin/inventory-adjustment/$id/detail'
    | '/admin/inventory-adjustment/$id/print'
    | '/admin/inventory-adjustment/$id/update'
    | '/admin/inventory-adjustment/cost-adjustment/import'
    | '/admin/inventory-adjustment/opening-balance/import'
    | '/admin/inventory-count-template-item/$id/detail'
    | '/admin/inventory-count-template-item/$id/import'
    | '/admin/inventory-count-template-item/$id/update'
    | '/admin/inventory-count/$id/detail'
    | '/admin/inventory-count/$id/print'
    | '/admin/inventory-count/$id/recount'
    | '/admin/inventory-count/$id/update'
    | '/admin/inventory-transaction/$id/detail'
    | '/admin/marketplace-channel-log/$id/detail'
    | '/admin/marketplace-order/$id/detail'
    | '/admin/member-type/$id/detail'
    | '/admin/member-type/$id/update'
    | '/admin/outbound-container/$id/detail'
    | '/admin/packing-task/$id/detail'
    | '/admin/packing-task/$id/process'
    | '/admin/packing-task/$id/verify'
    | '/admin/payment-method/$id/detail'
    | '/admin/payment-method/$id/update'
    | '/admin/payment-provider-config/$id/update'
    | '/admin/payment-transaction/$id/detail'
    | '/admin/petty-cash/$id/detail'
    | '/admin/petty-cash/$id/print'
    | '/admin/petty-cash/add-fund/create'
    | '/admin/petty-cash/expense/create'
    | '/admin/petty-cash/refund/create'
    | '/admin/picking-task/$id/create-location-group'
    | '/admin/picking-task/$id/detail'
    | '/admin/pos-bookmark/$id/detail'
    | '/admin/pos-bookmark/$id/update'
    | '/admin/poster/$id/detail'
    | '/admin/poster/$id/update'
    | '/admin/pricelist/$id/detail'
    | '/admin/pricelist/$id/import'
    | '/admin/pricelist/$id/update'
    | '/admin/pricelist/period/create'
    | '/admin/product-accounting-category/$id/detail'
    | '/admin/product-accounting-category/$id/update'
    | '/admin/product-addon-group/$id/detail'
    | '/admin/product-addon-group/$id/update'
    | '/admin/product-addon/$id/detail'
    | '/admin/product-addon/$id/update'
    | '/admin/product-availability-template/$id/detail'
    | '/admin/product-availability-template/$id/import'
    | '/admin/product-availability-template/$id/update'
    | '/admin/product-brand/$id/detail'
    | '/admin/product-brand/$id/update'
    | '/admin/product-category/$id/detail'
    | '/admin/product-category/$id/update'
    | '/admin/product-department/$id/detail'
    | '/admin/product-department/$id/update'
    | '/admin/product-division/$id/detail'
    | '/admin/product-division/$id/update'
    | '/admin/product-sub-category/$id/detail'
    | '/admin/product-sub-category/$id/update'
    | '/admin/product-sub-department/$id/detail'
    | '/admin/product-sub-department/$id/update'
    | '/admin/product-tag/$id/detail'
    | '/admin/product-tag/$id/update'
    | '/admin/product/$id/detail'
    | '/admin/product/$id/update'
    | '/admin/production/$id/detail'
    | '/admin/production/$id/update'
    | '/admin/promo/$id/detail'
    | '/admin/promo/$id/import'
    | '/admin/promo/$id/update'
    | '/admin/purchase-area/$id/detail'
    | '/admin/purchase-area/$id/update'
    | '/admin/purchase-order/$id/detail'
    | '/admin/purchase-order/$id/print'
    | '/admin/purchase-order/$id/revise'
    | '/admin/purchase-order/$id/update'
    | '/admin/putaway-task/$id/detail'
    | '/admin/receiving/$id/create'
    | '/admin/receiving/$id/detail'
    | '/admin/receiving/$id/print'
    | '/admin/receiving/$id/update'
    | '/admin/receiving/simple-transfer-order/create'
    | '/admin/receiving/transfer-order/create'
    | '/admin/recon-bank-upload/$id/detail'
    | '/admin/recon-bank/$id/detail'
    | '/admin/recon-bank/$id/process'
    | '/admin/recon-bank/$id/upload'
    | '/admin/replenishment-template-category/$id/detail'
    | '/admin/replenishment-template-category/$id/update'
    | '/admin/replenishment-template/$id/detail'
    | '/admin/replenishment-template/$id/import'
    | '/admin/replenishment-template/$id/update'
    | '/admin/replenishment/$id/detail'
    | '/admin/revenue-report-partner-branch/$id/detail'
    | '/admin/revenue-report-partner/$id/detail'
    | '/admin/revenue-report-template/$id/detail'
    | '/admin/revenue-report/$id/detail'
    | '/admin/sales-channel-campaign/$id/detail'
    | '/admin/sales-channel-campaign/$id/update'
    | '/admin/sales-channel-category-group/$id/detail'
    | '/admin/sales-channel-category-group/$id/update'
    | '/admin/sales-channel-category-mapping/$id/detail'
    | '/admin/sales-channel-category-mapping/$id/update'
    | '/admin/sales-channel/$id/detail'
    | '/admin/sales-channel/$id/update'
    | '/admin/sales-invoice-review/$id/detail'
    | '/admin/sales-invoice/$id/detail'
    | '/admin/simple-transfer-order/$id/detail'
    | '/admin/simple-transfer-order/$id/print'
    | '/admin/simple-transfer-order/$id/update'
    | '/admin/supplier/$id/detail'
    | '/admin/supplier/$id/update'
    | '/admin/tax/$id/detail'
    | '/admin/tax/$id/update'
    | '/admin/transfer-order/$id/create'
    | '/admin/transfer-order/$id/detail'
    | '/admin/transfer-order/$id/print'
    | '/admin/transfer-order/$id/update'
    | '/admin/transfer-request/$id/detail'
    | '/admin/transfer-request/$id/update'
    | '/admin/uom-category/$id/detail'
    | '/admin/uom-category/$id/update'
    | '/admin/user-shift/$id/detail'
    | '/admin/vendor-category/$id/detail'
    | '/admin/vendor-category/$id/update'
    | '/admin/vendor-rental-approval/$id/detail'
    | '/admin/vendor-rental-approval/$id/print'
    | '/admin/vendor/$id/detail'
    | '/admin/vendor/$id/update'
    | '/admin/voucher-category/$id/detail'
    | '/admin/voucher-category/$id/update'
    | '/admin/voucher/$id/detail'
    | '/admin/voucher/$id/update'
    | '/admin/warehouse-location-group/$id/detail'
    | '/admin/warehouse-location-group/$id/update'
    | '/admin/warehouse/$id/detail'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/admin/access/app'
    | '/admin/access/permission'
    | '/admin/access/resource'
    | '/admin/access/role'
    | '/admin/access/user'
    | '/admin/background-job/transaction'
    | '/admin/consignment/onboarding'
    | '/admin/consignment/requests'
    | '/admin/consignment/stores-teams'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID'
    | '/admin/geolocation/city'
    | '/admin/geolocation/country'
    | '/admin/geolocation/province'
    | '/admin/geolocation/subdistrict'
    | '/admin/geolocation/village'
    | '/admin/pricelist/period'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID'
    | '/vendor/stock/$productID'
    | '/admin/access/app/$id/update'
    | '/admin/access/permission/$id/update'
    | '/admin/access/resource/$id/update'
    | '/admin/access/role/$id/update'
    | '/admin/access/user/$id/update'
    | '/admin/background-job/transaction/$id/detail'
    | '/admin/consignment/registrations/$id/detail'
    | '/admin/geolocation/city/$id/detail'
    | '/admin/geolocation/city/$id/update'
    | '/admin/geolocation/country/$id/detail'
    | '/admin/geolocation/country/$id/update'
    | '/admin/geolocation/province/$id/detail'
    | '/admin/geolocation/province/$id/update'
    | '/admin/geolocation/subdistrict/$id/detail'
    | '/admin/geolocation/subdistrict/$id/update'
    | '/admin/geolocation/village/$id/detail'
    | '/admin/geolocation/village/$id/update'
    | '/admin/petty-cash/add-fund/$id/detail'
    | '/admin/petty-cash/add-fund/$id/update'
    | '/admin/petty-cash/expense/$id/detail'
    | '/admin/petty-cash/expense/$id/update'
    | '/admin/petty-cash/refund/$id/detail'
    | '/admin/petty-cash/refund/$id/update'
    | '/admin/pricelist/period/$id/detail'
    | '/admin/pricelist/period/$id/update'
    | '/admin/receiving/simple-transfer-order/$id/detail'
    | '/admin/receiving/simple-transfer-order/$id/print'
    | '/admin/receiving/simple-transfer-order/$id/update'
    | '/admin/receiving/transfer-order/$id/detail'
    | '/admin/receiving/transfer-order/$id/update'
    | '/admin/revenue-sharing/$id/detail/$detailId'
    | '/admin/revenue-sharing/$id/detail'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/vendor'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/dashboard'
    | '/admin/profile'
    | '/admin/sales-dashboard'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor/'
    | '/admin/bank-account/create'
    | '/admin/bill-of-material/create'
    | '/admin/branch-category/create'
    | '/admin/branch-qris-merchant/create'
    | '/admin/branch/create'
    | '/admin/consignment-config/create'
    | '/admin/consignment-settlement/create'
    | '/admin/consignment-stockin/create'
    | '/admin/consignment-stockout/create'
    | '/admin/consignment-vendor-registration/$id'
    | '/admin/customer/create'
    | '/admin/delivery-order-batch/create'
    | '/admin/delivery-order/create'
    | '/admin/edc-terminal/create'
    | '/admin/example/see-permissions'
    | '/admin/expense-item/create'
    | '/admin/import/$templateType'
    | '/admin/internal-transfer/create'
    | '/admin/inventory-adjustment-reason/create'
    | '/admin/inventory-adjustment/create'
    | '/admin/inventory-count-template-item/create'
    | '/admin/inventory-count/create'
    | '/admin/marketplace-automation/$jobKey'
    | '/admin/member-type/create'
    | '/admin/outbound-container/scan'
    | '/admin/payment-method/create'
    | '/admin/pos-bookmark/create'
    | '/admin/poster/create'
    | '/admin/pricelist/create'
    | '/admin/print-label/large'
    | '/admin/print-label/small'
    | '/admin/product-accounting-category/create'
    | '/admin/product-addon-group/create'
    | '/admin/product-addon/create'
    | '/admin/product-availability-template/create'
    | '/admin/product-brand/create'
    | '/admin/product-category/create'
    | '/admin/product-department/create'
    | '/admin/product-division/create'
    | '/admin/product-sub-category/create'
    | '/admin/product-sub-department/create'
    | '/admin/product-tag/create'
    | '/admin/product/create'
    | '/admin/product/import'
    | '/admin/production/create'
    | '/admin/promo/create'
    | '/admin/promo/import'
    | '/admin/purchase-area/create'
    | '/admin/purchase-order/create'
    | '/admin/purchase-order/import'
    | '/admin/receiving/create'
    | '/admin/recon-bank-upload/add'
    | '/admin/recon-bank/upload'
    | '/admin/replenishment-template-category/create'
    | '/admin/replenishment-template/create'
    | '/admin/sales-channel-campaign/create'
    | '/admin/sales-channel-campaign/rules'
    | '/admin/sales-channel-category-group/create'
    | '/admin/sales-channel-category-mapping/create'
    | '/admin/sales-channel-category-mapping/import'
    | '/admin/sales-channel/create'
    | '/admin/simple-transfer-order/create'
    | '/admin/supplier/create'
    | '/admin/tax/create'
    | '/admin/transfer-order/create'
    | '/admin/transfer-order/import'
    | '/admin/transfer-request/create'
    | '/admin/transfer-request/import'
    | '/admin/uom-category/create'
    | '/admin/vendor-category/create'
    | '/admin/vendor/create'
    | '/admin/voucher-category/create'
    | '/admin/voucher/create'
    | '/admin/warehouse-location-group/create'
    | '/auth/reset-password/$token'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/admin/bank-account/'
    | '/admin/bank/'
    | '/admin/bill-of-material/'
    | '/admin/branch-bank-account/'
    | '/admin/branch-category/'
    | '/admin/branch-qris-merchant/'
    | '/admin/branch-sales-channel/'
    | '/admin/branch/'
    | '/admin/consignment-admin-team/'
    | '/admin/consignment-branch-setting/'
    | '/admin/consignment-config/'
    | '/admin/consignment-curation/'
    | '/admin/consignment-product-request/'
    | '/admin/consignment-region/'
    | '/admin/consignment-request/'
    | '/admin/consignment-setting/'
    | '/admin/consignment-settlement/'
    | '/admin/consignment-stockin-request/'
    | '/admin/consignment-stockin/'
    | '/admin/consignment-stockout/'
    | '/admin/consignment-vendor-application-invite/'
    | '/admin/consignment-vendor-registration/'
    | '/admin/customer/'
    | '/admin/delivery-order-batch/'
    | '/admin/delivery-order/'
    | '/admin/edc-terminal/'
    | '/admin/example/'
    | '/admin/expense-item/'
    | '/admin/incoming-transfer-request/'
    | '/admin/internal-transfer/'
    | '/admin/inventory-adjustment-reason/'
    | '/admin/inventory-adjustment/'
    | '/admin/inventory-count-monitoring/'
    | '/admin/inventory-count-template-item/'
    | '/admin/inventory-count/'
    | '/admin/inventory-location/'
    | '/admin/inventory-movement-summary/'
    | '/admin/inventory-summary/'
    | '/admin/inventory-transaction-line-unit/'
    | '/admin/inventory-transaction/'
    | '/admin/marketplace-automation/'
    | '/admin/marketplace-channel-log/'
    | '/admin/marketplace-order/'
    | '/admin/member-type/'
    | '/admin/outbound-container/'
    | '/admin/packing-task/'
    | '/admin/payment-inbound-request/'
    | '/admin/payment-method/'
    | '/admin/payment-provider-config/'
    | '/admin/payment-transaction/'
    | '/admin/payment-webhook-event/'
    | '/admin/pending-sync-marketplace-order/'
    | '/admin/pending-sync-sales-order/'
    | '/admin/petty-cash/'
    | '/admin/picking-task/'
    | '/admin/pos-bookmark/'
    | '/admin/poster/'
    | '/admin/pricelist/'
    | '/admin/print-consignment/'
    | '/admin/print-non-consignment/'
    | '/admin/product-accounting-category/'
    | '/admin/product-addon-group/'
    | '/admin/product-addon/'
    | '/admin/product-availability-template/'
    | '/admin/product-brand/'
    | '/admin/product-category/'
    | '/admin/product-department/'
    | '/admin/product-division/'
    | '/admin/product-sub-category/'
    | '/admin/product-sub-department/'
    | '/admin/product-tag/'
    | '/admin/product/'
    | '/admin/production/'
    | '/admin/promo/'
    | '/admin/purchase-area/'
    | '/admin/purchase-order/'
    | '/admin/putaway-task/'
    | '/admin/receiving/'
    | '/admin/recon-bank-upload/'
    | '/admin/recon-bank/'
    | '/admin/recon-outstanding/'
    | '/admin/replenishment-template-category/'
    | '/admin/replenishment-template/'
    | '/admin/replenishment/'
    | '/admin/revenue-report-access-log/'
    | '/admin/revenue-report-partner-branch/'
    | '/admin/revenue-report-partner/'
    | '/admin/revenue-report-template/'
    | '/admin/revenue-report/'
    | '/admin/revenue-sharing/'
    | '/admin/sales-channel-campaign/'
    | '/admin/sales-channel-category-group/'
    | '/admin/sales-channel-category-mapping/'
    | '/admin/sales-channel-stock-threshold/'
    | '/admin/sales-channel/'
    | '/admin/sales-invoice-review/'
    | '/admin/sales-invoice/'
    | '/admin/simple-transfer-order/'
    | '/admin/supplier/'
    | '/admin/tax/'
    | '/admin/transfer-order/'
    | '/admin/transfer-request/'
    | '/admin/uom-category/'
    | '/admin/user-shift/'
    | '/admin/vendor-category/'
    | '/admin/vendor-consignment-rental-period/'
    | '/admin/vendor-rental-approval/'
    | '/admin/vendor/'
    | '/admin/voucher-category/'
    | '/admin/voucher/'
    | '/admin/warehouse-location-group/'
    | '/admin/warehouse/'
    | '/vendor/rental/'
    | '/vendor/sales/'
    | '/vendor/stock/'
    | '/vendor/transfer/'
    | '/admin/access/app/create'
    | '/admin/access/permission/create'
    | '/admin/access/resource/create'
    | '/admin/access/role/create'
    | '/admin/access/user/create'
    | '/admin/bank-account/$id/detail'
    | '/admin/bank-account/$id/update'
    | '/admin/bill-of-material/$id/detail'
    | '/admin/bill-of-material/$id/update'
    | '/admin/branch-category/$id/detail'
    | '/admin/branch-category/$id/update'
    | '/admin/branch-qris-merchant/$id/detail'
    | '/admin/branch-qris-merchant/$id/update'
    | '/admin/branch-sales-channel/$id/detail'
    | '/admin/branch-sales-channel/$id/operating-hours'
    | '/admin/branch/$id/detail'
    | '/admin/branch/$id/update'
    | '/admin/consignment-product-request/$id/detail'
    | '/admin/consignment-request/$id/detail'
    | '/admin/consignment-settlement/$id/detail'
    | '/admin/consignment-settlement/$id/edit'
    | '/admin/consignment-settlement/$id/edit-items'
    | '/admin/consignment-settlement/$id/email-preview'
    | '/admin/consignment-stockin-request/$id/detail'
    | '/admin/consignment-stockin-request/$id/print'
    | '/admin/consignment-stockin/$id/detail'
    | '/admin/consignment-stockin/$id/print'
    | '/admin/consignment-stockin/$id/update'
    | '/admin/consignment-stockout/$id/detail'
    | '/admin/consignment-stockout/$id/print'
    | '/admin/consignment-stockout/$id/update'
    | '/admin/customer/$id/detail'
    | '/admin/customer/$id/update'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/result'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
    | '/admin/delivery-order/$id/detail'
    | '/admin/delivery-order/$id/print'
    | '/admin/delivery-order/$id/update'
    | '/admin/edc-terminal/$id/detail'
    | '/admin/edc-terminal/$id/update'
    | '/admin/expense-item/$id/detail'
    | '/admin/expense-item/$id/update'
    | '/admin/geolocation/city/create'
    | '/admin/geolocation/country/create'
    | '/admin/geolocation/province/create'
    | '/admin/geolocation/subdistrict/create'
    | '/admin/geolocation/village/create'
    | '/admin/incoming-transfer-request/$id/detail'
    | '/admin/incoming-transfer-request/$id/update'
    | '/admin/internal-transfer/$id/detail'
    | '/admin/internal-transfer/$id/print'
    | '/admin/internal-transfer/$id/update'
    | '/admin/inventory-adjustment-reason/$id/detail'
    | '/admin/inventory-adjustment-reason/$id/update'
    | '/admin/inventory-adjustment/$id/detail'
    | '/admin/inventory-adjustment/$id/print'
    | '/admin/inventory-adjustment/$id/update'
    | '/admin/inventory-adjustment/cost-adjustment/import'
    | '/admin/inventory-adjustment/opening-balance/import'
    | '/admin/inventory-count-template-item/$id/detail'
    | '/admin/inventory-count-template-item/$id/import'
    | '/admin/inventory-count-template-item/$id/update'
    | '/admin/inventory-count/$id/detail'
    | '/admin/inventory-count/$id/print'
    | '/admin/inventory-count/$id/recount'
    | '/admin/inventory-count/$id/update'
    | '/admin/inventory-transaction/$id/detail'
    | '/admin/marketplace-channel-log/$id/detail'
    | '/admin/marketplace-order/$id/detail'
    | '/admin/member-type/$id/detail'
    | '/admin/member-type/$id/update'
    | '/admin/outbound-container/$id/detail'
    | '/admin/packing-task/$id/detail'
    | '/admin/packing-task/$id/process'
    | '/admin/packing-task/$id/verify'
    | '/admin/payment-method/$id/detail'
    | '/admin/payment-method/$id/update'
    | '/admin/payment-provider-config/$id/update'
    | '/admin/payment-transaction/$id/detail'
    | '/admin/petty-cash/$id/detail'
    | '/admin/petty-cash/$id/print'
    | '/admin/petty-cash/add-fund/create'
    | '/admin/petty-cash/expense/create'
    | '/admin/petty-cash/refund/create'
    | '/admin/picking-task/$id/create-location-group'
    | '/admin/picking-task/$id/detail'
    | '/admin/pos-bookmark/$id/detail'
    | '/admin/pos-bookmark/$id/update'
    | '/admin/poster/$id/detail'
    | '/admin/poster/$id/update'
    | '/admin/pricelist/$id/detail'
    | '/admin/pricelist/$id/import'
    | '/admin/pricelist/$id/update'
    | '/admin/pricelist/period/create'
    | '/admin/product-accounting-category/$id/detail'
    | '/admin/product-accounting-category/$id/update'
    | '/admin/product-addon-group/$id/detail'
    | '/admin/product-addon-group/$id/update'
    | '/admin/product-addon/$id/detail'
    | '/admin/product-addon/$id/update'
    | '/admin/product-availability-template/$id/detail'
    | '/admin/product-availability-template/$id/import'
    | '/admin/product-availability-template/$id/update'
    | '/admin/product-brand/$id/detail'
    | '/admin/product-brand/$id/update'
    | '/admin/product-category/$id/detail'
    | '/admin/product-category/$id/update'
    | '/admin/product-department/$id/detail'
    | '/admin/product-department/$id/update'
    | '/admin/product-division/$id/detail'
    | '/admin/product-division/$id/update'
    | '/admin/product-sub-category/$id/detail'
    | '/admin/product-sub-category/$id/update'
    | '/admin/product-sub-department/$id/detail'
    | '/admin/product-sub-department/$id/update'
    | '/admin/product-tag/$id/detail'
    | '/admin/product-tag/$id/update'
    | '/admin/product/$id/detail'
    | '/admin/product/$id/update'
    | '/admin/production/$id/detail'
    | '/admin/production/$id/update'
    | '/admin/promo/$id/detail'
    | '/admin/promo/$id/import'
    | '/admin/promo/$id/update'
    | '/admin/purchase-area/$id/detail'
    | '/admin/purchase-area/$id/update'
    | '/admin/purchase-order/$id/detail'
    | '/admin/purchase-order/$id/print'
    | '/admin/purchase-order/$id/revise'
    | '/admin/purchase-order/$id/update'
    | '/admin/putaway-task/$id/detail'
    | '/admin/receiving/$id/create'
    | '/admin/receiving/$id/detail'
    | '/admin/receiving/$id/print'
    | '/admin/receiving/$id/update'
    | '/admin/receiving/simple-transfer-order/create'
    | '/admin/receiving/transfer-order/create'
    | '/admin/recon-bank-upload/$id/detail'
    | '/admin/recon-bank/$id/detail'
    | '/admin/recon-bank/$id/process'
    | '/admin/recon-bank/$id/upload'
    | '/admin/replenishment-template-category/$id/detail'
    | '/admin/replenishment-template-category/$id/update'
    | '/admin/replenishment-template/$id/detail'
    | '/admin/replenishment-template/$id/import'
    | '/admin/replenishment-template/$id/update'
    | '/admin/replenishment/$id/detail'
    | '/admin/revenue-report-partner-branch/$id/detail'
    | '/admin/revenue-report-partner/$id/detail'
    | '/admin/revenue-report-template/$id/detail'
    | '/admin/revenue-report/$id/detail'
    | '/admin/sales-channel-campaign/$id/detail'
    | '/admin/sales-channel-campaign/$id/update'
    | '/admin/sales-channel-category-group/$id/detail'
    | '/admin/sales-channel-category-group/$id/update'
    | '/admin/sales-channel-category-mapping/$id/detail'
    | '/admin/sales-channel-category-mapping/$id/update'
    | '/admin/sales-channel/$id/detail'
    | '/admin/sales-channel/$id/update'
    | '/admin/sales-invoice-review/$id/detail'
    | '/admin/sales-invoice/$id/detail'
    | '/admin/simple-transfer-order/$id/detail'
    | '/admin/simple-transfer-order/$id/print'
    | '/admin/simple-transfer-order/$id/update'
    | '/admin/supplier/$id/detail'
    | '/admin/supplier/$id/update'
    | '/admin/tax/$id/detail'
    | '/admin/tax/$id/update'
    | '/admin/transfer-order/$id/create'
    | '/admin/transfer-order/$id/detail'
    | '/admin/transfer-order/$id/print'
    | '/admin/transfer-order/$id/update'
    | '/admin/transfer-request/$id/detail'
    | '/admin/transfer-request/$id/update'
    | '/admin/uom-category/$id/detail'
    | '/admin/uom-category/$id/update'
    | '/admin/user-shift/$id/detail'
    | '/admin/vendor-category/$id/detail'
    | '/admin/vendor-category/$id/update'
    | '/admin/vendor-rental-approval/$id/detail'
    | '/admin/vendor-rental-approval/$id/print'
    | '/admin/vendor/$id/detail'
    | '/admin/vendor/$id/update'
    | '/admin/voucher-category/$id/detail'
    | '/admin/voucher-category/$id/update'
    | '/admin/voucher/$id/detail'
    | '/admin/voucher/$id/update'
    | '/admin/warehouse-location-group/$id/detail'
    | '/admin/warehouse-location-group/$id/update'
    | '/admin/warehouse/$id/detail'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/admin/access/app/'
    | '/admin/access/permission/'
    | '/admin/access/resource/'
    | '/admin/access/role/'
    | '/admin/access/user/'
    | '/admin/background-job/transaction/'
    | '/admin/consignment/onboarding/'
    | '/admin/consignment/requests/'
    | '/admin/consignment/stores-teams/'
    | '/admin/delivery-order-batch/$deliveryOrderBatchID/'
    | '/admin/geolocation/city/'
    | '/admin/geolocation/country/'
    | '/admin/geolocation/province/'
    | '/admin/geolocation/subdistrict/'
    | '/admin/geolocation/village/'
    | '/admin/pricelist/period/'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/'
    | '/vendor/stock/$productID/'
    | '/admin/access/app/$id/update'
    | '/admin/access/permission/$id/update'
    | '/admin/access/resource/$id/update'
    | '/admin/access/role/$id/update'
    | '/admin/access/user/$id/update'
    | '/admin/background-job/transaction/$id/detail'
    | '/admin/consignment/registrations/$id/detail'
    | '/admin/geolocation/city/$id/detail'
    | '/admin/geolocation/city/$id/update'
    | '/admin/geolocation/country/$id/detail'
    | '/admin/geolocation/country/$id/update'
    | '/admin/geolocation/province/$id/detail'
    | '/admin/geolocation/province/$id/update'
    | '/admin/geolocation/subdistrict/$id/detail'
    | '/admin/geolocation/subdistrict/$id/update'
    | '/admin/geolocation/village/$id/detail'
    | '/admin/geolocation/village/$id/update'
    | '/admin/petty-cash/add-fund/$id/detail'
    | '/admin/petty-cash/add-fund/$id/update'
    | '/admin/petty-cash/expense/$id/detail'
    | '/admin/petty-cash/expense/$id/update'
    | '/admin/petty-cash/refund/$id/detail'
    | '/admin/petty-cash/refund/$id/update'
    | '/admin/pricelist/period/$id/detail'
    | '/admin/pricelist/period/$id/update'
    | '/admin/receiving/simple-transfer-order/$id/detail'
    | '/admin/receiving/simple-transfer-order/$id/print'
    | '/admin/receiving/simple-transfer-order/$id/update'
    | '/admin/receiving/transfer-order/$id/detail'
    | '/admin/receiving/transfer-order/$id/update'
    | '/admin/revenue-sharing/$id/detail/$detailId'
    | '/admin/revenue-sharing/$id/detail/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  VendorRouteRoute: typeof VendorRouteRouteWithChildren
  R403Route: typeof R403Route
  CheckEmailRoute: typeof CheckEmailRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/': {
      id: '/vendor/'
      path: '/'
      fullPath: '/vendor/'
      preLoaderRoute: typeof VendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/login': {
      id: '/vendor/login'
      path: '/login'
      fullPath: '/vendor/login'
      preLoaderRoute: typeof VendorLoginRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/dashboard': {
      id: '/vendor/dashboard'
      path: '/dashboard'
      fullPath: '/vendor/dashboard'
      preLoaderRoute: typeof VendorDashboardRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/admin/sales-dashboard': {
      id: '/admin/sales-dashboard'
      path: '/sales-dashboard'
      fullPath: '/admin/sales-dashboard'
      preLoaderRoute: typeof AdminSalesDashboardRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/vendor/transfer/': {
      id: '/vendor/transfer/'
      path: '/transfer'
      fullPath: '/vendor/transfer'
      preLoaderRoute: typeof VendorTransferIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock/': {
      id: '/vendor/stock/'
      path: '/stock'
      fullPath: '/vendor/stock'
      preLoaderRoute: typeof VendorStockIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/sales/': {
      id: '/vendor/sales/'
      path: '/sales'
      fullPath: '/vendor/sales'
      preLoaderRoute: typeof VendorSalesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/': {
      id: '/vendor/rental/'
      path: '/rental'
      fullPath: '/vendor/rental'
      preLoaderRoute: typeof VendorRentalIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/admin/warehouse/': {
      id: '/admin/warehouse/'
      path: '/warehouse'
      fullPath: '/admin/warehouse'
      preLoaderRoute: typeof AdminWarehouseIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/warehouse-location-group/': {
      id: '/admin/warehouse-location-group/'
      path: '/warehouse-location-group'
      fullPath: '/admin/warehouse-location-group'
      preLoaderRoute: typeof AdminWarehouseLocationGroupIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher/': {
      id: '/admin/voucher/'
      path: '/voucher'
      fullPath: '/admin/voucher'
      preLoaderRoute: typeof AdminVoucherIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher-category/': {
      id: '/admin/voucher-category/'
      path: '/voucher-category'
      fullPath: '/admin/voucher-category'
      preLoaderRoute: typeof AdminVoucherCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor/': {
      id: '/admin/vendor/'
      path: '/vendor'
      fullPath: '/admin/vendor'
      preLoaderRoute: typeof AdminVendorIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-rental-approval/': {
      id: '/admin/vendor-rental-approval/'
      path: '/vendor-rental-approval'
      fullPath: '/admin/vendor-rental-approval'
      preLoaderRoute: typeof AdminVendorRentalApprovalIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-consignment-rental-period/': {
      id: '/admin/vendor-consignment-rental-period/'
      path: '/vendor-consignment-rental-period'
      fullPath: '/admin/vendor-consignment-rental-period'
      preLoaderRoute: typeof AdminVendorConsignmentRentalPeriodIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-category/': {
      id: '/admin/vendor-category/'
      path: '/vendor-category'
      fullPath: '/admin/vendor-category'
      preLoaderRoute: typeof AdminVendorCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/user-shift/': {
      id: '/admin/user-shift/'
      path: '/user-shift'
      fullPath: '/admin/user-shift'
      preLoaderRoute: typeof AdminUserShiftIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/uom-category/': {
      id: '/admin/uom-category/'
      path: '/uom-category'
      fullPath: '/admin/uom-category'
      preLoaderRoute: typeof AdminUomCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-request/': {
      id: '/admin/transfer-request/'
      path: '/transfer-request'
      fullPath: '/admin/transfer-request'
      preLoaderRoute: typeof AdminTransferRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/': {
      id: '/admin/transfer-order/'
      path: '/transfer-order'
      fullPath: '/admin/transfer-order'
      preLoaderRoute: typeof AdminTransferOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tax/': {
      id: '/admin/tax/'
      path: '/tax'
      fullPath: '/admin/tax'
      preLoaderRoute: typeof AdminTaxIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/supplier/': {
      id: '/admin/supplier/'
      path: '/supplier'
      fullPath: '/admin/supplier'
      preLoaderRoute: typeof AdminSupplierIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/simple-transfer-order/': {
      id: '/admin/simple-transfer-order/'
      path: '/simple-transfer-order'
      fullPath: '/admin/simple-transfer-order'
      preLoaderRoute: typeof AdminSimpleTransferOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-invoice/': {
      id: '/admin/sales-invoice/'
      path: '/sales-invoice'
      fullPath: '/admin/sales-invoice'
      preLoaderRoute: typeof AdminSalesInvoiceIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-invoice-review/': {
      id: '/admin/sales-invoice-review/'
      path: '/sales-invoice-review'
      fullPath: '/admin/sales-invoice-review'
      preLoaderRoute: typeof AdminSalesInvoiceReviewIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel/': {
      id: '/admin/sales-channel/'
      path: '/sales-channel'
      fullPath: '/admin/sales-channel'
      preLoaderRoute: typeof AdminSalesChannelIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-stock-threshold/': {
      id: '/admin/sales-channel-stock-threshold/'
      path: '/sales-channel-stock-threshold'
      fullPath: '/admin/sales-channel-stock-threshold'
      preLoaderRoute: typeof AdminSalesChannelStockThresholdIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-mapping/': {
      id: '/admin/sales-channel-category-mapping/'
      path: '/sales-channel-category-mapping'
      fullPath: '/admin/sales-channel-category-mapping'
      preLoaderRoute: typeof AdminSalesChannelCategoryMappingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-group/': {
      id: '/admin/sales-channel-category-group/'
      path: '/sales-channel-category-group'
      fullPath: '/admin/sales-channel-category-group'
      preLoaderRoute: typeof AdminSalesChannelCategoryGroupIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-campaign/': {
      id: '/admin/sales-channel-campaign/'
      path: '/sales-channel-campaign'
      fullPath: '/admin/sales-channel-campaign'
      preLoaderRoute: typeof AdminSalesChannelCampaignIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-sharing/': {
      id: '/admin/revenue-sharing/'
      path: '/revenue-sharing'
      fullPath: '/admin/revenue-sharing'
      preLoaderRoute: typeof AdminRevenueSharingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report/': {
      id: '/admin/revenue-report/'
      path: '/revenue-report'
      fullPath: '/admin/revenue-report'
      preLoaderRoute: typeof AdminRevenueReportIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-template/': {
      id: '/admin/revenue-report-template/'
      path: '/revenue-report-template'
      fullPath: '/admin/revenue-report-template'
      preLoaderRoute: typeof AdminRevenueReportTemplateIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-partner/': {
      id: '/admin/revenue-report-partner/'
      path: '/revenue-report-partner'
      fullPath: '/admin/revenue-report-partner'
      preLoaderRoute: typeof AdminRevenueReportPartnerIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-partner-branch/': {
      id: '/admin/revenue-report-partner-branch/'
      path: '/revenue-report-partner-branch'
      fullPath: '/admin/revenue-report-partner-branch'
      preLoaderRoute: typeof AdminRevenueReportPartnerBranchIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-access-log/': {
      id: '/admin/revenue-report-access-log/'
      path: '/revenue-report-access-log'
      fullPath: '/admin/revenue-report-access-log'
      preLoaderRoute: typeof AdminRevenueReportAccessLogIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment/': {
      id: '/admin/replenishment/'
      path: '/replenishment'
      fullPath: '/admin/replenishment'
      preLoaderRoute: typeof AdminReplenishmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template/': {
      id: '/admin/replenishment-template/'
      path: '/replenishment-template'
      fullPath: '/admin/replenishment-template'
      preLoaderRoute: typeof AdminReplenishmentTemplateIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template-category/': {
      id: '/admin/replenishment-template-category/'
      path: '/replenishment-template-category'
      fullPath: '/admin/replenishment-template-category'
      preLoaderRoute: typeof AdminReplenishmentTemplateCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-outstanding/': {
      id: '/admin/recon-outstanding/'
      path: '/recon-outstanding'
      fullPath: '/admin/recon-outstanding'
      preLoaderRoute: typeof AdminReconOutstandingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank/': {
      id: '/admin/recon-bank/'
      path: '/recon-bank'
      fullPath: '/admin/recon-bank'
      preLoaderRoute: typeof AdminReconBankIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank-upload/': {
      id: '/admin/recon-bank-upload/'
      path: '/recon-bank-upload'
      fullPath: '/admin/recon-bank-upload'
      preLoaderRoute: typeof AdminReconBankUploadIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/': {
      id: '/admin/receiving/'
      path: '/receiving'
      fullPath: '/admin/receiving'
      preLoaderRoute: typeof AdminReceivingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/putaway-task/': {
      id: '/admin/putaway-task/'
      path: '/putaway-task'
      fullPath: '/admin/putaway-task'
      preLoaderRoute: typeof AdminPutawayTaskIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/': {
      id: '/admin/purchase-order/'
      path: '/purchase-order'
      fullPath: '/admin/purchase-order'
      preLoaderRoute: typeof AdminPurchaseOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-area/': {
      id: '/admin/purchase-area/'
      path: '/purchase-area'
      fullPath: '/admin/purchase-area'
      preLoaderRoute: typeof AdminPurchaseAreaIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/': {
      id: '/admin/promo/'
      path: '/promo'
      fullPath: '/admin/promo'
      preLoaderRoute: typeof AdminPromoIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/production/': {
      id: '/admin/production/'
      path: '/production'
      fullPath: '/admin/production'
      preLoaderRoute: typeof AdminProductionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product/': {
      id: '/admin/product/'
      path: '/product'
      fullPath: '/admin/product'
      preLoaderRoute: typeof AdminProductIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-tag/': {
      id: '/admin/product-tag/'
      path: '/product-tag'
      fullPath: '/admin/product-tag'
      preLoaderRoute: typeof AdminProductTagIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-department/': {
      id: '/admin/product-sub-department/'
      path: '/product-sub-department'
      fullPath: '/admin/product-sub-department'
      preLoaderRoute: typeof AdminProductSubDepartmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-category/': {
      id: '/admin/product-sub-category/'
      path: '/product-sub-category'
      fullPath: '/admin/product-sub-category'
      preLoaderRoute: typeof AdminProductSubCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-division/': {
      id: '/admin/product-division/'
      path: '/product-division'
      fullPath: '/admin/product-division'
      preLoaderRoute: typeof AdminProductDivisionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-department/': {
      id: '/admin/product-department/'
      path: '/product-department'
      fullPath: '/admin/product-department'
      preLoaderRoute: typeof AdminProductDepartmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-category/': {
      id: '/admin/product-category/'
      path: '/product-category'
      fullPath: '/admin/product-category'
      preLoaderRoute: typeof AdminProductCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-brand/': {
      id: '/admin/product-brand/'
      path: '/product-brand'
      fullPath: '/admin/product-brand'
      preLoaderRoute: typeof AdminProductBrandIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-availability-template/': {
      id: '/admin/product-availability-template/'
      path: '/product-availability-template'
      fullPath: '/admin/product-availability-template'
      preLoaderRoute: typeof AdminProductAvailabilityTemplateIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon/': {
      id: '/admin/product-addon/'
      path: '/product-addon'
      fullPath: '/admin/product-addon'
      preLoaderRoute: typeof AdminProductAddonIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon-group/': {
      id: '/admin/product-addon-group/'
      path: '/product-addon-group'
      fullPath: '/admin/product-addon-group'
      preLoaderRoute: typeof AdminProductAddonGroupIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-accounting-category/': {
      id: '/admin/product-accounting-category/'
      path: '/product-accounting-category'
      fullPath: '/admin/product-accounting-category'
      preLoaderRoute: typeof AdminProductAccountingCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/print-non-consignment/': {
      id: '/admin/print-non-consignment/'
      path: '/print-non-consignment'
      fullPath: '/admin/print-non-consignment'
      preLoaderRoute: typeof AdminPrintNonConsignmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/print-consignment/': {
      id: '/admin/print-consignment/'
      path: '/print-consignment'
      fullPath: '/admin/print-consignment'
      preLoaderRoute: typeof AdminPrintConsignmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/': {
      id: '/admin/pricelist/'
      path: '/pricelist'
      fullPath: '/admin/pricelist'
      preLoaderRoute: typeof AdminPricelistIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/poster/': {
      id: '/admin/poster/'
      path: '/poster'
      fullPath: '/admin/poster'
      preLoaderRoute: typeof AdminPosterIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pos-bookmark/': {
      id: '/admin/pos-bookmark/'
      path: '/pos-bookmark'
      fullPath: '/admin/pos-bookmark'
      preLoaderRoute: typeof AdminPosBookmarkIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/picking-task/': {
      id: '/admin/picking-task/'
      path: '/picking-task'
      fullPath: '/admin/picking-task'
      preLoaderRoute: typeof AdminPickingTaskIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/': {
      id: '/admin/petty-cash/'
      path: '/petty-cash'
      fullPath: '/admin/petty-cash'
      preLoaderRoute: typeof AdminPettyCashIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pending-sync-sales-order/': {
      id: '/admin/pending-sync-sales-order/'
      path: '/pending-sync-sales-order'
      fullPath: '/admin/pending-sync-sales-order'
      preLoaderRoute: typeof AdminPendingSyncSalesOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pending-sync-marketplace-order/': {
      id: '/admin/pending-sync-marketplace-order/'
      path: '/pending-sync-marketplace-order'
      fullPath: '/admin/pending-sync-marketplace-order'
      preLoaderRoute: typeof AdminPendingSyncMarketplaceOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-webhook-event/': {
      id: '/admin/payment-webhook-event/'
      path: '/payment-webhook-event'
      fullPath: '/admin/payment-webhook-event'
      preLoaderRoute: typeof AdminPaymentWebhookEventIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-transaction/': {
      id: '/admin/payment-transaction/'
      path: '/payment-transaction'
      fullPath: '/admin/payment-transaction'
      preLoaderRoute: typeof AdminPaymentTransactionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-provider-config/': {
      id: '/admin/payment-provider-config/'
      path: '/payment-provider-config'
      fullPath: '/admin/payment-provider-config'
      preLoaderRoute: typeof AdminPaymentProviderConfigIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-method/': {
      id: '/admin/payment-method/'
      path: '/payment-method'
      fullPath: '/admin/payment-method'
      preLoaderRoute: typeof AdminPaymentMethodIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-inbound-request/': {
      id: '/admin/payment-inbound-request/'
      path: '/payment-inbound-request'
      fullPath: '/admin/payment-inbound-request'
      preLoaderRoute: typeof AdminPaymentInboundRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/packing-task/': {
      id: '/admin/packing-task/'
      path: '/packing-task'
      fullPath: '/admin/packing-task'
      preLoaderRoute: typeof AdminPackingTaskIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/outbound-container/': {
      id: '/admin/outbound-container/'
      path: '/outbound-container'
      fullPath: '/admin/outbound-container'
      preLoaderRoute: typeof AdminOutboundContainerIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/member-type/': {
      id: '/admin/member-type/'
      path: '/member-type'
      fullPath: '/admin/member-type'
      preLoaderRoute: typeof AdminMemberTypeIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-order/': {
      id: '/admin/marketplace-order/'
      path: '/marketplace-order'
      fullPath: '/admin/marketplace-order'
      preLoaderRoute: typeof AdminMarketplaceOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-channel-log/': {
      id: '/admin/marketplace-channel-log/'
      path: '/marketplace-channel-log'
      fullPath: '/admin/marketplace-channel-log'
      preLoaderRoute: typeof AdminMarketplaceChannelLogIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-automation/': {
      id: '/admin/marketplace-automation/'
      path: '/marketplace-automation'
      fullPath: '/admin/marketplace-automation'
      preLoaderRoute: typeof AdminMarketplaceAutomationIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-transaction/': {
      id: '/admin/inventory-transaction/'
      path: '/inventory-transaction'
      fullPath: '/admin/inventory-transaction'
      preLoaderRoute: typeof AdminInventoryTransactionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-transaction-line-unit/': {
      id: '/admin/inventory-transaction-line-unit/'
      path: '/inventory-transaction-line-unit'
      fullPath: '/admin/inventory-transaction-line-unit'
      preLoaderRoute: typeof AdminInventoryTransactionLineUnitIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-summary/': {
      id: '/admin/inventory-summary/'
      path: '/inventory-summary'
      fullPath: '/admin/inventory-summary'
      preLoaderRoute: typeof AdminInventorySummaryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-movement-summary/': {
      id: '/admin/inventory-movement-summary/'
      path: '/inventory-movement-summary'
      fullPath: '/admin/inventory-movement-summary'
      preLoaderRoute: typeof AdminInventoryMovementSummaryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-location/': {
      id: '/admin/inventory-location/'
      path: '/inventory-location'
      fullPath: '/admin/inventory-location'
      preLoaderRoute: typeof AdminInventoryLocationIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/': {
      id: '/admin/inventory-count/'
      path: '/inventory-count'
      fullPath: '/admin/inventory-count'
      preLoaderRoute: typeof AdminInventoryCountIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-template-item/': {
      id: '/admin/inventory-count-template-item/'
      path: '/inventory-count-template-item'
      fullPath: '/admin/inventory-count-template-item'
      preLoaderRoute: typeof AdminInventoryCountTemplateItemIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-monitoring/': {
      id: '/admin/inventory-count-monitoring/'
      path: '/inventory-count-monitoring'
      fullPath: '/admin/inventory-count-monitoring'
      preLoaderRoute: typeof AdminInventoryCountMonitoringIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/': {
      id: '/admin/inventory-adjustment/'
      path: '/inventory-adjustment'
      fullPath: '/admin/inventory-adjustment'
      preLoaderRoute: typeof AdminInventoryAdjustmentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment-reason/': {
      id: '/admin/inventory-adjustment-reason/'
      path: '/inventory-adjustment-reason'
      fullPath: '/admin/inventory-adjustment-reason'
      preLoaderRoute: typeof AdminInventoryAdjustmentReasonIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/internal-transfer/': {
      id: '/admin/internal-transfer/'
      path: '/internal-transfer'
      fullPath: '/admin/internal-transfer'
      preLoaderRoute: typeof AdminInternalTransferIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/incoming-transfer-request/': {
      id: '/admin/incoming-transfer-request/'
      path: '/incoming-transfer-request'
      fullPath: '/admin/incoming-transfer-request'
      preLoaderRoute: typeof AdminIncomingTransferRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/expense-item/': {
      id: '/admin/expense-item/'
      path: '/expense-item'
      fullPath: '/admin/expense-item'
      preLoaderRoute: typeof AdminExpenseItemIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/example/': {
      id: '/admin/example/'
      path: '/example'
      fullPath: '/admin/example'
      preLoaderRoute: typeof AdminExampleIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/edc-terminal/': {
      id: '/admin/edc-terminal/'
      path: '/edc-terminal'
      fullPath: '/admin/edc-terminal'
      preLoaderRoute: typeof AdminEdcTerminalIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order/': {
      id: '/admin/delivery-order/'
      path: '/delivery-order'
      fullPath: '/admin/delivery-order'
      preLoaderRoute: typeof AdminDeliveryOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/': {
      id: '/admin/delivery-order-batch/'
      path: '/delivery-order-batch'
      fullPath: '/admin/delivery-order-batch'
      preLoaderRoute: typeof AdminDeliveryOrderBatchIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customer/': {
      id: '/admin/customer/'
      path: '/customer'
      fullPath: '/admin/customer'
      preLoaderRoute: typeof AdminCustomerIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-vendor-registration/': {
      id: '/admin/consignment-vendor-registration/'
      path: '/consignment-vendor-registration'
      fullPath: '/admin/consignment-vendor-registration'
      preLoaderRoute: typeof AdminConsignmentVendorRegistrationIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-vendor-application-invite/': {
      id: '/admin/consignment-vendor-application-invite/'
      path: '/consignment-vendor-application-invite'
      fullPath: '/admin/consignment-vendor-application-invite'
      preLoaderRoute: typeof AdminConsignmentVendorApplicationInviteIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockout/': {
      id: '/admin/consignment-stockout/'
      path: '/consignment-stockout'
      fullPath: '/admin/consignment-stockout'
      preLoaderRoute: typeof AdminConsignmentStockoutIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin/': {
      id: '/admin/consignment-stockin/'
      path: '/consignment-stockin'
      fullPath: '/admin/consignment-stockin'
      preLoaderRoute: typeof AdminConsignmentStockinIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin-request/': {
      id: '/admin/consignment-stockin-request/'
      path: '/consignment-stockin-request'
      fullPath: '/admin/consignment-stockin-request'
      preLoaderRoute: typeof AdminConsignmentStockinRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/': {
      id: '/admin/consignment-settlement/'
      path: '/consignment-settlement'
      fullPath: '/admin/consignment-settlement'
      preLoaderRoute: typeof AdminConsignmentSettlementIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-setting/': {
      id: '/admin/consignment-setting/'
      path: '/consignment-setting'
      fullPath: '/admin/consignment-setting'
      preLoaderRoute: typeof AdminConsignmentSettingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-request/': {
      id: '/admin/consignment-request/'
      path: '/consignment-request'
      fullPath: '/admin/consignment-request'
      preLoaderRoute: typeof AdminConsignmentRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-region/': {
      id: '/admin/consignment-region/'
      path: '/consignment-region'
      fullPath: '/admin/consignment-region'
      preLoaderRoute: typeof AdminConsignmentRegionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-product-request/': {
      id: '/admin/consignment-product-request/'
      path: '/consignment-product-request'
      fullPath: '/admin/consignment-product-request'
      preLoaderRoute: typeof AdminConsignmentProductRequestIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-curation/': {
      id: '/admin/consignment-curation/'
      path: '/consignment-curation'
      fullPath: '/admin/consignment-curation'
      preLoaderRoute: typeof AdminConsignmentCurationIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-config/': {
      id: '/admin/consignment-config/'
      path: '/consignment-config'
      fullPath: '/admin/consignment-config'
      preLoaderRoute: typeof AdminConsignmentConfigIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-branch-setting/': {
      id: '/admin/consignment-branch-setting/'
      path: '/consignment-branch-setting'
      fullPath: '/admin/consignment-branch-setting'
      preLoaderRoute: typeof AdminConsignmentBranchSettingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-admin-team/': {
      id: '/admin/consignment-admin-team/'
      path: '/consignment-admin-team'
      fullPath: '/admin/consignment-admin-team'
      preLoaderRoute: typeof AdminConsignmentAdminTeamIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch/': {
      id: '/admin/branch/'
      path: '/branch'
      fullPath: '/admin/branch'
      preLoaderRoute: typeof AdminBranchIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-sales-channel/': {
      id: '/admin/branch-sales-channel/'
      path: '/branch-sales-channel'
      fullPath: '/admin/branch-sales-channel'
      preLoaderRoute: typeof AdminBranchSalesChannelIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-qris-merchant/': {
      id: '/admin/branch-qris-merchant/'
      path: '/branch-qris-merchant'
      fullPath: '/admin/branch-qris-merchant'
      preLoaderRoute: typeof AdminBranchQrisMerchantIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-category/': {
      id: '/admin/branch-category/'
      path: '/branch-category'
      fullPath: '/admin/branch-category'
      preLoaderRoute: typeof AdminBranchCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-bank-account/': {
      id: '/admin/branch-bank-account/'
      path: '/branch-bank-account'
      fullPath: '/admin/branch-bank-account'
      preLoaderRoute: typeof AdminBranchBankAccountIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bill-of-material/': {
      id: '/admin/bill-of-material/'
      path: '/bill-of-material'
      fullPath: '/admin/bill-of-material'
      preLoaderRoute: typeof AdminBillOfMaterialIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bank/': {
      id: '/admin/bank/'
      path: '/bank'
      fullPath: '/admin/bank'
      preLoaderRoute: typeof AdminBankIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bank-account/': {
      id: '/admin/bank-account/'
      path: '/bank-account'
      fullPath: '/admin/bank-account'
      preLoaderRoute: typeof AdminBankAccountIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/vendor/sales/$salesConsignmentInvoiceID': {
      id: '/vendor/sales/$salesConsignmentInvoiceID'
      path: '/sales/$salesConsignmentInvoiceID'
      fullPath: '/vendor/sales/$salesConsignmentInvoiceID'
      preLoaderRoute: typeof VendorSalesSalesConsignmentInvoiceIDRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/new': {
      id: '/vendor/rental/new'
      path: '/rental/new'
      fullPath: '/vendor/rental/new'
      preLoaderRoute: typeof VendorRentalNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/auth/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/warehouse-location-group/create': {
      id: '/admin/warehouse-location-group/create'
      path: '/warehouse-location-group/create'
      fullPath: '/admin/warehouse-location-group/create'
      preLoaderRoute: typeof AdminWarehouseLocationGroupCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher/create': {
      id: '/admin/voucher/create'
      path: '/voucher/create'
      fullPath: '/admin/voucher/create'
      preLoaderRoute: typeof AdminVoucherCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher-category/create': {
      id: '/admin/voucher-category/create'
      path: '/voucher-category/create'
      fullPath: '/admin/voucher-category/create'
      preLoaderRoute: typeof AdminVoucherCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor/create': {
      id: '/admin/vendor/create'
      path: '/vendor/create'
      fullPath: '/admin/vendor/create'
      preLoaderRoute: typeof AdminVendorCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-category/create': {
      id: '/admin/vendor-category/create'
      path: '/vendor-category/create'
      fullPath: '/admin/vendor-category/create'
      preLoaderRoute: typeof AdminVendorCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/uom-category/create': {
      id: '/admin/uom-category/create'
      path: '/uom-category/create'
      fullPath: '/admin/uom-category/create'
      preLoaderRoute: typeof AdminUomCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-request/import': {
      id: '/admin/transfer-request/import'
      path: '/transfer-request/import'
      fullPath: '/admin/transfer-request/import'
      preLoaderRoute: typeof AdminTransferRequestImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-request/create': {
      id: '/admin/transfer-request/create'
      path: '/transfer-request/create'
      fullPath: '/admin/transfer-request/create'
      preLoaderRoute: typeof AdminTransferRequestCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/import': {
      id: '/admin/transfer-order/import'
      path: '/transfer-order/import'
      fullPath: '/admin/transfer-order/import'
      preLoaderRoute: typeof AdminTransferOrderImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/create': {
      id: '/admin/transfer-order/create'
      path: '/transfer-order/create'
      fullPath: '/admin/transfer-order/create'
      preLoaderRoute: typeof AdminTransferOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tax/create': {
      id: '/admin/tax/create'
      path: '/tax/create'
      fullPath: '/admin/tax/create'
      preLoaderRoute: typeof AdminTaxCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/supplier/create': {
      id: '/admin/supplier/create'
      path: '/supplier/create'
      fullPath: '/admin/supplier/create'
      preLoaderRoute: typeof AdminSupplierCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/simple-transfer-order/create': {
      id: '/admin/simple-transfer-order/create'
      path: '/simple-transfer-order/create'
      fullPath: '/admin/simple-transfer-order/create'
      preLoaderRoute: typeof AdminSimpleTransferOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel/create': {
      id: '/admin/sales-channel/create'
      path: '/sales-channel/create'
      fullPath: '/admin/sales-channel/create'
      preLoaderRoute: typeof AdminSalesChannelCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-mapping/import': {
      id: '/admin/sales-channel-category-mapping/import'
      path: '/sales-channel-category-mapping/import'
      fullPath: '/admin/sales-channel-category-mapping/import'
      preLoaderRoute: typeof AdminSalesChannelCategoryMappingImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-mapping/create': {
      id: '/admin/sales-channel-category-mapping/create'
      path: '/sales-channel-category-mapping/create'
      fullPath: '/admin/sales-channel-category-mapping/create'
      preLoaderRoute: typeof AdminSalesChannelCategoryMappingCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-group/create': {
      id: '/admin/sales-channel-category-group/create'
      path: '/sales-channel-category-group/create'
      fullPath: '/admin/sales-channel-category-group/create'
      preLoaderRoute: typeof AdminSalesChannelCategoryGroupCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-campaign/rules': {
      id: '/admin/sales-channel-campaign/rules'
      path: '/sales-channel-campaign/rules'
      fullPath: '/admin/sales-channel-campaign/rules'
      preLoaderRoute: typeof AdminSalesChannelCampaignRulesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-campaign/create': {
      id: '/admin/sales-channel-campaign/create'
      path: '/sales-channel-campaign/create'
      fullPath: '/admin/sales-channel-campaign/create'
      preLoaderRoute: typeof AdminSalesChannelCampaignCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template/create': {
      id: '/admin/replenishment-template/create'
      path: '/replenishment-template/create'
      fullPath: '/admin/replenishment-template/create'
      preLoaderRoute: typeof AdminReplenishmentTemplateCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template-category/create': {
      id: '/admin/replenishment-template-category/create'
      path: '/replenishment-template-category/create'
      fullPath: '/admin/replenishment-template-category/create'
      preLoaderRoute: typeof AdminReplenishmentTemplateCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank/upload': {
      id: '/admin/recon-bank/upload'
      path: '/recon-bank/upload'
      fullPath: '/admin/recon-bank/upload'
      preLoaderRoute: typeof AdminReconBankUploadRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank-upload/add': {
      id: '/admin/recon-bank-upload/add'
      path: '/recon-bank-upload/add'
      fullPath: '/admin/recon-bank-upload/add'
      preLoaderRoute: typeof AdminReconBankUploadAddRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/create': {
      id: '/admin/receiving/create'
      path: '/receiving/create'
      fullPath: '/admin/receiving/create'
      preLoaderRoute: typeof AdminReceivingCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/import': {
      id: '/admin/purchase-order/import'
      path: '/purchase-order/import'
      fullPath: '/admin/purchase-order/import'
      preLoaderRoute: typeof AdminPurchaseOrderImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/create': {
      id: '/admin/purchase-order/create'
      path: '/purchase-order/create'
      fullPath: '/admin/purchase-order/create'
      preLoaderRoute: typeof AdminPurchaseOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-area/create': {
      id: '/admin/purchase-area/create'
      path: '/purchase-area/create'
      fullPath: '/admin/purchase-area/create'
      preLoaderRoute: typeof AdminPurchaseAreaCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/import': {
      id: '/admin/promo/import'
      path: '/promo/import'
      fullPath: '/admin/promo/import'
      preLoaderRoute: typeof AdminPromoImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/create': {
      id: '/admin/promo/create'
      path: '/promo/create'
      fullPath: '/admin/promo/create'
      preLoaderRoute: typeof AdminPromoCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/production/create': {
      id: '/admin/production/create'
      path: '/production/create'
      fullPath: '/admin/production/create'
      preLoaderRoute: typeof AdminProductionCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product/import': {
      id: '/admin/product/import'
      path: '/product/import'
      fullPath: '/admin/product/import'
      preLoaderRoute: typeof AdminProductImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product/create': {
      id: '/admin/product/create'
      path: '/product/create'
      fullPath: '/admin/product/create'
      preLoaderRoute: typeof AdminProductCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-tag/create': {
      id: '/admin/product-tag/create'
      path: '/product-tag/create'
      fullPath: '/admin/product-tag/create'
      preLoaderRoute: typeof AdminProductTagCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-department/create': {
      id: '/admin/product-sub-department/create'
      path: '/product-sub-department/create'
      fullPath: '/admin/product-sub-department/create'
      preLoaderRoute: typeof AdminProductSubDepartmentCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-category/create': {
      id: '/admin/product-sub-category/create'
      path: '/product-sub-category/create'
      fullPath: '/admin/product-sub-category/create'
      preLoaderRoute: typeof AdminProductSubCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-division/create': {
      id: '/admin/product-division/create'
      path: '/product-division/create'
      fullPath: '/admin/product-division/create'
      preLoaderRoute: typeof AdminProductDivisionCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-department/create': {
      id: '/admin/product-department/create'
      path: '/product-department/create'
      fullPath: '/admin/product-department/create'
      preLoaderRoute: typeof AdminProductDepartmentCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-category/create': {
      id: '/admin/product-category/create'
      path: '/product-category/create'
      fullPath: '/admin/product-category/create'
      preLoaderRoute: typeof AdminProductCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-brand/create': {
      id: '/admin/product-brand/create'
      path: '/product-brand/create'
      fullPath: '/admin/product-brand/create'
      preLoaderRoute: typeof AdminProductBrandCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-availability-template/create': {
      id: '/admin/product-availability-template/create'
      path: '/product-availability-template/create'
      fullPath: '/admin/product-availability-template/create'
      preLoaderRoute: typeof AdminProductAvailabilityTemplateCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon/create': {
      id: '/admin/product-addon/create'
      path: '/product-addon/create'
      fullPath: '/admin/product-addon/create'
      preLoaderRoute: typeof AdminProductAddonCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon-group/create': {
      id: '/admin/product-addon-group/create'
      path: '/product-addon-group/create'
      fullPath: '/admin/product-addon-group/create'
      preLoaderRoute: typeof AdminProductAddonGroupCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-accounting-category/create': {
      id: '/admin/product-accounting-category/create'
      path: '/product-accounting-category/create'
      fullPath: '/admin/product-accounting-category/create'
      preLoaderRoute: typeof AdminProductAccountingCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/print-label/small': {
      id: '/admin/print-label/small'
      path: '/print-label/small'
      fullPath: '/admin/print-label/small'
      preLoaderRoute: typeof AdminPrintLabelSmallRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/print-label/large': {
      id: '/admin/print-label/large'
      path: '/print-label/large'
      fullPath: '/admin/print-label/large'
      preLoaderRoute: typeof AdminPrintLabelLargeRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/create': {
      id: '/admin/pricelist/create'
      path: '/pricelist/create'
      fullPath: '/admin/pricelist/create'
      preLoaderRoute: typeof AdminPricelistCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/poster/create': {
      id: '/admin/poster/create'
      path: '/poster/create'
      fullPath: '/admin/poster/create'
      preLoaderRoute: typeof AdminPosterCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pos-bookmark/create': {
      id: '/admin/pos-bookmark/create'
      path: '/pos-bookmark/create'
      fullPath: '/admin/pos-bookmark/create'
      preLoaderRoute: typeof AdminPosBookmarkCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-method/create': {
      id: '/admin/payment-method/create'
      path: '/payment-method/create'
      fullPath: '/admin/payment-method/create'
      preLoaderRoute: typeof AdminPaymentMethodCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/outbound-container/scan': {
      id: '/admin/outbound-container/scan'
      path: '/outbound-container/scan'
      fullPath: '/admin/outbound-container/scan'
      preLoaderRoute: typeof AdminOutboundContainerScanRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/member-type/create': {
      id: '/admin/member-type/create'
      path: '/member-type/create'
      fullPath: '/admin/member-type/create'
      preLoaderRoute: typeof AdminMemberTypeCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-automation/$jobKey': {
      id: '/admin/marketplace-automation/$jobKey'
      path: '/marketplace-automation/$jobKey'
      fullPath: '/admin/marketplace-automation/$jobKey'
      preLoaderRoute: typeof AdminMarketplaceAutomationJobKeyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/create': {
      id: '/admin/inventory-count/create'
      path: '/inventory-count/create'
      fullPath: '/admin/inventory-count/create'
      preLoaderRoute: typeof AdminInventoryCountCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-template-item/create': {
      id: '/admin/inventory-count-template-item/create'
      path: '/inventory-count-template-item/create'
      fullPath: '/admin/inventory-count-template-item/create'
      preLoaderRoute: typeof AdminInventoryCountTemplateItemCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/create': {
      id: '/admin/inventory-adjustment/create'
      path: '/inventory-adjustment/create'
      fullPath: '/admin/inventory-adjustment/create'
      preLoaderRoute: typeof AdminInventoryAdjustmentCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment-reason/create': {
      id: '/admin/inventory-adjustment-reason/create'
      path: '/inventory-adjustment-reason/create'
      fullPath: '/admin/inventory-adjustment-reason/create'
      preLoaderRoute: typeof AdminInventoryAdjustmentReasonCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/internal-transfer/create': {
      id: '/admin/internal-transfer/create'
      path: '/internal-transfer/create'
      fullPath: '/admin/internal-transfer/create'
      preLoaderRoute: typeof AdminInternalTransferCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/import/$templateType': {
      id: '/admin/import/$templateType'
      path: '/import/$templateType'
      fullPath: '/admin/import/$templateType'
      preLoaderRoute: typeof AdminImportTemplateTypeRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/expense-item/create': {
      id: '/admin/expense-item/create'
      path: '/expense-item/create'
      fullPath: '/admin/expense-item/create'
      preLoaderRoute: typeof AdminExpenseItemCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/example/see-permissions': {
      id: '/admin/example/see-permissions'
      path: '/example/see-permissions'
      fullPath: '/admin/example/see-permissions'
      preLoaderRoute: typeof AdminExampleSeePermissionsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/edc-terminal/create': {
      id: '/admin/edc-terminal/create'
      path: '/edc-terminal/create'
      fullPath: '/admin/edc-terminal/create'
      preLoaderRoute: typeof AdminEdcTerminalCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order/create': {
      id: '/admin/delivery-order/create'
      path: '/delivery-order/create'
      fullPath: '/admin/delivery-order/create'
      preLoaderRoute: typeof AdminDeliveryOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/create': {
      id: '/admin/delivery-order-batch/create'
      path: '/delivery-order-batch/create'
      fullPath: '/admin/delivery-order-batch/create'
      preLoaderRoute: typeof AdminDeliveryOrderBatchCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customer/create': {
      id: '/admin/customer/create'
      path: '/customer/create'
      fullPath: '/admin/customer/create'
      preLoaderRoute: typeof AdminCustomerCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-vendor-registration/$id': {
      id: '/admin/consignment-vendor-registration/$id'
      path: '/consignment-vendor-registration/$id'
      fullPath: '/admin/consignment-vendor-registration/$id'
      preLoaderRoute: typeof AdminConsignmentVendorRegistrationIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockout/create': {
      id: '/admin/consignment-stockout/create'
      path: '/consignment-stockout/create'
      fullPath: '/admin/consignment-stockout/create'
      preLoaderRoute: typeof AdminConsignmentStockoutCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin/create': {
      id: '/admin/consignment-stockin/create'
      path: '/consignment-stockin/create'
      fullPath: '/admin/consignment-stockin/create'
      preLoaderRoute: typeof AdminConsignmentStockinCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/create': {
      id: '/admin/consignment-settlement/create'
      path: '/consignment-settlement/create'
      fullPath: '/admin/consignment-settlement/create'
      preLoaderRoute: typeof AdminConsignmentSettlementCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-config/create': {
      id: '/admin/consignment-config/create'
      path: '/consignment-config/create'
      fullPath: '/admin/consignment-config/create'
      preLoaderRoute: typeof AdminConsignmentConfigCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch/create': {
      id: '/admin/branch/create'
      path: '/branch/create'
      fullPath: '/admin/branch/create'
      preLoaderRoute: typeof AdminBranchCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-qris-merchant/create': {
      id: '/admin/branch-qris-merchant/create'
      path: '/branch-qris-merchant/create'
      fullPath: '/admin/branch-qris-merchant/create'
      preLoaderRoute: typeof AdminBranchQrisMerchantCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-category/create': {
      id: '/admin/branch-category/create'
      path: '/branch-category/create'
      fullPath: '/admin/branch-category/create'
      preLoaderRoute: typeof AdminBranchCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bill-of-material/create': {
      id: '/admin/bill-of-material/create'
      path: '/bill-of-material/create'
      fullPath: '/admin/bill-of-material/create'
      preLoaderRoute: typeof AdminBillOfMaterialCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bank-account/create': {
      id: '/admin/bank-account/create'
      path: '/bank-account/create'
      fullPath: '/admin/bank-account/create'
      preLoaderRoute: typeof AdminBankAccountCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/vendor/stock/$productID/': {
      id: '/vendor/stock/$productID/'
      path: '/stock/$productID'
      fullPath: '/vendor/stock/$productID'
      preLoaderRoute: typeof VendorStockProductIDIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/'
      path: '/rental/$vendorConsignmentRentalPaymentID'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/admin/pricelist/period/': {
      id: '/admin/pricelist/period/'
      path: '/pricelist/period'
      fullPath: '/admin/pricelist/period'
      preLoaderRoute: typeof AdminPricelistPeriodIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/village/': {
      id: '/admin/geolocation/village/'
      path: '/geolocation/village'
      fullPath: '/admin/geolocation/village'
      preLoaderRoute: typeof AdminGeolocationVillageIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/subdistrict/': {
      id: '/admin/geolocation/subdistrict/'
      path: '/geolocation/subdistrict'
      fullPath: '/admin/geolocation/subdistrict'
      preLoaderRoute: typeof AdminGeolocationSubdistrictIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/province/': {
      id: '/admin/geolocation/province/'
      path: '/geolocation/province'
      fullPath: '/admin/geolocation/province'
      preLoaderRoute: typeof AdminGeolocationProvinceIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/country/': {
      id: '/admin/geolocation/country/'
      path: '/geolocation/country'
      fullPath: '/admin/geolocation/country'
      preLoaderRoute: typeof AdminGeolocationCountryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/city/': {
      id: '/admin/geolocation/city/'
      path: '/geolocation/city'
      fullPath: '/admin/geolocation/city'
      preLoaderRoute: typeof AdminGeolocationCityIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/$deliveryOrderBatchID/': {
      id: '/admin/delivery-order-batch/$deliveryOrderBatchID/'
      path: '/delivery-order-batch/$deliveryOrderBatchID'
      fullPath: '/admin/delivery-order-batch/$deliveryOrderBatchID'
      preLoaderRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment/stores-teams/': {
      id: '/admin/consignment/stores-teams/'
      path: '/consignment/stores-teams'
      fullPath: '/admin/consignment/stores-teams'
      preLoaderRoute: typeof AdminConsignmentStoresTeamsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment/requests/': {
      id: '/admin/consignment/requests/'
      path: '/consignment/requests'
      fullPath: '/admin/consignment/requests'
      preLoaderRoute: typeof AdminConsignmentRequestsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment/onboarding/': {
      id: '/admin/consignment/onboarding/'
      path: '/consignment/onboarding'
      fullPath: '/admin/consignment/onboarding'
      preLoaderRoute: typeof AdminConsignmentOnboardingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/background-job/transaction/': {
      id: '/admin/background-job/transaction/'
      path: '/background-job/transaction'
      fullPath: '/admin/background-job/transaction'
      preLoaderRoute: typeof AdminBackgroundJobTransactionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/user/': {
      id: '/admin/access/user/'
      path: '/access/user'
      fullPath: '/admin/access/user'
      preLoaderRoute: typeof AdminAccessUserIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/role/': {
      id: '/admin/access/role/'
      path: '/access/role'
      fullPath: '/admin/access/role'
      preLoaderRoute: typeof AdminAccessRoleIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/resource/': {
      id: '/admin/access/resource/'
      path: '/access/resource'
      fullPath: '/admin/access/resource'
      preLoaderRoute: typeof AdminAccessResourceIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/permission/': {
      id: '/admin/access/permission/'
      path: '/access/permission'
      fullPath: '/admin/access/permission'
      preLoaderRoute: typeof AdminAccessPermissionIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/app/': {
      id: '/admin/access/app/'
      path: '/access/app'
      fullPath: '/admin/access/app'
      preLoaderRoute: typeof AdminAccessAppIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/vendor/transfer/$type/$id': {
      id: '/vendor/transfer/$type/$id'
      path: '/transfer/$type/$id'
      fullPath: '/vendor/transfer/$type/$id'
      preLoaderRoute: typeof VendorTransferTypeIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock/$productID/inventory': {
      id: '/vendor/stock/$productID/inventory'
      path: '/stock/$productID/inventory'
      fullPath: '/vendor/stock/$productID/inventory'
      preLoaderRoute: typeof VendorStockProductIDInventoryRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/print': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
      path: '/rental/$vendorConsignmentRentalPaymentID/print'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
      path: '/rental/$vendorConsignmentRentalPaymentID/edit'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/auth/reset-password/$token': {
      id: '/vendor/auth/reset-password/$token'
      path: '/auth/reset-password/$token'
      fullPath: '/vendor/auth/reset-password/$token'
      preLoaderRoute: typeof VendorAuthResetPasswordTokenRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/admin/warehouse/$id/detail': {
      id: '/admin/warehouse/$id/detail'
      path: '/warehouse/$id/detail'
      fullPath: '/admin/warehouse/$id/detail'
      preLoaderRoute: typeof AdminWarehouseIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/warehouse-location-group/$id/update': {
      id: '/admin/warehouse-location-group/$id/update'
      path: '/warehouse-location-group/$id/update'
      fullPath: '/admin/warehouse-location-group/$id/update'
      preLoaderRoute: typeof AdminWarehouseLocationGroupIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/warehouse-location-group/$id/detail': {
      id: '/admin/warehouse-location-group/$id/detail'
      path: '/warehouse-location-group/$id/detail'
      fullPath: '/admin/warehouse-location-group/$id/detail'
      preLoaderRoute: typeof AdminWarehouseLocationGroupIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher/$id/update': {
      id: '/admin/voucher/$id/update'
      path: '/voucher/$id/update'
      fullPath: '/admin/voucher/$id/update'
      preLoaderRoute: typeof AdminVoucherIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher/$id/detail': {
      id: '/admin/voucher/$id/detail'
      path: '/voucher/$id/detail'
      fullPath: '/admin/voucher/$id/detail'
      preLoaderRoute: typeof AdminVoucherIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher-category/$id/update': {
      id: '/admin/voucher-category/$id/update'
      path: '/voucher-category/$id/update'
      fullPath: '/admin/voucher-category/$id/update'
      preLoaderRoute: typeof AdminVoucherCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voucher-category/$id/detail': {
      id: '/admin/voucher-category/$id/detail'
      path: '/voucher-category/$id/detail'
      fullPath: '/admin/voucher-category/$id/detail'
      preLoaderRoute: typeof AdminVoucherCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor/$id/update': {
      id: '/admin/vendor/$id/update'
      path: '/vendor/$id/update'
      fullPath: '/admin/vendor/$id/update'
      preLoaderRoute: typeof AdminVendorIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor/$id/detail': {
      id: '/admin/vendor/$id/detail'
      path: '/vendor/$id/detail'
      fullPath: '/admin/vendor/$id/detail'
      preLoaderRoute: typeof AdminVendorIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-rental-approval/$id/print': {
      id: '/admin/vendor-rental-approval/$id/print'
      path: '/vendor-rental-approval/$id/print'
      fullPath: '/admin/vendor-rental-approval/$id/print'
      preLoaderRoute: typeof AdminVendorRentalApprovalIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-rental-approval/$id/detail': {
      id: '/admin/vendor-rental-approval/$id/detail'
      path: '/vendor-rental-approval/$id/detail'
      fullPath: '/admin/vendor-rental-approval/$id/detail'
      preLoaderRoute: typeof AdminVendorRentalApprovalIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-category/$id/update': {
      id: '/admin/vendor-category/$id/update'
      path: '/vendor-category/$id/update'
      fullPath: '/admin/vendor-category/$id/update'
      preLoaderRoute: typeof AdminVendorCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/vendor-category/$id/detail': {
      id: '/admin/vendor-category/$id/detail'
      path: '/vendor-category/$id/detail'
      fullPath: '/admin/vendor-category/$id/detail'
      preLoaderRoute: typeof AdminVendorCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/user-shift/$id/detail': {
      id: '/admin/user-shift/$id/detail'
      path: '/user-shift/$id/detail'
      fullPath: '/admin/user-shift/$id/detail'
      preLoaderRoute: typeof AdminUserShiftIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/uom-category/$id/update': {
      id: '/admin/uom-category/$id/update'
      path: '/uom-category/$id/update'
      fullPath: '/admin/uom-category/$id/update'
      preLoaderRoute: typeof AdminUomCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/uom-category/$id/detail': {
      id: '/admin/uom-category/$id/detail'
      path: '/uom-category/$id/detail'
      fullPath: '/admin/uom-category/$id/detail'
      preLoaderRoute: typeof AdminUomCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-request/$id/update': {
      id: '/admin/transfer-request/$id/update'
      path: '/transfer-request/$id/update'
      fullPath: '/admin/transfer-request/$id/update'
      preLoaderRoute: typeof AdminTransferRequestIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-request/$id/detail': {
      id: '/admin/transfer-request/$id/detail'
      path: '/transfer-request/$id/detail'
      fullPath: '/admin/transfer-request/$id/detail'
      preLoaderRoute: typeof AdminTransferRequestIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/$id/update': {
      id: '/admin/transfer-order/$id/update'
      path: '/transfer-order/$id/update'
      fullPath: '/admin/transfer-order/$id/update'
      preLoaderRoute: typeof AdminTransferOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/$id/print': {
      id: '/admin/transfer-order/$id/print'
      path: '/transfer-order/$id/print'
      fullPath: '/admin/transfer-order/$id/print'
      preLoaderRoute: typeof AdminTransferOrderIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/$id/detail': {
      id: '/admin/transfer-order/$id/detail'
      path: '/transfer-order/$id/detail'
      fullPath: '/admin/transfer-order/$id/detail'
      preLoaderRoute: typeof AdminTransferOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transfer-order/$id/create': {
      id: '/admin/transfer-order/$id/create'
      path: '/transfer-order/$id/create'
      fullPath: '/admin/transfer-order/$id/create'
      preLoaderRoute: typeof AdminTransferOrderIdCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tax/$id/update': {
      id: '/admin/tax/$id/update'
      path: '/tax/$id/update'
      fullPath: '/admin/tax/$id/update'
      preLoaderRoute: typeof AdminTaxIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tax/$id/detail': {
      id: '/admin/tax/$id/detail'
      path: '/tax/$id/detail'
      fullPath: '/admin/tax/$id/detail'
      preLoaderRoute: typeof AdminTaxIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/supplier/$id/update': {
      id: '/admin/supplier/$id/update'
      path: '/supplier/$id/update'
      fullPath: '/admin/supplier/$id/update'
      preLoaderRoute: typeof AdminSupplierIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/supplier/$id/detail': {
      id: '/admin/supplier/$id/detail'
      path: '/supplier/$id/detail'
      fullPath: '/admin/supplier/$id/detail'
      preLoaderRoute: typeof AdminSupplierIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/simple-transfer-order/$id/update': {
      id: '/admin/simple-transfer-order/$id/update'
      path: '/simple-transfer-order/$id/update'
      fullPath: '/admin/simple-transfer-order/$id/update'
      preLoaderRoute: typeof AdminSimpleTransferOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/simple-transfer-order/$id/print': {
      id: '/admin/simple-transfer-order/$id/print'
      path: '/simple-transfer-order/$id/print'
      fullPath: '/admin/simple-transfer-order/$id/print'
      preLoaderRoute: typeof AdminSimpleTransferOrderIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/simple-transfer-order/$id/detail': {
      id: '/admin/simple-transfer-order/$id/detail'
      path: '/simple-transfer-order/$id/detail'
      fullPath: '/admin/simple-transfer-order/$id/detail'
      preLoaderRoute: typeof AdminSimpleTransferOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-invoice/$id/detail': {
      id: '/admin/sales-invoice/$id/detail'
      path: '/sales-invoice/$id/detail'
      fullPath: '/admin/sales-invoice/$id/detail'
      preLoaderRoute: typeof AdminSalesInvoiceIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-invoice-review/$id/detail': {
      id: '/admin/sales-invoice-review/$id/detail'
      path: '/sales-invoice-review/$id/detail'
      fullPath: '/admin/sales-invoice-review/$id/detail'
      preLoaderRoute: typeof AdminSalesInvoiceReviewIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel/$id/update': {
      id: '/admin/sales-channel/$id/update'
      path: '/sales-channel/$id/update'
      fullPath: '/admin/sales-channel/$id/update'
      preLoaderRoute: typeof AdminSalesChannelIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel/$id/detail': {
      id: '/admin/sales-channel/$id/detail'
      path: '/sales-channel/$id/detail'
      fullPath: '/admin/sales-channel/$id/detail'
      preLoaderRoute: typeof AdminSalesChannelIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-mapping/$id/update': {
      id: '/admin/sales-channel-category-mapping/$id/update'
      path: '/sales-channel-category-mapping/$id/update'
      fullPath: '/admin/sales-channel-category-mapping/$id/update'
      preLoaderRoute: typeof AdminSalesChannelCategoryMappingIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-mapping/$id/detail': {
      id: '/admin/sales-channel-category-mapping/$id/detail'
      path: '/sales-channel-category-mapping/$id/detail'
      fullPath: '/admin/sales-channel-category-mapping/$id/detail'
      preLoaderRoute: typeof AdminSalesChannelCategoryMappingIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-group/$id/update': {
      id: '/admin/sales-channel-category-group/$id/update'
      path: '/sales-channel-category-group/$id/update'
      fullPath: '/admin/sales-channel-category-group/$id/update'
      preLoaderRoute: typeof AdminSalesChannelCategoryGroupIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-category-group/$id/detail': {
      id: '/admin/sales-channel-category-group/$id/detail'
      path: '/sales-channel-category-group/$id/detail'
      fullPath: '/admin/sales-channel-category-group/$id/detail'
      preLoaderRoute: typeof AdminSalesChannelCategoryGroupIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-campaign/$id/update': {
      id: '/admin/sales-channel-campaign/$id/update'
      path: '/sales-channel-campaign/$id/update'
      fullPath: '/admin/sales-channel-campaign/$id/update'
      preLoaderRoute: typeof AdminSalesChannelCampaignIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sales-channel-campaign/$id/detail': {
      id: '/admin/sales-channel-campaign/$id/detail'
      path: '/sales-channel-campaign/$id/detail'
      fullPath: '/admin/sales-channel-campaign/$id/detail'
      preLoaderRoute: typeof AdminSalesChannelCampaignIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report/$id/detail': {
      id: '/admin/revenue-report/$id/detail'
      path: '/revenue-report/$id/detail'
      fullPath: '/admin/revenue-report/$id/detail'
      preLoaderRoute: typeof AdminRevenueReportIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-template/$id/detail': {
      id: '/admin/revenue-report-template/$id/detail'
      path: '/revenue-report-template/$id/detail'
      fullPath: '/admin/revenue-report-template/$id/detail'
      preLoaderRoute: typeof AdminRevenueReportTemplateIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-partner/$id/detail': {
      id: '/admin/revenue-report-partner/$id/detail'
      path: '/revenue-report-partner/$id/detail'
      fullPath: '/admin/revenue-report-partner/$id/detail'
      preLoaderRoute: typeof AdminRevenueReportPartnerIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-report-partner-branch/$id/detail': {
      id: '/admin/revenue-report-partner-branch/$id/detail'
      path: '/revenue-report-partner-branch/$id/detail'
      fullPath: '/admin/revenue-report-partner-branch/$id/detail'
      preLoaderRoute: typeof AdminRevenueReportPartnerBranchIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment/$id/detail': {
      id: '/admin/replenishment/$id/detail'
      path: '/replenishment/$id/detail'
      fullPath: '/admin/replenishment/$id/detail'
      preLoaderRoute: typeof AdminReplenishmentIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template/$id/update': {
      id: '/admin/replenishment-template/$id/update'
      path: '/replenishment-template/$id/update'
      fullPath: '/admin/replenishment-template/$id/update'
      preLoaderRoute: typeof AdminReplenishmentTemplateIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template/$id/import': {
      id: '/admin/replenishment-template/$id/import'
      path: '/replenishment-template/$id/import'
      fullPath: '/admin/replenishment-template/$id/import'
      preLoaderRoute: typeof AdminReplenishmentTemplateIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template/$id/detail': {
      id: '/admin/replenishment-template/$id/detail'
      path: '/replenishment-template/$id/detail'
      fullPath: '/admin/replenishment-template/$id/detail'
      preLoaderRoute: typeof AdminReplenishmentTemplateIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template-category/$id/update': {
      id: '/admin/replenishment-template-category/$id/update'
      path: '/replenishment-template-category/$id/update'
      fullPath: '/admin/replenishment-template-category/$id/update'
      preLoaderRoute: typeof AdminReplenishmentTemplateCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/replenishment-template-category/$id/detail': {
      id: '/admin/replenishment-template-category/$id/detail'
      path: '/replenishment-template-category/$id/detail'
      fullPath: '/admin/replenishment-template-category/$id/detail'
      preLoaderRoute: typeof AdminReplenishmentTemplateCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank/$id/upload': {
      id: '/admin/recon-bank/$id/upload'
      path: '/recon-bank/$id/upload'
      fullPath: '/admin/recon-bank/$id/upload'
      preLoaderRoute: typeof AdminReconBankIdUploadRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank/$id/process': {
      id: '/admin/recon-bank/$id/process'
      path: '/recon-bank/$id/process'
      fullPath: '/admin/recon-bank/$id/process'
      preLoaderRoute: typeof AdminReconBankIdProcessRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank/$id/detail': {
      id: '/admin/recon-bank/$id/detail'
      path: '/recon-bank/$id/detail'
      fullPath: '/admin/recon-bank/$id/detail'
      preLoaderRoute: typeof AdminReconBankIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recon-bank-upload/$id/detail': {
      id: '/admin/recon-bank-upload/$id/detail'
      path: '/recon-bank-upload/$id/detail'
      fullPath: '/admin/recon-bank-upload/$id/detail'
      preLoaderRoute: typeof AdminReconBankUploadIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/transfer-order/create': {
      id: '/admin/receiving/transfer-order/create'
      path: '/receiving/transfer-order/create'
      fullPath: '/admin/receiving/transfer-order/create'
      preLoaderRoute: typeof AdminReceivingTransferOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/simple-transfer-order/create': {
      id: '/admin/receiving/simple-transfer-order/create'
      path: '/receiving/simple-transfer-order/create'
      fullPath: '/admin/receiving/simple-transfer-order/create'
      preLoaderRoute: typeof AdminReceivingSimpleTransferOrderCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/$id/update': {
      id: '/admin/receiving/$id/update'
      path: '/receiving/$id/update'
      fullPath: '/admin/receiving/$id/update'
      preLoaderRoute: typeof AdminReceivingIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/$id/print': {
      id: '/admin/receiving/$id/print'
      path: '/receiving/$id/print'
      fullPath: '/admin/receiving/$id/print'
      preLoaderRoute: typeof AdminReceivingIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/$id/detail': {
      id: '/admin/receiving/$id/detail'
      path: '/receiving/$id/detail'
      fullPath: '/admin/receiving/$id/detail'
      preLoaderRoute: typeof AdminReceivingIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/$id/create': {
      id: '/admin/receiving/$id/create'
      path: '/receiving/$id/create'
      fullPath: '/admin/receiving/$id/create'
      preLoaderRoute: typeof AdminReceivingIdCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/putaway-task/$id/detail': {
      id: '/admin/putaway-task/$id/detail'
      path: '/putaway-task/$id/detail'
      fullPath: '/admin/putaway-task/$id/detail'
      preLoaderRoute: typeof AdminPutawayTaskIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/$id/update': {
      id: '/admin/purchase-order/$id/update'
      path: '/purchase-order/$id/update'
      fullPath: '/admin/purchase-order/$id/update'
      preLoaderRoute: typeof AdminPurchaseOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/$id/revise': {
      id: '/admin/purchase-order/$id/revise'
      path: '/purchase-order/$id/revise'
      fullPath: '/admin/purchase-order/$id/revise'
      preLoaderRoute: typeof AdminPurchaseOrderIdReviseRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/$id/print': {
      id: '/admin/purchase-order/$id/print'
      path: '/purchase-order/$id/print'
      fullPath: '/admin/purchase-order/$id/print'
      preLoaderRoute: typeof AdminPurchaseOrderIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-order/$id/detail': {
      id: '/admin/purchase-order/$id/detail'
      path: '/purchase-order/$id/detail'
      fullPath: '/admin/purchase-order/$id/detail'
      preLoaderRoute: typeof AdminPurchaseOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-area/$id/update': {
      id: '/admin/purchase-area/$id/update'
      path: '/purchase-area/$id/update'
      fullPath: '/admin/purchase-area/$id/update'
      preLoaderRoute: typeof AdminPurchaseAreaIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/purchase-area/$id/detail': {
      id: '/admin/purchase-area/$id/detail'
      path: '/purchase-area/$id/detail'
      fullPath: '/admin/purchase-area/$id/detail'
      preLoaderRoute: typeof AdminPurchaseAreaIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/$id/update': {
      id: '/admin/promo/$id/update'
      path: '/promo/$id/update'
      fullPath: '/admin/promo/$id/update'
      preLoaderRoute: typeof AdminPromoIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/$id/import': {
      id: '/admin/promo/$id/import'
      path: '/promo/$id/import'
      fullPath: '/admin/promo/$id/import'
      preLoaderRoute: typeof AdminPromoIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/promo/$id/detail': {
      id: '/admin/promo/$id/detail'
      path: '/promo/$id/detail'
      fullPath: '/admin/promo/$id/detail'
      preLoaderRoute: typeof AdminPromoIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/production/$id/update': {
      id: '/admin/production/$id/update'
      path: '/production/$id/update'
      fullPath: '/admin/production/$id/update'
      preLoaderRoute: typeof AdminProductionIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/production/$id/detail': {
      id: '/admin/production/$id/detail'
      path: '/production/$id/detail'
      fullPath: '/admin/production/$id/detail'
      preLoaderRoute: typeof AdminProductionIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product/$id/update': {
      id: '/admin/product/$id/update'
      path: '/product/$id/update'
      fullPath: '/admin/product/$id/update'
      preLoaderRoute: typeof AdminProductIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product/$id/detail': {
      id: '/admin/product/$id/detail'
      path: '/product/$id/detail'
      fullPath: '/admin/product/$id/detail'
      preLoaderRoute: typeof AdminProductIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-tag/$id/update': {
      id: '/admin/product-tag/$id/update'
      path: '/product-tag/$id/update'
      fullPath: '/admin/product-tag/$id/update'
      preLoaderRoute: typeof AdminProductTagIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-tag/$id/detail': {
      id: '/admin/product-tag/$id/detail'
      path: '/product-tag/$id/detail'
      fullPath: '/admin/product-tag/$id/detail'
      preLoaderRoute: typeof AdminProductTagIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-department/$id/update': {
      id: '/admin/product-sub-department/$id/update'
      path: '/product-sub-department/$id/update'
      fullPath: '/admin/product-sub-department/$id/update'
      preLoaderRoute: typeof AdminProductSubDepartmentIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-department/$id/detail': {
      id: '/admin/product-sub-department/$id/detail'
      path: '/product-sub-department/$id/detail'
      fullPath: '/admin/product-sub-department/$id/detail'
      preLoaderRoute: typeof AdminProductSubDepartmentIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-category/$id/update': {
      id: '/admin/product-sub-category/$id/update'
      path: '/product-sub-category/$id/update'
      fullPath: '/admin/product-sub-category/$id/update'
      preLoaderRoute: typeof AdminProductSubCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-sub-category/$id/detail': {
      id: '/admin/product-sub-category/$id/detail'
      path: '/product-sub-category/$id/detail'
      fullPath: '/admin/product-sub-category/$id/detail'
      preLoaderRoute: typeof AdminProductSubCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-division/$id/update': {
      id: '/admin/product-division/$id/update'
      path: '/product-division/$id/update'
      fullPath: '/admin/product-division/$id/update'
      preLoaderRoute: typeof AdminProductDivisionIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-division/$id/detail': {
      id: '/admin/product-division/$id/detail'
      path: '/product-division/$id/detail'
      fullPath: '/admin/product-division/$id/detail'
      preLoaderRoute: typeof AdminProductDivisionIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-department/$id/update': {
      id: '/admin/product-department/$id/update'
      path: '/product-department/$id/update'
      fullPath: '/admin/product-department/$id/update'
      preLoaderRoute: typeof AdminProductDepartmentIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-department/$id/detail': {
      id: '/admin/product-department/$id/detail'
      path: '/product-department/$id/detail'
      fullPath: '/admin/product-department/$id/detail'
      preLoaderRoute: typeof AdminProductDepartmentIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-category/$id/update': {
      id: '/admin/product-category/$id/update'
      path: '/product-category/$id/update'
      fullPath: '/admin/product-category/$id/update'
      preLoaderRoute: typeof AdminProductCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-category/$id/detail': {
      id: '/admin/product-category/$id/detail'
      path: '/product-category/$id/detail'
      fullPath: '/admin/product-category/$id/detail'
      preLoaderRoute: typeof AdminProductCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-brand/$id/update': {
      id: '/admin/product-brand/$id/update'
      path: '/product-brand/$id/update'
      fullPath: '/admin/product-brand/$id/update'
      preLoaderRoute: typeof AdminProductBrandIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-brand/$id/detail': {
      id: '/admin/product-brand/$id/detail'
      path: '/product-brand/$id/detail'
      fullPath: '/admin/product-brand/$id/detail'
      preLoaderRoute: typeof AdminProductBrandIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-availability-template/$id/update': {
      id: '/admin/product-availability-template/$id/update'
      path: '/product-availability-template/$id/update'
      fullPath: '/admin/product-availability-template/$id/update'
      preLoaderRoute: typeof AdminProductAvailabilityTemplateIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-availability-template/$id/import': {
      id: '/admin/product-availability-template/$id/import'
      path: '/product-availability-template/$id/import'
      fullPath: '/admin/product-availability-template/$id/import'
      preLoaderRoute: typeof AdminProductAvailabilityTemplateIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-availability-template/$id/detail': {
      id: '/admin/product-availability-template/$id/detail'
      path: '/product-availability-template/$id/detail'
      fullPath: '/admin/product-availability-template/$id/detail'
      preLoaderRoute: typeof AdminProductAvailabilityTemplateIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon/$id/update': {
      id: '/admin/product-addon/$id/update'
      path: '/product-addon/$id/update'
      fullPath: '/admin/product-addon/$id/update'
      preLoaderRoute: typeof AdminProductAddonIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon/$id/detail': {
      id: '/admin/product-addon/$id/detail'
      path: '/product-addon/$id/detail'
      fullPath: '/admin/product-addon/$id/detail'
      preLoaderRoute: typeof AdminProductAddonIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon-group/$id/update': {
      id: '/admin/product-addon-group/$id/update'
      path: '/product-addon-group/$id/update'
      fullPath: '/admin/product-addon-group/$id/update'
      preLoaderRoute: typeof AdminProductAddonGroupIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-addon-group/$id/detail': {
      id: '/admin/product-addon-group/$id/detail'
      path: '/product-addon-group/$id/detail'
      fullPath: '/admin/product-addon-group/$id/detail'
      preLoaderRoute: typeof AdminProductAddonGroupIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-accounting-category/$id/update': {
      id: '/admin/product-accounting-category/$id/update'
      path: '/product-accounting-category/$id/update'
      fullPath: '/admin/product-accounting-category/$id/update'
      preLoaderRoute: typeof AdminProductAccountingCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/product-accounting-category/$id/detail': {
      id: '/admin/product-accounting-category/$id/detail'
      path: '/product-accounting-category/$id/detail'
      fullPath: '/admin/product-accounting-category/$id/detail'
      preLoaderRoute: typeof AdminProductAccountingCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/period/create': {
      id: '/admin/pricelist/period/create'
      path: '/pricelist/period/create'
      fullPath: '/admin/pricelist/period/create'
      preLoaderRoute: typeof AdminPricelistPeriodCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/$id/update': {
      id: '/admin/pricelist/$id/update'
      path: '/pricelist/$id/update'
      fullPath: '/admin/pricelist/$id/update'
      preLoaderRoute: typeof AdminPricelistIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/$id/import': {
      id: '/admin/pricelist/$id/import'
      path: '/pricelist/$id/import'
      fullPath: '/admin/pricelist/$id/import'
      preLoaderRoute: typeof AdminPricelistIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/$id/detail': {
      id: '/admin/pricelist/$id/detail'
      path: '/pricelist/$id/detail'
      fullPath: '/admin/pricelist/$id/detail'
      preLoaderRoute: typeof AdminPricelistIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/poster/$id/update': {
      id: '/admin/poster/$id/update'
      path: '/poster/$id/update'
      fullPath: '/admin/poster/$id/update'
      preLoaderRoute: typeof AdminPosterIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/poster/$id/detail': {
      id: '/admin/poster/$id/detail'
      path: '/poster/$id/detail'
      fullPath: '/admin/poster/$id/detail'
      preLoaderRoute: typeof AdminPosterIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pos-bookmark/$id/update': {
      id: '/admin/pos-bookmark/$id/update'
      path: '/pos-bookmark/$id/update'
      fullPath: '/admin/pos-bookmark/$id/update'
      preLoaderRoute: typeof AdminPosBookmarkIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pos-bookmark/$id/detail': {
      id: '/admin/pos-bookmark/$id/detail'
      path: '/pos-bookmark/$id/detail'
      fullPath: '/admin/pos-bookmark/$id/detail'
      preLoaderRoute: typeof AdminPosBookmarkIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/picking-task/$id/detail': {
      id: '/admin/picking-task/$id/detail'
      path: '/picking-task/$id/detail'
      fullPath: '/admin/picking-task/$id/detail'
      preLoaderRoute: typeof AdminPickingTaskIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/picking-task/$id/create-location-group': {
      id: '/admin/picking-task/$id/create-location-group'
      path: '/picking-task/$id/create-location-group'
      fullPath: '/admin/picking-task/$id/create-location-group'
      preLoaderRoute: typeof AdminPickingTaskIdCreateLocationGroupRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/refund/create': {
      id: '/admin/petty-cash/refund/create'
      path: '/petty-cash/refund/create'
      fullPath: '/admin/petty-cash/refund/create'
      preLoaderRoute: typeof AdminPettyCashRefundCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/expense/create': {
      id: '/admin/petty-cash/expense/create'
      path: '/petty-cash/expense/create'
      fullPath: '/admin/petty-cash/expense/create'
      preLoaderRoute: typeof AdminPettyCashExpenseCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/add-fund/create': {
      id: '/admin/petty-cash/add-fund/create'
      path: '/petty-cash/add-fund/create'
      fullPath: '/admin/petty-cash/add-fund/create'
      preLoaderRoute: typeof AdminPettyCashAddFundCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/$id/print': {
      id: '/admin/petty-cash/$id/print'
      path: '/petty-cash/$id/print'
      fullPath: '/admin/petty-cash/$id/print'
      preLoaderRoute: typeof AdminPettyCashIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/$id/detail': {
      id: '/admin/petty-cash/$id/detail'
      path: '/petty-cash/$id/detail'
      fullPath: '/admin/petty-cash/$id/detail'
      preLoaderRoute: typeof AdminPettyCashIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-transaction/$id/detail': {
      id: '/admin/payment-transaction/$id/detail'
      path: '/payment-transaction/$id/detail'
      fullPath: '/admin/payment-transaction/$id/detail'
      preLoaderRoute: typeof AdminPaymentTransactionIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-provider-config/$id/update': {
      id: '/admin/payment-provider-config/$id/update'
      path: '/payment-provider-config/$id/update'
      fullPath: '/admin/payment-provider-config/$id/update'
      preLoaderRoute: typeof AdminPaymentProviderConfigIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-method/$id/update': {
      id: '/admin/payment-method/$id/update'
      path: '/payment-method/$id/update'
      fullPath: '/admin/payment-method/$id/update'
      preLoaderRoute: typeof AdminPaymentMethodIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payment-method/$id/detail': {
      id: '/admin/payment-method/$id/detail'
      path: '/payment-method/$id/detail'
      fullPath: '/admin/payment-method/$id/detail'
      preLoaderRoute: typeof AdminPaymentMethodIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/packing-task/$id/verify': {
      id: '/admin/packing-task/$id/verify'
      path: '/packing-task/$id/verify'
      fullPath: '/admin/packing-task/$id/verify'
      preLoaderRoute: typeof AdminPackingTaskIdVerifyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/packing-task/$id/process': {
      id: '/admin/packing-task/$id/process'
      path: '/packing-task/$id/process'
      fullPath: '/admin/packing-task/$id/process'
      preLoaderRoute: typeof AdminPackingTaskIdProcessRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/packing-task/$id/detail': {
      id: '/admin/packing-task/$id/detail'
      path: '/packing-task/$id/detail'
      fullPath: '/admin/packing-task/$id/detail'
      preLoaderRoute: typeof AdminPackingTaskIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/outbound-container/$id/detail': {
      id: '/admin/outbound-container/$id/detail'
      path: '/outbound-container/$id/detail'
      fullPath: '/admin/outbound-container/$id/detail'
      preLoaderRoute: typeof AdminOutboundContainerIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/member-type/$id/update': {
      id: '/admin/member-type/$id/update'
      path: '/member-type/$id/update'
      fullPath: '/admin/member-type/$id/update'
      preLoaderRoute: typeof AdminMemberTypeIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/member-type/$id/detail': {
      id: '/admin/member-type/$id/detail'
      path: '/member-type/$id/detail'
      fullPath: '/admin/member-type/$id/detail'
      preLoaderRoute: typeof AdminMemberTypeIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-order/$id/detail': {
      id: '/admin/marketplace-order/$id/detail'
      path: '/marketplace-order/$id/detail'
      fullPath: '/admin/marketplace-order/$id/detail'
      preLoaderRoute: typeof AdminMarketplaceOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/marketplace-channel-log/$id/detail': {
      id: '/admin/marketplace-channel-log/$id/detail'
      path: '/marketplace-channel-log/$id/detail'
      fullPath: '/admin/marketplace-channel-log/$id/detail'
      preLoaderRoute: typeof AdminMarketplaceChannelLogIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-transaction/$id/detail': {
      id: '/admin/inventory-transaction/$id/detail'
      path: '/inventory-transaction/$id/detail'
      fullPath: '/admin/inventory-transaction/$id/detail'
      preLoaderRoute: typeof AdminInventoryTransactionIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/$id/update': {
      id: '/admin/inventory-count/$id/update'
      path: '/inventory-count/$id/update'
      fullPath: '/admin/inventory-count/$id/update'
      preLoaderRoute: typeof AdminInventoryCountIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/$id/recount': {
      id: '/admin/inventory-count/$id/recount'
      path: '/inventory-count/$id/recount'
      fullPath: '/admin/inventory-count/$id/recount'
      preLoaderRoute: typeof AdminInventoryCountIdRecountRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/$id/print': {
      id: '/admin/inventory-count/$id/print'
      path: '/inventory-count/$id/print'
      fullPath: '/admin/inventory-count/$id/print'
      preLoaderRoute: typeof AdminInventoryCountIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count/$id/detail': {
      id: '/admin/inventory-count/$id/detail'
      path: '/inventory-count/$id/detail'
      fullPath: '/admin/inventory-count/$id/detail'
      preLoaderRoute: typeof AdminInventoryCountIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-template-item/$id/update': {
      id: '/admin/inventory-count-template-item/$id/update'
      path: '/inventory-count-template-item/$id/update'
      fullPath: '/admin/inventory-count-template-item/$id/update'
      preLoaderRoute: typeof AdminInventoryCountTemplateItemIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-template-item/$id/import': {
      id: '/admin/inventory-count-template-item/$id/import'
      path: '/inventory-count-template-item/$id/import'
      fullPath: '/admin/inventory-count-template-item/$id/import'
      preLoaderRoute: typeof AdminInventoryCountTemplateItemIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-count-template-item/$id/detail': {
      id: '/admin/inventory-count-template-item/$id/detail'
      path: '/inventory-count-template-item/$id/detail'
      fullPath: '/admin/inventory-count-template-item/$id/detail'
      preLoaderRoute: typeof AdminInventoryCountTemplateItemIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/opening-balance/import': {
      id: '/admin/inventory-adjustment/opening-balance/import'
      path: '/inventory-adjustment/opening-balance/import'
      fullPath: '/admin/inventory-adjustment/opening-balance/import'
      preLoaderRoute: typeof AdminInventoryAdjustmentOpeningBalanceImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/cost-adjustment/import': {
      id: '/admin/inventory-adjustment/cost-adjustment/import'
      path: '/inventory-adjustment/cost-adjustment/import'
      fullPath: '/admin/inventory-adjustment/cost-adjustment/import'
      preLoaderRoute: typeof AdminInventoryAdjustmentCostAdjustmentImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/$id/update': {
      id: '/admin/inventory-adjustment/$id/update'
      path: '/inventory-adjustment/$id/update'
      fullPath: '/admin/inventory-adjustment/$id/update'
      preLoaderRoute: typeof AdminInventoryAdjustmentIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/$id/print': {
      id: '/admin/inventory-adjustment/$id/print'
      path: '/inventory-adjustment/$id/print'
      fullPath: '/admin/inventory-adjustment/$id/print'
      preLoaderRoute: typeof AdminInventoryAdjustmentIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment/$id/detail': {
      id: '/admin/inventory-adjustment/$id/detail'
      path: '/inventory-adjustment/$id/detail'
      fullPath: '/admin/inventory-adjustment/$id/detail'
      preLoaderRoute: typeof AdminInventoryAdjustmentIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment-reason/$id/update': {
      id: '/admin/inventory-adjustment-reason/$id/update'
      path: '/inventory-adjustment-reason/$id/update'
      fullPath: '/admin/inventory-adjustment-reason/$id/update'
      preLoaderRoute: typeof AdminInventoryAdjustmentReasonIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inventory-adjustment-reason/$id/detail': {
      id: '/admin/inventory-adjustment-reason/$id/detail'
      path: '/inventory-adjustment-reason/$id/detail'
      fullPath: '/admin/inventory-adjustment-reason/$id/detail'
      preLoaderRoute: typeof AdminInventoryAdjustmentReasonIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/internal-transfer/$id/update': {
      id: '/admin/internal-transfer/$id/update'
      path: '/internal-transfer/$id/update'
      fullPath: '/admin/internal-transfer/$id/update'
      preLoaderRoute: typeof AdminInternalTransferIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/internal-transfer/$id/print': {
      id: '/admin/internal-transfer/$id/print'
      path: '/internal-transfer/$id/print'
      fullPath: '/admin/internal-transfer/$id/print'
      preLoaderRoute: typeof AdminInternalTransferIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/internal-transfer/$id/detail': {
      id: '/admin/internal-transfer/$id/detail'
      path: '/internal-transfer/$id/detail'
      fullPath: '/admin/internal-transfer/$id/detail'
      preLoaderRoute: typeof AdminInternalTransferIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/incoming-transfer-request/$id/update': {
      id: '/admin/incoming-transfer-request/$id/update'
      path: '/incoming-transfer-request/$id/update'
      fullPath: '/admin/incoming-transfer-request/$id/update'
      preLoaderRoute: typeof AdminIncomingTransferRequestIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/incoming-transfer-request/$id/detail': {
      id: '/admin/incoming-transfer-request/$id/detail'
      path: '/incoming-transfer-request/$id/detail'
      fullPath: '/admin/incoming-transfer-request/$id/detail'
      preLoaderRoute: typeof AdminIncomingTransferRequestIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/village/create': {
      id: '/admin/geolocation/village/create'
      path: '/geolocation/village/create'
      fullPath: '/admin/geolocation/village/create'
      preLoaderRoute: typeof AdminGeolocationVillageCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/subdistrict/create': {
      id: '/admin/geolocation/subdistrict/create'
      path: '/geolocation/subdistrict/create'
      fullPath: '/admin/geolocation/subdistrict/create'
      preLoaderRoute: typeof AdminGeolocationSubdistrictCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/province/create': {
      id: '/admin/geolocation/province/create'
      path: '/geolocation/province/create'
      fullPath: '/admin/geolocation/province/create'
      preLoaderRoute: typeof AdminGeolocationProvinceCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/country/create': {
      id: '/admin/geolocation/country/create'
      path: '/geolocation/country/create'
      fullPath: '/admin/geolocation/country/create'
      preLoaderRoute: typeof AdminGeolocationCountryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/city/create': {
      id: '/admin/geolocation/city/create'
      path: '/geolocation/city/create'
      fullPath: '/admin/geolocation/city/create'
      preLoaderRoute: typeof AdminGeolocationCityCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/expense-item/$id/update': {
      id: '/admin/expense-item/$id/update'
      path: '/expense-item/$id/update'
      fullPath: '/admin/expense-item/$id/update'
      preLoaderRoute: typeof AdminExpenseItemIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/expense-item/$id/detail': {
      id: '/admin/expense-item/$id/detail'
      path: '/expense-item/$id/detail'
      fullPath: '/admin/expense-item/$id/detail'
      preLoaderRoute: typeof AdminExpenseItemIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/edc-terminal/$id/update': {
      id: '/admin/edc-terminal/$id/update'
      path: '/edc-terminal/$id/update'
      fullPath: '/admin/edc-terminal/$id/update'
      preLoaderRoute: typeof AdminEdcTerminalIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/edc-terminal/$id/detail': {
      id: '/admin/edc-terminal/$id/detail'
      path: '/edc-terminal/$id/detail'
      fullPath: '/admin/edc-terminal/$id/detail'
      preLoaderRoute: typeof AdminEdcTerminalIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order/$id/update': {
      id: '/admin/delivery-order/$id/update'
      path: '/delivery-order/$id/update'
      fullPath: '/admin/delivery-order/$id/update'
      preLoaderRoute: typeof AdminDeliveryOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order/$id/print': {
      id: '/admin/delivery-order/$id/print'
      path: '/delivery-order/$id/print'
      fullPath: '/admin/delivery-order/$id/print'
      preLoaderRoute: typeof AdminDeliveryOrderIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order/$id/detail': {
      id: '/admin/delivery-order/$id/detail'
      path: '/delivery-order/$id/detail'
      fullPath: '/admin/delivery-order/$id/detail'
      preLoaderRoute: typeof AdminDeliveryOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb': {
      id: '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
      path: '/delivery-order-batch/$deliveryOrderBatchID/stpb'
      fullPath: '/admin/delivery-order-batch/$deliveryOrderBatchID/stpb'
      preLoaderRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/$deliveryOrderBatchID/result': {
      id: '/admin/delivery-order-batch/$deliveryOrderBatchID/result'
      path: '/delivery-order-batch/$deliveryOrderBatchID/result'
      fullPath: '/admin/delivery-order-batch/$deliveryOrderBatchID/result'
      preLoaderRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders': {
      id: '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
      path: '/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
      fullPath: '/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders'
      preLoaderRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers': {
      id: '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
      path: '/delivery-order-batch/$deliveryOrderBatchID/left-containers'
      fullPath: '/admin/delivery-order-batch/$deliveryOrderBatchID/left-containers'
      preLoaderRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customer/$id/update': {
      id: '/admin/customer/$id/update'
      path: '/customer/$id/update'
      fullPath: '/admin/customer/$id/update'
      preLoaderRoute: typeof AdminCustomerIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customer/$id/detail': {
      id: '/admin/customer/$id/detail'
      path: '/customer/$id/detail'
      fullPath: '/admin/customer/$id/detail'
      preLoaderRoute: typeof AdminCustomerIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockout/$id/update': {
      id: '/admin/consignment-stockout/$id/update'
      path: '/consignment-stockout/$id/update'
      fullPath: '/admin/consignment-stockout/$id/update'
      preLoaderRoute: typeof AdminConsignmentStockoutIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockout/$id/print': {
      id: '/admin/consignment-stockout/$id/print'
      path: '/consignment-stockout/$id/print'
      fullPath: '/admin/consignment-stockout/$id/print'
      preLoaderRoute: typeof AdminConsignmentStockoutIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockout/$id/detail': {
      id: '/admin/consignment-stockout/$id/detail'
      path: '/consignment-stockout/$id/detail'
      fullPath: '/admin/consignment-stockout/$id/detail'
      preLoaderRoute: typeof AdminConsignmentStockoutIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin/$id/update': {
      id: '/admin/consignment-stockin/$id/update'
      path: '/consignment-stockin/$id/update'
      fullPath: '/admin/consignment-stockin/$id/update'
      preLoaderRoute: typeof AdminConsignmentStockinIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin/$id/print': {
      id: '/admin/consignment-stockin/$id/print'
      path: '/consignment-stockin/$id/print'
      fullPath: '/admin/consignment-stockin/$id/print'
      preLoaderRoute: typeof AdminConsignmentStockinIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin/$id/detail': {
      id: '/admin/consignment-stockin/$id/detail'
      path: '/consignment-stockin/$id/detail'
      fullPath: '/admin/consignment-stockin/$id/detail'
      preLoaderRoute: typeof AdminConsignmentStockinIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin-request/$id/print': {
      id: '/admin/consignment-stockin-request/$id/print'
      path: '/consignment-stockin-request/$id/print'
      fullPath: '/admin/consignment-stockin-request/$id/print'
      preLoaderRoute: typeof AdminConsignmentStockinRequestIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-stockin-request/$id/detail': {
      id: '/admin/consignment-stockin-request/$id/detail'
      path: '/consignment-stockin-request/$id/detail'
      fullPath: '/admin/consignment-stockin-request/$id/detail'
      preLoaderRoute: typeof AdminConsignmentStockinRequestIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/$id/email-preview': {
      id: '/admin/consignment-settlement/$id/email-preview'
      path: '/consignment-settlement/$id/email-preview'
      fullPath: '/admin/consignment-settlement/$id/email-preview'
      preLoaderRoute: typeof AdminConsignmentSettlementIdEmailPreviewRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/$id/edit-items': {
      id: '/admin/consignment-settlement/$id/edit-items'
      path: '/consignment-settlement/$id/edit-items'
      fullPath: '/admin/consignment-settlement/$id/edit-items'
      preLoaderRoute: typeof AdminConsignmentSettlementIdEditItemsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/$id/edit': {
      id: '/admin/consignment-settlement/$id/edit'
      path: '/consignment-settlement/$id/edit'
      fullPath: '/admin/consignment-settlement/$id/edit'
      preLoaderRoute: typeof AdminConsignmentSettlementIdEditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-settlement/$id/detail': {
      id: '/admin/consignment-settlement/$id/detail'
      path: '/consignment-settlement/$id/detail'
      fullPath: '/admin/consignment-settlement/$id/detail'
      preLoaderRoute: typeof AdminConsignmentSettlementIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-request/$id/detail': {
      id: '/admin/consignment-request/$id/detail'
      path: '/consignment-request/$id/detail'
      fullPath: '/admin/consignment-request/$id/detail'
      preLoaderRoute: typeof AdminConsignmentRequestIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment-product-request/$id/detail': {
      id: '/admin/consignment-product-request/$id/detail'
      path: '/consignment-product-request/$id/detail'
      fullPath: '/admin/consignment-product-request/$id/detail'
      preLoaderRoute: typeof AdminConsignmentProductRequestIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch/$id/update': {
      id: '/admin/branch/$id/update'
      path: '/branch/$id/update'
      fullPath: '/admin/branch/$id/update'
      preLoaderRoute: typeof AdminBranchIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch/$id/detail': {
      id: '/admin/branch/$id/detail'
      path: '/branch/$id/detail'
      fullPath: '/admin/branch/$id/detail'
      preLoaderRoute: typeof AdminBranchIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-sales-channel/$id/operating-hours': {
      id: '/admin/branch-sales-channel/$id/operating-hours'
      path: '/branch-sales-channel/$id/operating-hours'
      fullPath: '/admin/branch-sales-channel/$id/operating-hours'
      preLoaderRoute: typeof AdminBranchSalesChannelIdOperatingHoursRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-sales-channel/$id/detail': {
      id: '/admin/branch-sales-channel/$id/detail'
      path: '/branch-sales-channel/$id/detail'
      fullPath: '/admin/branch-sales-channel/$id/detail'
      preLoaderRoute: typeof AdminBranchSalesChannelIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-qris-merchant/$id/update': {
      id: '/admin/branch-qris-merchant/$id/update'
      path: '/branch-qris-merchant/$id/update'
      fullPath: '/admin/branch-qris-merchant/$id/update'
      preLoaderRoute: typeof AdminBranchQrisMerchantIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-qris-merchant/$id/detail': {
      id: '/admin/branch-qris-merchant/$id/detail'
      path: '/branch-qris-merchant/$id/detail'
      fullPath: '/admin/branch-qris-merchant/$id/detail'
      preLoaderRoute: typeof AdminBranchQrisMerchantIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-category/$id/update': {
      id: '/admin/branch-category/$id/update'
      path: '/branch-category/$id/update'
      fullPath: '/admin/branch-category/$id/update'
      preLoaderRoute: typeof AdminBranchCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branch-category/$id/detail': {
      id: '/admin/branch-category/$id/detail'
      path: '/branch-category/$id/detail'
      fullPath: '/admin/branch-category/$id/detail'
      preLoaderRoute: typeof AdminBranchCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bill-of-material/$id/update': {
      id: '/admin/bill-of-material/$id/update'
      path: '/bill-of-material/$id/update'
      fullPath: '/admin/bill-of-material/$id/update'
      preLoaderRoute: typeof AdminBillOfMaterialIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bill-of-material/$id/detail': {
      id: '/admin/bill-of-material/$id/detail'
      path: '/bill-of-material/$id/detail'
      fullPath: '/admin/bill-of-material/$id/detail'
      preLoaderRoute: typeof AdminBillOfMaterialIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bank-account/$id/update': {
      id: '/admin/bank-account/$id/update'
      path: '/bank-account/$id/update'
      fullPath: '/admin/bank-account/$id/update'
      preLoaderRoute: typeof AdminBankAccountIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/bank-account/$id/detail': {
      id: '/admin/bank-account/$id/detail'
      path: '/bank-account/$id/detail'
      fullPath: '/admin/bank-account/$id/detail'
      preLoaderRoute: typeof AdminBankAccountIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/user/create': {
      id: '/admin/access/user/create'
      path: '/access/user/create'
      fullPath: '/admin/access/user/create'
      preLoaderRoute: typeof AdminAccessUserCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/role/create': {
      id: '/admin/access/role/create'
      path: '/access/role/create'
      fullPath: '/admin/access/role/create'
      preLoaderRoute: typeof AdminAccessRoleCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/resource/create': {
      id: '/admin/access/resource/create'
      path: '/access/resource/create'
      fullPath: '/admin/access/resource/create'
      preLoaderRoute: typeof AdminAccessResourceCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/permission/create': {
      id: '/admin/access/permission/create'
      path: '/access/permission/create'
      fullPath: '/admin/access/permission/create'
      preLoaderRoute: typeof AdminAccessPermissionCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/app/create': {
      id: '/admin/access/app/create'
      path: '/access/app/create'
      fullPath: '/admin/access/app/create'
      preLoaderRoute: typeof AdminAccessAppCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-sharing/$id/detail/': {
      id: '/admin/revenue-sharing/$id/detail/'
      path: '/revenue-sharing/$id/detail'
      fullPath: '/admin/revenue-sharing/$id/detail'
      preLoaderRoute: typeof AdminRevenueSharingIdDetailIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/revenue-sharing/$id/detail/$detailId': {
      id: '/admin/revenue-sharing/$id/detail/$detailId'
      path: '/revenue-sharing/$id/detail/$detailId'
      fullPath: '/admin/revenue-sharing/$id/detail/$detailId'
      preLoaderRoute: typeof AdminRevenueSharingIdDetailDetailIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/transfer-order/$id/update': {
      id: '/admin/receiving/transfer-order/$id/update'
      path: '/receiving/transfer-order/$id/update'
      fullPath: '/admin/receiving/transfer-order/$id/update'
      preLoaderRoute: typeof AdminReceivingTransferOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/transfer-order/$id/detail': {
      id: '/admin/receiving/transfer-order/$id/detail'
      path: '/receiving/transfer-order/$id/detail'
      fullPath: '/admin/receiving/transfer-order/$id/detail'
      preLoaderRoute: typeof AdminReceivingTransferOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/simple-transfer-order/$id/update': {
      id: '/admin/receiving/simple-transfer-order/$id/update'
      path: '/receiving/simple-transfer-order/$id/update'
      fullPath: '/admin/receiving/simple-transfer-order/$id/update'
      preLoaderRoute: typeof AdminReceivingSimpleTransferOrderIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/simple-transfer-order/$id/print': {
      id: '/admin/receiving/simple-transfer-order/$id/print'
      path: '/receiving/simple-transfer-order/$id/print'
      fullPath: '/admin/receiving/simple-transfer-order/$id/print'
      preLoaderRoute: typeof AdminReceivingSimpleTransferOrderIdPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/receiving/simple-transfer-order/$id/detail': {
      id: '/admin/receiving/simple-transfer-order/$id/detail'
      path: '/receiving/simple-transfer-order/$id/detail'
      fullPath: '/admin/receiving/simple-transfer-order/$id/detail'
      preLoaderRoute: typeof AdminReceivingSimpleTransferOrderIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/period/$id/update': {
      id: '/admin/pricelist/period/$id/update'
      path: '/pricelist/period/$id/update'
      fullPath: '/admin/pricelist/period/$id/update'
      preLoaderRoute: typeof AdminPricelistPeriodIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricelist/period/$id/detail': {
      id: '/admin/pricelist/period/$id/detail'
      path: '/pricelist/period/$id/detail'
      fullPath: '/admin/pricelist/period/$id/detail'
      preLoaderRoute: typeof AdminPricelistPeriodIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/refund/$id/update': {
      id: '/admin/petty-cash/refund/$id/update'
      path: '/petty-cash/refund/$id/update'
      fullPath: '/admin/petty-cash/refund/$id/update'
      preLoaderRoute: typeof AdminPettyCashRefundIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/refund/$id/detail': {
      id: '/admin/petty-cash/refund/$id/detail'
      path: '/petty-cash/refund/$id/detail'
      fullPath: '/admin/petty-cash/refund/$id/detail'
      preLoaderRoute: typeof AdminPettyCashRefundIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/expense/$id/update': {
      id: '/admin/petty-cash/expense/$id/update'
      path: '/petty-cash/expense/$id/update'
      fullPath: '/admin/petty-cash/expense/$id/update'
      preLoaderRoute: typeof AdminPettyCashExpenseIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/expense/$id/detail': {
      id: '/admin/petty-cash/expense/$id/detail'
      path: '/petty-cash/expense/$id/detail'
      fullPath: '/admin/petty-cash/expense/$id/detail'
      preLoaderRoute: typeof AdminPettyCashExpenseIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/add-fund/$id/update': {
      id: '/admin/petty-cash/add-fund/$id/update'
      path: '/petty-cash/add-fund/$id/update'
      fullPath: '/admin/petty-cash/add-fund/$id/update'
      preLoaderRoute: typeof AdminPettyCashAddFundIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/petty-cash/add-fund/$id/detail': {
      id: '/admin/petty-cash/add-fund/$id/detail'
      path: '/petty-cash/add-fund/$id/detail'
      fullPath: '/admin/petty-cash/add-fund/$id/detail'
      preLoaderRoute: typeof AdminPettyCashAddFundIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/village/$id/update': {
      id: '/admin/geolocation/village/$id/update'
      path: '/geolocation/village/$id/update'
      fullPath: '/admin/geolocation/village/$id/update'
      preLoaderRoute: typeof AdminGeolocationVillageIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/village/$id/detail': {
      id: '/admin/geolocation/village/$id/detail'
      path: '/geolocation/village/$id/detail'
      fullPath: '/admin/geolocation/village/$id/detail'
      preLoaderRoute: typeof AdminGeolocationVillageIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/subdistrict/$id/update': {
      id: '/admin/geolocation/subdistrict/$id/update'
      path: '/geolocation/subdistrict/$id/update'
      fullPath: '/admin/geolocation/subdistrict/$id/update'
      preLoaderRoute: typeof AdminGeolocationSubdistrictIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/subdistrict/$id/detail': {
      id: '/admin/geolocation/subdistrict/$id/detail'
      path: '/geolocation/subdistrict/$id/detail'
      fullPath: '/admin/geolocation/subdistrict/$id/detail'
      preLoaderRoute: typeof AdminGeolocationSubdistrictIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/province/$id/update': {
      id: '/admin/geolocation/province/$id/update'
      path: '/geolocation/province/$id/update'
      fullPath: '/admin/geolocation/province/$id/update'
      preLoaderRoute: typeof AdminGeolocationProvinceIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/province/$id/detail': {
      id: '/admin/geolocation/province/$id/detail'
      path: '/geolocation/province/$id/detail'
      fullPath: '/admin/geolocation/province/$id/detail'
      preLoaderRoute: typeof AdminGeolocationProvinceIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/country/$id/update': {
      id: '/admin/geolocation/country/$id/update'
      path: '/geolocation/country/$id/update'
      fullPath: '/admin/geolocation/country/$id/update'
      preLoaderRoute: typeof AdminGeolocationCountryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/country/$id/detail': {
      id: '/admin/geolocation/country/$id/detail'
      path: '/geolocation/country/$id/detail'
      fullPath: '/admin/geolocation/country/$id/detail'
      preLoaderRoute: typeof AdminGeolocationCountryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/city/$id/update': {
      id: '/admin/geolocation/city/$id/update'
      path: '/geolocation/city/$id/update'
      fullPath: '/admin/geolocation/city/$id/update'
      preLoaderRoute: typeof AdminGeolocationCityIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/geolocation/city/$id/detail': {
      id: '/admin/geolocation/city/$id/detail'
      path: '/geolocation/city/$id/detail'
      fullPath: '/admin/geolocation/city/$id/detail'
      preLoaderRoute: typeof AdminGeolocationCityIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/consignment/registrations/$id/detail': {
      id: '/admin/consignment/registrations/$id/detail'
      path: '/consignment/registrations/$id/detail'
      fullPath: '/admin/consignment/registrations/$id/detail'
      preLoaderRoute: typeof AdminConsignmentRegistrationsIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/background-job/transaction/$id/detail': {
      id: '/admin/background-job/transaction/$id/detail'
      path: '/background-job/transaction/$id/detail'
      fullPath: '/admin/background-job/transaction/$id/detail'
      preLoaderRoute: typeof AdminBackgroundJobTransactionIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/user/$id/update': {
      id: '/admin/access/user/$id/update'
      path: '/access/user/$id/update'
      fullPath: '/admin/access/user/$id/update'
      preLoaderRoute: typeof AdminAccessUserIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/role/$id/update': {
      id: '/admin/access/role/$id/update'
      path: '/access/role/$id/update'
      fullPath: '/admin/access/role/$id/update'
      preLoaderRoute: typeof AdminAccessRoleIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/resource/$id/update': {
      id: '/admin/access/resource/$id/update'
      path: '/access/resource/$id/update'
      fullPath: '/admin/access/resource/$id/update'
      preLoaderRoute: typeof AdminAccessResourceIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/permission/$id/update': {
      id: '/admin/access/permission/$id/update'
      path: '/access/permission/$id/update'
      fullPath: '/admin/access/permission/$id/update'
      preLoaderRoute: typeof AdminAccessPermissionIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/access/app/$id/update': {
      id: '/admin/access/app/$id/update'
      path: '/access/app/$id/update'
      fullPath: '/admin/access/app/$id/update'
      preLoaderRoute: typeof AdminAccessAppIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminSalesDashboardRoute: typeof AdminSalesDashboardRoute
  AdminBankAccountCreateRoute: typeof AdminBankAccountCreateRoute
  AdminBillOfMaterialCreateRoute: typeof AdminBillOfMaterialCreateRoute
  AdminBranchCategoryCreateRoute: typeof AdminBranchCategoryCreateRoute
  AdminBranchQrisMerchantCreateRoute: typeof AdminBranchQrisMerchantCreateRoute
  AdminBranchCreateRoute: typeof AdminBranchCreateRoute
  AdminConsignmentConfigCreateRoute: typeof AdminConsignmentConfigCreateRoute
  AdminConsignmentSettlementCreateRoute: typeof AdminConsignmentSettlementCreateRoute
  AdminConsignmentStockinCreateRoute: typeof AdminConsignmentStockinCreateRoute
  AdminConsignmentStockoutCreateRoute: typeof AdminConsignmentStockoutCreateRoute
  AdminConsignmentVendorRegistrationIdRoute: typeof AdminConsignmentVendorRegistrationIdRoute
  AdminCustomerCreateRoute: typeof AdminCustomerCreateRoute
  AdminDeliveryOrderBatchCreateRoute: typeof AdminDeliveryOrderBatchCreateRoute
  AdminDeliveryOrderCreateRoute: typeof AdminDeliveryOrderCreateRoute
  AdminEdcTerminalCreateRoute: typeof AdminEdcTerminalCreateRoute
  AdminExampleSeePermissionsRoute: typeof AdminExampleSeePermissionsRoute
  AdminExpenseItemCreateRoute: typeof AdminExpenseItemCreateRoute
  AdminImportTemplateTypeRoute: typeof AdminImportTemplateTypeRoute
  AdminInternalTransferCreateRoute: typeof AdminInternalTransferCreateRoute
  AdminInventoryAdjustmentReasonCreateRoute: typeof AdminInventoryAdjustmentReasonCreateRoute
  AdminInventoryAdjustmentCreateRoute: typeof AdminInventoryAdjustmentCreateRoute
  AdminInventoryCountTemplateItemCreateRoute: typeof AdminInventoryCountTemplateItemCreateRoute
  AdminInventoryCountCreateRoute: typeof AdminInventoryCountCreateRoute
  AdminMarketplaceAutomationJobKeyRoute: typeof AdminMarketplaceAutomationJobKeyRoute
  AdminMemberTypeCreateRoute: typeof AdminMemberTypeCreateRoute
  AdminOutboundContainerScanRoute: typeof AdminOutboundContainerScanRoute
  AdminPaymentMethodCreateRoute: typeof AdminPaymentMethodCreateRoute
  AdminPosBookmarkCreateRoute: typeof AdminPosBookmarkCreateRoute
  AdminPosterCreateRoute: typeof AdminPosterCreateRoute
  AdminPricelistCreateRoute: typeof AdminPricelistCreateRoute
  AdminPrintLabelLargeRoute: typeof AdminPrintLabelLargeRoute
  AdminPrintLabelSmallRoute: typeof AdminPrintLabelSmallRoute
  AdminProductAccountingCategoryCreateRoute: typeof AdminProductAccountingCategoryCreateRoute
  AdminProductAddonGroupCreateRoute: typeof AdminProductAddonGroupCreateRoute
  AdminProductAddonCreateRoute: typeof AdminProductAddonCreateRoute
  AdminProductAvailabilityTemplateCreateRoute: typeof AdminProductAvailabilityTemplateCreateRoute
  AdminProductBrandCreateRoute: typeof AdminProductBrandCreateRoute
  AdminProductCategoryCreateRoute: typeof AdminProductCategoryCreateRoute
  AdminProductDepartmentCreateRoute: typeof AdminProductDepartmentCreateRoute
  AdminProductDivisionCreateRoute: typeof AdminProductDivisionCreateRoute
  AdminProductSubCategoryCreateRoute: typeof AdminProductSubCategoryCreateRoute
  AdminProductSubDepartmentCreateRoute: typeof AdminProductSubDepartmentCreateRoute
  AdminProductTagCreateRoute: typeof AdminProductTagCreateRoute
  AdminProductCreateRoute: typeof AdminProductCreateRoute
  AdminProductImportRoute: typeof AdminProductImportRoute
  AdminProductionCreateRoute: typeof AdminProductionCreateRoute
  AdminPromoCreateRoute: typeof AdminPromoCreateRoute
  AdminPromoImportRoute: typeof AdminPromoImportRoute
  AdminPurchaseAreaCreateRoute: typeof AdminPurchaseAreaCreateRoute
  AdminPurchaseOrderCreateRoute: typeof AdminPurchaseOrderCreateRoute
  AdminPurchaseOrderImportRoute: typeof AdminPurchaseOrderImportRoute
  AdminReceivingCreateRoute: typeof AdminReceivingCreateRoute
  AdminReconBankUploadAddRoute: typeof AdminReconBankUploadAddRoute
  AdminReconBankUploadRoute: typeof AdminReconBankUploadRoute
  AdminReplenishmentTemplateCategoryCreateRoute: typeof AdminReplenishmentTemplateCategoryCreateRoute
  AdminReplenishmentTemplateCreateRoute: typeof AdminReplenishmentTemplateCreateRoute
  AdminSalesChannelCampaignCreateRoute: typeof AdminSalesChannelCampaignCreateRoute
  AdminSalesChannelCampaignRulesRoute: typeof AdminSalesChannelCampaignRulesRoute
  AdminSalesChannelCategoryGroupCreateRoute: typeof AdminSalesChannelCategoryGroupCreateRoute
  AdminSalesChannelCategoryMappingCreateRoute: typeof AdminSalesChannelCategoryMappingCreateRoute
  AdminSalesChannelCategoryMappingImportRoute: typeof AdminSalesChannelCategoryMappingImportRoute
  AdminSalesChannelCreateRoute: typeof AdminSalesChannelCreateRoute
  AdminSimpleTransferOrderCreateRoute: typeof AdminSimpleTransferOrderCreateRoute
  AdminSupplierCreateRoute: typeof AdminSupplierCreateRoute
  AdminTaxCreateRoute: typeof AdminTaxCreateRoute
  AdminTransferOrderCreateRoute: typeof AdminTransferOrderCreateRoute
  AdminTransferOrderImportRoute: typeof AdminTransferOrderImportRoute
  AdminTransferRequestCreateRoute: typeof AdminTransferRequestCreateRoute
  AdminTransferRequestImportRoute: typeof AdminTransferRequestImportRoute
  AdminUomCategoryCreateRoute: typeof AdminUomCategoryCreateRoute
  AdminVendorCategoryCreateRoute: typeof AdminVendorCategoryCreateRoute
  AdminVendorCreateRoute: typeof AdminVendorCreateRoute
  AdminVoucherCategoryCreateRoute: typeof AdminVoucherCategoryCreateRoute
  AdminVoucherCreateRoute: typeof AdminVoucherCreateRoute
  AdminWarehouseLocationGroupCreateRoute: typeof AdminWarehouseLocationGroupCreateRoute
  AdminBankAccountIndexRoute: typeof AdminBankAccountIndexRoute
  AdminBankIndexRoute: typeof AdminBankIndexRoute
  AdminBillOfMaterialIndexRoute: typeof AdminBillOfMaterialIndexRoute
  AdminBranchBankAccountIndexRoute: typeof AdminBranchBankAccountIndexRoute
  AdminBranchCategoryIndexRoute: typeof AdminBranchCategoryIndexRoute
  AdminBranchQrisMerchantIndexRoute: typeof AdminBranchQrisMerchantIndexRoute
  AdminBranchSalesChannelIndexRoute: typeof AdminBranchSalesChannelIndexRoute
  AdminBranchIndexRoute: typeof AdminBranchIndexRoute
  AdminConsignmentAdminTeamIndexRoute: typeof AdminConsignmentAdminTeamIndexRoute
  AdminConsignmentBranchSettingIndexRoute: typeof AdminConsignmentBranchSettingIndexRoute
  AdminConsignmentConfigIndexRoute: typeof AdminConsignmentConfigIndexRoute
  AdminConsignmentCurationIndexRoute: typeof AdminConsignmentCurationIndexRoute
  AdminConsignmentProductRequestIndexRoute: typeof AdminConsignmentProductRequestIndexRoute
  AdminConsignmentRegionIndexRoute: typeof AdminConsignmentRegionIndexRoute
  AdminConsignmentRequestIndexRoute: typeof AdminConsignmentRequestIndexRoute
  AdminConsignmentSettingIndexRoute: typeof AdminConsignmentSettingIndexRoute
  AdminConsignmentSettlementIndexRoute: typeof AdminConsignmentSettlementIndexRoute
  AdminConsignmentStockinRequestIndexRoute: typeof AdminConsignmentStockinRequestIndexRoute
  AdminConsignmentStockinIndexRoute: typeof AdminConsignmentStockinIndexRoute
  AdminConsignmentStockoutIndexRoute: typeof AdminConsignmentStockoutIndexRoute
  AdminConsignmentVendorApplicationInviteIndexRoute: typeof AdminConsignmentVendorApplicationInviteIndexRoute
  AdminConsignmentVendorRegistrationIndexRoute: typeof AdminConsignmentVendorRegistrationIndexRoute
  AdminCustomerIndexRoute: typeof AdminCustomerIndexRoute
  AdminDeliveryOrderBatchIndexRoute: typeof AdminDeliveryOrderBatchIndexRoute
  AdminDeliveryOrderIndexRoute: typeof AdminDeliveryOrderIndexRoute
  AdminEdcTerminalIndexRoute: typeof AdminEdcTerminalIndexRoute
  AdminExampleIndexRoute: typeof AdminExampleIndexRoute
  AdminExpenseItemIndexRoute: typeof AdminExpenseItemIndexRoute
  AdminIncomingTransferRequestIndexRoute: typeof AdminIncomingTransferRequestIndexRoute
  AdminInternalTransferIndexRoute: typeof AdminInternalTransferIndexRoute
  AdminInventoryAdjustmentReasonIndexRoute: typeof AdminInventoryAdjustmentReasonIndexRoute
  AdminInventoryAdjustmentIndexRoute: typeof AdminInventoryAdjustmentIndexRoute
  AdminInventoryCountMonitoringIndexRoute: typeof AdminInventoryCountMonitoringIndexRoute
  AdminInventoryCountTemplateItemIndexRoute: typeof AdminInventoryCountTemplateItemIndexRoute
  AdminInventoryCountIndexRoute: typeof AdminInventoryCountIndexRoute
  AdminInventoryLocationIndexRoute: typeof AdminInventoryLocationIndexRoute
  AdminInventoryMovementSummaryIndexRoute: typeof AdminInventoryMovementSummaryIndexRoute
  AdminInventorySummaryIndexRoute: typeof AdminInventorySummaryIndexRoute
  AdminInventoryTransactionLineUnitIndexRoute: typeof AdminInventoryTransactionLineUnitIndexRoute
  AdminInventoryTransactionIndexRoute: typeof AdminInventoryTransactionIndexRoute
  AdminMarketplaceAutomationIndexRoute: typeof AdminMarketplaceAutomationIndexRoute
  AdminMarketplaceChannelLogIndexRoute: typeof AdminMarketplaceChannelLogIndexRoute
  AdminMarketplaceOrderIndexRoute: typeof AdminMarketplaceOrderIndexRoute
  AdminMemberTypeIndexRoute: typeof AdminMemberTypeIndexRoute
  AdminOutboundContainerIndexRoute: typeof AdminOutboundContainerIndexRoute
  AdminPackingTaskIndexRoute: typeof AdminPackingTaskIndexRoute
  AdminPaymentInboundRequestIndexRoute: typeof AdminPaymentInboundRequestIndexRoute
  AdminPaymentMethodIndexRoute: typeof AdminPaymentMethodIndexRoute
  AdminPaymentProviderConfigIndexRoute: typeof AdminPaymentProviderConfigIndexRoute
  AdminPaymentTransactionIndexRoute: typeof AdminPaymentTransactionIndexRoute
  AdminPaymentWebhookEventIndexRoute: typeof AdminPaymentWebhookEventIndexRoute
  AdminPendingSyncMarketplaceOrderIndexRoute: typeof AdminPendingSyncMarketplaceOrderIndexRoute
  AdminPendingSyncSalesOrderIndexRoute: typeof AdminPendingSyncSalesOrderIndexRoute
  AdminPettyCashIndexRoute: typeof AdminPettyCashIndexRoute
  AdminPickingTaskIndexRoute: typeof AdminPickingTaskIndexRoute
  AdminPosBookmarkIndexRoute: typeof AdminPosBookmarkIndexRoute
  AdminPosterIndexRoute: typeof AdminPosterIndexRoute
  AdminPricelistIndexRoute: typeof AdminPricelistIndexRoute
  AdminPrintConsignmentIndexRoute: typeof AdminPrintConsignmentIndexRoute
  AdminPrintNonConsignmentIndexRoute: typeof AdminPrintNonConsignmentIndexRoute
  AdminProductAccountingCategoryIndexRoute: typeof AdminProductAccountingCategoryIndexRoute
  AdminProductAddonGroupIndexRoute: typeof AdminProductAddonGroupIndexRoute
  AdminProductAddonIndexRoute: typeof AdminProductAddonIndexRoute
  AdminProductAvailabilityTemplateIndexRoute: typeof AdminProductAvailabilityTemplateIndexRoute
  AdminProductBrandIndexRoute: typeof AdminProductBrandIndexRoute
  AdminProductCategoryIndexRoute: typeof AdminProductCategoryIndexRoute
  AdminProductDepartmentIndexRoute: typeof AdminProductDepartmentIndexRoute
  AdminProductDivisionIndexRoute: typeof AdminProductDivisionIndexRoute
  AdminProductSubCategoryIndexRoute: typeof AdminProductSubCategoryIndexRoute
  AdminProductSubDepartmentIndexRoute: typeof AdminProductSubDepartmentIndexRoute
  AdminProductTagIndexRoute: typeof AdminProductTagIndexRoute
  AdminProductIndexRoute: typeof AdminProductIndexRoute
  AdminProductionIndexRoute: typeof AdminProductionIndexRoute
  AdminPromoIndexRoute: typeof AdminPromoIndexRoute
  AdminPurchaseAreaIndexRoute: typeof AdminPurchaseAreaIndexRoute
  AdminPurchaseOrderIndexRoute: typeof AdminPurchaseOrderIndexRoute
  AdminPutawayTaskIndexRoute: typeof AdminPutawayTaskIndexRoute
  AdminReceivingIndexRoute: typeof AdminReceivingIndexRoute
  AdminReconBankUploadIndexRoute: typeof AdminReconBankUploadIndexRoute
  AdminReconBankIndexRoute: typeof AdminReconBankIndexRoute
  AdminReconOutstandingIndexRoute: typeof AdminReconOutstandingIndexRoute
  AdminReplenishmentTemplateCategoryIndexRoute: typeof AdminReplenishmentTemplateCategoryIndexRoute
  AdminReplenishmentTemplateIndexRoute: typeof AdminReplenishmentTemplateIndexRoute
  AdminReplenishmentIndexRoute: typeof AdminReplenishmentIndexRoute
  AdminRevenueReportAccessLogIndexRoute: typeof AdminRevenueReportAccessLogIndexRoute
  AdminRevenueReportPartnerBranchIndexRoute: typeof AdminRevenueReportPartnerBranchIndexRoute
  AdminRevenueReportPartnerIndexRoute: typeof AdminRevenueReportPartnerIndexRoute
  AdminRevenueReportTemplateIndexRoute: typeof AdminRevenueReportTemplateIndexRoute
  AdminRevenueReportIndexRoute: typeof AdminRevenueReportIndexRoute
  AdminRevenueSharingIndexRoute: typeof AdminRevenueSharingIndexRoute
  AdminSalesChannelCampaignIndexRoute: typeof AdminSalesChannelCampaignIndexRoute
  AdminSalesChannelCategoryGroupIndexRoute: typeof AdminSalesChannelCategoryGroupIndexRoute
  AdminSalesChannelCategoryMappingIndexRoute: typeof AdminSalesChannelCategoryMappingIndexRoute
  AdminSalesChannelStockThresholdIndexRoute: typeof AdminSalesChannelStockThresholdIndexRoute
  AdminSalesChannelIndexRoute: typeof AdminSalesChannelIndexRoute
  AdminSalesInvoiceReviewIndexRoute: typeof AdminSalesInvoiceReviewIndexRoute
  AdminSalesInvoiceIndexRoute: typeof AdminSalesInvoiceIndexRoute
  AdminSimpleTransferOrderIndexRoute: typeof AdminSimpleTransferOrderIndexRoute
  AdminSupplierIndexRoute: typeof AdminSupplierIndexRoute
  AdminTaxIndexRoute: typeof AdminTaxIndexRoute
  AdminTransferOrderIndexRoute: typeof AdminTransferOrderIndexRoute
  AdminTransferRequestIndexRoute: typeof AdminTransferRequestIndexRoute
  AdminUomCategoryIndexRoute: typeof AdminUomCategoryIndexRoute
  AdminUserShiftIndexRoute: typeof AdminUserShiftIndexRoute
  AdminVendorCategoryIndexRoute: typeof AdminVendorCategoryIndexRoute
  AdminVendorConsignmentRentalPeriodIndexRoute: typeof AdminVendorConsignmentRentalPeriodIndexRoute
  AdminVendorRentalApprovalIndexRoute: typeof AdminVendorRentalApprovalIndexRoute
  AdminVendorIndexRoute: typeof AdminVendorIndexRoute
  AdminVoucherCategoryIndexRoute: typeof AdminVoucherCategoryIndexRoute
  AdminVoucherIndexRoute: typeof AdminVoucherIndexRoute
  AdminWarehouseLocationGroupIndexRoute: typeof AdminWarehouseLocationGroupIndexRoute
  AdminWarehouseIndexRoute: typeof AdminWarehouseIndexRoute
  AdminAccessAppCreateRoute: typeof AdminAccessAppCreateRoute
  AdminAccessPermissionCreateRoute: typeof AdminAccessPermissionCreateRoute
  AdminAccessResourceCreateRoute: typeof AdminAccessResourceCreateRoute
  AdminAccessRoleCreateRoute: typeof AdminAccessRoleCreateRoute
  AdminAccessUserCreateRoute: typeof AdminAccessUserCreateRoute
  AdminBankAccountIdDetailRoute: typeof AdminBankAccountIdDetailRoute
  AdminBankAccountIdUpdateRoute: typeof AdminBankAccountIdUpdateRoute
  AdminBillOfMaterialIdDetailRoute: typeof AdminBillOfMaterialIdDetailRoute
  AdminBillOfMaterialIdUpdateRoute: typeof AdminBillOfMaterialIdUpdateRoute
  AdminBranchCategoryIdDetailRoute: typeof AdminBranchCategoryIdDetailRoute
  AdminBranchCategoryIdUpdateRoute: typeof AdminBranchCategoryIdUpdateRoute
  AdminBranchQrisMerchantIdDetailRoute: typeof AdminBranchQrisMerchantIdDetailRoute
  AdminBranchQrisMerchantIdUpdateRoute: typeof AdminBranchQrisMerchantIdUpdateRoute
  AdminBranchSalesChannelIdDetailRoute: typeof AdminBranchSalesChannelIdDetailRoute
  AdminBranchSalesChannelIdOperatingHoursRoute: typeof AdminBranchSalesChannelIdOperatingHoursRoute
  AdminBranchIdDetailRoute: typeof AdminBranchIdDetailRoute
  AdminBranchIdUpdateRoute: typeof AdminBranchIdUpdateRoute
  AdminConsignmentProductRequestIdDetailRoute: typeof AdminConsignmentProductRequestIdDetailRoute
  AdminConsignmentRequestIdDetailRoute: typeof AdminConsignmentRequestIdDetailRoute
  AdminConsignmentSettlementIdDetailRoute: typeof AdminConsignmentSettlementIdDetailRoute
  AdminConsignmentSettlementIdEditRoute: typeof AdminConsignmentSettlementIdEditRoute
  AdminConsignmentSettlementIdEditItemsRoute: typeof AdminConsignmentSettlementIdEditItemsRoute
  AdminConsignmentSettlementIdEmailPreviewRoute: typeof AdminConsignmentSettlementIdEmailPreviewRoute
  AdminConsignmentStockinRequestIdDetailRoute: typeof AdminConsignmentStockinRequestIdDetailRoute
  AdminConsignmentStockinRequestIdPrintRoute: typeof AdminConsignmentStockinRequestIdPrintRoute
  AdminConsignmentStockinIdDetailRoute: typeof AdminConsignmentStockinIdDetailRoute
  AdminConsignmentStockinIdPrintRoute: typeof AdminConsignmentStockinIdPrintRoute
  AdminConsignmentStockinIdUpdateRoute: typeof AdminConsignmentStockinIdUpdateRoute
  AdminConsignmentStockoutIdDetailRoute: typeof AdminConsignmentStockoutIdDetailRoute
  AdminConsignmentStockoutIdPrintRoute: typeof AdminConsignmentStockoutIdPrintRoute
  AdminConsignmentStockoutIdUpdateRoute: typeof AdminConsignmentStockoutIdUpdateRoute
  AdminCustomerIdDetailRoute: typeof AdminCustomerIdDetailRoute
  AdminCustomerIdUpdateRoute: typeof AdminCustomerIdUpdateRoute
  AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute
  AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute
  AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute
  AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute
  AdminDeliveryOrderIdDetailRoute: typeof AdminDeliveryOrderIdDetailRoute
  AdminDeliveryOrderIdPrintRoute: typeof AdminDeliveryOrderIdPrintRoute
  AdminDeliveryOrderIdUpdateRoute: typeof AdminDeliveryOrderIdUpdateRoute
  AdminEdcTerminalIdDetailRoute: typeof AdminEdcTerminalIdDetailRoute
  AdminEdcTerminalIdUpdateRoute: typeof AdminEdcTerminalIdUpdateRoute
  AdminExpenseItemIdDetailRoute: typeof AdminExpenseItemIdDetailRoute
  AdminExpenseItemIdUpdateRoute: typeof AdminExpenseItemIdUpdateRoute
  AdminGeolocationCityCreateRoute: typeof AdminGeolocationCityCreateRoute
  AdminGeolocationCountryCreateRoute: typeof AdminGeolocationCountryCreateRoute
  AdminGeolocationProvinceCreateRoute: typeof AdminGeolocationProvinceCreateRoute
  AdminGeolocationSubdistrictCreateRoute: typeof AdminGeolocationSubdistrictCreateRoute
  AdminGeolocationVillageCreateRoute: typeof AdminGeolocationVillageCreateRoute
  AdminIncomingTransferRequestIdDetailRoute: typeof AdminIncomingTransferRequestIdDetailRoute
  AdminIncomingTransferRequestIdUpdateRoute: typeof AdminIncomingTransferRequestIdUpdateRoute
  AdminInternalTransferIdDetailRoute: typeof AdminInternalTransferIdDetailRoute
  AdminInternalTransferIdPrintRoute: typeof AdminInternalTransferIdPrintRoute
  AdminInternalTransferIdUpdateRoute: typeof AdminInternalTransferIdUpdateRoute
  AdminInventoryAdjustmentReasonIdDetailRoute: typeof AdminInventoryAdjustmentReasonIdDetailRoute
  AdminInventoryAdjustmentReasonIdUpdateRoute: typeof AdminInventoryAdjustmentReasonIdUpdateRoute
  AdminInventoryAdjustmentIdDetailRoute: typeof AdminInventoryAdjustmentIdDetailRoute
  AdminInventoryAdjustmentIdPrintRoute: typeof AdminInventoryAdjustmentIdPrintRoute
  AdminInventoryAdjustmentIdUpdateRoute: typeof AdminInventoryAdjustmentIdUpdateRoute
  AdminInventoryAdjustmentCostAdjustmentImportRoute: typeof AdminInventoryAdjustmentCostAdjustmentImportRoute
  AdminInventoryAdjustmentOpeningBalanceImportRoute: typeof AdminInventoryAdjustmentOpeningBalanceImportRoute
  AdminInventoryCountTemplateItemIdDetailRoute: typeof AdminInventoryCountTemplateItemIdDetailRoute
  AdminInventoryCountTemplateItemIdImportRoute: typeof AdminInventoryCountTemplateItemIdImportRoute
  AdminInventoryCountTemplateItemIdUpdateRoute: typeof AdminInventoryCountTemplateItemIdUpdateRoute
  AdminInventoryCountIdDetailRoute: typeof AdminInventoryCountIdDetailRoute
  AdminInventoryCountIdPrintRoute: typeof AdminInventoryCountIdPrintRoute
  AdminInventoryCountIdRecountRoute: typeof AdminInventoryCountIdRecountRoute
  AdminInventoryCountIdUpdateRoute: typeof AdminInventoryCountIdUpdateRoute
  AdminInventoryTransactionIdDetailRoute: typeof AdminInventoryTransactionIdDetailRoute
  AdminMarketplaceChannelLogIdDetailRoute: typeof AdminMarketplaceChannelLogIdDetailRoute
  AdminMarketplaceOrderIdDetailRoute: typeof AdminMarketplaceOrderIdDetailRoute
  AdminMemberTypeIdDetailRoute: typeof AdminMemberTypeIdDetailRoute
  AdminMemberTypeIdUpdateRoute: typeof AdminMemberTypeIdUpdateRoute
  AdminOutboundContainerIdDetailRoute: typeof AdminOutboundContainerIdDetailRoute
  AdminPackingTaskIdDetailRoute: typeof AdminPackingTaskIdDetailRoute
  AdminPackingTaskIdProcessRoute: typeof AdminPackingTaskIdProcessRoute
  AdminPackingTaskIdVerifyRoute: typeof AdminPackingTaskIdVerifyRoute
  AdminPaymentMethodIdDetailRoute: typeof AdminPaymentMethodIdDetailRoute
  AdminPaymentMethodIdUpdateRoute: typeof AdminPaymentMethodIdUpdateRoute
  AdminPaymentProviderConfigIdUpdateRoute: typeof AdminPaymentProviderConfigIdUpdateRoute
  AdminPaymentTransactionIdDetailRoute: typeof AdminPaymentTransactionIdDetailRoute
  AdminPettyCashIdDetailRoute: typeof AdminPettyCashIdDetailRoute
  AdminPettyCashIdPrintRoute: typeof AdminPettyCashIdPrintRoute
  AdminPettyCashAddFundCreateRoute: typeof AdminPettyCashAddFundCreateRoute
  AdminPettyCashExpenseCreateRoute: typeof AdminPettyCashExpenseCreateRoute
  AdminPettyCashRefundCreateRoute: typeof AdminPettyCashRefundCreateRoute
  AdminPickingTaskIdCreateLocationGroupRoute: typeof AdminPickingTaskIdCreateLocationGroupRoute
  AdminPickingTaskIdDetailRoute: typeof AdminPickingTaskIdDetailRoute
  AdminPosBookmarkIdDetailRoute: typeof AdminPosBookmarkIdDetailRoute
  AdminPosBookmarkIdUpdateRoute: typeof AdminPosBookmarkIdUpdateRoute
  AdminPosterIdDetailRoute: typeof AdminPosterIdDetailRoute
  AdminPosterIdUpdateRoute: typeof AdminPosterIdUpdateRoute
  AdminPricelistIdDetailRoute: typeof AdminPricelistIdDetailRoute
  AdminPricelistIdImportRoute: typeof AdminPricelistIdImportRoute
  AdminPricelistIdUpdateRoute: typeof AdminPricelistIdUpdateRoute
  AdminPricelistPeriodCreateRoute: typeof AdminPricelistPeriodCreateRoute
  AdminProductAccountingCategoryIdDetailRoute: typeof AdminProductAccountingCategoryIdDetailRoute
  AdminProductAccountingCategoryIdUpdateRoute: typeof AdminProductAccountingCategoryIdUpdateRoute
  AdminProductAddonGroupIdDetailRoute: typeof AdminProductAddonGroupIdDetailRoute
  AdminProductAddonGroupIdUpdateRoute: typeof AdminProductAddonGroupIdUpdateRoute
  AdminProductAddonIdDetailRoute: typeof AdminProductAddonIdDetailRoute
  AdminProductAddonIdUpdateRoute: typeof AdminProductAddonIdUpdateRoute
  AdminProductAvailabilityTemplateIdDetailRoute: typeof AdminProductAvailabilityTemplateIdDetailRoute
  AdminProductAvailabilityTemplateIdImportRoute: typeof AdminProductAvailabilityTemplateIdImportRoute
  AdminProductAvailabilityTemplateIdUpdateRoute: typeof AdminProductAvailabilityTemplateIdUpdateRoute
  AdminProductBrandIdDetailRoute: typeof AdminProductBrandIdDetailRoute
  AdminProductBrandIdUpdateRoute: typeof AdminProductBrandIdUpdateRoute
  AdminProductCategoryIdDetailRoute: typeof AdminProductCategoryIdDetailRoute
  AdminProductCategoryIdUpdateRoute: typeof AdminProductCategoryIdUpdateRoute
  AdminProductDepartmentIdDetailRoute: typeof AdminProductDepartmentIdDetailRoute
  AdminProductDepartmentIdUpdateRoute: typeof AdminProductDepartmentIdUpdateRoute
  AdminProductDivisionIdDetailRoute: typeof AdminProductDivisionIdDetailRoute
  AdminProductDivisionIdUpdateRoute: typeof AdminProductDivisionIdUpdateRoute
  AdminProductSubCategoryIdDetailRoute: typeof AdminProductSubCategoryIdDetailRoute
  AdminProductSubCategoryIdUpdateRoute: typeof AdminProductSubCategoryIdUpdateRoute
  AdminProductSubDepartmentIdDetailRoute: typeof AdminProductSubDepartmentIdDetailRoute
  AdminProductSubDepartmentIdUpdateRoute: typeof AdminProductSubDepartmentIdUpdateRoute
  AdminProductTagIdDetailRoute: typeof AdminProductTagIdDetailRoute
  AdminProductTagIdUpdateRoute: typeof AdminProductTagIdUpdateRoute
  AdminProductIdDetailRoute: typeof AdminProductIdDetailRoute
  AdminProductIdUpdateRoute: typeof AdminProductIdUpdateRoute
  AdminProductionIdDetailRoute: typeof AdminProductionIdDetailRoute
  AdminProductionIdUpdateRoute: typeof AdminProductionIdUpdateRoute
  AdminPromoIdDetailRoute: typeof AdminPromoIdDetailRoute
  AdminPromoIdImportRoute: typeof AdminPromoIdImportRoute
  AdminPromoIdUpdateRoute: typeof AdminPromoIdUpdateRoute
  AdminPurchaseAreaIdDetailRoute: typeof AdminPurchaseAreaIdDetailRoute
  AdminPurchaseAreaIdUpdateRoute: typeof AdminPurchaseAreaIdUpdateRoute
  AdminPurchaseOrderIdDetailRoute: typeof AdminPurchaseOrderIdDetailRoute
  AdminPurchaseOrderIdPrintRoute: typeof AdminPurchaseOrderIdPrintRoute
  AdminPurchaseOrderIdReviseRoute: typeof AdminPurchaseOrderIdReviseRoute
  AdminPurchaseOrderIdUpdateRoute: typeof AdminPurchaseOrderIdUpdateRoute
  AdminPutawayTaskIdDetailRoute: typeof AdminPutawayTaskIdDetailRoute
  AdminReceivingIdCreateRoute: typeof AdminReceivingIdCreateRoute
  AdminReceivingIdDetailRoute: typeof AdminReceivingIdDetailRoute
  AdminReceivingIdPrintRoute: typeof AdminReceivingIdPrintRoute
  AdminReceivingIdUpdateRoute: typeof AdminReceivingIdUpdateRoute
  AdminReceivingSimpleTransferOrderCreateRoute: typeof AdminReceivingSimpleTransferOrderCreateRoute
  AdminReceivingTransferOrderCreateRoute: typeof AdminReceivingTransferOrderCreateRoute
  AdminReconBankUploadIdDetailRoute: typeof AdminReconBankUploadIdDetailRoute
  AdminReconBankIdDetailRoute: typeof AdminReconBankIdDetailRoute
  AdminReconBankIdProcessRoute: typeof AdminReconBankIdProcessRoute
  AdminReconBankIdUploadRoute: typeof AdminReconBankIdUploadRoute
  AdminReplenishmentTemplateCategoryIdDetailRoute: typeof AdminReplenishmentTemplateCategoryIdDetailRoute
  AdminReplenishmentTemplateCategoryIdUpdateRoute: typeof AdminReplenishmentTemplateCategoryIdUpdateRoute
  AdminReplenishmentTemplateIdDetailRoute: typeof AdminReplenishmentTemplateIdDetailRoute
  AdminReplenishmentTemplateIdImportRoute: typeof AdminReplenishmentTemplateIdImportRoute
  AdminReplenishmentTemplateIdUpdateRoute: typeof AdminReplenishmentTemplateIdUpdateRoute
  AdminReplenishmentIdDetailRoute: typeof AdminReplenishmentIdDetailRoute
  AdminRevenueReportPartnerBranchIdDetailRoute: typeof AdminRevenueReportPartnerBranchIdDetailRoute
  AdminRevenueReportPartnerIdDetailRoute: typeof AdminRevenueReportPartnerIdDetailRoute
  AdminRevenueReportTemplateIdDetailRoute: typeof AdminRevenueReportTemplateIdDetailRoute
  AdminRevenueReportIdDetailRoute: typeof AdminRevenueReportIdDetailRoute
  AdminSalesChannelCampaignIdDetailRoute: typeof AdminSalesChannelCampaignIdDetailRoute
  AdminSalesChannelCampaignIdUpdateRoute: typeof AdminSalesChannelCampaignIdUpdateRoute
  AdminSalesChannelCategoryGroupIdDetailRoute: typeof AdminSalesChannelCategoryGroupIdDetailRoute
  AdminSalesChannelCategoryGroupIdUpdateRoute: typeof AdminSalesChannelCategoryGroupIdUpdateRoute
  AdminSalesChannelCategoryMappingIdDetailRoute: typeof AdminSalesChannelCategoryMappingIdDetailRoute
  AdminSalesChannelCategoryMappingIdUpdateRoute: typeof AdminSalesChannelCategoryMappingIdUpdateRoute
  AdminSalesChannelIdDetailRoute: typeof AdminSalesChannelIdDetailRoute
  AdminSalesChannelIdUpdateRoute: typeof AdminSalesChannelIdUpdateRoute
  AdminSalesInvoiceReviewIdDetailRoute: typeof AdminSalesInvoiceReviewIdDetailRoute
  AdminSalesInvoiceIdDetailRoute: typeof AdminSalesInvoiceIdDetailRoute
  AdminSimpleTransferOrderIdDetailRoute: typeof AdminSimpleTransferOrderIdDetailRoute
  AdminSimpleTransferOrderIdPrintRoute: typeof AdminSimpleTransferOrderIdPrintRoute
  AdminSimpleTransferOrderIdUpdateRoute: typeof AdminSimpleTransferOrderIdUpdateRoute
  AdminSupplierIdDetailRoute: typeof AdminSupplierIdDetailRoute
  AdminSupplierIdUpdateRoute: typeof AdminSupplierIdUpdateRoute
  AdminTaxIdDetailRoute: typeof AdminTaxIdDetailRoute
  AdminTaxIdUpdateRoute: typeof AdminTaxIdUpdateRoute
  AdminTransferOrderIdCreateRoute: typeof AdminTransferOrderIdCreateRoute
  AdminTransferOrderIdDetailRoute: typeof AdminTransferOrderIdDetailRoute
  AdminTransferOrderIdPrintRoute: typeof AdminTransferOrderIdPrintRoute
  AdminTransferOrderIdUpdateRoute: typeof AdminTransferOrderIdUpdateRoute
  AdminTransferRequestIdDetailRoute: typeof AdminTransferRequestIdDetailRoute
  AdminTransferRequestIdUpdateRoute: typeof AdminTransferRequestIdUpdateRoute
  AdminUomCategoryIdDetailRoute: typeof AdminUomCategoryIdDetailRoute
  AdminUomCategoryIdUpdateRoute: typeof AdminUomCategoryIdUpdateRoute
  AdminUserShiftIdDetailRoute: typeof AdminUserShiftIdDetailRoute
  AdminVendorCategoryIdDetailRoute: typeof AdminVendorCategoryIdDetailRoute
  AdminVendorCategoryIdUpdateRoute: typeof AdminVendorCategoryIdUpdateRoute
  AdminVendorRentalApprovalIdDetailRoute: typeof AdminVendorRentalApprovalIdDetailRoute
  AdminVendorRentalApprovalIdPrintRoute: typeof AdminVendorRentalApprovalIdPrintRoute
  AdminVendorIdDetailRoute: typeof AdminVendorIdDetailRoute
  AdminVendorIdUpdateRoute: typeof AdminVendorIdUpdateRoute
  AdminVoucherCategoryIdDetailRoute: typeof AdminVoucherCategoryIdDetailRoute
  AdminVoucherCategoryIdUpdateRoute: typeof AdminVoucherCategoryIdUpdateRoute
  AdminVoucherIdDetailRoute: typeof AdminVoucherIdDetailRoute
  AdminVoucherIdUpdateRoute: typeof AdminVoucherIdUpdateRoute
  AdminWarehouseLocationGroupIdDetailRoute: typeof AdminWarehouseLocationGroupIdDetailRoute
  AdminWarehouseLocationGroupIdUpdateRoute: typeof AdminWarehouseLocationGroupIdUpdateRoute
  AdminWarehouseIdDetailRoute: typeof AdminWarehouseIdDetailRoute
  AdminAccessAppIndexRoute: typeof AdminAccessAppIndexRoute
  AdminAccessPermissionIndexRoute: typeof AdminAccessPermissionIndexRoute
  AdminAccessResourceIndexRoute: typeof AdminAccessResourceIndexRoute
  AdminAccessRoleIndexRoute: typeof AdminAccessRoleIndexRoute
  AdminAccessUserIndexRoute: typeof AdminAccessUserIndexRoute
  AdminBackgroundJobTransactionIndexRoute: typeof AdminBackgroundJobTransactionIndexRoute
  AdminConsignmentOnboardingIndexRoute: typeof AdminConsignmentOnboardingIndexRoute
  AdminConsignmentRequestsIndexRoute: typeof AdminConsignmentRequestsIndexRoute
  AdminConsignmentStoresTeamsIndexRoute: typeof AdminConsignmentStoresTeamsIndexRoute
  AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute: typeof AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute
  AdminGeolocationCityIndexRoute: typeof AdminGeolocationCityIndexRoute
  AdminGeolocationCountryIndexRoute: typeof AdminGeolocationCountryIndexRoute
  AdminGeolocationProvinceIndexRoute: typeof AdminGeolocationProvinceIndexRoute
  AdminGeolocationSubdistrictIndexRoute: typeof AdminGeolocationSubdistrictIndexRoute
  AdminGeolocationVillageIndexRoute: typeof AdminGeolocationVillageIndexRoute
  AdminPricelistPeriodIndexRoute: typeof AdminPricelistPeriodIndexRoute
  AdminAccessAppIdUpdateRoute: typeof AdminAccessAppIdUpdateRoute
  AdminAccessPermissionIdUpdateRoute: typeof AdminAccessPermissionIdUpdateRoute
  AdminAccessResourceIdUpdateRoute: typeof AdminAccessResourceIdUpdateRoute
  AdminAccessRoleIdUpdateRoute: typeof AdminAccessRoleIdUpdateRoute
  AdminAccessUserIdUpdateRoute: typeof AdminAccessUserIdUpdateRoute
  AdminBackgroundJobTransactionIdDetailRoute: typeof AdminBackgroundJobTransactionIdDetailRoute
  AdminConsignmentRegistrationsIdDetailRoute: typeof AdminConsignmentRegistrationsIdDetailRoute
  AdminGeolocationCityIdDetailRoute: typeof AdminGeolocationCityIdDetailRoute
  AdminGeolocationCityIdUpdateRoute: typeof AdminGeolocationCityIdUpdateRoute
  AdminGeolocationCountryIdDetailRoute: typeof AdminGeolocationCountryIdDetailRoute
  AdminGeolocationCountryIdUpdateRoute: typeof AdminGeolocationCountryIdUpdateRoute
  AdminGeolocationProvinceIdDetailRoute: typeof AdminGeolocationProvinceIdDetailRoute
  AdminGeolocationProvinceIdUpdateRoute: typeof AdminGeolocationProvinceIdUpdateRoute
  AdminGeolocationSubdistrictIdDetailRoute: typeof AdminGeolocationSubdistrictIdDetailRoute
  AdminGeolocationSubdistrictIdUpdateRoute: typeof AdminGeolocationSubdistrictIdUpdateRoute
  AdminGeolocationVillageIdDetailRoute: typeof AdminGeolocationVillageIdDetailRoute
  AdminGeolocationVillageIdUpdateRoute: typeof AdminGeolocationVillageIdUpdateRoute
  AdminPettyCashAddFundIdDetailRoute: typeof AdminPettyCashAddFundIdDetailRoute
  AdminPettyCashAddFundIdUpdateRoute: typeof AdminPettyCashAddFundIdUpdateRoute
  AdminPettyCashExpenseIdDetailRoute: typeof AdminPettyCashExpenseIdDetailRoute
  AdminPettyCashExpenseIdUpdateRoute: typeof AdminPettyCashExpenseIdUpdateRoute
  AdminPettyCashRefundIdDetailRoute: typeof AdminPettyCashRefundIdDetailRoute
  AdminPettyCashRefundIdUpdateRoute: typeof AdminPettyCashRefundIdUpdateRoute
  AdminPricelistPeriodIdDetailRoute: typeof AdminPricelistPeriodIdDetailRoute
  AdminPricelistPeriodIdUpdateRoute: typeof AdminPricelistPeriodIdUpdateRoute
  AdminReceivingSimpleTransferOrderIdDetailRoute: typeof AdminReceivingSimpleTransferOrderIdDetailRoute
  AdminReceivingSimpleTransferOrderIdPrintRoute: typeof AdminReceivingSimpleTransferOrderIdPrintRoute
  AdminReceivingSimpleTransferOrderIdUpdateRoute: typeof AdminReceivingSimpleTransferOrderIdUpdateRoute
  AdminReceivingTransferOrderIdDetailRoute: typeof AdminReceivingTransferOrderIdDetailRoute
  AdminReceivingTransferOrderIdUpdateRoute: typeof AdminReceivingTransferOrderIdUpdateRoute
  AdminRevenueSharingIdDetailDetailIdRoute: typeof AdminRevenueSharingIdDetailDetailIdRoute
  AdminRevenueSharingIdDetailIndexRoute: typeof AdminRevenueSharingIdDetailIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminSalesDashboardRoute: AdminSalesDashboardRoute,
  AdminBankAccountCreateRoute: AdminBankAccountCreateRoute,
  AdminBillOfMaterialCreateRoute: AdminBillOfMaterialCreateRoute,
  AdminBranchCategoryCreateRoute: AdminBranchCategoryCreateRoute,
  AdminBranchQrisMerchantCreateRoute: AdminBranchQrisMerchantCreateRoute,
  AdminBranchCreateRoute: AdminBranchCreateRoute,
  AdminConsignmentConfigCreateRoute: AdminConsignmentConfigCreateRoute,
  AdminConsignmentSettlementCreateRoute: AdminConsignmentSettlementCreateRoute,
  AdminConsignmentStockinCreateRoute: AdminConsignmentStockinCreateRoute,
  AdminConsignmentStockoutCreateRoute: AdminConsignmentStockoutCreateRoute,
  AdminConsignmentVendorRegistrationIdRoute:
    AdminConsignmentVendorRegistrationIdRoute,
  AdminCustomerCreateRoute: AdminCustomerCreateRoute,
  AdminDeliveryOrderBatchCreateRoute: AdminDeliveryOrderBatchCreateRoute,
  AdminDeliveryOrderCreateRoute: AdminDeliveryOrderCreateRoute,
  AdminEdcTerminalCreateRoute: AdminEdcTerminalCreateRoute,
  AdminExampleSeePermissionsRoute: AdminExampleSeePermissionsRoute,
  AdminExpenseItemCreateRoute: AdminExpenseItemCreateRoute,
  AdminImportTemplateTypeRoute: AdminImportTemplateTypeRoute,
  AdminInternalTransferCreateRoute: AdminInternalTransferCreateRoute,
  AdminInventoryAdjustmentReasonCreateRoute:
    AdminInventoryAdjustmentReasonCreateRoute,
  AdminInventoryAdjustmentCreateRoute: AdminInventoryAdjustmentCreateRoute,
  AdminInventoryCountTemplateItemCreateRoute:
    AdminInventoryCountTemplateItemCreateRoute,
  AdminInventoryCountCreateRoute: AdminInventoryCountCreateRoute,
  AdminMarketplaceAutomationJobKeyRoute: AdminMarketplaceAutomationJobKeyRoute,
  AdminMemberTypeCreateRoute: AdminMemberTypeCreateRoute,
  AdminOutboundContainerScanRoute: AdminOutboundContainerScanRoute,
  AdminPaymentMethodCreateRoute: AdminPaymentMethodCreateRoute,
  AdminPosBookmarkCreateRoute: AdminPosBookmarkCreateRoute,
  AdminPosterCreateRoute: AdminPosterCreateRoute,
  AdminPricelistCreateRoute: AdminPricelistCreateRoute,
  AdminPrintLabelLargeRoute: AdminPrintLabelLargeRoute,
  AdminPrintLabelSmallRoute: AdminPrintLabelSmallRoute,
  AdminProductAccountingCategoryCreateRoute:
    AdminProductAccountingCategoryCreateRoute,
  AdminProductAddonGroupCreateRoute: AdminProductAddonGroupCreateRoute,
  AdminProductAddonCreateRoute: AdminProductAddonCreateRoute,
  AdminProductAvailabilityTemplateCreateRoute:
    AdminProductAvailabilityTemplateCreateRoute,
  AdminProductBrandCreateRoute: AdminProductBrandCreateRoute,
  AdminProductCategoryCreateRoute: AdminProductCategoryCreateRoute,
  AdminProductDepartmentCreateRoute: AdminProductDepartmentCreateRoute,
  AdminProductDivisionCreateRoute: AdminProductDivisionCreateRoute,
  AdminProductSubCategoryCreateRoute: AdminProductSubCategoryCreateRoute,
  AdminProductSubDepartmentCreateRoute: AdminProductSubDepartmentCreateRoute,
  AdminProductTagCreateRoute: AdminProductTagCreateRoute,
  AdminProductCreateRoute: AdminProductCreateRoute,
  AdminProductImportRoute: AdminProductImportRoute,
  AdminProductionCreateRoute: AdminProductionCreateRoute,
  AdminPromoCreateRoute: AdminPromoCreateRoute,
  AdminPromoImportRoute: AdminPromoImportRoute,
  AdminPurchaseAreaCreateRoute: AdminPurchaseAreaCreateRoute,
  AdminPurchaseOrderCreateRoute: AdminPurchaseOrderCreateRoute,
  AdminPurchaseOrderImportRoute: AdminPurchaseOrderImportRoute,
  AdminReceivingCreateRoute: AdminReceivingCreateRoute,
  AdminReconBankUploadAddRoute: AdminReconBankUploadAddRoute,
  AdminReconBankUploadRoute: AdminReconBankUploadRoute,
  AdminReplenishmentTemplateCategoryCreateRoute:
    AdminReplenishmentTemplateCategoryCreateRoute,
  AdminReplenishmentTemplateCreateRoute: AdminReplenishmentTemplateCreateRoute,
  AdminSalesChannelCampaignCreateRoute: AdminSalesChannelCampaignCreateRoute,
  AdminSalesChannelCampaignRulesRoute: AdminSalesChannelCampaignRulesRoute,
  AdminSalesChannelCategoryGroupCreateRoute:
    AdminSalesChannelCategoryGroupCreateRoute,
  AdminSalesChannelCategoryMappingCreateRoute:
    AdminSalesChannelCategoryMappingCreateRoute,
  AdminSalesChannelCategoryMappingImportRoute:
    AdminSalesChannelCategoryMappingImportRoute,
  AdminSalesChannelCreateRoute: AdminSalesChannelCreateRoute,
  AdminSimpleTransferOrderCreateRoute: AdminSimpleTransferOrderCreateRoute,
  AdminSupplierCreateRoute: AdminSupplierCreateRoute,
  AdminTaxCreateRoute: AdminTaxCreateRoute,
  AdminTransferOrderCreateRoute: AdminTransferOrderCreateRoute,
  AdminTransferOrderImportRoute: AdminTransferOrderImportRoute,
  AdminTransferRequestCreateRoute: AdminTransferRequestCreateRoute,
  AdminTransferRequestImportRoute: AdminTransferRequestImportRoute,
  AdminUomCategoryCreateRoute: AdminUomCategoryCreateRoute,
  AdminVendorCategoryCreateRoute: AdminVendorCategoryCreateRoute,
  AdminVendorCreateRoute: AdminVendorCreateRoute,
  AdminVoucherCategoryCreateRoute: AdminVoucherCategoryCreateRoute,
  AdminVoucherCreateRoute: AdminVoucherCreateRoute,
  AdminWarehouseLocationGroupCreateRoute:
    AdminWarehouseLocationGroupCreateRoute,
  AdminBankAccountIndexRoute: AdminBankAccountIndexRoute,
  AdminBankIndexRoute: AdminBankIndexRoute,
  AdminBillOfMaterialIndexRoute: AdminBillOfMaterialIndexRoute,
  AdminBranchBankAccountIndexRoute: AdminBranchBankAccountIndexRoute,
  AdminBranchCategoryIndexRoute: AdminBranchCategoryIndexRoute,
  AdminBranchQrisMerchantIndexRoute: AdminBranchQrisMerchantIndexRoute,
  AdminBranchSalesChannelIndexRoute: AdminBranchSalesChannelIndexRoute,
  AdminBranchIndexRoute: AdminBranchIndexRoute,
  AdminConsignmentAdminTeamIndexRoute: AdminConsignmentAdminTeamIndexRoute,
  AdminConsignmentBranchSettingIndexRoute:
    AdminConsignmentBranchSettingIndexRoute,
  AdminConsignmentConfigIndexRoute: AdminConsignmentConfigIndexRoute,
  AdminConsignmentCurationIndexRoute: AdminConsignmentCurationIndexRoute,
  AdminConsignmentProductRequestIndexRoute:
    AdminConsignmentProductRequestIndexRoute,
  AdminConsignmentRegionIndexRoute: AdminConsignmentRegionIndexRoute,
  AdminConsignmentRequestIndexRoute: AdminConsignmentRequestIndexRoute,
  AdminConsignmentSettingIndexRoute: AdminConsignmentSettingIndexRoute,
  AdminConsignmentSettlementIndexRoute: AdminConsignmentSettlementIndexRoute,
  AdminConsignmentStockinRequestIndexRoute:
    AdminConsignmentStockinRequestIndexRoute,
  AdminConsignmentStockinIndexRoute: AdminConsignmentStockinIndexRoute,
  AdminConsignmentStockoutIndexRoute: AdminConsignmentStockoutIndexRoute,
  AdminConsignmentVendorApplicationInviteIndexRoute:
    AdminConsignmentVendorApplicationInviteIndexRoute,
  AdminConsignmentVendorRegistrationIndexRoute:
    AdminConsignmentVendorRegistrationIndexRoute,
  AdminCustomerIndexRoute: AdminCustomerIndexRoute,
  AdminDeliveryOrderBatchIndexRoute: AdminDeliveryOrderBatchIndexRoute,
  AdminDeliveryOrderIndexRoute: AdminDeliveryOrderIndexRoute,
  AdminEdcTerminalIndexRoute: AdminEdcTerminalIndexRoute,
  AdminExampleIndexRoute: AdminExampleIndexRoute,
  AdminExpenseItemIndexRoute: AdminExpenseItemIndexRoute,
  AdminIncomingTransferRequestIndexRoute:
    AdminIncomingTransferRequestIndexRoute,
  AdminInternalTransferIndexRoute: AdminInternalTransferIndexRoute,
  AdminInventoryAdjustmentReasonIndexRoute:
    AdminInventoryAdjustmentReasonIndexRoute,
  AdminInventoryAdjustmentIndexRoute: AdminInventoryAdjustmentIndexRoute,
  AdminInventoryCountMonitoringIndexRoute:
    AdminInventoryCountMonitoringIndexRoute,
  AdminInventoryCountTemplateItemIndexRoute:
    AdminInventoryCountTemplateItemIndexRoute,
  AdminInventoryCountIndexRoute: AdminInventoryCountIndexRoute,
  AdminInventoryLocationIndexRoute: AdminInventoryLocationIndexRoute,
  AdminInventoryMovementSummaryIndexRoute:
    AdminInventoryMovementSummaryIndexRoute,
  AdminInventorySummaryIndexRoute: AdminInventorySummaryIndexRoute,
  AdminInventoryTransactionLineUnitIndexRoute:
    AdminInventoryTransactionLineUnitIndexRoute,
  AdminInventoryTransactionIndexRoute: AdminInventoryTransactionIndexRoute,
  AdminMarketplaceAutomationIndexRoute: AdminMarketplaceAutomationIndexRoute,
  AdminMarketplaceChannelLogIndexRoute: AdminMarketplaceChannelLogIndexRoute,
  AdminMarketplaceOrderIndexRoute: AdminMarketplaceOrderIndexRoute,
  AdminMemberTypeIndexRoute: AdminMemberTypeIndexRoute,
  AdminOutboundContainerIndexRoute: AdminOutboundContainerIndexRoute,
  AdminPackingTaskIndexRoute: AdminPackingTaskIndexRoute,
  AdminPaymentInboundRequestIndexRoute: AdminPaymentInboundRequestIndexRoute,
  AdminPaymentMethodIndexRoute: AdminPaymentMethodIndexRoute,
  AdminPaymentProviderConfigIndexRoute: AdminPaymentProviderConfigIndexRoute,
  AdminPaymentTransactionIndexRoute: AdminPaymentTransactionIndexRoute,
  AdminPaymentWebhookEventIndexRoute: AdminPaymentWebhookEventIndexRoute,
  AdminPendingSyncMarketplaceOrderIndexRoute:
    AdminPendingSyncMarketplaceOrderIndexRoute,
  AdminPendingSyncSalesOrderIndexRoute: AdminPendingSyncSalesOrderIndexRoute,
  AdminPettyCashIndexRoute: AdminPettyCashIndexRoute,
  AdminPickingTaskIndexRoute: AdminPickingTaskIndexRoute,
  AdminPosBookmarkIndexRoute: AdminPosBookmarkIndexRoute,
  AdminPosterIndexRoute: AdminPosterIndexRoute,
  AdminPricelistIndexRoute: AdminPricelistIndexRoute,
  AdminPrintConsignmentIndexRoute: AdminPrintConsignmentIndexRoute,
  AdminPrintNonConsignmentIndexRoute: AdminPrintNonConsignmentIndexRoute,
  AdminProductAccountingCategoryIndexRoute:
    AdminProductAccountingCategoryIndexRoute,
  AdminProductAddonGroupIndexRoute: AdminProductAddonGroupIndexRoute,
  AdminProductAddonIndexRoute: AdminProductAddonIndexRoute,
  AdminProductAvailabilityTemplateIndexRoute:
    AdminProductAvailabilityTemplateIndexRoute,
  AdminProductBrandIndexRoute: AdminProductBrandIndexRoute,
  AdminProductCategoryIndexRoute: AdminProductCategoryIndexRoute,
  AdminProductDepartmentIndexRoute: AdminProductDepartmentIndexRoute,
  AdminProductDivisionIndexRoute: AdminProductDivisionIndexRoute,
  AdminProductSubCategoryIndexRoute: AdminProductSubCategoryIndexRoute,
  AdminProductSubDepartmentIndexRoute: AdminProductSubDepartmentIndexRoute,
  AdminProductTagIndexRoute: AdminProductTagIndexRoute,
  AdminProductIndexRoute: AdminProductIndexRoute,
  AdminProductionIndexRoute: AdminProductionIndexRoute,
  AdminPromoIndexRoute: AdminPromoIndexRoute,
  AdminPurchaseAreaIndexRoute: AdminPurchaseAreaIndexRoute,
  AdminPurchaseOrderIndexRoute: AdminPurchaseOrderIndexRoute,
  AdminPutawayTaskIndexRoute: AdminPutawayTaskIndexRoute,
  AdminReceivingIndexRoute: AdminReceivingIndexRoute,
  AdminReconBankUploadIndexRoute: AdminReconBankUploadIndexRoute,
  AdminReconBankIndexRoute: AdminReconBankIndexRoute,
  AdminReconOutstandingIndexRoute: AdminReconOutstandingIndexRoute,
  AdminReplenishmentTemplateCategoryIndexRoute:
    AdminReplenishmentTemplateCategoryIndexRoute,
  AdminReplenishmentTemplateIndexRoute: AdminReplenishmentTemplateIndexRoute,
  AdminReplenishmentIndexRoute: AdminReplenishmentIndexRoute,
  AdminRevenueReportAccessLogIndexRoute: AdminRevenueReportAccessLogIndexRoute,
  AdminRevenueReportPartnerBranchIndexRoute:
    AdminRevenueReportPartnerBranchIndexRoute,
  AdminRevenueReportPartnerIndexRoute: AdminRevenueReportPartnerIndexRoute,
  AdminRevenueReportTemplateIndexRoute: AdminRevenueReportTemplateIndexRoute,
  AdminRevenueReportIndexRoute: AdminRevenueReportIndexRoute,
  AdminRevenueSharingIndexRoute: AdminRevenueSharingIndexRoute,
  AdminSalesChannelCampaignIndexRoute: AdminSalesChannelCampaignIndexRoute,
  AdminSalesChannelCategoryGroupIndexRoute:
    AdminSalesChannelCategoryGroupIndexRoute,
  AdminSalesChannelCategoryMappingIndexRoute:
    AdminSalesChannelCategoryMappingIndexRoute,
  AdminSalesChannelStockThresholdIndexRoute:
    AdminSalesChannelStockThresholdIndexRoute,
  AdminSalesChannelIndexRoute: AdminSalesChannelIndexRoute,
  AdminSalesInvoiceReviewIndexRoute: AdminSalesInvoiceReviewIndexRoute,
  AdminSalesInvoiceIndexRoute: AdminSalesInvoiceIndexRoute,
  AdminSimpleTransferOrderIndexRoute: AdminSimpleTransferOrderIndexRoute,
  AdminSupplierIndexRoute: AdminSupplierIndexRoute,
  AdminTaxIndexRoute: AdminTaxIndexRoute,
  AdminTransferOrderIndexRoute: AdminTransferOrderIndexRoute,
  AdminTransferRequestIndexRoute: AdminTransferRequestIndexRoute,
  AdminUomCategoryIndexRoute: AdminUomCategoryIndexRoute,
  AdminUserShiftIndexRoute: AdminUserShiftIndexRoute,
  AdminVendorCategoryIndexRoute: AdminVendorCategoryIndexRoute,
  AdminVendorConsignmentRentalPeriodIndexRoute:
    AdminVendorConsignmentRentalPeriodIndexRoute,
  AdminVendorRentalApprovalIndexRoute: AdminVendorRentalApprovalIndexRoute,
  AdminVendorIndexRoute: AdminVendorIndexRoute,
  AdminVoucherCategoryIndexRoute: AdminVoucherCategoryIndexRoute,
  AdminVoucherIndexRoute: AdminVoucherIndexRoute,
  AdminWarehouseLocationGroupIndexRoute: AdminWarehouseLocationGroupIndexRoute,
  AdminWarehouseIndexRoute: AdminWarehouseIndexRoute,
  AdminAccessAppCreateRoute: AdminAccessAppCreateRoute,
  AdminAccessPermissionCreateRoute: AdminAccessPermissionCreateRoute,
  AdminAccessResourceCreateRoute: AdminAccessResourceCreateRoute,
  AdminAccessRoleCreateRoute: AdminAccessRoleCreateRoute,
  AdminAccessUserCreateRoute: AdminAccessUserCreateRoute,
  AdminBankAccountIdDetailRoute: AdminBankAccountIdDetailRoute,
  AdminBankAccountIdUpdateRoute: AdminBankAccountIdUpdateRoute,
  AdminBillOfMaterialIdDetailRoute: AdminBillOfMaterialIdDetailRoute,
  AdminBillOfMaterialIdUpdateRoute: AdminBillOfMaterialIdUpdateRoute,
  AdminBranchCategoryIdDetailRoute: AdminBranchCategoryIdDetailRoute,
  AdminBranchCategoryIdUpdateRoute: AdminBranchCategoryIdUpdateRoute,
  AdminBranchQrisMerchantIdDetailRoute: AdminBranchQrisMerchantIdDetailRoute,
  AdminBranchQrisMerchantIdUpdateRoute: AdminBranchQrisMerchantIdUpdateRoute,
  AdminBranchSalesChannelIdDetailRoute: AdminBranchSalesChannelIdDetailRoute,
  AdminBranchSalesChannelIdOperatingHoursRoute:
    AdminBranchSalesChannelIdOperatingHoursRoute,
  AdminBranchIdDetailRoute: AdminBranchIdDetailRoute,
  AdminBranchIdUpdateRoute: AdminBranchIdUpdateRoute,
  AdminConsignmentProductRequestIdDetailRoute:
    AdminConsignmentProductRequestIdDetailRoute,
  AdminConsignmentRequestIdDetailRoute: AdminConsignmentRequestIdDetailRoute,
  AdminConsignmentSettlementIdDetailRoute:
    AdminConsignmentSettlementIdDetailRoute,
  AdminConsignmentSettlementIdEditRoute: AdminConsignmentSettlementIdEditRoute,
  AdminConsignmentSettlementIdEditItemsRoute:
    AdminConsignmentSettlementIdEditItemsRoute,
  AdminConsignmentSettlementIdEmailPreviewRoute:
    AdminConsignmentSettlementIdEmailPreviewRoute,
  AdminConsignmentStockinRequestIdDetailRoute:
    AdminConsignmentStockinRequestIdDetailRoute,
  AdminConsignmentStockinRequestIdPrintRoute:
    AdminConsignmentStockinRequestIdPrintRoute,
  AdminConsignmentStockinIdDetailRoute: AdminConsignmentStockinIdDetailRoute,
  AdminConsignmentStockinIdPrintRoute: AdminConsignmentStockinIdPrintRoute,
  AdminConsignmentStockinIdUpdateRoute: AdminConsignmentStockinIdUpdateRoute,
  AdminConsignmentStockoutIdDetailRoute: AdminConsignmentStockoutIdDetailRoute,
  AdminConsignmentStockoutIdPrintRoute: AdminConsignmentStockoutIdPrintRoute,
  AdminConsignmentStockoutIdUpdateRoute: AdminConsignmentStockoutIdUpdateRoute,
  AdminCustomerIdDetailRoute: AdminCustomerIdDetailRoute,
  AdminCustomerIdUpdateRoute: AdminCustomerIdUpdateRoute,
  AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute:
    AdminDeliveryOrderBatchDeliveryOrderBatchIDLeftContainersRoute,
  AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute:
    AdminDeliveryOrderBatchDeliveryOrderBatchIDReadyTransferOrdersRoute,
  AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute:
    AdminDeliveryOrderBatchDeliveryOrderBatchIDResultRoute,
  AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute:
    AdminDeliveryOrderBatchDeliveryOrderBatchIDStpbRoute,
  AdminDeliveryOrderIdDetailRoute: AdminDeliveryOrderIdDetailRoute,
  AdminDeliveryOrderIdPrintRoute: AdminDeliveryOrderIdPrintRoute,
  AdminDeliveryOrderIdUpdateRoute: AdminDeliveryOrderIdUpdateRoute,
  AdminEdcTerminalIdDetailRoute: AdminEdcTerminalIdDetailRoute,
  AdminEdcTerminalIdUpdateRoute: AdminEdcTerminalIdUpdateRoute,
  AdminExpenseItemIdDetailRoute: AdminExpenseItemIdDetailRoute,
  AdminExpenseItemIdUpdateRoute: AdminExpenseItemIdUpdateRoute,
  AdminGeolocationCityCreateRoute: AdminGeolocationCityCreateRoute,
  AdminGeolocationCountryCreateRoute: AdminGeolocationCountryCreateRoute,
  AdminGeolocationProvinceCreateRoute: AdminGeolocationProvinceCreateRoute,
  AdminGeolocationSubdistrictCreateRoute:
    AdminGeolocationSubdistrictCreateRoute,
  AdminGeolocationVillageCreateRoute: AdminGeolocationVillageCreateRoute,
  AdminIncomingTransferRequestIdDetailRoute:
    AdminIncomingTransferRequestIdDetailRoute,
  AdminIncomingTransferRequestIdUpdateRoute:
    AdminIncomingTransferRequestIdUpdateRoute,
  AdminInternalTransferIdDetailRoute: AdminInternalTransferIdDetailRoute,
  AdminInternalTransferIdPrintRoute: AdminInternalTransferIdPrintRoute,
  AdminInternalTransferIdUpdateRoute: AdminInternalTransferIdUpdateRoute,
  AdminInventoryAdjustmentReasonIdDetailRoute:
    AdminInventoryAdjustmentReasonIdDetailRoute,
  AdminInventoryAdjustmentReasonIdUpdateRoute:
    AdminInventoryAdjustmentReasonIdUpdateRoute,
  AdminInventoryAdjustmentIdDetailRoute: AdminInventoryAdjustmentIdDetailRoute,
  AdminInventoryAdjustmentIdPrintRoute: AdminInventoryAdjustmentIdPrintRoute,
  AdminInventoryAdjustmentIdUpdateRoute: AdminInventoryAdjustmentIdUpdateRoute,
  AdminInventoryAdjustmentCostAdjustmentImportRoute:
    AdminInventoryAdjustmentCostAdjustmentImportRoute,
  AdminInventoryAdjustmentOpeningBalanceImportRoute:
    AdminInventoryAdjustmentOpeningBalanceImportRoute,
  AdminInventoryCountTemplateItemIdDetailRoute:
    AdminInventoryCountTemplateItemIdDetailRoute,
  AdminInventoryCountTemplateItemIdImportRoute:
    AdminInventoryCountTemplateItemIdImportRoute,
  AdminInventoryCountTemplateItemIdUpdateRoute:
    AdminInventoryCountTemplateItemIdUpdateRoute,
  AdminInventoryCountIdDetailRoute: AdminInventoryCountIdDetailRoute,
  AdminInventoryCountIdPrintRoute: AdminInventoryCountIdPrintRoute,
  AdminInventoryCountIdRecountRoute: AdminInventoryCountIdRecountRoute,
  AdminInventoryCountIdUpdateRoute: AdminInventoryCountIdUpdateRoute,
  AdminInventoryTransactionIdDetailRoute:
    AdminInventoryTransactionIdDetailRoute,
  AdminMarketplaceChannelLogIdDetailRoute:
    AdminMarketplaceChannelLogIdDetailRoute,
  AdminMarketplaceOrderIdDetailRoute: AdminMarketplaceOrderIdDetailRoute,
  AdminMemberTypeIdDetailRoute: AdminMemberTypeIdDetailRoute,
  AdminMemberTypeIdUpdateRoute: AdminMemberTypeIdUpdateRoute,
  AdminOutboundContainerIdDetailRoute: AdminOutboundContainerIdDetailRoute,
  AdminPackingTaskIdDetailRoute: AdminPackingTaskIdDetailRoute,
  AdminPackingTaskIdProcessRoute: AdminPackingTaskIdProcessRoute,
  AdminPackingTaskIdVerifyRoute: AdminPackingTaskIdVerifyRoute,
  AdminPaymentMethodIdDetailRoute: AdminPaymentMethodIdDetailRoute,
  AdminPaymentMethodIdUpdateRoute: AdminPaymentMethodIdUpdateRoute,
  AdminPaymentProviderConfigIdUpdateRoute:
    AdminPaymentProviderConfigIdUpdateRoute,
  AdminPaymentTransactionIdDetailRoute: AdminPaymentTransactionIdDetailRoute,
  AdminPettyCashIdDetailRoute: AdminPettyCashIdDetailRoute,
  AdminPettyCashIdPrintRoute: AdminPettyCashIdPrintRoute,
  AdminPettyCashAddFundCreateRoute: AdminPettyCashAddFundCreateRoute,
  AdminPettyCashExpenseCreateRoute: AdminPettyCashExpenseCreateRoute,
  AdminPettyCashRefundCreateRoute: AdminPettyCashRefundCreateRoute,
  AdminPickingTaskIdCreateLocationGroupRoute:
    AdminPickingTaskIdCreateLocationGroupRoute,
  AdminPickingTaskIdDetailRoute: AdminPickingTaskIdDetailRoute,
  AdminPosBookmarkIdDetailRoute: AdminPosBookmarkIdDetailRoute,
  AdminPosBookmarkIdUpdateRoute: AdminPosBookmarkIdUpdateRoute,
  AdminPosterIdDetailRoute: AdminPosterIdDetailRoute,
  AdminPosterIdUpdateRoute: AdminPosterIdUpdateRoute,
  AdminPricelistIdDetailRoute: AdminPricelistIdDetailRoute,
  AdminPricelistIdImportRoute: AdminPricelistIdImportRoute,
  AdminPricelistIdUpdateRoute: AdminPricelistIdUpdateRoute,
  AdminPricelistPeriodCreateRoute: AdminPricelistPeriodCreateRoute,
  AdminProductAccountingCategoryIdDetailRoute:
    AdminProductAccountingCategoryIdDetailRoute,
  AdminProductAccountingCategoryIdUpdateRoute:
    AdminProductAccountingCategoryIdUpdateRoute,
  AdminProductAddonGroupIdDetailRoute: AdminProductAddonGroupIdDetailRoute,
  AdminProductAddonGroupIdUpdateRoute: AdminProductAddonGroupIdUpdateRoute,
  AdminProductAddonIdDetailRoute: AdminProductAddonIdDetailRoute,
  AdminProductAddonIdUpdateRoute: AdminProductAddonIdUpdateRoute,
  AdminProductAvailabilityTemplateIdDetailRoute:
    AdminProductAvailabilityTemplateIdDetailRoute,
  AdminProductAvailabilityTemplateIdImportRoute:
    AdminProductAvailabilityTemplateIdImportRoute,
  AdminProductAvailabilityTemplateIdUpdateRoute:
    AdminProductAvailabilityTemplateIdUpdateRoute,
  AdminProductBrandIdDetailRoute: AdminProductBrandIdDetailRoute,
  AdminProductBrandIdUpdateRoute: AdminProductBrandIdUpdateRoute,
  AdminProductCategoryIdDetailRoute: AdminProductCategoryIdDetailRoute,
  AdminProductCategoryIdUpdateRoute: AdminProductCategoryIdUpdateRoute,
  AdminProductDepartmentIdDetailRoute: AdminProductDepartmentIdDetailRoute,
  AdminProductDepartmentIdUpdateRoute: AdminProductDepartmentIdUpdateRoute,
  AdminProductDivisionIdDetailRoute: AdminProductDivisionIdDetailRoute,
  AdminProductDivisionIdUpdateRoute: AdminProductDivisionIdUpdateRoute,
  AdminProductSubCategoryIdDetailRoute: AdminProductSubCategoryIdDetailRoute,
  AdminProductSubCategoryIdUpdateRoute: AdminProductSubCategoryIdUpdateRoute,
  AdminProductSubDepartmentIdDetailRoute:
    AdminProductSubDepartmentIdDetailRoute,
  AdminProductSubDepartmentIdUpdateRoute:
    AdminProductSubDepartmentIdUpdateRoute,
  AdminProductTagIdDetailRoute: AdminProductTagIdDetailRoute,
  AdminProductTagIdUpdateRoute: AdminProductTagIdUpdateRoute,
  AdminProductIdDetailRoute: AdminProductIdDetailRoute,
  AdminProductIdUpdateRoute: AdminProductIdUpdateRoute,
  AdminProductionIdDetailRoute: AdminProductionIdDetailRoute,
  AdminProductionIdUpdateRoute: AdminProductionIdUpdateRoute,
  AdminPromoIdDetailRoute: AdminPromoIdDetailRoute,
  AdminPromoIdImportRoute: AdminPromoIdImportRoute,
  AdminPromoIdUpdateRoute: AdminPromoIdUpdateRoute,
  AdminPurchaseAreaIdDetailRoute: AdminPurchaseAreaIdDetailRoute,
  AdminPurchaseAreaIdUpdateRoute: AdminPurchaseAreaIdUpdateRoute,
  AdminPurchaseOrderIdDetailRoute: AdminPurchaseOrderIdDetailRoute,
  AdminPurchaseOrderIdPrintRoute: AdminPurchaseOrderIdPrintRoute,
  AdminPurchaseOrderIdReviseRoute: AdminPurchaseOrderIdReviseRoute,
  AdminPurchaseOrderIdUpdateRoute: AdminPurchaseOrderIdUpdateRoute,
  AdminPutawayTaskIdDetailRoute: AdminPutawayTaskIdDetailRoute,
  AdminReceivingIdCreateRoute: AdminReceivingIdCreateRoute,
  AdminReceivingIdDetailRoute: AdminReceivingIdDetailRoute,
  AdminReceivingIdPrintRoute: AdminReceivingIdPrintRoute,
  AdminReceivingIdUpdateRoute: AdminReceivingIdUpdateRoute,
  AdminReceivingSimpleTransferOrderCreateRoute:
    AdminReceivingSimpleTransferOrderCreateRoute,
  AdminReceivingTransferOrderCreateRoute:
    AdminReceivingTransferOrderCreateRoute,
  AdminReconBankUploadIdDetailRoute: AdminReconBankUploadIdDetailRoute,
  AdminReconBankIdDetailRoute: AdminReconBankIdDetailRoute,
  AdminReconBankIdProcessRoute: AdminReconBankIdProcessRoute,
  AdminReconBankIdUploadRoute: AdminReconBankIdUploadRoute,
  AdminReplenishmentTemplateCategoryIdDetailRoute:
    AdminReplenishmentTemplateCategoryIdDetailRoute,
  AdminReplenishmentTemplateCategoryIdUpdateRoute:
    AdminReplenishmentTemplateCategoryIdUpdateRoute,
  AdminReplenishmentTemplateIdDetailRoute:
    AdminReplenishmentTemplateIdDetailRoute,
  AdminReplenishmentTemplateIdImportRoute:
    AdminReplenishmentTemplateIdImportRoute,
  AdminReplenishmentTemplateIdUpdateRoute:
    AdminReplenishmentTemplateIdUpdateRoute,
  AdminReplenishmentIdDetailRoute: AdminReplenishmentIdDetailRoute,
  AdminRevenueReportPartnerBranchIdDetailRoute:
    AdminRevenueReportPartnerBranchIdDetailRoute,
  AdminRevenueReportPartnerIdDetailRoute:
    AdminRevenueReportPartnerIdDetailRoute,
  AdminRevenueReportTemplateIdDetailRoute:
    AdminRevenueReportTemplateIdDetailRoute,
  AdminRevenueReportIdDetailRoute: AdminRevenueReportIdDetailRoute,
  AdminSalesChannelCampaignIdDetailRoute:
    AdminSalesChannelCampaignIdDetailRoute,
  AdminSalesChannelCampaignIdUpdateRoute:
    AdminSalesChannelCampaignIdUpdateRoute,
  AdminSalesChannelCategoryGroupIdDetailRoute:
    AdminSalesChannelCategoryGroupIdDetailRoute,
  AdminSalesChannelCategoryGroupIdUpdateRoute:
    AdminSalesChannelCategoryGroupIdUpdateRoute,
  AdminSalesChannelCategoryMappingIdDetailRoute:
    AdminSalesChannelCategoryMappingIdDetailRoute,
  AdminSalesChannelCategoryMappingIdUpdateRoute:
    AdminSalesChannelCategoryMappingIdUpdateRoute,
  AdminSalesChannelIdDetailRoute: AdminSalesChannelIdDetailRoute,
  AdminSalesChannelIdUpdateRoute: AdminSalesChannelIdUpdateRoute,
  AdminSalesInvoiceReviewIdDetailRoute: AdminSalesInvoiceReviewIdDetailRoute,
  AdminSalesInvoiceIdDetailRoute: AdminSalesInvoiceIdDetailRoute,
  AdminSimpleTransferOrderIdDetailRoute: AdminSimpleTransferOrderIdDetailRoute,
  AdminSimpleTransferOrderIdPrintRoute: AdminSimpleTransferOrderIdPrintRoute,
  AdminSimpleTransferOrderIdUpdateRoute: AdminSimpleTransferOrderIdUpdateRoute,
  AdminSupplierIdDetailRoute: AdminSupplierIdDetailRoute,
  AdminSupplierIdUpdateRoute: AdminSupplierIdUpdateRoute,
  AdminTaxIdDetailRoute: AdminTaxIdDetailRoute,
  AdminTaxIdUpdateRoute: AdminTaxIdUpdateRoute,
  AdminTransferOrderIdCreateRoute: AdminTransferOrderIdCreateRoute,
  AdminTransferOrderIdDetailRoute: AdminTransferOrderIdDetailRoute,
  AdminTransferOrderIdPrintRoute: AdminTransferOrderIdPrintRoute,
  AdminTransferOrderIdUpdateRoute: AdminTransferOrderIdUpdateRoute,
  AdminTransferRequestIdDetailRoute: AdminTransferRequestIdDetailRoute,
  AdminTransferRequestIdUpdateRoute: AdminTransferRequestIdUpdateRoute,
  AdminUomCategoryIdDetailRoute: AdminUomCategoryIdDetailRoute,
  AdminUomCategoryIdUpdateRoute: AdminUomCategoryIdUpdateRoute,
  AdminUserShiftIdDetailRoute: AdminUserShiftIdDetailRoute,
  AdminVendorCategoryIdDetailRoute: AdminVendorCategoryIdDetailRoute,
  AdminVendorCategoryIdUpdateRoute: AdminVendorCategoryIdUpdateRoute,
  AdminVendorRentalApprovalIdDetailRoute:
    AdminVendorRentalApprovalIdDetailRoute,
  AdminVendorRentalApprovalIdPrintRoute: AdminVendorRentalApprovalIdPrintRoute,
  AdminVendorIdDetailRoute: AdminVendorIdDetailRoute,
  AdminVendorIdUpdateRoute: AdminVendorIdUpdateRoute,
  AdminVoucherCategoryIdDetailRoute: AdminVoucherCategoryIdDetailRoute,
  AdminVoucherCategoryIdUpdateRoute: AdminVoucherCategoryIdUpdateRoute,
  AdminVoucherIdDetailRoute: AdminVoucherIdDetailRoute,
  AdminVoucherIdUpdateRoute: AdminVoucherIdUpdateRoute,
  AdminWarehouseLocationGroupIdDetailRoute:
    AdminWarehouseLocationGroupIdDetailRoute,
  AdminWarehouseLocationGroupIdUpdateRoute:
    AdminWarehouseLocationGroupIdUpdateRoute,
  AdminWarehouseIdDetailRoute: AdminWarehouseIdDetailRoute,
  AdminAccessAppIndexRoute: AdminAccessAppIndexRoute,
  AdminAccessPermissionIndexRoute: AdminAccessPermissionIndexRoute,
  AdminAccessResourceIndexRoute: AdminAccessResourceIndexRoute,
  AdminAccessRoleIndexRoute: AdminAccessRoleIndexRoute,
  AdminAccessUserIndexRoute: AdminAccessUserIndexRoute,
  AdminBackgroundJobTransactionIndexRoute:
    AdminBackgroundJobTransactionIndexRoute,
  AdminConsignmentOnboardingIndexRoute: AdminConsignmentOnboardingIndexRoute,
  AdminConsignmentRequestsIndexRoute: AdminConsignmentRequestsIndexRoute,
  AdminConsignmentStoresTeamsIndexRoute: AdminConsignmentStoresTeamsIndexRoute,
  AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute:
    AdminDeliveryOrderBatchDeliveryOrderBatchIDIndexRoute,
  AdminGeolocationCityIndexRoute: AdminGeolocationCityIndexRoute,
  AdminGeolocationCountryIndexRoute: AdminGeolocationCountryIndexRoute,
  AdminGeolocationProvinceIndexRoute: AdminGeolocationProvinceIndexRoute,
  AdminGeolocationSubdistrictIndexRoute: AdminGeolocationSubdistrictIndexRoute,
  AdminGeolocationVillageIndexRoute: AdminGeolocationVillageIndexRoute,
  AdminPricelistPeriodIndexRoute: AdminPricelistPeriodIndexRoute,
  AdminAccessAppIdUpdateRoute: AdminAccessAppIdUpdateRoute,
  AdminAccessPermissionIdUpdateRoute: AdminAccessPermissionIdUpdateRoute,
  AdminAccessResourceIdUpdateRoute: AdminAccessResourceIdUpdateRoute,
  AdminAccessRoleIdUpdateRoute: AdminAccessRoleIdUpdateRoute,
  AdminAccessUserIdUpdateRoute: AdminAccessUserIdUpdateRoute,
  AdminBackgroundJobTransactionIdDetailRoute:
    AdminBackgroundJobTransactionIdDetailRoute,
  AdminConsignmentRegistrationsIdDetailRoute:
    AdminConsignmentRegistrationsIdDetailRoute,
  AdminGeolocationCityIdDetailRoute: AdminGeolocationCityIdDetailRoute,
  AdminGeolocationCityIdUpdateRoute: AdminGeolocationCityIdUpdateRoute,
  AdminGeolocationCountryIdDetailRoute: AdminGeolocationCountryIdDetailRoute,
  AdminGeolocationCountryIdUpdateRoute: AdminGeolocationCountryIdUpdateRoute,
  AdminGeolocationProvinceIdDetailRoute: AdminGeolocationProvinceIdDetailRoute,
  AdminGeolocationProvinceIdUpdateRoute: AdminGeolocationProvinceIdUpdateRoute,
  AdminGeolocationSubdistrictIdDetailRoute:
    AdminGeolocationSubdistrictIdDetailRoute,
  AdminGeolocationSubdistrictIdUpdateRoute:
    AdminGeolocationSubdistrictIdUpdateRoute,
  AdminGeolocationVillageIdDetailRoute: AdminGeolocationVillageIdDetailRoute,
  AdminGeolocationVillageIdUpdateRoute: AdminGeolocationVillageIdUpdateRoute,
  AdminPettyCashAddFundIdDetailRoute: AdminPettyCashAddFundIdDetailRoute,
  AdminPettyCashAddFundIdUpdateRoute: AdminPettyCashAddFundIdUpdateRoute,
  AdminPettyCashExpenseIdDetailRoute: AdminPettyCashExpenseIdDetailRoute,
  AdminPettyCashExpenseIdUpdateRoute: AdminPettyCashExpenseIdUpdateRoute,
  AdminPettyCashRefundIdDetailRoute: AdminPettyCashRefundIdDetailRoute,
  AdminPettyCashRefundIdUpdateRoute: AdminPettyCashRefundIdUpdateRoute,
  AdminPricelistPeriodIdDetailRoute: AdminPricelistPeriodIdDetailRoute,
  AdminPricelistPeriodIdUpdateRoute: AdminPricelistPeriodIdUpdateRoute,
  AdminReceivingSimpleTransferOrderIdDetailRoute:
    AdminReceivingSimpleTransferOrderIdDetailRoute,
  AdminReceivingSimpleTransferOrderIdPrintRoute:
    AdminReceivingSimpleTransferOrderIdPrintRoute,
  AdminReceivingSimpleTransferOrderIdUpdateRoute:
    AdminReceivingSimpleTransferOrderIdUpdateRoute,
  AdminReceivingTransferOrderIdDetailRoute:
    AdminReceivingTransferOrderIdDetailRoute,
  AdminReceivingTransferOrderIdUpdateRoute:
    AdminReceivingTransferOrderIdUpdateRoute,
  AdminRevenueSharingIdDetailDetailIdRoute:
    AdminRevenueSharingIdDetailDetailIdRoute,
  AdminRevenueSharingIdDetailIndexRoute: AdminRevenueSharingIdDetailIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface VendorRouteRouteChildren {
  VendorDashboardRoute: typeof VendorDashboardRoute
  VendorLoginRoute: typeof VendorLoginRoute
  VendorIndexRoute: typeof VendorIndexRoute
  VendorRentalNewRoute: typeof VendorRentalNewRoute
  VendorSalesSalesConsignmentInvoiceIDRoute: typeof VendorSalesSalesConsignmentInvoiceIDRoute
  VendorRentalIndexRoute: typeof VendorRentalIndexRoute
  VendorSalesIndexRoute: typeof VendorSalesIndexRoute
  VendorStockIndexRoute: typeof VendorStockIndexRoute
  VendorTransferIndexRoute: typeof VendorTransferIndexRoute
  VendorAuthResetPasswordTokenRoute: typeof VendorAuthResetPasswordTokenRoute
  VendorRentalVendorConsignmentRentalPaymentIDEditRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  VendorRentalVendorConsignmentRentalPaymentIDPrintRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  VendorStockProductIDInventoryRoute: typeof VendorStockProductIDInventoryRoute
  VendorTransferTypeIdRoute: typeof VendorTransferTypeIdRoute
  VendorRentalVendorConsignmentRentalPaymentIDIndexRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  VendorStockProductIDIndexRoute: typeof VendorStockProductIDIndexRoute
}

const VendorRouteRouteChildren: VendorRouteRouteChildren = {
  VendorDashboardRoute: VendorDashboardRoute,
  VendorLoginRoute: VendorLoginRoute,
  VendorIndexRoute: VendorIndexRoute,
  VendorRentalNewRoute: VendorRentalNewRoute,
  VendorSalesSalesConsignmentInvoiceIDRoute:
    VendorSalesSalesConsignmentInvoiceIDRoute,
  VendorRentalIndexRoute: VendorRentalIndexRoute,
  VendorSalesIndexRoute: VendorSalesIndexRoute,
  VendorStockIndexRoute: VendorStockIndexRoute,
  VendorTransferIndexRoute: VendorTransferIndexRoute,
  VendorAuthResetPasswordTokenRoute: VendorAuthResetPasswordTokenRoute,
  VendorRentalVendorConsignmentRentalPaymentIDEditRoute:
    VendorRentalVendorConsignmentRentalPaymentIDEditRoute,
  VendorRentalVendorConsignmentRentalPaymentIDPrintRoute:
    VendorRentalVendorConsignmentRentalPaymentIDPrintRoute,
  VendorStockProductIDInventoryRoute: VendorStockProductIDInventoryRoute,
  VendorTransferTypeIdRoute: VendorTransferTypeIdRoute,
  VendorRentalVendorConsignmentRentalPaymentIDIndexRoute:
    VendorRentalVendorConsignmentRentalPaymentIDIndexRoute,
  VendorStockProductIDIndexRoute: VendorStockProductIDIndexRoute,
}

const VendorRouteRouteWithChildren = VendorRouteRoute._addFileChildren(
  VendorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  VendorRouteRoute: VendorRouteRouteWithChildren,
  R403Route: R403Route,
  CheckEmailRoute: CheckEmailRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
